/*!
 * @license
 * nanoStream H5Live Player 5.0.5
 * Build from Wed Jan 07 2026 15:01:52 GMT+0100 (Mitteleuropäische Normalzeit)
 * Copyright (c) 2014-2024 nanocosmos IT GmbH. All rights reserved.
 * http://www.nanocosmos.de
 * sales@nanocosmos.de
 *
 * LEGAL NOTICE:
 * This material is subject to the terms and conditions defined in
 * separate license conditions ('LICENSE.txt')
 * All information contained herein is, and remains the property
 * of nanocosmos GmbH and its suppliers if any. The intellectual and technical concepts
 * contained herein are proprietary to nanocosmos GmbH, and are protected by trade secret
 * or copyright law. Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained from nanocosmos.
 * All modifications will remain property of nanocosmos.
 */

/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

/*!
* @license
* SWFObject v2.3.20130521 <http://github.com/swfobject/swfobject> is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
*/

!function () {
  var e = {
    4216: function (e, t, n) {
      var r, i;
      r = [n(8478), n(8197), n(2459), n(2437), n(9470), n(7884), n(3293)], void 0 === (i = function (e, t, n, r, i, a, o) {
        "use strict";

        function s(i) {
          var a, s, l, f, E = !1, p = i.source.group, m = "https://bintu.nanocosmos.de", g = {profile: "player"};
          return new Promise((function (b, _) {
            if (!i.source.bintu || i.source.entries && i.source.entries.length || (i.source.entries = [{
              index: 0,
              bintu: t.copy(i.source.bintu)
            }], i.source.h5live && (i.source.entries[0].h5live = t.copy(i.source.h5live), delete i.source.h5live), i.source.hls && (i.source.entries[0].hls = t.copy(i.source.hls), delete i.source.hls)), a = performance.now(), "object" == typeof p && p.id) {
              p.apiurl = c(p.apiurl, m);
              var h = new o(p.apiurl, null, null, "player");
              s = p.apiurl, l = p.id, h.getStreamgroup(p.id, g).then(function (t, o) {
                try {
                  f = o;
                  var s, u = JSON.parse(f.responseText), c = u.id, l = u.playout, E = l.rtmp, m = l.hls, g = l.h5live,
                    _ = u.state;
                  if (E && !E.length && !g || g && !g.length) return void R(new e(r.SETUP.BINTU_STREAM_NOT_LIVE.replace("$streamid$", c), n.SETUP.BINTU_STREAM_NOT_LIVE));
                  i.source.entries = [];
                  var h = i.source.entries;
                  if (g && g.length) for (var T = 0; T < g.length; T += 1) {
                    if (h[T] = h[T] || {}, m && m.length) {
                      var A = m[T].url;
                      h[T].hls = A
                    }
                    if (h[T].h5live = h[T].h5live || {}, !h[T].h5live.server && (h[T].h5live.server = {})) for (s in g[T].server) Object.prototype.hasOwnProperty.call(g[T].server, s) && (h[T].h5live.server[s] = g[T].server[s].replace("bintu-stream", "bintu-h5live"));
                    h[T].index = g[T].index || 0;
                    var S = {width: 0, height: 0, bitrate: 0, framerate: 0},
                      y = {width: "width", height: "height", bitrate: "bitrate", framerate: "fps"};
                    for (s in h[T].info = h[T].info || {}, S) g[T].info && Object.keys(g[T].info).length && void 0 !== g[T].info[y[s]] ? h[T].info[s] = g[T].info[y[s]] : h[T].info[s] = S[s];
                    g[T].label && (h[T].label = g[T].label), h[T].h5live.rtmp = {}, h[T].h5live.rtmp.url = g[T].rtmp.url, h[T].h5live.rtmp.streamname = g[T].rtmp.streamname, p.security && p.security.jwtoken && "string" == typeof p.security.jwtoken && (h[T].h5live.security = h[T].h5live.security || {}, h[T].h5live.security.jwtoken = p.security.jwtoken), g[T].server.webtransport && g[T].server.webtransport.length || (h[T].h5live.server.webtransport = g[T].server.websocket.replace(/^wss:\/\//, "https://"))
                  }
                  if (_ && (i.source.group.state = _), h && h.length) {
                    var v = {
                      high: 0,
                      "medium-high": Math.round(1 * (h.length - 1) / 5),
                      medium: Math.round(1 * (h.length - 1) / 2),
                      "medium-low": Math.round(4 * (h.length - 1) / 5),
                      low: h.length - 1
                    };
                    Object.prototype.hasOwnProperty.call(i.source.group, "startQuality") && "string" == typeof i.source.group.startQuality && Object.prototype.hasOwnProperty.call(v, i.source.group.startQuality) ? i.source.startIndex = v[i.source.group.startQuality] : i.source.startIndex = v.low
                  }
                  (!i.source.options || i.source.options && !i.source.options.adaption || i.source.options && i.source.options.adaption && !i.source.options.adaption.rule || i.source.options && i.source.options.adaption && i.source.options.adaption.rule && "none" !== i.source.options.adaption.rule && "deviationOfMean" !== i.source.options.adaption.rule) && (i.source.options = i.source.options || {}, i.source.options.adaption = i.source.options.adaption || {}, i.source.options.adaption.rule = "deviationOfMean2"), p = !1, d(i, a, b)
                } catch (e) {
                  R(e)
                }
              }.bind(this, void 0)).catch(R)
            } else if (i.source.entries && i.source.entries.length) {
              for (var T = i.source.entries, A = 0; A < T.length; A += 1) {
                var S = T[A];
                if ("object" == typeof S.bintu) {
                  if (!S.bintu.streamid) {
                    if (S.h5live && (!S.h5live || S.h5live.rtmp)) continue;
                    _(new e(r.SETUP.BINTU_NO_STREAM_ID, n.SETUP.BINTU_NO_STREAM_ID))
                  }
                  S.bintu.apiurl = c(S.bintu.apiurl, m), (E = E || {})[A] = new o(S.bintu.apiurl, null, null, "player"), s = S.bintu.apiurl, l = S.bintu.streamid, S.bintu.streamid && E[A].getStream(S.bintu.streamid, g).then(y.bind(this, A)).catch(R)
                }
              }

              function y(t, o) {
                try {
                  f = o;
                  var s, u = JSON.parse(f.responseText), c = u.id, l = u.playout, p = l.rtmp, m = l.hls, g = l.h5live,
                    _ = u.state;
                  if (p && !p.length && !g || g && !g.length) return void R(new e(r.SETUP.BINTU_STREAM_NOT_LIVE.replace("$streamid$", c), n.SETUP.BINTU_STREAM_NOT_LIVE));
                  if (m && m.length) {
                    var h = m[0].url;
                    T[t].hls = h
                  }
                  if (g && g.length) {
                    if (T[t].h5live = T[t].h5live || {}, !T[t].h5live.server && (T[t].h5live.server = {})) for (s in g[0].server) Object.prototype.hasOwnProperty.call(g[0].server, s) && (T[t].h5live.server[s] = g[0].server[s].replace("bintu-stream", "bintu-h5live"));
                    T[t].h5live.rtmp = {}, T[t].h5live.rtmp.url = g[0].rtmp.url, T[t].h5live.rtmp.streamname = g[0].rtmp.streamname
                  } else p && p.length && (T[t].h5live = i.source.h5live || {}, T[t].h5live.rtmp = {}, T[t].h5live.rtmp.url = p[0].url, T[t].h5live.rtmp.streamname = p[0].streamname);
                  _ && (T[t].bintu.state = _), E[t] = !1;
                  var A = !0;
                  for (s in E) if (Object.prototype.hasOwnProperty.call(E, s) && !1 !== E[s]) {
                    A = !1;
                    break
                  }
                  A && d(i, a, b)
                } catch (e) {
                  R(e)
                }
              }

              E || d(i, 0, b)
            } else d(i, a, b);

            function R(t) {
              f = t.request ? t.request : f;
              var i = {
                error: null,
                bintu: {responseTime: u(a), apiUrl: s, isGroup: "object" == typeof p, id: l, status: f ? f.status : 0}
              };
              t.code && t.message ? i.error = t : "onstatuserror" === t.error ? i.error = new e(r.SETUP.BINTU_STATUS_ERROR.replace("$status$", f.status), n.SETUP.BINTU_STATUS_ERROR) : t.error ? i.error = new e(t.error) : t.message && (i.error = new e(t.message)), _(i)
            }
          }))
        }

        function d(e, t, n) {
          var r = 0;
          0 !== t && (r = u(t)), n({config: e, bintu: {responseTime: r}})
        }

        function u(e) {
          var t = Math.min(Math.max(0, performance.now() - e), 6e4);
          return Math.floor(t)
        }

        function c(e, t) {
          if ("string" != typeof e || "" === e) return t;
          var n = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, r = /^[^:\/]+[:\/]+\/?/;
          if (e.match(r)) {
            var i = e.replace(r, "https://"), a = i.replace(/^https?:\/\//, "");
            return n.test(a) ? i : t
          }
          return n.test(e) ? "https://" + e : t
        }

        return {
          setup: s, updateSource: function (e) {
            return s({source: e})
          }, emptyConfig: i, validConfig: a
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9470: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {source: {bintu: {apiurl: "", streamid: ""}}}
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7884: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {source: {bintu: {apiurl: "string", streamid: "string"}}}
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2459: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({SETUP: {BINTU_STREAM_NOT_LIVE: 5101, BINTU_NO_STREAM_ID: 5102, BINTU_STATUS_ERROR: 5103}})
      }.apply(t, [])) || (e.exports = n)
    }, 2437: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          SETUP: {
            BINTU_STREAM_NOT_LIVE: "Could not find bintu stream with id $streamid$. The stream is not live.",
            BINTU_NO_STREAM_ID: "No bintu stream id passed.",
            BINTU_STATUS_ERROR: "The bintu service rejected with http status $status$."
          }
        })
      }.apply(t, [])) || (e.exports = n)
    }, 3293: function (e, t) {
      var n;
      (function () {
        "use strict";
        var t = function (e, t, n, r) {
          if (!(e.length > 0 && ("string" == typeof e || e instanceof String))) throw new Error('The param "apiUrl" must be of type "string" and also may not be empty string.');
          if (this.apiUrl = e, t && ("string" == typeof t || t instanceof String) && (this.apiKey = t), n && ("string" == typeof n || n instanceof String) && (this.playerKey = n), r && ("string" == typeof r || r instanceof String)) {
            if ("api" !== r && "player" !== r) throw new Error('The param "keyMode" must be "api", "player" or undefined');
            this.keyMode = r
          }
        }, r = t.prototype, i = function (e, t, n, r) {
          this.method = e || "GET", this.url = t || "http://localhost:8088", this.header = n || {}, this.async = r || !0, this.Send = function (e) {
            return new Promise(function (t, n) {
              var r = new XMLHttpRequest;
              for (var i in r.open(this.method, this.url, this.async), this.header) Object.prototype.hasOwnProperty.call(this.header, i) && r.setRequestHeader(i, this.header[i]);
              if (r.onreadystatechange = function () {
                return 4 === r.readyState && 200 === r.status ? t(r) : 4 === r.readyState && 200 !== r.status ? n({
                  error: "onstatuserror",
                  request: r
                }) : void 0
              }, r.onabort = function () {
                return n({error: "onabort", request: r})
              }, r.onerror = function () {
                return n({error: "onerror", request: r})
              }, r.ontimeout = function () {
                return n({error: "ontimeout", request: r})
              }, void 0 !== e) {
                if ("string" == typeof e) try {
                  e = JSON.parse(e)
                } catch (t) {
                  return e = null, n({error: "invalid json string", request: r})
                }
                if ("object" == typeof e) try {
                  e = JSON.stringify(e), r.send(e)
                } catch (e) {
                  return n({error: "invalid json object", request: r})
                }
              } else r.send()
            }.bind(this))
          }
        };

        function a(e) {
          var t = "";
          for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
            var r = e[n];
            n && r && (0 === t.length ? t += "?" : t += "&", t += n + "=" + r)
          }
          return t
        }

        function o(e, t, n, r) {
          var i = {};
          return t = "string" != typeof t ? "." : t, n = isNaN(n) ? 10 : n, r = isNaN(r) ? 0 : parseInt(r, 10), e && "object" == typeof e && function e(a, o, s) {
            if (!(s >= n)) for (var d in a) {
              var u = (o ? o + t : "") + d;
              "[object Array]" === Object.prototype.toString.call(a[d]) && 0 === r || ("object" == typeof a[d] ? e(a[d], u, s + 1) : i[u] = a[d].toString())
            }
          }(e, "", 0), i
        }

        r.apiKey = null, r.apiUrl = null, r.playerKey = null, r.keyMode = "api", r.createStream = function (e, t, n) {
          return new Promise(function (r, a) {
            if (!this.apiUrl) return a({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey) return a({error: "no api key set", request: {responseText: "no response error"}});
            if ("api" !== this.keyMode) return a({
              error: "wrong key mode set",
              request: {responseText: "no response error"}
            });
            var o = new i("POST", this.apiUrl + "/stream");
            o.header = {Accept: "application/json", "Content-Type": "application/json", "X-BINTU-APIKEY": this.apiKey};
            var s = {webrtc: !!e, transcoding: !!t};
            return "object" == typeof n && "function" == typeof n.push && n.length > 0 && ("string" == typeof n[0] || n[0] instanceof String) && (s.tags = n), o.Send(s).then(r).catch(a)
          }.bind(this))
        }, r.getStream = function (e, t) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey && "api" === this.keyMode) return r({
              error: "no api key set",
              request: {responseText: "no response error"}
            });
            var s = a(o(t, ".", 10, 0)), d = new i("GET", this.apiUrl + "/stream/" + e + s);
            return d.header = "api" === this.keyMode && this.apiKey ? {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-APIKEY": this.apiKey
            } : {
              Accept: "application/json",
              "Content-Type": "application/json; charset=utf-8"
            }, d.Send().then(n).catch(r)
          }.bind(this))
        }, r.getStreamgroup = function (e, t) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey && "api" === this.keyMode) return r({
              error: "no api key set",
              request: {responseText: "no response error"}
            });
            var s = a(o(t, ".", 10, 0)), d = new i("GET", this.apiUrl + "/stream/" + e + "/group" + s);
            return d.header = "api" === this.keyMode && this.apiKey ? {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-APIKEY": this.apiKey
            } : {
              Accept: "application/json",
              "Content-Type": "application/json; charset=utf-8"
            }, d.Send().then(n).catch(r)
          }.bind(this))
        }, r.getStreams = function (e) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey) return r({error: "no api key set", request: {responseText: "no response error"}});
            var a = this.apiUrl + "/stream";
            e instanceof t.StreamFilter && (a += e.getQueryString(!1));
            var o = new i("GET", a);
            return o.header = {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-APIKEY": this.apiKey
            }, o.Send().then(n).catch(r)
          }.bind(this))
        }, r.getStreamsPublic = function (e) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.playerKey) return r({error: "no player key set", request: {responseText: "no response error"}});
            var a = this.apiUrl + "/stream/public";
            e instanceof t.StreamFilter && (a += e.getQueryString(!0));
            var o = new i("GET", a);
            return o.header = {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-PLAYERKEY": this.playerKey
            }, o.Send().then(n).catch(r)
          }.bind(this))
        }, r.tagStream = function (e, t) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey) return r({error: "no api key set", request: {responseText: "no response error"}});
            if ("api" !== this.keyMode) return r({
              error: "wrong key mode set",
              request: {responseText: "no response error"}
            });
            if (!e) return r({error: "no stream id set"});
            var a = new i("PUT", this.apiUrl + "/stream/" + e + "/tag");
            return a.header = {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-APIKEY": this.apiKey
            }, "object" == typeof t && "function" == typeof t.push && t.length > 0 && ("string" == typeof t[0] || t[0] instanceof String) ? a.Send({tags: t}).then(n).catch(r) : a.Send().then(n).catch(r)
          }.bind(this))
        }, r.pushStream = function (e, t) {
          return new Promise(function (n, r) {
            if (!this.apiUrl) return r({error: "no api url set", request: {responseText: "no response error"}});
            if (!this.apiKey) return r({error: "no api key set", request: {responseText: "no response error"}});
            if ("api" !== this.keyMode) return r({
              error: "wrong key mode set",
              request: {responseText: "no response error"}
            });
            if (!e) return r({error: "no stream id set"});
            var a = new i("PUT", this.apiUrl + "/stream/" + e + "/push_url");
            return a.header = {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-BINTU-APIKEY": this.apiKey
            }, a.Send({url: t}).then(n).catch(r)
          }.bind(this))
        }, r = (t.StreamFilter = function () {
          this.state = this.setState(t.StreamFilter.STATE.ALL), this.tags = []
        }).prototype, t.StreamFilter.STATE = Object.create({
          LIVE: "live",
          CREATED: "created",
          ENDED: "ended",
          ALL: null
        }), r.setState = function (e) {
          var n;
          for (var r in t.StreamFilter.STATE) t.StreamFilter.STATE[r] === e && (n = t.StreamFilter.STATE[r]);
          if (void 0 === n) throw new Error('The param "state" must be of type "Bintu.StreamFilter.STATE"');
          return this.state = n, this
        }, r.addTag = function (e) {
          if (!(e.length > 0 && ("string" == typeof e || e instanceof String))) throw new Error('The param "tag" must be of type "string" and also may not be empty string.');
          return this.tags.push(e), this.tags = this._reduceDuplicates(this.tags), this
        }, r.addTags = function (e) {
          if ("object" != typeof e || "function" != typeof e.push || !(0 === e.length || e.length > 0 && ("string" == typeof e[0] || e[0] instanceof String))) throw new Error('The param "tags" must be of type "string array"');
          return this.tags = this.tags.concat(e), this.tags = this._reduceDuplicates(this.tags), this
        }, r.getQueryString = function (e) {
          var t = "";
          if ("object" == typeof this.tags && "function" == typeof this.tags.push && this.tags.length > 0) for (var n = 0; n < this.tags.length; n += 1) "string" == typeof this.tags[n] && (t += 0 === n ? "?" : "&", t += "tags[]=" + this.tags[n]);
          return !0 === e && "" === t && (t += "?tags[]="), "string" == typeof this.state && this.state.length > 0 && (t += -1 === t.indexOf("?") ? "?" : "&", t += "state=" + this.state), t
        }, r._reduceDuplicates = function (e) {
          if ("object" != typeof e || "function" != typeof e.push || !(0 === e.length || e.length > 0 && ("string" == typeof e[0] || e[0] instanceof String))) throw new Error('The param "tags" must be of type "string array"');
          return e.reduce((function (e, t) {
            return e.indexOf(t) < 0 && e.push(t), e
          }), [])
        }, void 0 === (n = function () {
          return t
        }.apply(this, [])) || (e.exports = n)
      }).call(this)
    }, 6965: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              playback: {
                autoplay: !0,
                automute: !0,
                muted: !1,
                metadata: !1,
                videoId: "",
                keepConnection: !1,
                allowSafariHlsFallback: !1,
                crossOrigin: "not-set",
                mediaErrorRecoveries: 3,
                metadataLowDelay: !0,
                reconnect: {minDelay: 2, maxDelay: 10, delaySteps: 10, maxRetries: 10},
                timeouts: {loading: 20, buffering: 20, connecting: 5},
                latencyControlMode: "balancedadaptive",
                faststart: !0,
                enableMediaOverQuic: !0,
                enableQuicConnectionProbe: !0,
                volume: 1,
                enableWakeLock: !0
              },
              source: {
                hls: "",
                h5live: {
                  server: {websocket: "", progressive: "", hls: "", webtransport: ""},
                  token: "",
                  rtmp: {url: "", streamname: ""},
                  security: {token: "", jwtoken: "", expires: "", options: "", tag: ""},
                  params: {}
                },
                bintu: {apiurl: "", streamid: "", state: ""},
                startIndex: 0,
                options: {switch: {}, adaption: {}},
                entries: [],
                defaults: {},
                group: {apiurl: "", id: "", startQuality: "", state: "", security: {jwtoken: ""}},
                general: {}
              },
              events: {
                onReady: void 0,
                onPlay: void 0,
                onPause: void 0,
                onLoading: void 0,
                onStartBuffering: void 0,
                onStopBuffering: void 0,
                onError: void 0,
                onMetaData: void 0,
                onStats: void 0,
                onMute: void 0,
                onUnmute: void 0,
                onVolumeChange: void 0,
                onServerInfo: void 0,
                onStreamInfo: void 0,
                onStreamInfoUpdate: void 0,
                onWarning: void 0,
                onDestroy: void 0,
                onUpdateSourceInit: void 0,
                onUpdateSourceSuccess: void 0,
                onUpdateSourceFail: void 0,
                onUpdateSourceAbort: void 0,
                onSwitchStreamInit: void 0,
                onSwitchStreamSuccess: void 0,
                onSwitchStreamFail: void 0,
                onSwitchStreamAbort: void 0,
                onActiveVideoElementChange: void 0
              },
              tweaks: {
                buffer: {min: void 0, start: void 0, max: void 0, target: void 0, limit: void 0},
                bufferDynamic: {offsetThreshold: void 0, offsetStep: void 0, cooldownTime: void 0}
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1493: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              index: 0,
              label: "high",
              tag: "high res",
              info: {bitrate: 0, width: 0, height: 0, framerate: 0},
              hls: "",
              h5live: {
                server: {websocket: "", progressive: "", hls: "", webtransport: ""},
                token: "",
                rtmp: {url: "", streamname: ""},
                params: {},
                security: {token: "", jwtoken: "", expires: "", options: "", tag: ""}
              },
              bintu: {apiurl: "", streamid: "", state: ""}
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 828: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              index: "number",
              label: "string",
              tag: "string",
              info: {bitrate: "number", width: "number", height: "number", framerate: "number"},
              hls: "string",
              h5live: {
                server: {websocket: "string", progressive: "string", hls: "string", webtransport: "string"},
                token: "string",
                rtmp: {url: "string", streamname: "string"},
                params: "object",
                security: {token: "string", jwtoken: "string", expires: "string", options: "string", tag: "string"}
              },
              bintu: {apiurl: "string", streamid: "string", state: "string"}
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5055: function (e, t, n) {
      var r, i;
      r = [n(6637)], void 0 === (i = function (e) {
        return {
          create: function (t, n, r) {
            var i, a = {};

            function o(e) {
              a[e.name] && a[e.name].forEach((function (t) {
                var r = {};
                for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
                n.emit(t, r)
              }))
            }

            return i = [], r.forEach((function (e) {
              i.push({type: e.from, listener: o}), a[e.from] || (a[e.from] = []), a[e.from].push(e.to)
            })), e.add({target: t, listeners: i}), {
              destroy: function () {
                e.remove({target: t, listeners: i}), i = null, a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1969: function (e, t, n) {
      var r, i;
      r = [n(9658)], void 0 === (i = function (e) {
        "use strict";

        function t() {
          this.version = void 0, this.type = void 0
        }

        var n = t.prototype = Object.create(e.prototype);
        return n.setup = function () {
          throw new Error('"setup" must be implemented or player not initialized')
        }, n.destroy = function () {
          throw new Error('"destroy" must be implemented or player not initialized')
        }, n.play = function () {
          throw new Error('"play" must be implemented or player not initialized by call setup')
        }, n.pause = function () {
          throw new Error('"pause" must be implemented or player not initialized by call setup')
        }, n.mute = function () {
          throw new Error('"mute" must be implemented or player not initialized by call setup')
        }, n.unmute = function () {
          throw new Error('"unmute" must be implemented or player not initialized by call setup')
        }, n.setVolume = function () {
          throw new Error('"setVolume" must be implemented or player not initialized by call setup')
        }, n.updateSource = function () {
          throw new Error('"updateSource" must be implemented or player not initialized by call setup')
        }, n.switchStream = function () {
          throw new Error('"switchStream" must be implemented or player not initialized by call setup')
        }, n.setAdaption = function () {
          throw new Error('"setAdaption" must be implemented or player not initialized by call setup')
        }, t.isSupported = function () {
          return !1
        }, t.supportedTechniques = [], t
      }.apply(t, r)) || (e.exports = i)
    }, 6637: function (e, t, n) {
      var r, i;
      r = [n(939)], void 0 === (i = function (e) {
        "use strict";
        var t = ["addEventListener", "addListener", "on"], n = ["removeEventListener", "removeListener", "off"];

        function r(e, t) {
          for (var n = 0; n < t.length; ++n) if ("function" == typeof e[t[n]]) return e[t[n]];
          return null
        }

        function i(i, a) {
          !function (i) {
            if (!i.target) throw new Error(e.NO_TARGET);
            if (!i.listeners || !i.listeners.length) throw new Error(e.NO_LISTENERS);
            if (!r(i.target, t) || !r(i.target, n)) throw new Error(e.NOT_DISPATCHER);
            for (var a = 0; a < i.listeners.length; ++a) if (!i.listeners[a].type && "string" != typeof i.listeners[a].type || 0 !== i.listeners[a].type.length) {
              if (!i.listeners[a].type) throw new Error(e.MISSING_TYPE.replace("%index%", a));
              if ("function" != typeof i.listeners[a].listener) throw new Error(e.MISSING_LISTENER.replace("%index%", a))
            } else i.listeners.splice(a, 1), a--
          }(a), function (e, t, n) {
            for (var r = 0; r < n.length; ++r) e.call(t, n[r].type, n[r].listener)
          }(r(a.target, i), a.target, a.listeners)
        }

        return {add: i.bind(null, t), remove: i.bind(null, n)}
      }.apply(t, r)) || (e.exports = i)
    }, 8544: function (e, t, n) {
      var r, i;
      r = [n(1933), n(8478), n(9775), n(182), n(3284), n(3778)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (e, o) {
            return new Promise((function (s, d) {
              var u = n;
              try {
                s(function (e, t) {
                  return new (0, e[0])(t)
                }(u = function (e, n) {
                  var o = {};
                  o[i.H5LIVE_WSS] = "h5live", o[i.H5LIVE_HLS] = "h5live";
                  var s = [], d = e.filter((function (e) {
                    var t = !1;
                    return e.supportedTechniques.forEach((function (e) {
                      s.push(o[e]), !1 === t && (t = Object.prototype.hasOwnProperty.call(n, "source") && (Object.prototype.hasOwnProperty.call(n.source, o[e]) || function (e, t) {
                        if (!Object.prototype.hasOwnProperty.call(e.source, "entries") || !e.source.entries.length) return !1;
                        var n = !0;
                        return e.source.entries.forEach((function (e) {
                          Object.prototype.hasOwnProperty.call(e, t) || (n = !1)
                        })), n
                      }(n, o[e])))
                    })), t
                  }));
                  if (!d.length) throw new t(r.SOURCE_NOT_SUPPORTED, a.SETUP.SOURCE_NOT_SUPPORTED);
                  return d
                }(u = function (e) {
                  var n = e.filter((function (e) {
                    return e.isSupported()
                  }));
                  if (!n.length) throw new t(r.CLIENT_NOT_SUPPORTED, a.SETUP.CLIENT_NOT_SUPPORTED);
                  return n
                }(u), o), e))
              } catch (e) {
                d(e)
              }
            }))
          }, capabilities: (o = [], n.filter((function (e) {
            return e.isSupported()
          })).forEach((function (e) {
            o = o.concat(e.supportedTechniques)
          })), o)
        };
        var o
      }.apply(t, r)) || (e.exports = i)
    }, 9775: function (e, t, n) {
      var r, i;
      r = [n(1128), n(1128)], void 0 === (i = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e.push(arguments[t]);
        return e
      }.apply(t, r)) || (e.exports = i)
    }, 5810: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              source: {
                hls: "string",
                h5live: {
                  server: {websocket: "string", progressive: "string", hls: "string", webtransport: "string"},
                  token: "string",
                  rtmp: {url: "string", streamname: "string"},
                  params: "object",
                  security: {token: "string", jwtoken: "string", expires: "string", options: "string", tag: "string"}
                },
                bintu: {apiurl: "string", streamid: "string", state: "string"},
                startIndex: "number",
                options: "object",
                entries: "object",
                defaults: "object",
                group: {
                  apiurl: "string",
                  id: "string",
                  startQuality: "string",
                  state: "string",
                  security: {jwtoken: "string"}
                },
                general: "object"
              },
              playback: {
                autoplay: "boolean",
                automute: "boolean",
                muted: "boolean",
                metadata: "boolean",
                videoId: "*",
                keepConnection: "boolean",
                allowSafariHlsFallback: "boolean",
                crossOrigin: "string",
                mediaErrorRecoveries: "number",
                metadataLowDelay: "boolean",
                reconnect: {minDelay: "number", maxDelay: "number", delaySteps: "number", maxRetries: "number"},
                timeouts: {loading: "number", buffering: "number", connecting: "number"},
                latencyControlMode: "string",
                faststart: "boolean",
                enableMediaOverQuic: "boolean",
                enableQuicConnectionProbe: "boolean",
                volume: "number",
                enableWakeLock: "boolean"
              },
              events: {
                onReady: "function",
                onPlay: "function",
                onPause: "function",
                onLoading: "function",
                onStartBuffering: "function",
                onStopBuffering: "function",
                onError: "function",
                onMetaData: "function",
                onStats: "function",
                onMute: "function",
                onUnmute: "function",
                onVolumeChange: "function",
                onServerInfo: "function",
                onStreamInfo: "function",
                onStreamInfoUpdate: "function",
                onWarning: "function",
                onDestroy: "function",
                onUpdateSourceInit: "function",
                onUpdateSourceSuccess: "function",
                onUpdateSourceFail: "function",
                onUpdateSourceAbort: "function",
                onSwitchStreamInit: "function",
                onSwitchStreamSuccess: "function",
                onSwitchStreamFail: "function",
                onSwitchStreamAbort: "function",
                onActiveVideoElementChange: "function"
              },
              tweaks: {
                buffer: {max: "number", min: "number", start: "number", target: "number", limit: "number"},
                bufferDynamic: {offsetThreshold: "number", offsetStep: "number", cooldownTime: "number"}
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1313: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          CONFIG_RTMP: "Configuration error. Could not create player, the rtmp configuration is missing or incomplete. Add an rtmp url and streamname to the configuration.",
          CONFIG_TOKEN: "Configuration error. Could not create player, with this configuration an security token is required. Add an token to the configuration.",
          CONFIG_WSS: "Configuration error. Could not create player, the websocket server configuration is missing.",
          CONFIG_HLS: "Configuration error. Could not create player, the hls server configuration is missing.",
          CONFIG_METADATA: "Configuration error. Could not create player, the websocket server configuration for metadata is missing.",
          CONFIG_SOURCE: "The players source configuration is malformed or missing, please check documentation for more information or contact us."
        })
      }.apply(t, [])) || (e.exports = n)
    }, 3778: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          PLAYER: {
            NO_RTMP_URL_SET: 1001,
            NO_SERVER_SET: 1002,
            NOT_CONFIGURED: 1003,
            NOT_PLAYING: 1004,
            INTERACTION_REQUIRED: 1005,
            BUFFER_CONFIG_INVALID: 1006,
            PLAYBACK_SUSPENDED: 1007,
            PLAYBACK_ERROR: 1008,
            VISIBILITY_HIDDEN: 1009,
            INVALID_ENTRY_INDEX: 1010
          },
          STREAM: {
            NOT_FOUND: 2001,
            MEDIA_NOT_AVAILABLE: 2002,
            NOT_ENOUGH_DATA: 2003,
            SOURCE_STOPPED: 2004,
            SOURCE_NOT_RETRIEVED: 2005,
            METADATA_WRONG_INDEX: 2011,
            METADATA_INVALID_JSON: 2012,
            METADATA_NO_START_INDEX: 2013,
            METADATA_STILL_PROCESSING: 2014
          },
          MEDIA: {
            ABORTED: 3001,
            DOWNLOAD_ERROR: 3002,
            DECODE_ERROR: 3003,
            NOT_SUPPORTED: 3004,
            HLS_VIDEO_DECODE_ERROR: 3005,
            MEDIA_SOURCE_ENDED: 3100,
            HLS_BUFFER_UNDERRUN: 3101,
            HLS_MAX_RANGE: 3102,
            UNSPECIFIC_ERROR: 3200,
            DECODER_STARTUP_ERROR: 3201
          },
          NETWORK: {
            COULD_NOT_ESTABLISH_CONNECTION: 4001,
            CONNECTION_ERROR: 4002,
            MAX_RECONNECTS_REACHED: 4003,
            RECONNECTION_CONFIG_INVALID: 4004,
            SOURCE_STREAM_STOPPED: 4005,
            SOURCE_TIMEOUT: 4006,
            TRANSPORT_NOT_CONNECTED: 4201,
            PLAYBACK_ACCESS_REJECTED: 4401
          },
          SETUP: {
            EXCEPTION: 5001,
            CLIENT_NOT_SUPPORTED: 5002,
            FORCE_NOT_SUPPORTED: 5003,
            SOURCE_NOT_SUPPORTED: 5004,
            CONFIG_RTMP: 5005,
            CONFIG_TOKEN: 5006,
            CONFIG_WSS: 5007,
            CONFIG_HLS: 5008,
            CONFIG_METADATA: 5009,
            EMBED_PLAYER: 5010
          }
        })
      }.apply(t, [])) || (e.exports = n)
    }, 3890: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          PLAYER: {
            NO_RTMP_URL_SET: "No rtmp url set.",
            NO_SERVER_SET: "No server set.",
            NOT_CONFIGURED: "Could not play because player has not been configured.",
            PLAYBACK_ERROR: "Playback error.",
            VISIBILITY_HIDDEN: "Playback failed because the player was in visibility state 'hidden' at load start.",
            INVALID_ENTRY_INDEX: "The given stream entry index is not valid.",
            INTERACTION_REQUIRED: "Playback must be initialized by user gesture.",
            PLAYBACK_SUSPENDED: "Playback suspended by external reason."
          },
          STREAM: {
            NOT_FOUND: "The requested stream can not be found.",
            MEDIA_NOT_AVAILABLE: "No media available.",
            NOT_ENOUGH_DATA: "Not enough media data received.",
            SOURCE_STOPPED: "The source stream has been stopped.",
            SOURCE_NOT_RETRIEVED: "The source stream could not be retrieved",
            METADATA_WRONG_INDEX: "Received metadata with wrong index. Discard.",
            METADATA_INVALID_JSON: "Received metadata with invalid json string.",
            METADATA_NO_START_INDEX: "Received metadata but no start index. Discard.",
            METADATA_STILL_PROCESSING: "Received metadata with start index but currently process another. Discard old one."
          },
          MEDIA: {
            ABORTED: "A fetching process of the media aborted by user.",
            DOWNLOAD_ERROR: "An error occurred when downloading media.",
            DECODE_ERROR: "An error occurred when decoding media.",
            DECODER_STARTUP_ERROR: "An error occurred when starting the decoder.",
            NOT_SUPPORTED: "The received audio/video is not supported.",
            HLS_VIDEO_DECODE_ERROR: "An error occurred while hls playback when decoding video.",
            MEDIA_SOURCE_ENDED: "The media source extension changed the state to 'ended'.",
            HLS_BUFFER_UNDERRUN: "An error occurred while buffering on hls playback.",
            HLS_MAX_RANGE: "Buffer range is higher than allowed on hls playback."
          },
          NETWORK: {
            SOURCE_STREAM_STOPPED: "The requested source stream has been stopped.",
            SOURCE_TIMEOUT: "The source request was aborted by timeout.",
            PLAYBACK_ACCESS_REJECTED: "Playback access has been rejected"
          }
        })
      }.apply(t, [])) || (e.exports = n)
    }, 9583: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          READY: "Ready",
          ERROR: "Error",
          PAUSE: "Pause",
          LOADING: "Loading",
          START_BUFFERING: "StartBuffering",
          STOP_BUFFERING: "StopBuffering",
          PLAY: "Play",
          METADATA: "MetaData",
          STATS: "Stats",
          PLAYBACK_FINISHED: "PlaybackFinished",
          MEDIA: "Media",
          STREAM_INFO: "StreamInfo",
          STREAM_INFO_UPDATE: "StreamInfoUpdate",
          MUTE: "Mute",
          UNMUTE: "Unmute",
          VOLUME_CHANGE: "VolumeChange",
          STATE_CHANGE: "StateChange",
          WARNING: "Warning",
          DESTROY: "Destroy",
          UPDATE_SOURCE_INIT: "UpdateSourceInit",
          UPDATE_SOURCE_SUCCESS: "UpdateSourceSuccess",
          UPDATE_SOURCE_FAIL: "UpdateSourceFail",
          UPDATE_SOURCE_ABORT: "UpdateSourceAbort",
          SWITCH_STREAM_INIT: "SwitchStreamInit",
          SWITCH_STREAM_SUCCESS: "SwitchStreamSuccess",
          SWITCH_STREAM_FAIL: "SwitchStreamFail",
          SWITCH_STREAM_ABORT: "SwitchStreamAbort",
          SERVER_INFO: "ServerInfo",
          ACTIVE_VIDEO_ELEMENT_CHANGE: "ActiveVideoElementChange"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 182: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          FORCE_NOT_SUPPORTED: 'The forced tech "$tech$" is not supported by your browser.',
          SOURCE_NOT_SUPPORTED: "The players source configuration is malformed or missing, please check documentation for more information or contact us.",
          CLIENT_NOT_SUPPORTED: "This browser does not fully support HTML5 and H5Live.            Supported are: Chrome >=54 (Windows, MacOSX, Android), Firefox >=48 (Windows, MacOSX, Android), Microsoft Edge (Windows), Microsoft Internet Explorer 11 (at least Windows 8), Safari (MacOSX & at least iOS 10)."
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9474: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({CLASSIC: "classic", FAST_ADAPTIVE: "fastadaptive", BALANCED_ADAPTIVE: "balancedadaptive"})
      }.apply(t, [])) || (e.exports = n)
    }, 939: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          NO_TARGET: "No target in config",
          NO_LISTENERS: "No listeners in config",
          NOT_DISPATCHER: "Target is not an event dispatcher",
          MISSING_TYPE: "Missing type in listener #%index%",
          MISSING_LISTENER: "Missing/invalid listener in listener #%index%"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 8730: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          MP4: "video/mp4",
          MP4_MS: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
          HLS: "application/vnd.apple.mpegURL"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 8405: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({UNINITIALIZED: 1, CONNECTING: 2, OPEN: 3, CLOSING: 4, CLOSED: 5})
      }.apply(t, [])) || (e.exports = n)
    }, 5493: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          NORMAL: "normal",
          BUFFER: "buffer",
          CONNECTION_CLOSE: "connectionclose",
          SERVER_NOT_FOUND: "servernotfound",
          STREAM_NOT_FOUND: "streamnotfound",
          INTERACTION_REQUIRED: "interactionrequired",
          PLAYBACK_SUSPENDED: "playbacksuspended",
          PLAYBACK_ERROR: "playbackerror",
          RECONNECTION_IMMINENT: "reconnectionimminent",
          DESTROY: "destroy",
          VISIBILITY_HIDDEN: "visibilityhidden",
          NOT_ENOUGH_DATA: "notenoughdata",
          SOURCE_STREAM_STOPPED: "sourcestreamstopped",
          MEDIA_NOT_AVAILABLE: "medianotavailable"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 492: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          UNINITIALIZED: 1,
          IDLE: 2,
          READY: 3,
          LOADING: 4,
          PLAYING: 5,
          PAUSED: 6,
          BUFFERING: 7,
          UNKNOWN: 8,
          PLAYBACK_NOT_STARTED: 9,
          PLAYBACK_SUSPENDED: 10,
          PAUSING: 11,
          PLAYBACK_ERROR: 12,
          RECONNECTION_IMMINENT: 13,
          CONNECTION_ERROR: 14,
          DESTROYING: 15,
          MEDIA_NOT_AVAILABLE: 16,
          VISIBILITY_HIDDEN: 17,
          NOT_ENOUGH_DATA: 18,
          SOURCE_STREAM_STOPPED: 19
        })
      }.apply(t, [])) || (e.exports = n)
    }, 7605: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          HAVE_VIDEO: "haveVideo",
          HAVE_AUDIO: "haveAudio",
          VIDEO_INFO: "videoInfo",
          AUDIO_INFO: "audioInfo",
          PREROLL_DURATION: "prerollDuration",
          MIME_TYPE: "mimeType"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 3284: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({H5LIVE_WSS: "h5live", H5LIVE_HLS: "h5live.hls"})
      }.apply(t, [])) || (e.exports = n)
    }, 2682: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {CORE: "5.0.5"}
      }.apply(t, [])) || (e.exports = n)
    }, 728: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          1e3: "Normal closure, meaning that the purpose for which the connection was established has been fulfilled.",
          1001: 'An endpoint is "going away", such as a server going down or a browser having navigated away from a page.',
          1002: "An endpoint is terminating the connection due to a protocol error",
          1003: "An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).",
          1004: "Reserved. The specific meaning might be defined in the future.",
          1005: "No status code was actually present.",
          1006: "Maybe no network, wrong url or server down.",
          1007: "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).",
          1008: 'An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.',
          1009: "An endpoint is terminating the connection because it has received a message that is too big for it to process.",
          1011: "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.",
          1015: "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).",
          4005: "The requested source stream has been stopped.",
          4400: "Bad request. Maybe stream parameters are missing or malformed.",
          4403: "Access denied. The authentication token is missing or invalid.",
          4500: "The connection has been rejected due an internal server error.",
          4503: "The requested service is currently unavailable.",
          4900: "The security service has been rejected due an internal server error.",
          4901: "The security service denied access. The authentication token is invalid.",
          4903: "The security service denied access. The url is expired or a token parameter is missing (expires, token, or options).",
          4904: "The security service can not be found."
        })
      }.apply(t, [])) || (e.exports = n)
    }, 9374: function (e, t, n) {
      var r, i;
      r = [n(8197), n(908), n(4341)], void 0 === (i = function (e, t, n) {
        return {
          check: function (r) {
            var i, a;
            switch (r && r.source && r.source.defaults && r.source.defaults.service && (i = r.source.defaults.service), i) {
              case t.service:
                a = t.preset;
                break;
              case n.service:
                a = n.preset
            }
            if (a) {
              var o, s, d = r.source;
              if (!d || !d.h5live || d.entries && d.entries.length || (d.entries = [{h5live: e.copy(d.h5live)}]), d && d.entries && d.entries.length > 0) for (var u = 0; u < d.entries.length; u += 1) (o = d.entries[u].h5live) && c(o.security && "object" == typeof o.security && null !== o.security ? a.secure.source : a.unsecure.source, o)
            }

            function c(e, t) {
              if (t.server && "object" == typeof t.server && null !== t.server) for (s in e.h5live.server) t.server[s] && typeof t.server[s] == typeof e.h5live.server[s] && "" !== t.server[s] || (t.server[s] = e.h5live.server[s]); else t.server = e.h5live.server;
              t.rtmp && (!t.rtmp.url || "string" != typeof t.rtmp.url || t.rtmp.url.length < 1) && (t.rtmp.url = e.h5live.rtmp.url)
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 908: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          service: "bintu",
          preset: {
            unsecure: {
              source: {
                h5live: {
                  server: {
                    websocket: "wss://bintu-play.nanocosmos.de:443/h5live/stream/stream.mp4",
                    hls: "https://bintu-play.nanocosmos.de:443/h5live/http/playlist.m3u8",
                    progressive: "https://bintu-play.nanocosmos.de:443/h5live/http/stream.mp4",
                    webtransport: "https://bintu-play.nanocosmos.de:443/h5live/stream/stream.mp4"
                  }, rtmp: {url: "rtmp://localhost/play"}
                }
              }
            },
            secure: {
              source: {
                h5live: {
                  server: {
                    websocket: "wss://bintu-play.nanocosmos.de:443/h5live/authstream/stream.mp4",
                    hls: "https://bintu-play.nanocosmos.de:443/h5live/authhttp/playlist.m3u8",
                    progressive: "https://bintu-play.nanocosmos.de:443/h5live/authhttp/stream.mp4",
                    webtransport: "https://bintu-play.nanocosmos.de:443/h5live/authstream/stream.mp4"
                  }, rtmp: {url: "rtmp://localhost/splay"}
                }
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4341: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          service: "bintu-dev",
          preset: {
            unsecure: {
              source: {
                h5live: {
                  server: {
                    websocket: "wss://bintu-play-dev.nanocosmos.de:443/h5live/stream/stream.mp4",
                    hls: "https://bintu-play-dev.nanocosmos.de:443/h5live/http/playlist.m3u8",
                    progressive: "https://bintu-play-dev.nanocosmos.de:443/h5live/http/stream.mp4",
                    webtransport: "https://bintu-play-dev.nanocosmos.de:443/h5live/stream/stream.mp4"
                  }, rtmp: {url: "rtmp://localhost/play"}
                }
              }
            },
            secure: {
              source: {
                h5live: {
                  server: {
                    websocket: "wss://bintu-play-dev.nanocosmos.de:443/h5live/authstream/stream.mp4",
                    hls: "https://bintu-play-dev.nanocosmos.de:443/h5live/authhttp/playlist.m3u8",
                    progressive: "https://bintu-play-dev.nanocosmos.de:443/h5live/authhttp/stream.mp4",
                    webtransport: "https://bintu-play-dev.nanocosmos.de:443/h5live/authstream/stream.mp4"
                  }, rtmp: {url: "rtmp://localhost/splay"}
                }
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1490: function (e, t, n) {
      var r, i;
      r = [n(8197), n(9771)], void 0 === (i = function (e, t) {
        var n, r, i, a = [];
        return a.push(t), {
          apply: function (t) {
            if (n = t.source, r = n.general, !n.h5live || n.entries && n.entries.length || (n.entries = [{h5live: e.copy(n.h5live)}]), n && n.entries && n.entries.length > 0 && r && Object.keys(r).length) for (var o = 0; o < n.entries.length; o += 1) if (i = n.entries[o]) for (var s = 0; s < a.length; s += 1) a[s].apply(r, i)
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9771: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "serverDomain", t = ["websocket", "hls", "progressive", "webtransport"];

        function n(e, t) {
          var n, i, a, o, s;
          try {
            var d = e.split("://");
            if (d.length > 1) {
              n = d[0];
              var u = d[1].split("/");
              i = u[0], a = u.length > 1 ? "/" + u.slice(1).join("/") : "", o = r(i), s = t, o.port && (s = -1 !== t.indexOf(":") && t.indexOf(":") !== t.lastIndexOf(":") && "[" !== t.charAt(0) ? "[" + t + "]:" + o.port : t + ":" + o.port), e = n + "://" + s + a
            }
          } catch (e) {
          }
          return e
        }

        function r(e) {
          var t = e, n = "";
          if ("[" === e.charAt(0)) {
            var r = e.indexOf("]");
            -1 !== r && (t = e.substring(0, r + 1), ":" === e.charAt(r + 1) && (n = e.substring(r + 2)))
          } else {
            var i = e.lastIndexOf(":"), a = e.indexOf(":");
            -1 !== i && i === a && (t = e.substring(0, i), n = e.substring(i + 1))
          }
          return {host: t, port: n}
        }

        return {
          apply: function (i, a) {
            var o = function (t) {
              var n = !1;
              return t && "object" == typeof t && Object.keys(t).length && t[e] && "string" == typeof t[e] && t[e].length && (n = function (e) {
                var t = e;
                try {
                  var n = (t = t.replace(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//, "")).indexOf("/");
                  -1 !== n && (t = t.substring(0, n)), t = (t = r(t).host).trim()
                } catch (e) {
                }
                return t
              }(t[e])), n
            }(i);
            if (o) {
              if (a && a.h5live && a.h5live.server && "object" == typeof a.h5live.server) for (var s = 0; s < t.length; s += 1) {
                var d = t[s];
                Object.prototype.hasOwnProperty.call(a.h5live.server, d) && (a.h5live.server[d] = n(a.h5live.server[d], o))
              }
              a && a.hls && (a.hls = n(a.hls, o))
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2556: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              metrics: {
                accountId: void 0,
                accountKey: void 0,
                serverDomain: void 0,
                userId: "",
                eventId: "",
                statsInterval: 10,
                customField1: void 0,
                customField2: void 0,
                customField3: void 0,
                customField4: void 0,
                customField5: void 0,
                customField6: void 0,
                customField7: void 0,
                customField8: void 0,
                customField9: void 0,
                customField10: void 0
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7982: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              metrics: {
                accountId: "string",
                accountKey: "string",
                serverDomain: "string",
                userId: "string",
                eventId: "string",
                statsInterval: "number",
                customField1: "*",
                customField2: "*",
                customField3: "*",
                customField4: "*",
                customField5: "*",
                customField6: "*",
                customField7: "*",
                customField8: "*",
                customField9: "*",
                customField10: "*"
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9914: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          SETUP: {
            METRICS_NO_OBJECT: 5201,
            METRICS_NOT_OBJECT: 5202,
            METRICS_EMPTY_OBJECT: 5203,
            METRICS_INDEX_INVALID: 5204,
            METRICS_INDEX_INCORRECT: 5205,
            METRICS_INDEX_RANGE: 5206,
            METRICS_PROPERTY_INVALID: 5207,
            METRICS_NO_CREDENTIALS: 5208
          }
        })
      }.apply(t, [])) || (e.exports = n)
    }, 5999: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          METRICS_NO_OBJECT: "Metrics configuration error. No metrics config object passed.",
          METRICS_NOT_OBJECT: "Metrics configuration error. Metrics config is not from type 'object'.",
          METRICS_EMPTY_OBJECT: "Metrics configuration error. Metrics config is empty.",
          METRICS_INDEX_INVALID: "Metrics configuration error. The custom property '$key$' has no valid index number, the range is 1 to 10 e.g. 'customField1'.",
          METRICS_INDEX_INCORRECT: "Metrics configuration error. The custom property '$key$' is not indexed correctly, the range is 1 to 10 e.g. 'customField1'.",
          METRICS_INDEX_RANGE: "Metrics configuration error. The custom property '$key$' has an index out of range, the range is 1 to 10 e.g. 'customField1'.",
          METRICS_PROPERTY_INVALID: "Metrics configuration error. The property '$key$' is not valid.",
          METRICS_NO_CREDENTIALS: "Metrics configuration error. No credentials passed."
        })
      }.apply(t, [])) || (e.exports = n)
    }, 27: function (e, t, n) {
      var r, i;
      r = [n(7080)], void 0 === (i = function (e) {
        return {
          create: function () {
            var t, n = e.create(), r = "statsAdaptive", i = {}, a = {
              deviationOfMean: {
                buffer: {
                  delay: {
                    bufferDelaysArithmeticMeans: {calcArrayStats: !0},
                    bufferDelaysStandardDeviations: {calcArrayStats: !0}
                  }
                }
              },
              deviationOfMean2: {
                buffer: {
                  delay: {
                    bufferDelaysArithmeticMeans: {calcArrayStats: !0},
                    bufferDelaysStandardDeviations: {calcArrayStats: !0}
                  }
                }
              }
            };

            function o(e) {
              if (Array.isArray(e) && e.length) {
                for (var t, n = e.length, r = e[0], i = e[0], a = e[0], o = 1; o < n; o++) e[o] < r && (r = e[o]), e[o] > i && (i = e[o]), a += e[o];
                return t = a / n, {
                  min: isNaN(r) ? r : r.toFixed(3),
                  max: isNaN(i) ? i : i.toFixed(3),
                  avg: isNaN(t) ? t : t.toFixed(3),
                  count: n
                }
              }
              return {}
            }

            function s(e, t) {
              for (var n in t) {
                if (!e[n]) return;
                Object.prototype.hasOwnProperty.call(t[n], "calcArrayStats") ? i[n] = t[n].calcArrayStats ? o(e[n]) : e[n] : s(e[n], t[n])
              }
            }

            return {
              setStats: function (e) {
                e && e.data && e.data.stats && e.data.stats.adaptive && (t = e.data.stats.adaptive)
              }, getStatsFlat: function () {
                var e = t && Object.keys(t).length ? Object.keys(t)[0] : "";
                return Object.prototype.hasOwnProperty.call(a, e) ? (s(t[e], a[e]), n.get(i, r, 5)) : n.get(t, r, 5)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3932: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            var e = 0, t = 0, n = [], r = {
              buffering_duration_current: 0,
              buffering_duration_average: 0,
              buffering_duration_total: 0,
              buffering_count: 0
            };
            return {
              start: function () {
                e = performance.now()
              }, end: function () {
                t = performance.now()
              }, measure: function (i, a) {
                if (e && t && t > e) {
                  var o = Math.round(Math.abs(t - e)) / 1e3;
                  if (t = e = 0, o >= 1 && o <= a.time_elapsed) {
                    for (var s in n.push(o), r.buffering_duration_current = o, r.buffering_duration_total += o, r.buffering_count += 1, r.buffering_duration_average = Math.round(r.buffering_duration_total / r.buffering_count * 1e3) / 1e3, r) !/buffering_count/.test(s) && r[s];
                    return r
                  }
                }
                return !1
              }, reset: function (i, a) {
                if (i && a) {
                  for (t = e = 0; n.length;) n.pop();
                  var o = {};
                  for (var s in r) !/buffering_duration_current/.test(s) && (o[s] = r[s]), r[s] = 0;
                  return o.time_played_total = a.time_played, o.time_elapsed_total = a.time_elapsed, o.time_buffering_total = o.buffering_duration_total, o
                }
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4815: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              measure: function (e) {
                return function (e, t, n, r) {
                  t = t || "_";
                  var i = {};
                  return function e(n, r) {
                    for (var a in n) {
                      var o = r + (r ? t : "") + a.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(), s = o.split(t);
                      o = (s = s.map((function (e) {
                        return e.substring(0, 10)
                      }))).join(t);
                      var d = n[a];
                      "object" == typeof d && null !== d ? e(d, o) : i[o] = d
                    }
                  }(e, n = n || ""), i
                }(e.data, "_", "error")
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4245: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              measure: function (e) {
                return {pause_reason: e.data.reason}
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2247: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            var e = 0, t = 0, n = 0;

            function r() {
              e = performance.now()
            }

            function i() {
              t = performance.now(), n += Math.abs(t - e), e = 0, t = 0
            }

            return {
              measure: function (e) {
                r();
                var t, n = {
                  connecting: 0,
                  connected: 0,
                  firstFragmentReceived: 0,
                  firstFrameRendered: 0,
                  playable: 0,
                  playing: 0
                };
                try {
                  if (e.data && e.data.stats && "object" == typeof e.data.stats) {
                    var i = e.data.stats;
                    for (t in n) Object.prototype.hasOwnProperty.call(i, t) && "number" == typeof i[t] && (n[t] = i[t])
                  }
                } catch (e) {
                }
                var a = {};
                return [{
                  start: "connecting",
                  end: "connecting",
                  measurement: "play_connecting",
                  value: 0
                }, {
                  start: "connecting",
                  end: "connected",
                  measurement: "play_connected",
                  value: 0
                }, {
                  start: "connected",
                  end: "firstFragmentReceived",
                  measurement: "play_first_fragment_received",
                  value: 0
                }, {
                  start: "firstFragmentReceived",
                  end: "firstFrameRendered",
                  measurement: "play_first_frame_rendered",
                  value: 0
                }, {
                  start: "firstFrameRendered",
                  end: "playable",
                  measurement: "play_playable",
                  value: 0
                }, {start: "playable", end: "playing", measurement: "play_playing", value: 0}].forEach((function (e) {
                  var t = n[e.start], r = n[e.end];
                  r - t >= 0 && (e.value = Math.floor(r - t)), a[e.measurement + "_relative"] = e.value, a[e.measurement + "_absolute"] = n[e.end]
                })), a.play_start_time_total = a.play_playing_absolute, a.play_faststart = e.data.faststart, a.play_preroll_duration = e.data.prerollDuration, a
              }, setTimePlayingStateStart: r, setTimePlayingStateEnd: i, getTimePlayingStateTotal: function () {
                return e && !t && i(), Math.round(n / 1e3 * 100) / 100
              }, resetTimePlayingStateSubtotal: function () {
                n = 0
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7666: function (e, t, n) {
      var r, i;
      r = [n(7080)], void 0 === (i = function (e) {
        return {
          create: function () {
            var t = e.create();
            return {
              measure: function (e) {
                return t.get(e.data, "ready", 10, !0)
              }, flattenCodecs: function (e) {
                var t = {};
                for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) if ("video" === n || "audio" === n) for (var r = "video" === n ? "vc_" : "ac_", i = Array.isArray(e[n].codecs) ? e[n].codecs : [], a = 0; a < i.length; a++) {
                  var o = i[a];
                  if (o && "string" == typeof o.codec) {
                    var s = "ready_bi_" + r + o.codec.replace(/[.]/g, "_");
                    t[s] = o.supported, "video" === n && o.supported ? t[s + "_max"] = o.maxResolution || "N/A" : "audio" === n && o.supported && (t[s + "_max"] = o.maxConfig || "N/A")
                  }
                } else "codecs_time" === n && (t.ready_bi_codecs_time = e[n].execution);
                return t.ready_bi_moq_supported = void 0 !== e.moq_supported && e.moq_supported, t.ready_bi_webcodecs_vc = void 0 !== e.webcodecs_vc && e.webcodecs_vc, t.ready_bi_webcodecs_ac = void 0 !== e.webcodecs_ac && e.webcodecs_ac, t
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2381: function (e, t, n) {
      var r, i;
      r = [n(7080)], void 0 === (i = function (e) {
        return {
          create: function () {
            var t = e.create(), n = {};
            return {
              measure: function (e) {
                return {
                  server_info_server_application_name: (n = e.data.serverInfo).serverApplicationName,
                  server_info_server_application_version: n.serverApplicationVersion,
                  server_info_hostname: n.hostname
                }
              }, getFlat: function () {
                return t.get(n, "serverInfo", 5)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1025: function (e, t, n) {
      var r, i;
      r = [n(7080), n(8197)], void 0 === (i = function (e, t) {
        return {
          create: function () {
            var n = e.create(), r = {
              SwitchStreamInit: {removeKeys: ["source"]},
              SwitchStreamSuccess: {removeKeys: ["source"], evaluateSwitch: !0},
              SwitchStreamAbort: {removeKeys: ["source"]},
              SwitchStreamFail: {removeKeys: ["source"]},
              UpdateSourceInit: {removeKeys: ["source"]},
              UpdateSourcAbort: {removeKeys: ["source"]},
              UpdateSourceFail: {removeKeys: ["source"]}
            }, i = {up: 0, down: 0, direct: 0, recover: 0};
            return {
              handleEvent: function (e) {
                var a, o;
                return !!function (e) {
                  return e && e.data && e.name
                }(e) && (a = e.name, o = t.copy(e.data), Object.prototype.hasOwnProperty.call(r, a) && Object.prototype.hasOwnProperty.call(r[a], "removeKeys") && r[a].removeKeys.length && function (e, t) {
                  for (var n = 0; n < t.length; n++) Object.prototype.hasOwnProperty.call(e, t[n]) && delete e[t[n]]
                }(o, r[a].removeKeys), Object.prototype.hasOwnProperty.call(r, a) && Object.prototype.hasOwnProperty.call(r[a], "evaluateSwitch") && r[a].evaluateSwitch && function (e) {
                  e && e.type && Object.keys(i).includes(e.type) && (i[e.type] += 1)
                }(o), n.get(o, "e", 5, !0))
              }, getSwitchCountFlat: function () {
                var e = 0, t = {};
                return Object.keys(i).forEach((function (n) {
                  e += i[n], t[n] = i[n]
                })), t.total = e, n.get(t, "switches", 2, !0)
              }, resetSwitchCount: function () {
                Object.keys(i).forEach((function (e) {
                  i[e] = 0
                }))
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9555: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function (e) {
            var t = 10;
            e && !isNaN(e) && (e = parseInt(e, 10)) >= 5 && (t = e);
            var n = 10 * t, r = 0, i = [], a = [], o = [], s = [], d = 0, u = {
              stats_buffer_average: 0,
              stats_buffer_min: 0,
              stats_buffer_max: 0,
              stats_bitrate_average: 0,
              stats_bitrate_min: 0,
              stats_bitrate_max: 0,
              stats_frame_rate_average: 0,
              stats_frame_rate_min: 0,
              stats_frame_rate_max: 0,
              stats_playback_rate_average: 0,
              stats_playback_rate_min: 0,
              stats_playback_rate_max: 0,
              stats_playback_rate_frequency: 0,
              stats_buffergoal_real: 0,
              stats_buffergoal_base: 0,
              stats_buffergoal_min: 0,
              stats_buffergoal_max: 0,
              stats_quality_dropped_video_frames: 0,
              stats_quality_dropped_video_frames_current: 0,
              stats_quality_dropped_video_frames_ratio: 0,
              stats_quality_dropped_video_frames_level_max: 0,
              stats_quality_corrupted_video_frames: 0,
              stats_quality_corrupted_video_frames_current: 0,
              stats_quality_creation_time: 0,
              stats_quality_total_video_frames: 0,
              stats_measure_count: 0,
              stats_measure_samples: n,
              stats_buffer_duration_delta: 0
            };
            return {
              measure: function (e) {
                var t = {
                  currentTime: 0,
                  playout: {start: 0, end: 0},
                  buffer: {
                    start: 0,
                    end: 0,
                    delay: {before: 0, current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                    update: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                    durationDelta: 0
                  },
                  buffergoal: {real: 0, base: 0, min: 0, max: 0},
                  quality: {
                    droppedVideoFrames: 0,
                    droppedVideoFramesCurrent: 0,
                    droppedVideoFramesLevel: 0,
                    corruptedVideoFrames: 0,
                    corruptedVideoFramesCurrent: 0,
                    creationTime: 0,
                    totalVideoFrames: 0
                  },
                  bitrate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                  framerate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                  playbackrate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0}
                };
                e.data.stats && "object" == typeof e.data.stats && (t = e.data.stats);
                try {
                  for (r += 1, i.push(t.buffer.delay.current), a.push(t.bitrate.current), o.push(t.framerate.current), s.push(t.playbackrate.current); i.length > n;) i.shift();
                  for (; a.length > n;) a.shift();
                  for (; o.length > n;) o.shift();
                  for (; s.length > n;) s.shift();
                  if (d = Math.max(d, t.quality.droppedVideoFramesLevel), r % n == 0) {
                    var c = JSON.parse(JSON.stringify(i)).sort((function (e, t) {
                      return e - t
                    }), 0);
                    u.stats_buffer_average = Math.round(c.reduce((function (e, t) {
                      return e + t
                    }), 0) / c.length * 1e3) / 1e3, u.stats_buffer_min = Math.round(1e3 * c[0]) / 1e3, u.stats_buffer_max = Math.round(1e3 * c[c.length - 1]) / 1e3, u.stats_buffer_duration_delta = t.buffer.durationDelta;
                    var l = JSON.parse(JSON.stringify(a)).sort((function (e, t) {
                      return e - t
                    }), 0);
                    u.stats_bitrate_average = Math.round(l.reduce((function (e, t) {
                      return e + t
                    }), 0) / l.length / 1e3), u.stats_bitrate_min = Math.round(l[0] / 1e3), u.stats_bitrate_max = Math.round(l[c.length - 1] / 1e3);
                    var f = JSON.parse(JSON.stringify(o)).sort((function (e, t) {
                      return e - t
                    }), 0);
                    u.stats_frame_rate_average = Math.round(f.reduce((function (e, t) {
                      return e + t
                    }), 0) / f.length * 1e3) / 1e3, u.stats_frame_rate_min = f[0], u.stats_frame_rate_max = f[f.length - 1];
                    var E = JSON.parse(JSON.stringify(s)).sort((function (e, t) {
                      return e - t
                    }), 0), p = s.map((function (e, t, n) {
                      return t ? e - n[t - 1] : 0
                    })).filter((function (e) {
                      return 0 !== e
                    }));
                    u.stats_playback_rate_average = Math.round(E.reduce((function (e, t) {
                      return e + t
                    }), 0) / E.length * 1e3) / 1e3, u.stats_playback_rate_min = E[0], u.stats_playback_rate_max = E[E.length - 1], u.stats_playback_rate_frequency = Math.round(10 * p.length / n * 1e3) / 1e3, u.stats_buffergoal_real = t.buffergoal.real, u.stats_buffergoal_base = t.buffergoal.base, u.stats_buffergoal_min = t.buffergoal.min, u.stats_buffergoal_max = t.buffergoal.max, u.stats_measure_count += 1;
                    var m = Math.round((t.quality.droppedVideoFrames - u.stats_quality_dropped_video_frames) / (t.quality.totalVideoFrames - u.stats_quality_total_video_frames) * 100) / 100;
                    return u.stats_quality_dropped_video_frames = t.quality.droppedVideoFrames, u.stats_quality_dropped_video_frames_current = t.quality.droppedVideoFramesCurrent, u.stats_quality_dropped_video_frames_ratio = m, u.stats_quality_dropped_video_frames_level_max = d, u.stats_quality_corrupted_video_frames = t.quality.corruptedVideoFrames, u.stats_quality_corrupted_video_frames_current = t.quality.corruptedVideoFramesCurrent, u.stats_quality_creation_time = t.quality.creationTime, u.stats_quality_total_video_frames = t.quality.totalVideoFrames, d = 0, u
                  }
                  return !1
                } catch (e) {
                  return !1
                }
              }, reset: function () {
                for (r = 0; i.length;) i.shift();
                for (; a.length;) a.shift();
                for (; o.length;) o.shift();
                for (; s.length;) s.shift();
                for (var e in u) "stats_measure_samples" !== e && (u[e] = 0)
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4402: function (e, t, n) {
      var r, i;
      r = [n(7080)], void 0 === (i = function (e) {
        return {
          create: function () {
            var t = e.create(), n = {};
            return {
              measure: function (e) {
                return {
                  stream_info_has_audio: (n = e.data.streamInfo).haveAudio,
                  stream_info_has_video: n.haveVideo,
                  stream_info_preroll_duration: n.prerollDuration ? n.prerollDuration : 0,
                  stream_info_width: n.videoInfo ? n.videoInfo.width : 0,
                  stream_info_height: n.videoInfo ? n.videoInfo.height : 0,
                  stream_info_frame_rate: n.videoInfo ? n.videoInfo.frameRate : 0,
                  stream_info_sample_rate: n.audioInfo ? n.audioInfo.sampleRate : 0,
                  stream_info_channels: n.audioInfo ? n.audioInfo.channels : 0,
                  stream_info_bits_per_sample: n.audioInfo ? n.audioInfo.bitsPerSample : 0,
                  connection_id: n.url.split("&cid=")[1].split("&pid=")[0]
                }
              }, getFlat: function () {
                return t.get(n, "streamInfo", 5)
              }, reset: function () {
                n = {}
              }, getStreamname: function () {
                return void ((e = n) && Object.prototype.hasOwnProperty.call(e, "rtmp") && Object.prototype.hasOwnProperty.call(e.rtmp, "streamname")) ? n.rtmp.streamname : "";
                var e
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6545: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              measure: function (e) {
                return {warning_message: e.data.message}
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2215: function (e, t, n) {
      var r, i;
      r = [n(1933), n(8818), n(8478), n(8333), n(8197), n(6627), n(9583), n(9914), n(5999), n(2556), n(7982), n(2788), n(4402), n(2381), n(2247), n(9555), n(3932), n(4245), n(4815), n(7666), n(1025), n(27), n(6545)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b, _, h, T, A, S) {
        function y() {
          var c, y, R, v, O, I, C, N, D, w, U, P, M, L, F, x, k, B = u.create().metrics, H = {},
            G = r.create("NanoMetrics"), V = e, W = t, Y = n, j = {}, K = {}, q = {}, z = {}, Q = 0, J = "classic",
            X = 0, $ = 0, Z = 0, ee = a, te = 1, ne = 0, re = ["glog1.nanocosmos.de"];

          function ie(e) {
            try {
              var t = function (e) {
                var t = z && z.source && z.source.entries && z.source.entries[Q] && z.source.entries[Q].h5live ? z.source.entries[Q].h5live : {},
                  n = t.server || {websocket: "", hls: "", progressive: ""}, r = t.rtmp && t.rtmp.url ? t.rtmp.url : "",
                  i = function (e) {
                    var t = e.split(/\?(.+)/);
                    return 1 === t.length ? t.push("") : t.pop(), t
                  }(t.rtmp && t.rtmp.streamname ? t.rtmp.streamname : ""), a = i[0], o = i[1], s = function (e, t, n) {
                    var r, i, a = "";
                    return e && t && (-1 !== e.indexOf("bintu") || n && n.websocket && n.websocket.length && -1 !== n.websocket.indexOf("bintu") && -1 !== e.indexOf("localhost")) && (i = /^[A-Za-z0-9 ]+$/, (r = t.split("-")[0]).length > 4 && r.length <= 6 && i.test(r)) && (a = t.split("-")[0]), a
                  }(r, a, n), d = void 0 !== K.hostname ? K.hostname : "";
                void 0 === (L = document.visibilityState) && (L = "unknown"), L = L;
                var u = (F = ee.isIOSDesktopMode) ? "iOS" : V.os;
                x = function () {
                  if (!F || !V.browserVersion) return V.osVersion;
                  var e = V.browserVersion.split("."), t = !0;
                  if (!(e.length <= 2)) return "unknown";
                  for (var n = 0; n < e.length; n++) if (e[n].length < 1 || e[n].length > 2) {
                    t = !1;
                    break
                  }
                  return t ? V.browserVersion : void 0
                }();
                var c = {
                  application_name: "h5live-player",
                  application_user_id: "" + B.userId,
                  application_event_id: "" + B.eventId,
                  application_account_id: "" + B.accountId,
                  application_account_key: "" + B.accountKey,
                  message: e.name.replace(/\b\w/g, (function (e) {
                    return e.toLowerCase()
                  })).replace(/([A-Z])/g, "_$1").toUpperCase(),
                  severity: "info",
                  client_ip: "",
                  timestamp_client: (new Date).toISOString(),
                  referrer: document.location.href,
                  os: u,
                  os_version: x,
                  browser: V.browser,
                  browser_version: V.browserVersion,
                  player_id: y.id,
                  player_type: y.type,
                  player_mediaplaybackapi: y.mediaplaybackapi,
                  player_version: y.version,
                  player_event_name: e.name.replace(/\b\w/g, (function (e) {
                    return e.toLowerCase()
                  })).replace(/([A-Z])/g, "_$1").toUpperCase(),
                  server_domain: n.websocket && n.websocket.length ? n.websocket.split("//")[1].split("/")[0] : "",
                  server_hostname: d,
                  rtmp_url: r,
                  rtmp_streamname: a,
                  rtmp_streamparameter: o,
                  connection_id: j && j.url && j.url.length ? j.url.split("&cid=")[1].split("&pid=")[0] : "",
                  time_played: q.currentTime ? Math.round(1e3 * q.currentTime) / 1e3 : 0,
                  time_elapsed: X > 0 ? Math.round(performance.now() - X) / 1e3 : 0,
                  bintu_orga_hash: s,
                  latency_control_mode: J,
                  visibility: L,
                  player_event_count: te
                };
                for (var l in H) Object.prototype.hasOwnProperty.call(H, l) && (c[l] = "" + H[l]);
                return c
              }(e);
              switch (e.name) {
                case o.READY:
                  J = e.data.config.latencyControlMode, t.latency_control_mode = J, e.data.config.playback.latencyControlMode = z.playback && z.playback.latencyControlMode ? z.playback.latencyControlMode : J, ae(w, "measure", e, t) && (Ee(!1) && de(t, {bintu_response_time: k.responseTime}), de(t, w.flattenCodecs(W.getCodecSupport(), "")), de(t, {ready_bi_webtransport: V.hasWebTransport}), oe(t));
                  break;
                case o.LOADING:
                  C.reset(), I.reset(), oe(t);
                  break;
                case o.STREAM_INFO:
                case o.STREAM_INFO_UPDATE:
                  j = e.data.streamInfo, ae(R, "measure", e, t), oe(t);
                  break;
                case o.PLAY:
                  X = performance.now(), ae(O, "measure", e, t), Ee(!1) && de(t, {bintu_response_time: k.responseTime}), oe(t), U.resetSwitchCount();
                  break;
                case o.STATS:
                  q = e.data.stats;
                  var n = Object.prototype.hasOwnProperty.call(q, "adaptive");
                  n && P.setStats(e, t), ae(I, "measure", e, t) && (n && de(t, P.getStatsFlat()), oe(t));
                  break;
                case o.START_BUFFERING:
                  O.setTimePlayingStateEnd(), C.start();
                  break;
                case o.STOP_BUFFERING:
                  C.end(), O.setTimePlayingStateStart(), ae(C, "measure", e, t) && (t.message = t.player_event_name = "BUFFERING", oe(t));
                  break;
                case o.PAUSE:
                  $ = t.time_elapsed, Z += $, O.setTimePlayingStateEnd();
                  var r = O.getTimePlayingStateTotal();
                  ae(N, "measure", e, t), ae(C, "reset", e, t), de(t, R.getFlat()), de(t, {
                    time_playing_state_total: r,
                    time_elapsed_total_sum: Z,
                    entries_length: z && Object.prototype.hasOwnProperty.call(z, "source") && Object.prototype.hasOwnProperty.call(z.source, "entries") ? z.source.entries.length : 1
                  }), de(t, U.getSwitchCountFlat()), oe(t), j = {}, q = {}, O.resetTimePlayingStateSubtotal(), U.resetSwitchCount(), Z = 0, X = 0;
                  break;
                case o.ERROR:
                  ae(D, "measure", e, t);
                  var i = Ee(!0);
                  if (i) switch (e.data.code) {
                    case 5101:
                    case 5102:
                    case 5103:
                      de(t, {
                        bintu_response_time: i.responseTime,
                        bintu_api_url: i.apiUrl,
                        bintu_is_group: i.isGroup,
                        bintu_id: i.id,
                        bintu_status: i.status
                      });
                      break;
                    default:
                      de(t, {bintu_response_time: k.responseTime})
                  }
                  oe(t);
                  break;
                case o.DESTROY:
                  oe(t);
                  break;
                case o.METADATA:
                case o.PLAYBACK_FINISHED:
                case o.MEDIA:
                case o.MUTE:
                case o.UNMUTE:
                case o.VOLUME_CHANGE:
                case o.STATE_CHANGE:
                  break;
                case o.WARNING:
                  ae(M, "measure", e, t), oe(t);
                  break;
                case o.SWITCH_STREAM_INIT:
                  ae(U, "handleEvent", e, t) && (de(t, P.getStatsFlat()), oe(t));
                  break;
                case o.SWITCH_STREAM_SUCCESS:
                  ce(e, "entry") && ue(e.data.entry.index), $ = t.time_elapsed, Z += $, X = performance.now(), ae(U, "handleEvent", e, t) && (de(t, R.getFlat()), de(t, {
                    time_elapsed_total: $,
                    time_elapsed_total_sum: Z
                  }), oe(t), R.reset());
                  break;
                case o.SWITCH_STREAM_FAIL:
                case o.SWITCH_STREAM_ABORT:
                case o.UPDATE_SOURCE_INIT:
                  ae(U, "handleEvent", e, t) && oe(t);
                  break;
                case o.UPDATE_SOURCE_SUCCESS:
                  ce(e, "source") && ((a = e.data.source) && (z.source = a), ue(e.data.source.startIndex)), $ = t.time_elapsed, Z += $, X = performance.now(), ae(U, "handleEvent", e, t) && (de(t, R.getFlat()), de(t, {
                    time_elapsed_total: $,
                    time_elapsed_total_sum: Z
                  }), oe(t), R.reset());
                  break;
                case o.UPDATE_SOURCE_FAIL:
                case o.UPDATE_SOURCE_ABORT:
                  ae(U, "handleEvent", e, t) && oe(t);
                  break;
                case o.SERVER_INFO:
                  K = e.data.serverInfo, ae(v, "measure", e, t) && (t.server_hostname = void 0 !== K.hostname ? K.hostname : "", oe(t))
              }
            } catch (e) {
              G.debugEnabled() && G.debug("metrics event error: " + (e.message ? e.message : "exception"))
            }
            var a
          }

          function ae(e, t, n, r) {
            var i = e[t](n, r);
            if (i) {
              for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
              return !0
            }
            return !1
          }

          function oe(e) {
            G.debugEnabled() && G.debug("send " + e.player_event_name), c.send(e.player_event_name, e), 1e5 === te ? (te = 1, G.debugEnabled() && G.debug("playerEventCount reached 100000, reset to 1")) : te += 1
          }

          function se() {
            if ("object" == typeof y && "function" == typeof y.off) for (var e in o) Object.prototype.hasOwnProperty.call(o, e) && y.off(o[e], ie);
            c && (c.destroy(), c = null), R = null, O = null, I = null, C = null, N = null, D = null, w = null, U = null, P = null, M = null
          }

          function de(e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(e, n) || (e[n] = t[n])
          }

          function ue(e) {
            Q = isNaN(e) ? 0 : e
          }

          function ce(e, t) {
            var n = e && Object.prototype.hasOwnProperty.call(e, "data");
            return t ? n && Object.prototype.hasOwnProperty.call(e.data, t) : n
          }

          function le(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
          }

          function fe(e, t) {
            if ("string" === t) return function (e) {
              return "string" != typeof e || "" === e.trim() ? "unknown" : e.trim()
            }(e);
            if ("boolean" === t) return Boolean(e);
            if ("number" === t) {
              var n = Number(e);
              return isNaN(n) ? 0 : n
            }
            return e
          }

          function Ee(e) {
            var t = function (e) {
              if ("object" != typeof k || null === k) return !1;
              var t = {apiUrl: "string", id: "string", isGroup: "boolean", responseTime: "number", status: "string"};
              if ("number" == typeof k.status && (k.status = k.status.toString()), e) {
                for (var n in t) if (le(t, n) && (k[n] = fe(k[n], t[n]), !le(k, n))) return !1;
                return k
              }
              if (le(k, "responseTime")) {
                var r = k.responseTime;
                if ("string" == typeof r && (r = Number(r)), "number" == typeof r && !isNaN(r)) return k.responseTime = r, k
              }
              return !1
            }(e);
            return !!(t && t.responseTime > 0) && t
          }

          return {
            setup: function (e, t, n) {
              var r;
              G.debugEnabled() && G.debug("setup"), y = t, z = i.copy(e), se(), k = n, !z.source.h5live || z.source.entries && z.source.entries.length || (z.source.entries = [{h5live: i.copy(z.source.h5live)}], delete z.source.h5live);
              var a = z.metrics;
              if (!a) throw new Y(d.METRICS_NO_OBJECT, s.SETUP.METRICS_NO_OBJECT);
              if ("object" != typeof a) throw new Y(d.METRICS_NOT_OBJECT, s.SETUP.METRICS_NOT_OBJECT);
              if (!Object.getOwnPropertyNames(a).length) throw new Y(d.METRICS_EMPTY_OBJECT, s.SETUP.METRICS_EMPTY_OBJECT);
              for (r in a) if (!Object.prototype.hasOwnProperty.call(a, r) || !Object.prototype.hasOwnProperty.call(B, r) || (B[r] = a[r], 0 === r.indexOf("customField"))) {
                var u, L = r.split("customField");
                if (!(L.length > 1 && 0 === L[0].length)) throw new Y(d.METRICS_PROPERTY_INVALID.replace("$key$", r), s.SETUP.METRICS_PROPERTY_INVALID);
                if (u = parseInt(L[1], 10), isNaN(u)) throw new Y(d.METRICS_INDEX_INVALID.replace("$key$", r), s.SETUP.METRICS_INDEX_INVALID);
                if (u.toString() !== L[1]) throw new Y(d.METRICS_INDEX_INCORRECT.replace("$key$", r), s.SETUP.METRICS_INDEX_INCORRECT);
                if (u < 1 || u > 10) throw new Y(d.METRICS_INDEX_RANGE.replace("$key$", r), s.SETUP.METRICS_INDEX_RANGE);
                H["application_custom_field_" + L[1]] = a[r]
              }
              if (!B.accountId || !B.accountKey) throw new Y(d.METRICS_NO_CREDENTIALS, s.SETUP.METRICS_NO_CREDENTIALS);
              for (r in a.serverDomain && a.serverDomain.length > 0 ? B.serverDomain = a.serverDomain : B.serverDomain = re[0], a) G.debugEnabled() && G.debug("metrics config[" + r + "]: " + JSON.stringify(a[r]));
              for (var F in R = f.create(), v = E.create(), O = p.create(), I = m.create(B.statsInterval), C = g.create(), N = b.create(), D = _.create(), w = h.create(), U = T.create(), P = A.create(), M = S.create(), c = l.create({
                accountId: B.accountId,
                accountKey: B.accountKey,
                serverDomain: B.serverDomain
              }), o) Object.prototype.hasOwnProperty.call(o, F) && (y.off(o[F], ie), y.on(o[F], ie));
              z.source && z.source.entries && z.source.entries.length > 0 && (ne = z.source.entries.length - 1), Q = z.source && !isNaN(z.source.startIndex) && z.source.entries && z.source.startIndex >= 0 && z.source.startIndex < z.source.entries.length ? z.source.startIndex : ne
            }, destroy: se
          }
        }

        return y.emptyConfig = u, y.validConfig = c, y
      }.apply(t, r)) || (e.exports = i)
    }, 2788: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        return {
          create: function (t) {
            var n = {accountId: void 0, accountKey: void 0, serverDomain: void 0};
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && t && Object.prototype.hasOwnProperty.call(t, r) && void 0 !== t[r] && (n[r] = t[r]);
            var i = 0, a = {}, o = "https://" + n.serverDomain + "/gelf/" + n.accountKey, s = e.create("MetricsLogger"),
              d = !0;

            function u(e, t, n) {
              void 0 !== a[e] && (s.detailEnabled() && s.detail("#" + e + " " + t + " " + n + " " + a[e].status), delete a[e])
            }

            return window.addEventListener("unload", (function () {
              d = !1
            })), {
              send: function (e, t) {
                try {
                  i += 1;
                  var n = new XMLHttpRequest;
                  a[i] = n;
                  var r = a[i];
                  if (r.open("POST", o, d), r.onreadystatechange = function (e, t) {
                    if (this && 4 === this.readyState) {
                      var n = this.status >= 400 ? "fail" : this.status >= 200 ? "success" : "unknown";
                      u.call(null, e, t, n)
                    }
                  }.bind(r, i, e), ["abort", "error", "timeout"].forEach((function (t) {
                    r.addEventListener(t, u.bind(null, i, e, t))
                  })), void 0 !== t) {
                    if ("string" == typeof t) try {
                      t = JSON.parse(t)
                    } catch (e) {
                      t = null
                    }
                    if ("object" == typeof t) try {
                      t = JSON.stringify(t), s.detailEnabled() && s.detail("#" + i + " " + e + " send " + t), setTimeout(u.bind(null, i, e, "suspend"), 5e3), r.send(t)
                    } catch (e) {
                      u.call(null, i, "catch " + e.message)
                    }
                  } else r.send()
                } catch (e) {
                  u.call(null, i, "catch " + e.message)
                }
              }, destroy: function () {
                for (var e in a) Object.prototype.hasOwnProperty.call(a, e) && delete a[e]
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7080: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            var e, t, n = {}, r = {source: "src", options: "opt", config: "cfg", playback: "pb", entries: "entr"};

            function i(t, r) {
              var a;
              for (var s in t) a = o(s, r), e && Array.isArray(t[s]) ? i(t[s].slice(Math.max(t[s].length - e, 0)), a) : "object" == typeof t[s] ? i(t[s], a) : n[a] = t[s];
              return n
            }

            function a(e) {
              return isNaN(e) && e === e.toUpperCase()
            }

            function o(e, n) {
              var i, o = n + "_";
              t && Object.prototype.hasOwnProperty.call(r, e) && (e = r[e]);
              for (var s = 0; s < e.length; s++) a(i = e.charAt(s)) && (o += "_"), o += i.toLowerCase();
              return o
            }

            function s() {
              n = {}
            }

            return {
              get: function (n, r, a, o) {
                return s(), n && "object" == typeof n ? (r = r ? r.toLowerCase() : "", e = a, t = o, i(n, r)) : {}
              }, reset: s
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8209: function (e, t, n) {
      var r, i;
      r = [n(1969), n(8544), n(6965), n(5810), n(1493), n(828), n(9583), n(492), n(5493), n(2682), n(3778), n(8333), n(6028), n(6725), n(2874)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p) {
        "use strict";
        var m = l.create("NanoCore");

        function g(t) {
          E.validatePlayerDivId(t), this.version = u.CORE, this.type = "default", this.mediaplaybackapi = "default", this.id = Math.round(1e11 * Math.random()).toString(), this._playerDivId = t, this._dummyPlayer = new e(this._playerDivId), this._realPlayer = this._dummyPlayer
        }

        m.debugEnabled() && m.debug("NanoCore api version: " + u.CORE);
        var b = g.prototype = Object.create(e.prototype);
        return b.setup = function (e) {
          return new p(function (n, r) {
            var i = e && e.events && e.events.onError ? e.events.onError : null, a = function (e) {
              e.code || (e.code = c.SETUP.EXCEPTION), e.message || (e.message = "An unknown error occured during setup.");
              var t = {
                name: "Error",
                data: {code: e.code, message: e.message},
                player: this._playerDivId,
                id: this.id,
                version: this.version,
                state: s.IDLE
              };
              i && this.on(t.name, i), this.emit(t.name, t), r(e)
            }.bind(this);
            try {
              this._realPlayer && this._realPlayer !== this._dummyPlayer && (this._realPlayer.destroy(), this._realPlayer = this._dummyPlayer), t.create(this._playerDivId, e).then(function (t) {
                this.version = t.version, this.type = t.type, this._realPlayer = t, this._realPlayer.id = this.id, this._propagator = f.create(t, o, this), this._realPlayer.setup(e).then(function (e) {
                  this.mediaplaybackapi = t.mediaplaybackapi, window.onunload = function () {
                    this._realPlayer.destroy()
                  }.bind(this), function (e) {
                    n(e)
                  }(e)
                }.bind(this), a)
              }.bind(this), (function (e) {
                a(e)
              }))
            } catch (e) {
              a(e)
            }
          }.bind(this))
        }, b.destroy = function () {
          this._realPlayer.destroy()
        }, b.play = function () {
          this._realPlayer.play()
        }, b.pause = function () {
          this._realPlayer.pause()
        }, b.mute = function () {
          this._realPlayer.mute()
        }, b.unmute = function () {
          this._realPlayer.unmute()
        }, b.setVolume = function (e) {
          this._realPlayer.setVolume(e)
        }, b.updateSource = function (e, t) {
          return this._realPlayer.updateSource(e, t)
        }, b.switchStream = function (e) {
          return this._realPlayer.switchStream(e)
        }, b.setAdaption = function (e) {
          this._realPlayer.setAdaption(e)
        }, g.events = o, g.states = s, g.emptyConfig = n, g.validConfig = r, g.entryEmptyConfig = i, g.entryValidConfig = a, g.pauseReasons = d, g.errorCodes = c, g.version = u.CORE, g.capabilities = t.capabilities, g
      }.apply(t, r)) || (e.exports = i)
    }, 9921: function (e, t, n) {
      var r, i;
      r = [n(130), n(8209), n(1583), n(2215), n(4216), n(9374), n(1490), n(8333), n(6028), n(1473), n(6725), n(9658), n(8197)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f) {
        "use strict";
        var E = s.create("NanoPlayer");
        E.debugEnabled() && E.debug("NanoPlayer api version: " + e.NANOPLAYER);
        var p, m = t.events, g = t.states, b = t.emptyConfig, _ = t.validConfig, h = t.entryEmptyConfig,
          T = t.entryValidConfig, A = t.pauseReasons, S = t.errorCodes, y = t.capabilities, R = n.events,
          v = n.publicEvents, O = n.emptyConfig, I = n.validConfig, C = i.emptyConfig, N = i.validConfig,
          D = r.emptyConfig, w = r.validConfig, U = {};
        for (p in m) U[p] = m[p];
        for (p in v) U[p] = v[p];
        var P = {};
        u.extend(b.create(), P), u.extend(O.create(), P), u.extend(C.create(), P), u.extend(D.create(), P);
        var M = {};
        u.extend(_.create(), M), u.extend(I.create(), M), u.extend(N.create(), M), u.extend(w.create(), M);
        var L = {};
        u.extend(h.create(), L);
        var F = {};

        function x(t) {
          c.validatePlayerDivId(t), this.version = e.NANOPLAYER, this.coreversion = "", this.viewversion = "", this.type = "default", this.mediaplaybackapi = "default", this.id = Math.round(1e11 * Math.random()).toString(), this._playerDivId = t, this._core = null, this._view = null, this._metrics = null, this.state = g.IDLE
        }

        u.extend(T.create(), F);
        var k = x.prototype = Object.create(l.prototype);
        return k.setup = function (e) {
          var n = f.copy(e);
          return new Promise(function (e, s) {
            try {
              var c = {};
              u.extend(n, c);
              var l = c && c.events && c.events.onError ? c.events.onError : null, f = function (e) {
                var t = "object" == typeof e.error ? e.error : e;
                t && !t.code && (t.code = S.SETUP.EXCEPTION), t && !t.message && (t.message = "An unknown error occured during setup.");
                var n = {
                  name: "Error",
                  data: {code: t.code, message: t.message},
                  player: this._playerDivId,
                  id: this.id,
                  version: this.version,
                  state: this.state
                };
                c.metrics && (this._metrics || (this._metrics = new r, this._metrics.version = this.version), this._metrics.setup(c, this, e.bintu)), l && this.on(n.name, l), this._emit(n.name, n), u.merge(c, this._viewConfig), u.extend(this._viewConfig, c), c.style.view && (this._initView(c), null !== this._view && this._view.handleView(x.states.UNINITIALIZED)), s(t)
              }.bind(this);
              this._bintuConfig = C.create(), this._coreConfig = b.create(), this._viewConfig = O.create(), u.merge(c, this._bintuConfig), u.clean(c), this.destroy();
              var E = {};
              u.extend(n, E), this._checkConfig(E), i.setup(c).then(function (n) {
                var i = n.config;
                try {
                  a.check(i), o.apply(i), (c = i).metrics && (this._metrics && this._metrics.destroy(), this._metrics = new r, this._metrics.version = this.version, this._metrics.setup(c, this, n.bintu)), u.merge(c, this._viewConfig), u.merge(c, this._coreConfig), u.extend(this._viewConfig, c), u.extend(this._coreConfig, c), u.clean(c), this._initView(c), this._core && this._core.destroy(), this._core = new t(this._playerDivId), this._core.id = this.id, this._corePropagator = d.create(this._core, x.coreEvents, this), this._connectLayers(), this._core.setup(this._coreConfig).then(function (t) {
                    window.removeEventListener("unload", this.destroy.bind(this)), window.addEventListener("unload", this.destroy.bind(this)), this.coreversion = this._core.version, this.type = this._core.type, this.mediaplaybackapi = this._core.mediaplaybackapi, this._view && this._view.postSetup(), u.extend(this._bintuConfig, t), u.extend(this._viewConfig, t), u.clean(t), e(t)
                  }.bind(this), function (e) {
                    this._view && this._viewConfig.style && this._viewConfig.style.view && this._view.handleView(x.states.UNINITIALIZED), s(e)
                  }.bind(this))
                } catch (e) {
                  f(e)
                }
              }.bind(this), f)
            } catch (e) {
              f(e)
            }
          }.bind(this))
        }, k.destroy = function () {
          this._view && this._view.destroy(), this._view = null, this._core && this._core.destroy(), this._core = null, this._metrics && this._metrics.destroy(), this._metrics = null
        }, k._checkConfig = function (e) {
          var t = [];
          if (e.source && e.source.bintu) {
            var n = u.check({source: {bintu: e.source.bintu}}, N.create());
            t = t.concat(n)
          }
          if (e.style) {
            var r = u.check({style: e.style}, I.create());
            t = t.concat(r)
          }
          if (e.source) {
            delete e.source.bintu, delete e.style, delete e.metrics, delete e.events;
            var i = u.check(e, _.create()).filter((function (e) {
              return -1 !== e.indexOf("valid")
            }));
            t = t.concat(i)
          }
          if (t.length) {
            var a = e && e.events && e.events.onWarning ? e.events.onWarning : null;
            a && this.on(m.WARNING, a), t.forEach(function (e) {
              var t = {
                name: m.WARNING,
                data: {message: e},
                player: this._playerDivId,
                id: this.id,
                version: this.version,
                state: this.state
              };
              this._emit(t.name, t)
            }.bind(this))
          }
        }, k._initView = function (e) {
          this._view && this._view.destroy(), this._view = new n, this._view.version = this.version, this.viewversion = this._view.version, this._view.setBaseValues(this._playerDivId), this._view.baseSetup(e), this._viewPropagator = d.create(this._view, x.viewPublicEvents, this)
        }, k._connectLayers = function () {
          var e = [x.coreEvents.MEDIA];

          function t(e, t, n, r) {
            for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && -1 === t.indexOf(e[i]) && n.on(e[i], r.bind(this))
          }

          t(x.coreEvents, e, this, this._onCoreEvent.bind(this)), this._view && t(x.viewEvents, [], this._view, this._onViewEvent.bind(this))
        }, k._onCoreEvent = function (e) {
          if (this.state = e.state, this._view && this._viewConfig.style && this._viewConfig.style.view) {
            if (e.name === x.coreEvents.STATS) return void this._view.handleStats(e.data.stats);
            e.name === x.coreEvents.STATE_CHANGE ? this._view.update(e) : e.name === x.coreEvents.STREAM_INFO ? this._view.handleStreamInfo(e) : e.name === x.coreEvents.STREAM_INFO_UPDATE ? this._view.handleStreamInfoUpdate(e) : e.name === x.coreEvents.MUTE || e.name === x.coreEvents.UNMUTE ? this._view.handleMute(e.name === x.coreEvents.MUTE) : e.name === x.coreEvents.VOLUME_CHANGE ? this._view.handleVolume(e.data.volume) : e.name === x.coreEvents.READY ? this._view.handleConfig(e.data.config) : e.name === x.coreEvents.METADATA ? this._view.handleMetaData(e) : e.name === x.coreEvents.ACTIVE_VIDEO_ELEMENT_CHANGE && (e.data.activeVideoElement && "VIDEO" === e.data.activeVideoElement.tagName && "moq" === this.mediaplaybackapi && (this.mediaplaybackapi = "mse"), this._view.handleActiveVideoElementChange(e))
          }
        }, k._onViewEvent = function (e) {
          this._core && (e.name === x.viewEvents.PLAY ? this._core.play() : e.name === x.viewEvents.PAUSE ? this._core.pause() : e.name === x.viewEvents.MUTE ? this._core.mute() : e.name === x.viewEvents.UNMUTE ? this._core.unmute() : e.name === x.viewEvents.VOLUME_CHANGE ? this._core.setVolume(e.data.volume) : e.name === x.viewEvents.FULLSCREEN_CHANGE && this._emit(x.viewPublicEvents.FULLSCREEN_CHANGE, e.data))
        }, k._emit = function (e, t) {
          var n = {};
          t && t.name && t.data ? n = t : t ? (n.data = t, n.name = e || "unknown") : (n.data = {}, n.name = e || "unknown"), n.player = this._playerDivId, n.id = this.id, n.version = this.version, n.state = this.state, this.emit(n.name, n)
        }, k._callMethod = function () {
          if (!this._core) throw new Error('"' + arguments[0] + '" must be implemented or player not initialized by call setup.');
          return this._core[arguments[0]].apply(this._core, Array.prototype.slice.call(arguments, 1))
        }, k._callViewMethod = function () {
          if (!this._view) throw new Error('"' + arguments[0] + '" must be implemented or player not initialized by call setup.');
          return this._view[arguments[0]].apply(this._view, Array.prototype.slice.call(arguments, 1))
        }, k.play = function () {
          this._callMethod("play")
        }, k.pause = function () {
          this._callMethod("pause")
        }, k.mute = function () {
          this._callMethod("mute")
        }, k.unmute = function () {
          this._callMethod("unmute")
        }, k.setVolume = function (e) {
          this._callMethod("setVolume", e)
        }, k.updateSource = function (e, t) {
          return new Promise(function (n, r) {
            i.updateSource(e, t).then(function (e) {
              var i = e.config;
              a.check(i), o.apply(i), this._callMethod("updateSource", i.source, t).then((function (e) {
                n(e)
              }), (function (e) {
                r(e)
              }))
            }.bind(this), function (e) {
              var t = "object" == typeof e.error ? e.error : e, n = {
                name: "Error",
                data: {code: t.code, message: t.message},
                player: this._playerDivId,
                id: this.id,
                version: this.version,
                state: this.state
              };
              this._emit(n.name, n), r(t)
            }.bind(this))
          }.bind(this))
        }, k.switchStream = function (e) {
          return new Promise(function (t, n) {
            this._callMethod("switchStream", e).then((function (e) {
              t(e)
            }), (function (e) {
              n(e)
            }))
          }.bind(this))
        }, k.setAdaption = function (e) {
          this._callMethod("setAdaption", e)
        }, k.requestFullscreen = function () {
          return this._callViewMethod("requestFullscreen")
        }, k.exitFullscreen = function () {
          return this._callViewMethod("exitFullscreen")
        }, x.states = g, x.coreEvents = m, x.viewEvents = R, x.viewPublicEvents = v, x.emptyConfig = P, x.validConfig = M, x.entryEmptyConfig = L, x.entryValidConfig = F, x.events = U, x.pauseReasons = A, x.capabilities = y, window.NanoPlayer = x, x
      }.apply(t, r)) || (e.exports = i)
    }, 651: function (e, t, n) {
      var r, i;
      r = [n(6637), n(3778), n(3890), n(492), n(9583), n(9673), n(594), n(680), n(1376), n(7354), n(8333)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        return {
          create: function (a) {
            var u, l, f, E, p, m, g, b, _, h, T = c.create("ErrorSelector");
            const A = "loading", S = "error";
            var y = [{
              type: s.STATE_CHANGE, listener: function (e) {
                switch (u = e.data.state) {
                  case r.LOADING:
                    m = !0, b = {loading: void 0, error: void 0}, U(A), f = !1, l = null, _ = {
                      bufferDelayCurrent: 0,
                      bitrateCurrent: 0,
                      framerateCurrent: 0
                    }, h = null;
                    break;
                  case r.PLAYING:
                    g = setTimeout((function () {
                      m = !1
                    }), 3e4);
                    break;
                  case r.BUFFERING:
                    break;
                  default:
                    clearTimeout(g), m = !1
                }
              }
            }, {type: s.DOCUMENT_VISIBLE, listener: R}, {type: s.DOCUMENT_HIDDEN, listener: R}, {
              type: s.STREAM_INFO,
              listener: function () {
                f = !0
              }
            }, {
              type: d.STREAM_STATUS, listener: function (e) {
                l = e.data.onStreamStatus.status
              }
            }, {
              type: i.STATS, listener: function (e) {
                m && (_.bufferDelayCurrent = e.data.stats.buffer.delay.current, _.bitrateCurrent = e.data.stats.bitrate.current, _.framerateCurrent = e.data.stats.framerate.current)
              }
            }, {type: s.STARTUP_STATS_ADDED, listener: v}, {
              type: s.STARTUP_STATS_COMPLETED,
              listener: v
            }, {
              type: s.BUFFER_TWEAKS_ERROR, listener: function (e) {
                N(e.data.code, e.data.message, !1, !0)
              }
            }, {
              type: s.LOADING_TIMEOUT, listener: function () {
                f ? E || p ? N(t.PLAYER.VISIBILITY_HIDDEN, n.PLAYER.VISIBILITY_HIDDEN) : N(t.STREAM.NOT_ENOUGH_DATA, n.STREAM.NOT_ENOUGH_DATA) : l && "stopped" === l ? N(t.STREAM.SOURCE_STOPPED, n.STREAM.SOURCE_STOPPED) : N(t.STREAM.NOT_FOUND, n.STREAM.NOT_FOUND)
              }
            }, {
              type: s.BUFFERING_TIMEOUT, listener: function () {
                l && "stopped" === l ? N(t.STREAM.SOURCE_STOPPED, n.STREAM.SOURCE_STOPPED) : N(t.STREAM.MEDIA_NOT_AVAILABLE, n.STREAM.MEDIA_NOT_AVAILABLE)
              }
            }, {
              type: s.MIME_TYPE_UNSUPPORTED, listener: function () {
                N(t.MEDIA.NOT_SUPPORTED, n.MEDIA.NOT_SUPPORTED)
              }
            }, {
              type: s.META_DATA_ERROR, listener: function (e) {
                N(e.data.code, e.data.message, !0, !0)
              }
            }, {
              type: s.MISSING_RTMP_ERROR, listener: function () {
                N(t.PLAYER.NO_RTMP_URL_SET, n.PLAYER.NO_RTMP_URL_SET, !1, !0)
              }
            }, {
              type: s.NO_SERVER_ERROR, listener: function () {
                N(t.PLAYER.NO_SERVER_SET, n.PLAYER.NO_SERVER_SET, !1, !0)
              }
            }, {
              type: s.SOURCE_STREAM_STOPPED, listener: function () {
                N(t.STREAM.SOURCE_STOPPED, n.STREAM.SOURCE_STOPPED)
              }
            }, {
              type: s.NOT_CONFIGURED, listener: function () {
                N(t.PLAYER.NOT_CONFIGURED, n.PLAYER.NOT_CONFIGURED)
              }
            }, {
              type: s.UPDATE_SOURCE_INVALID, listener: function (e) {
                N(e.data.code, e.data.message)
              }
            }, {
              type: s.INVALID_ENTRY_INDEX, listener: function (e) {
                N(e.data.code, e.data.message, !1, !e.data.pauseOnError)
              }
            }, {
              type: o.PLAY_START_NOT_ALLOWED_ERROR, listener: function (e) {
                e.data.automuted || N(t.PLAYER.INTERACTION_REQUIRED, n.PLAYER.INTERACTION_REQUIRED)
              }
            }, {
              type: o.MEDIA_ERROR, listener: function (e) {
                switch (e.data.code) {
                  case t.MEDIA.ABORTED:
                    N(t.MEDIA.ABORTED, n.MEDIA.ABORTED);
                    break;
                  case t.MEDIA.DOWNLOAD_ERROR:
                    N(t.MEDIA.DOWNLOAD_ERROR, n.MEDIA.DOWNLOAD_ERROR);
                    break;
                  case t.MEDIA.DECODE_ERROR:
                    N(t.MEDIA.DECODE_ERROR, n.MEDIA.DECODE_ERROR);
                    break;
                  case t.MEDIA.DECODER_STARTUP_ERROR:
                    N(t.MEDIA.DECODER_STARTUP_ERROR, n.MEDIA.DECODER_STARTUP_ERROR);
                    break;
                  case t.MEDIA.NOT_SUPPORTED:
                    N(t.MEDIA.NOT_SUPPORTED, n.MEDIA.NOT_SUPPORTED);
                    break;
                  case t.MEDIA.HLS_VIDEO_DECODE_ERROR:
                    N(t.MEDIA.HLS_VIDEO_DECODE_ERROR, n.MEDIA.HLS_VIDEO_DECODE_ERROR);
                    break;
                  case t.MEDIA.MEDIA_SOURCE_ENDED:
                    (E || p) && u === r.LOADING ? N(t.PLAYER.VISIBILITY_HIDDEN, n.PLAYER.VISIBILITY_HIDDEN) : N(t.MEDIA.MEDIA_SOURCE_ENDED, n.MEDIA.MEDIA_SOURCE_ENDED);
                    break;
                  case t.PLAYER.PLAYBACK_ERROR:
                    N(t.PLAYER.PLAYBACK_ERROR, n.PLAYER.PLAYBACK_ERROR);
                    break;
                  case t.MEDIA.HLS_BUFFER_UNDERRUN:
                    N(t.MEDIA.HLS_BUFFER_UNDERRUN, n.MEDIA.HLS_BUFFER_UNDERRUN)
                }
              }
            }, {
              type: o.PLAYBACK_SUSPENDED, listener: function () {
                N(t.PLAYER.PLAYBACK_SUSPENDED, n.PLAYER.PLAYBACK_SUSPENDED)
              }
            }, {
              type: o.UPDATE_SOURCE_TIMEOUT, listener: function (e) {
                N(e.data.code, e.data.message)
              }
            }, {type: d.DISCONNECTED, listener: O}, {
              type: d.INITIALIZATION_ERROR,
              listener: O
            }, {type: d.CONNECTION_ERROR, listener: O}, {
              type: d.ERROR,
              listener: O
            }, {type: d.RECONNECTION_CONFIG_INVALID, listener: O}];

            function R(e) {
              e.name === s.DOCUMENT_HIDDEN ? E = !0 : (E && (p = !0), E = !1, setTimeout((function () {
                p = !1
              }), 1e3))
            }

            function v(e) {
              h = e.data.stats
            }

            function O(e) {
              4004 === e.data.code ? N(e.data.code, e.data.message, !0, !0) : N(e.data.code, e.data.message)
            }

            function I(e, t, n) {
              n ? setTimeout(C.bind(this, e, t), 0) : C(e, t)
            }

            function C(e, t) {
              a.emit(e, t)
            }

            function N(e, t, n, r) {
              m && U(S), I(i.ERROR, function (e, t) {
                var n = {code: e, message: t};
                if (m && h) {
                  var r = P(function () {
                    for (var e in delete h.connecting, h.error = b.error - b.loading, _) Object.prototype.hasOwnProperty.call(_, e) && (h[e] = _[e]);
                    return {
                      playback: {
                        bufferDelayCurrent: h.bufferDelayCurrent,
                        bitrateCurrent: h.bitrateCurrent,
                        framerateCurrent: h.framerateCurrent
                      },
                      state: {
                        connected: h.connected,
                        firstFragmentReceived: h.firstFragmentReceived,
                        firstFrameRendered: h.firstFrameRendered,
                        playable: h.playable,
                        playing: h.playing,
                        error: h.error
                      }
                    }
                  }());
                  for (var i in r) D(r, i) && !D(n, i) && (n[i] = r[i])
                }
                return n
              }(e, t), n), r || I(s.ERROR, {state: w(e)}, n)
            }

            function D(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t)
            }

            function w(e) {
              var n;
              switch (e) {
                case t.PLAYER.INTERACTION_REQUIRED:
                  n = r.PLAYBACK_NOT_STARTED;
                  break;
                case t.PLAYER.PLAYBACK_SUSPENDED:
                  n = r.PLAYBACK_SUSPENDED;
                  break;
                case t.PLAYER.VISIBILITY_HIDDEN:
                  n = r.VISIBILITY_HIDDEN;
                  break;
                case t.STREAM.NOT_ENOUGH_DATA:
                  n = r.NOT_ENOUGH_DATA;
                  break;
                case t.STREAM.SOURCE_STOPPED:
                  n = r.SOURCE_STREAM_STOPPED;
                  break;
                case t.STREAM.MEDIA_NOT_AVAILABLE:
                  n = r.MEDIA_NOT_AVAILABLE;
                  break;
                case t.MEDIA.ABORTED:
                case t.MEDIA.DOWNLOAD_ERROR:
                case t.MEDIA.DECODE_ERROR:
                case t.MEDIA.NOT_SUPPORTED:
                case t.MEDIA.HLS_VIDEO_DECODE_ERROR:
                case t.MEDIA.MEDIA_SOURCE_ENDED:
                case t.PLAYER.PLAYBACK_ERROR:
                case t.MEDIA.HLS_BUFFER_UNDERRUN:
                  n = r.PLAYBACK_ERROR;
                  break;
                default:
                  e >= 4e3 && e < 5e3 && (n = r.CONNECTION_ERROR)
              }
              return n
            }

            function U(e) {
              -1 !== Object.keys(b).indexOf(e) && (b[e] = Date.now())
            }

            function P(e, t) {
              if (t = isNaN(t) ? 2 : parseInt(t, 10), "object" == typeof e) {
                for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
                  var r = e[n];
                  if ("object" == typeof r && null !== r) if (Array.isArray(r)) for (var i = 0; i < r.length; i++) r[i] = P(r[i], t); else e[n] = P(r, t); else "number" == typeof r && (e[n] = Math.round(r * Math.pow(10, t)) / Math.pow(10, t))
                }
              } else e = Math.round(e * Math.pow(10, t)) / Math.pow(10, t);
              return e
            }

            return T.debugEnabled() && T.debug("init"), e.add({target: a, listeners: y}), {
              destroy: function () {
                e.remove({target: a, listeners: y})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6231: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "buffer.",
          BUFFER_TWEAKS_CREATED: "buffer.tweaksCreated",
          BUFFER_TWEAKS_ERROR: "buffer.tweaksError"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7771: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "connection.";
        return {
          BASE: e,
          CONNECT: e + "connect",
          DISCONNECT: e + "disconnect",
          VIDEO_SOURCE: e + "videoSource",
          NETWORK_PLAY: e + "networkPlay",
          NO_SERVER_ERROR: e + "noServerError",
          MISSING_RTMP_ERROR: e + "missingRtmpError",
          SERVER_INFO: e + "serverInfo",
          NO_KEEP_CONNECTION: e + "noKeepConnection",
          URL: e + "url",
          NETWORK_UPDATE_SOURCE: e + "networkUpdateSource",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          SWITCH_STREAM_INIT: e + "switchStreamInit",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3937: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "latency.",
          SEEK: "latency.seek",
          RATE: "latency.rate",
          BUFFER_GOAL_STATS: "latency.bufferGoalStats",
          CONTROL_MODE_SET: "latency.controlModeSet"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3019: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "logicManager.";
        return {
          BASE: e,
          API_PLAY: e + "apiPlay",
          API_PAUSE: e + "apiPause",
          NETWORK_CONNECTING: e + "networkConnecting",
          NETWORK_CONNECTED: e + "networkConnected",
          NETWORK_DISCONNECTED: e + "networkDisconnected",
          NETWORK_CONNECTION_OPEN: e + "networkConnectionOpen",
          NETWORK_RECONNECTION_IMMINENT: e + "networkReconnectionImminent",
          NETWORK_RECONNECTING: e + "networkReconnecting",
          NETWORK_CONNECTION_ERROR: e + "networkConnectionError",
          NETWORK_INITIALIZATION_ERROR: e + "networkInitializationError",
          NETWORK_MAX_RETRY_REACHED: e + "networkMaxRetryReached",
          NETWORK_ERROR: e + "networkError",
          NETWORK_STATE_CHANGE: e + "networkStateChange",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_QUALITY: e + "streamQuality",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          STREAM_URL: e + "streamUrl",
          BUFFER_TWEAKS_CREATED: e + "bufferTweaksCreated",
          PLAYING: e + "playing",
          PLAYBACK_STARTED: e + "playbackStarted",
          BUFFERING: e + "buffering",
          PLAY_STATS: e + "playStats",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          DURATION_CHANGE: e + "durationChange",
          CAN_PLAY: e + "canPlay",
          CAN_PLAY_THROUGH: e + "canPlayThrough",
          META_DATA: e + "metaData",
          FRAME_DROP: e + "frameDrop",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          SWITCH_STREAM: e + "switchStream",
          MEDIA_PLAYING: e + "mediaPlaying",
          TIME_OFFSET: e + "timeOffset",
          LOADED_DATA: e + "loadedData",
          LOADED_META_DATA: e + "loadedMetaData",
          MEDIA_ERROR: e + "mediaError",
          MEDIA_ERROR_RECOVER: e + "mediaErrorRecover",
          ADJUSTED_META_DATA: e + "adjustedMetaData",
          CONFIG: e + "config",
          UPDATE_SOURCE: e + "updateSource",
          STREAM_SWITCH: e + "streamSwitch",
          SET_ADAPTION: e + "setAdaption",
          NETWORK_PLAY: e + "networkPlay",
          PLAY: e + "play",
          PUBLIC_EVENT: e + "publicEvent"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1683: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {BASE: "metaData.", RECEIVED: "metaData.received", ERROR: "metaData.error"}
      }.apply(t, [])) || (e.exports = n)
    }, 164: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {BASE: "source.", STATS: "source.stats", STREAM_SWITCH: "source.streamSwitch"}
      }.apply(t, [])) || (e.exports = n)
    }, 519: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "startupstats.";
        return {BASE: e, ADDED: e + "added", COMPLETED: e + "completed"}
      }.apply(t, [])) || (e.exports = n)
    }, 8983: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "streamInfo.";
        return {
          BASE: e,
          CREATED: e + "created",
          UPDATED: e + "updated",
          MIME_TYPE_UNSUPPORTED: e + "mimetypeUnsupported"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3667: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "timeout.",
          LOADING_TIMEOUT: "timeout.loadingTimeout",
          BUFFERING_TIMEOUT: "timeout.bufferingTimeout"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2450: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "visibility.";
        return {BASE: e, HIDDEN: e + "hidden", VISIBLE: e + "visible"}
      }.apply(t, [])) || (e.exports = n)
    }, 1797: function (e, t, n) {
      var r, i;
      r = [n(6637), n(9583), n(594), n(680), n(8333), n(8197)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s, d = i.create("FacadePropagator"), u = 1, c = !1, l = [{
              type: n.VOLUME_CHANGE, listener: function (e) {
                e.data.muted !== c ? f((c = e.data.muted) ? t.MUTE : t.UNMUTE, {volume: u}) : e.data.volume !== u && (u = e.data.volume, f(t.VOLUME_CHANGE, {volume: u}))
              }
            }, {
              type: n.QUALITY_STATS, listener: function (e) {
                s || (s = {}), s.quality = e.data
              }
            }, {
              type: n.PLAY_STATS, listener: function (e) {
                var n, r, i;
                s && s.quality && (n = s.quality), r && s.adaptive && (r = s.adaptive), i && s.buffergoal && (i = s.buffergoal), s = e.data.stats, n && !s.quality && (s.quality = n), r && !s.adaptive && (s.adaptive = r), i && !s.buffergoal && (s.buffergoal = i);
                var a, o = "stats error";
                try {
                  o = JSON.stringify(s), delete (a = JSON.parse(o)).buffer.update
                } catch (e) {
                }
                f(t.STATS, {stats: a})
              }
            }, {
              type: n.PLAYBACK_FINISHED, listener: function () {
                f(t.PLAYBACK_FINISHED)
              }
            }, {
              type: n.ACTIVE_VIDEO_ELEMENT_CHANGE, listener: function (e) {
                setTimeout(f.bind(this, t.ACTIVE_VIDEO_ELEMENT_CHANGE, e.data), 0)
              }
            }, {
              type: r.META_DATA_RECEIVED, listener: function (e) {
                setTimeout(f.bind(this, t.METADATA, e.data), 0)
              }
            }, {
              type: r.UPDATE_SOURCE_INIT, listener: function (e) {
                setTimeout(f.bind(this, t.UPDATE_SOURCE_INIT, e.data), 0)
              }
            }, {
              type: r.UPDATE_SOURCE_SUCCESS, listener: function (e) {
                setTimeout(f.bind(this, t.UPDATE_SOURCE_SUCCESS, e.data), 0)
              }
            }, {
              type: r.UPDATE_SOURCE_FAIL, listener: function (e) {
                setTimeout(f.bind(this, t.UPDATE_SOURCE_FAIL, e.data), 0)
              }
            }, {
              type: r.UPDATE_SOURCE_ABORT, listener: function (e) {
                setTimeout(f.bind(this, t.UPDATE_SOURCE_ABORT, e.data), 0)
              }
            }, {
              type: r.STREAM_INFO, listener: function (e) {
                var n = a.copy(e.data);
                delete n.streamInfo.mimeType, setTimeout(f.bind(this, t.STREAM_INFO, n), 0)
              }
            }, {
              type: r.STREAM_INFO_UPDATE, listener: function (e) {
                var n = a.copy(e.data);
                delete n.streamInfo.mimeType, setTimeout(f.bind(this, t.STREAM_INFO_UPDATE, n), 0)
              }
            }, {
              type: r.SWITCH_STREAM_INIT, listener: function (e) {
                setTimeout(f.bind(this, t.SWITCH_STREAM_INIT, e.data), 0)
              }
            }, {
              type: r.SWITCH_STREAM_SUCCESS, listener: function (e) {
                setTimeout(f.bind(this, t.SWITCH_STREAM_SUCCESS, e.data), 0)
              }
            }, {
              type: r.SWITCH_STREAM_FAIL, listener: function (e) {
                setTimeout(f.bind(this, t.SWITCH_STREAM_FAIL, e.data), 0)
              }
            }, {
              type: r.SWITCH_STREAM_ABORT, listener: function (e) {
                setTimeout(f.bind(this, t.SWITCH_STREAM_ABORT, e.data), 0)
              }
            }, {
              type: r.ADAPTIVE_STATS, listener: function (e) {
                s || (s = {}), s.adaptive = e.data
              }
            }, {
              type: r.BUFFER_GOAL_STATS, listener: function (e) {
                s || (s = {}), s.buffergoal = e.data
              }
            }, {
              type: r.SERVER_INFO, listener: function (e) {
                var n = {serverInfo: a.copy(e.data.onServerInfo)};
                delete n.serverInfo.capabilities, delete n.serverInfo.events, delete n.serverInfo.interfaceVersion, n.serverInfo.serverApplicationName = n.serverInfo.serverName, n.serverInfo.serverApplicationVersion = n.serverInfo.serverVersion, delete n.serverInfo.serverName, delete n.serverInfo.serverVersion, setTimeout(f.bind(this, t.SERVER_INFO, n), 0)
              }
            }];

            function f(e, t) {
              o.emit(e, a.copy(t))
            }

            return d.debugEnabled() && d.debug("init"), e.add({target: o, listeners: l}), {
              destroy: function () {
                e.remove({target: o, listeners: l})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2909: function (e, t, n) {
      var r, i;
      r = [n(8333), n(9658), n(6627), n(8197), n(6637), n(5055), n(9336), n(9673), n(680), n(594), n(1376), n(7354), n(7771), n(3019), n(3667), n(8983), n(1683), n(2450), n(164), n(3937), n(519), n(6231), n(387), n(5444), n(4600), n(9665), n(4351), n(5620), n(2805), n(8307), n(7831)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b, _, h, T, A, S, y, R, v, O, I, C, N, D) {
        "use strict";
        return {
          create: function (n) {
            var w, U, P = new t, M = e.create("LogicManager"), L = [],
              F = [{from: f.CONNECT, to: s.CONNECT}, {from: f.DISCONNECT, to: s.DISCONNECT}, {
                from: f.VIDEO_SOURCE,
                to: s.VIDEO_SOURCE
              }, {from: f.NETWORK_PLAY, to: s.NETWORK_PLAY}, {
                from: f.NETWORK_UPDATE_SOURCE,
                to: s.NETWORK_UPDATE_SOURCE
              }, {from: f.NO_SERVER_ERROR, to: d.NO_SERVER_ERROR}, {
                from: f.MISSING_RTMP_ERROR,
                to: d.MISSING_RTMP_ERROR
              }, {from: f.NO_KEEP_CONNECTION, to: d.NO_KEEP_CONNECTION}, {
                from: f.SERVER_INFO,
                to: d.SERVER_INFO
              }, {from: f.URL, to: d.STREAM_URL}, {
                from: f.UPDATE_SOURCE_INIT,
                to: d.UPDATE_SOURCE_INIT
              }, {from: f.UPDATE_SOURCE_SUCCESS, to: d.UPDATE_SOURCE_SUCCESS}, {
                from: f.UPDATE_SOURCE_FAIL,
                to: d.UPDATE_SOURCE_FAIL
              }, {from: f.UPDATE_SOURCE_ABORT, to: d.UPDATE_SOURCE_ABORT}, {
                from: f.SWITCH_STREAM_INIT,
                to: d.SWITCH_STREAM_INIT
              }, {from: f.SWITCH_STREAM_SUCCESS, to: d.SWITCH_STREAM_SUCCESS}, {
                from: f.SWITCH_STREAM_FAIL,
                to: d.SWITCH_STREAM_FAIL
              }, {from: f.SWITCH_STREAM_ABORT, to: d.SWITCH_STREAM_ABORT}, {
                from: p.LOADING_TIMEOUT,
                to: d.LOADING_TIMEOUT
              }, {from: p.BUFFERING_TIMEOUT, to: d.BUFFERING_TIMEOUT}, {
                from: m.CREATED,
                to: d.STREAM_INFO
              }, {from: m.UPDATED, to: d.STREAM_INFO_UPDATE}, {
                from: m.MIME_TYPE_UNSUPPORTED,
                to: d.MIME_TYPE_UNSUPPORTED
              }, {from: g.RECEIVED, to: d.META_DATA_RECEIVED}, {from: g.ERROR, to: d.META_DATA_ERROR}, {
                from: b.VISIBLE,
                to: d.DOCUMENT_VISIBLE
              }, {from: b.HIDDEN, to: d.DOCUMENT_HIDDEN}, {from: _.STATS, to: d.ADAPTIVE_STATS}, {
                from: _.STREAM_SWITCH,
                to: d.STREAM_SWITCH
              }, {from: h.SEEK, to: s.SEEK}, {from: h.RATE, to: s.SET_RATE}, {
                from: h.BUFFER_GOAL_STATS,
                to: d.BUFFER_GOAL_STATS
              }, {from: h.CONTROL_MODE_SET, to: d.LATENCY_CONTROL_MODE_SET}, {
                from: T.ADDED,
                to: d.STARTUP_STATS_ADDED
              }, {from: T.COMPLETED, to: d.STARTUP_STATS_COMPLETED}, {
                from: A.BUFFER_TWEAKS_CREATED,
                to: d.BUFFER_TWEAKS_CREATED
              }, {from: A.BUFFER_TWEAKS_ERROR, to: d.BUFFER_TWEAKS_ERROR}],
              x = [{from: o.PLAY, to: E.API_PLAY}, {from: o.PAUSE, to: E.API_PAUSE}, {
                from: u.PLAY_STATS,
                to: E.PLAY_STATS
              }, {from: u.PLAYING, to: E.PLAYING}, {
                from: u.PLAYBACK_STARTED,
                to: E.PLAYBACK_STARTED
              }, {from: u.BUFFERING, to: E.BUFFERING}, {
                from: u.DURATION_CHANGE,
                to: E.DURATION_CHANGE
              }, {from: u.CAN_PLAY, to: E.CAN_PLAY}, {
                from: u.CAN_PLAY_THROUGH,
                to: E.CAN_PLAY_THROUGH
              }, {from: u.PLAYING, to: E.MEDIA_PLAYING}, {
                from: u.FRAME_DROP,
                to: E.FRAME_DROP
              }, {from: u.VIEWPORT_VISIBLE, to: E.VIEWPORT_VISIBLE}, {
                from: u.VIEWPORT_HIDDEN,
                to: E.VIEWPORT_HIDDEN
              }, {from: u.TIME_OFFSET, to: E.TIME_OFFSET}, {
                from: u.LOADED_DATA,
                to: E.LOADED_DATA
              }, {from: u.LOADED_META_DATA, to: E.LOADED_META_DATA}, {
                from: u.UPDATE_SOURCE_ABORT,
                to: E.UPDATE_SOURCE_ABORT
              }, {from: u.UPDATE_SOURCE_FAIL, to: E.UPDATE_SOURCE_FAIL}, {
                from: u.MEDIA_ERROR,
                to: E.MEDIA_ERROR
              }, {from: u.MEDIA_ERROR_RECOVER, to: E.MEDIA_ERROR_RECOVER}, {
                from: u.ADJUSTED_META_DATA,
                to: E.ADJUSTED_META_DATA
              }, {from: c.CONNECTING, to: E.NETWORK_CONNECTING}, {
                from: c.CONNECTED,
                to: E.NETWORK_CONNECTED
              }, {from: c.CONNECTION_OPEN, to: E.NETWORK_CONNECTION_OPEN}, {
                from: c.DISCONNECTED,
                to: E.NETWORK_DISCONNECTED
              }, {from: c.DESTROYED, to: E.NETWORK_DISCONNECTED}, {
                from: c.RECONNECTING,
                to: E.NETWORK_RECONNECTING
              }, {from: c.RECONNECTION_IMMINENT, to: E.NETWORK_RECONNECTION_IMMINENT}, {
                from: c.INITIALIZATION_ERROR,
                to: E.NETWORK_INITIALIZATION_ERROR
              }, {from: c.ERROR, to: E.NETWORK_ERROR}, {
                from: c.STATE_CHANGE,
                to: E.NETWORK_STATE_CHANGE
              }, {from: c.RANDOM_ACCESS_POINT, to: E.RANDOM_ACCESS_POINT}, {
                from: c.STREAM_FRAGMENT,
                to: E.STREAM_FRAGMENT
              }, {from: c.SERVER_INFO, to: E.SERVER_INFO}, {
                from: c.STREAM_INFO,
                to: E.STREAM_INFO
              }, {from: c.STREAM_INFO_UPDATE, to: E.STREAM_INFO_UPDATE}, {
                from: c.STREAM_QUALITY,
                to: E.STREAM_QUALITY
              }, {from: c.META_DATA, to: E.META_DATA}, {
                from: c.UPDATE_SOURCE_SUCCESS,
                to: E.UPDATE_SOURCE_SUCCESS
              }, {from: c.UPDATE_SOURCE_FAIL, to: E.UPDATE_SOURCE_FAIL}, {
                from: c.UPDATE_SOURCE_ABORT,
                to: E.UPDATE_SOURCE_ABORT
              }, {from: d.UPDATE_SOURCE_INIT, to: E.UPDATE_SOURCE_INIT}, {
                from: d.STATE_CHANGE,
                to: E.APPLICATION_STATE_CHANGE
              }, {from: d.STREAM_URL, to: E.STREAM_URL}, {
                from: d.STREAM_SWITCH,
                to: E.STREAM_SWITCH
              }, {from: d.BUFFER_TWEAKS_CREATED, to: E.BUFFER_TWEAKS_CREATED}, {
                from: s.CONFIG,
                to: E.CONFIG
              }, {from: s.UPDATE_SOURCE, to: E.UPDATE_SOURCE}, {
                from: s.SWITCH_STREAM,
                to: E.SWITCH_STREAM
              }, {from: s.SET_ADAPTION, to: E.SET_ADAPTION}, {from: s.NETWORK_PLAY, to: E.NETWORK_PLAY}, {
                from: s.PLAY,
                to: E.PLAY
              }], k = [{
                type: E.CONFIG, listener: function (e) {
                  e.data.config.playback.metadata && L.push(v.create(P, e.data.config))
                }
              }], B = [];

            function H(e) {
              P.emit(E.PUBLIC_EVENT, {event: r.copy(e)})
            }

            return function () {
              for (var e in M.debugEnabled() && M.debug("init"), l) Object.prototype.hasOwnProperty.call(l, e) && -1 === l.STATS.indexOf(l[e]) && B.push({
                type: l[e],
                listener: H
              });
              w = a.create(n, P, x), U = a.create(P, n, F), i.add({target: P, listeners: k}), i.add({
                target: n,
                listeners: B
              }), L.push(C.create(P)), L.push(y.create(P)), L.push(N.create(P)), L.push(D.create(P)), L.push(S.create(P)), L.push(R.create(P)), L.push(O.create(P)), L.push(I.create(P))
            }(), {
              destroy: function () {
                for (w.destroy(), w = null, U.destroy(), U = null; L.length;) L.pop().destroy();
                i.remove({target: P, listeners: k}), i.remove({target: n, listeners: B})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6704: function (e, t, n) {
      var r, i;
      r = [n(6637), n(9583), n(9673), n(594), n(680), n(1376), n(8333)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (n) {
            var r = o.create("StateMachine"), a = [{
              type: i.STATE_CHANGE, listener: function (e) {
                var r, i;
                r = t.STATE_CHANGE, i = e.data, n.emit(r, i)
              }
            }];
            return r.debugEnabled() && r.debug("init"), e.add({target: n, listeners: a}), {
              destroy: function () {
                e.remove({target: n, listeners: a})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2805: function (e, t, n) {
      var r, i;
      r = [n(8333), n(8197), n(6627), n(5337), n(6637), n(9474), n(3778), n(941), n(3019), n(8983), n(6231)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        return {
          create: function (l) {
            var f, E, p, m = e.create("BufferTweaker"), g = {max: 8, min: .2, start: .5, target: 1.2, limit: 1.7},
              b = t.copy(g), _ = t.copy(g), h = a.CLASSIC, T = 0, A = 0, S = 0, y = -1, R = !1, v = !1, O = [{
                type: d.FRAME_DROP, listener: function (e) {
                  if (m.debugEnabled() && m.debug("frame drop with type " + e.data.type), !p && n.isFirefox && h === a.CLASSIC) switch (m.debugEnabled() && m.debug("frame drop on firefox in classic mode with type " + e.data.type), e.data.type) {
                    case"extreme":
                    case"high":
                    case"medium":
                      m.debugEnabled() && m.debug("frame drop"), m.debugEnabled() && m.debug("" + JSON.stringify(e)), m.debugEnabled() && m.debug("current buffer: " + JSON.stringify(b)), m.debugEnabled() && m.debug("limit: " + _.limit + ", start: " + b.start), b.start < _.limit ? (m.debugEnabled() && m.debug("start lower then limit -> tweaking"), U(b.target - b.start), P()) : m.debugEnabled() && m.debug("start higher then limit -> tweaking denied");
                      break;
                    case"low":
                      m.debugEnabled() && m.debug("just low, no tweaking necessary")
                  }
                }
              }, {
                type: d.CONFIG, listener: function (e) {
                  var r;
                  if ((p = n.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && n.canUseHLS) || i.add({
                    target: l,
                    listeners: C
                  }), e.data.config.playback.latencyControlMode) for (var d in a) Object.prototype.hasOwnProperty.call(a, d) && a[d] === e.data.config.playback.latencyControlMode && (h = a[d]);
                  e.data.config.tweaks && (e.data.config.tweaks.buffer && ((r = s.validateBuffer(e.data.config.tweaks.buffer)).success ? (b = t.copy(e.data.config.tweaks.buffer), _ = t.copy(b), v = !0) : l.emit(c.BUFFER_TWEAKS_ERROR, {
                    code: o.PLAYER.BUFFER_CONFIG_INVALID,
                    message: r.reason
                  })), e.data.config.tweaks.bufferDynamic && !p && h === a.CLASSIC && ((r = s.validateBuffer(e.data.config.tweaks.bufferDynamic, "dynamic")).success ? (T = e.data.config.tweaks.bufferDynamic.offsetThreshold, A = e.data.config.tweaks.bufferDynamic.offsetStep, S = e.data.config.tweaks.bufferDynamic.cooldownTime) : l.emit(c.BUFFER_TWEAKS_ERROR, {
                    code: o.PLAYER.BUFFER_CONFIG_INVALID,
                    message: r.reason
                  }))), P()
                }
              }, {type: u.CREATED, listener: w}, {
                type: u.UPDATED, listener: function (e) {
                  w(e)
                }
              }], I = [{
                type: d.PLAY_STATS, listener: function (e) {
                  var t = e.data.stats.buffer.delay.current;
                  t && E.add(t), !R && n.isTridentBrowser && t > 2 && (b.target = t, b.limit = b.target + 1.5, P()), R = !0
                }
              }, {
                type: d.BUFFERING, listener: function () {
                  D(!0);
                  var e = ((new Date).getTime() - y) / 1e3;
                  -1 !== y && e < T && b.start < _.limit && (m.warnEnabled() && m.warn("buffering " + e + " seconds after stream started, raising buffer values"), U(A), P()), N(), clearInterval(f), f = 0
                }
              }], C = [{
                type: d.PLAYBACK_STARTED, listener: function () {
                  D(!1), y = (new Date).getTime(), R && S && (f = setInterval((function () {
                    m.debugEnabled() && m.debug("stream running stable since " + S + " sec"), m.debugEnabled() && m.debug("buffer min: " + E.minimum + ", max: " + E.maximum), b.start > _.start ? (b.start - _.start < A ? (m.debug("normalize cooldown"), U()) : (m.debug(-A + " sec cooldown"), U(-A)), P()) : (m.debugEnabled() && m.debug("no cooldown"), clearInterval(f), f = 0)
                  }), 1e3 * S))
                }
              }];

            function N() {
              E = r.create(10 * S)
            }

            function D(e) {
              i.add({target: l, listeners: e ? C : I}), i.remove({target: l, listeners: e ? I : C})
            }

            function w(e) {
              e.data.streamInfo.videoInfo && e.data.streamInfo.haveVideo && e.data.streamInfo.videoInfo.frameRate <= 30 && n.isTridentBrowser && !v && (b = t.copy(g), U(Math.sqrt(30) - Math.sqrt(e.data.streamInfo.videoInfo.frameRate), 1), b.start += (b.target - b.start) / 2, b.min += (b.start - b.min) / 2, P())
            }

            function U(e, t) {
              t = t || 1, ["start", "target", "limit"].forEach((function (n) {
                void 0 === typeof e || isNaN(t) ? b[n] = _[n] : (b[n] *= t, b[n] += e)
              }))
            }

            function P() {
              m.debugEnabled() && m.debug("new buffer: " + JSON.stringify(b)), m.debugEnabled() && m.debug("latencyControlMode: " + h), l.emit(c.BUFFER_TWEAKS_CREATED, {
                tweaks: {buffer: t.copy(b)},
                latencyControlMode: h
              })
            }

            return m.debugEnabled() && m.debug("initialize"), N(), i.add({
              target: l,
              listeners: O
            }), {
              destroy: function () {
                E = null, [O, I, C].forEach((function (e) {
                  i.remove({target: l, listeners: e})
                }))
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 387: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(7771), n(3019), n(2706), n(6432), n(8405), n(492), n(3778), n(8730)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        return {
          create: function (l) {
            var f, E, p, m, g, b, _, h = e.create("Connection"), T = a.create(h), A = o.create(), S = [], y = {},
              R = s.UNITIALIZED, v = !1, O = !1, I = !1, C = !1, N = !0, D = !1, w = 0, U = [{
                type: i.NETWORK_STATE_CHANGE, listener: function (e) {
                  h.debug(e.name + ": network state change from " + B(R) + " to " + B(e.data.connectionState)), R = e.data.connectionState
                }
              }, {
                type: i.SERVER_INFO, listener: function (e) {
                  if (b = e.data.onServerInfo, O) {
                    var t = b.capabilities, n = b.serverVersion, i = parseFloat(n);
                    -1 === t.indexOf("onPlay") && -1 === t.indexOf("onPause") && (O = !1, l.emit(r.NO_KEEP_CONNECTION, {message: i < 1.8 ? "The keepConnection feature is enabled by the players config, but is not supported by this server version (" + n + "). Use at least server version 1.8.0.0. The feature will be disabled." : "The keepConnection feature is enabled by the players config, but is not enabled by this server (" + n + "). The feature will be disabled."}), N || L())
                  }
                  l.emit(r.SERVER_INFO, e.data)
                }
              }, {type: i.UPDATE_SOURCE_SUCCESS, listener: P}, {
                type: i.UPDATE_SOURCE_FAIL, listener: function (e) {
                  S.length > 1 && ("update" === e.data.type ? S.shift() : S.pop()), "update" === e.data.type ? l.emit(r.UPDATE_SOURCE_FAIL, {
                    source: p.source,
                    entry: p.entry,
                    rule: p.rule,
                    tag: e.data.tag,
                    count: e.data.count,
                    code: e.data.code,
                    message: e.data.message,
                    type: e.data.type,
                    id: e.data.id
                  }) : l.emit(r.SWITCH_STREAM_FAIL, {
                    source: p.source,
                    entry: p.entry,
                    rule: p.rule,
                    tag: e.data.tag,
                    count: e.data.count,
                    code: e.data.code,
                    message: e.data.message,
                    type: e.data.type,
                    id: e.data.id
                  }), e.data.code === u.NETWORK.SOURCE_TIMEOUT && V(p), h.debugEnabled() && h.debug("set updating to false in onUpdateSourceFail"), H(!1), O && !N && (L(!0), M())
                }
              }, {
                type: i.UPDATE_SOURCE_ABORT, listener: function (e) {
                  var t = !1;
                  S.length > 1 && ("update" === e.data.type ? S.shift() : S.pop()), "superseded" === e.data.reason && m && (t = !0), "update" === e.data.type ? "equalsource" === e.data.reason ? l.emit(r.UPDATE_SOURCE_SUCCESS, {
                    source: p.source,
                    entry: p.entry,
                    rule: p.rule,
                    tag: e.data.tag,
                    count: e.data.count,
                    type: e.data.type,
                    id: e.data.id
                  }) : l.emit(r.UPDATE_SOURCE_ABORT, {
                    source: t ? m.source : p.source,
                    entry: t ? m.entry : p.entry,
                    rule: t ? m.rule : p.rule,
                    tag: e.data.tag,
                    count: e.data.count,
                    reason: e.data.reason,
                    type: e.data.type,
                    id: e.data.id
                  }) : l.emit(r.SWITCH_STREAM_ABORT, {
                    source: I ? e.data.source : p.source,
                    entry: I ? e.data.entry : p.entry,
                    rule: I ? e.data.rule : p.rule,
                    tag: e.data.tag,
                    count: e.data.count,
                    reason: "equalsource" === e.data.reason ? "equal" : e.data.reason,
                    type: e.data.type,
                    id: e.data.id
                  }), "recover" === e.data.reason ? m ? (h.debugEnabled() && h.debug("set updating to updatingPrevious in onUpdateSourceAbort"), H(m), G(!1)) : (h.debugEnabled() && h.debug("recover abort without updatePrevious, do nothing"), h.debugEnabled() && h.debug("updating in abort is " + JSON.stringify(p))) : t ? G(!1) : (h.debugEnabled() && h.debug("set updating to false in onUpdateSourceAbort"), H(!1))
                }
              }, {
                type: i.CONFIG, listener: function (e) {
                  E = e.data.config, f = E.id, v = E.playback.metadata, O = E.playback.keepConnection && !(t.isMediaOverQuicSupported && e.data.config.playback.enableMediaOverQuic), N = E.playback.autoplay, I = t.mustUseHLS || E.playback.allowSafariHlsFallback && t.canUseHLS, C = E.playback.faststart
                }
              }, {
                type: i.STREAM_SWITCH, listener: function (e) {
                  var t = e.data.entry, n = e.data.options;
                  if ("init" === e.data.type) {
                    for (; S.length;) S.pop();
                    return F(t.h5live), void (O && M())
                  }
                  w += 1, n.tag = n.tag || "", n.count = w, "update" === e.data.type ? l.emit(r.UPDATE_SOURCE_INIT, {
                    source: e.data.source,
                    entry: t,
                    rule: e.data.rule,
                    options: n,
                    tag: n.tag,
                    count: n.count,
                    type: e.data.type,
                    id: e.data.id
                  }) : l.emit(r.SWITCH_STREAM_INIT, {
                    source: e.data.source,
                    entry: t,
                    rule: e.data.rule,
                    options: n,
                    tag: n.tag,
                    count: n.count,
                    type: e.data.type,
                    id: e.data.id
                  }), D ? "update" === e.data.type ? l.emit(r.UPDATE_SOURCE_ABORT, {
                    source: e.data.source,
                    entry: t,
                    rule: e.data.rule,
                    reason: "frequency",
                    tag: n.tag,
                    count: n.count,
                    type: e.data.type,
                    id: e.data.id
                  }) : l.emit(r.SWITCH_STREAM_ABORT, {
                    source: e.data.source,
                    entry: t,
                    rule: e.data.rule,
                    reason: "frequency",
                    tag: n.tag,
                    count: n.count,
                    type: e.data.type,
                    id: e.data.id
                  }) : !I || !p || "update" !== p.type && "recover" !== p.type || "update" === e.data.type ? (D = !0, setTimeout((function () {
                    D = !1
                  }), 500), p && G(p), h.debugEnabled() && h.debug("set updating to e.data in onStreamSwitch"), H(e.data), "update" === e.data.type ? h.debugEnabled() && h.debug("update source: " + JSON.stringify(e.data.source)) : h.debugEnabled() && h.debug("switch stream: " + JSON.stringify(t)), S.length > 1 && S.pop(), F(t.h5live), N || O && !I && !N ? (h.debugEnabled() && h.debug("connect to new source without terminating the old one"), e.data.options.forcePlay && !N && (N = !0), M(e.data)) : (S.shift(), h.debugEnabled() && h.debug("replaced source"), P({
                    data: {
                      tag: e.data.options.tag,
                      count: w,
                      type: e.data.type,
                      id: e.data.id
                    }
                  }))) : l.emit(r.SWITCH_STREAM_ABORT, {
                    source: e.data.source,
                    entry: t,
                    rule: e.data.rule,
                    reason: "recover" === p.type ? "recover" : "updateProgress",
                    tag: n.tag,
                    count: n.count,
                    type: e.data.type,
                    id: e.data.id
                  })
                }
              }, {
                type: i.API_PLAY, listener: function () {
                  if (h.debugEnabled() && h.debug("api play"), N = !0, O ? (h.debugEnabled() && h.debug("send network play"), l.emit(r.NETWORK_PLAY)) : M(p && p.options.forcePlay ? p : void 0), I) {
                    var e = x("hls").url;
                    l.emit(r.VIDEO_SOURCE, {src: e, type: c.HLS})
                  }
                }
              }, {
                type: i.API_PAUSE, listener: function () {
                  h.debugEnabled() && h.debug("api pause"), N = !1, (!O || p) && L(), I && l.emit(r.VIDEO_SOURCE, {
                    src: "",
                    type: c.HLS
                  })
                }
              }, {
                type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case d.PAUSED:
                      p && P({data: {tag: p.options.tag, count: p.options.count, type: p.type, id: p.id}})
                  }
                }
              }, {
                type: i.CAN_PLAY, listener: function () {
                  p && I && (h.debugEnabled() && h.debug("updating onCanPlay is " + JSON.stringify(p)), clearTimeout(_), P({
                    data: {
                      tag: p.options.tag,
                      count: p.options.count,
                      type: p.type,
                      id: p.id
                    }
                  }))
                }
              }];

            function P(e) {
              S.length > 1 && S.shift(), g && g.id === e.data.id && (h.debugEnabled() && h.debug("set updating to updatingTimeoutObject in onUpdateSourceSuccess"), H(g), V(null)), "update" === e.data.type ? l.emit(r.UPDATE_SOURCE_SUCCESS, {
                source: p.source,
                entry: p.entry,
                rule: p.rule,
                tag: e.data.tag,
                count: e.data.count,
                type: e.data.type,
                id: e.data.id
              }) : l.emit(r.SWITCH_STREAM_SUCCESS, {
                source: p.source,
                entry: p.entry,
                rule: p.rule,
                tag: e.data.tag,
                count: e.data.count,
                type: e.data.type,
                id: e.data.id
              }), h.debugEnabled() && h.debug("set updating to false in onUpdateSourceSuccess"), H(!1), clearTimeout(_)
            }

            function M(e) {
              var n, i, a = e ? S.length - 1 : 0;
              if (v || S[a].security || !I) {
                k(!N, "paused"), k(v && I, "metastreamonly"), k(!v && !!S[a].security && I, "checkandclose"), k(e ? e.faststart : C, "faststart");
                var o = t.isMediaOverQuicSupported && E.playback.enableMediaOverQuic ? "webtransport" : "websocket";
                n = (i = x(o, a)).url;
                var s = e ? r.NETWORK_UPDATE_SOURCE : r.CONNECT;
                h.debugEnabled() && h.debug("connect to: " + n, 1), l.emit(s, {
                  url: n,
                  config: i,
                  update: e || !1,
                  reconnect: E.playback.reconnect,
                  timeouts: E.playback.timeouts,
                  connectionType: o
                }), I || l.emit(r.URL, {url: n})
              }
              I && (k(e ? e.faststart : C, "faststart"), n = (i = x("hls")).url, l.emit(r.URL, {url: n}), l.emit(r.VIDEO_SOURCE, {
                src: n,
                type: c.HLS
              }))
            }

            function L(e) {
              h.debugEnabled() && h.debug("disconnecting"), l.emit(r.DISCONNECT, {silent: !!e})
            }

            function F(e) {
              var n = e.rtmp, i = e.params;
              T.initConfig().setServer(e.server).setToken(e.token).setQueryParams(i).setSecurity(e.security), T.connectionConfig.server.websocket.length || T.connectionConfig.server.hls.length || l.emit(r.NO_SERVER_ERROR), "object" == typeof n && n.url && n.url.length && n.streamname && n.streamname.length || i ? T.setRtmp(n) : l.emit(r.MISSING_RTMP_ERROR), (t.isIOSDesktopMode || t.isIOS) && T.addQueryParam("os", "ios"), S.push(T.connectionConfig)
            }

            function x(e, t) {
              var n = void 0 !== typeof t && t > -1 && void 0 !== typeof S[t] ? t : S.length - 1, r = S[n];
              return A.initURL(r, e).processConfigFlags(y).processConfigQuery(f).processSecurity().buildConnectionURL(), A.connectionConfig
            }

            function k(e, t) {
              !0 === e && void 0 === y[t] ? y[t] = !0 : !1 === e && y[t] && delete y[t]
            }

            function B(e) {
              for (var t in s) if (Object.prototype.hasOwnProperty.call(s, t) && s[t] === e) return t
            }

            function H(e) {
              h.debugEnabled() && h.debug("set updating to " + JSON.stringify(e) + " from " + JSON.stringify(p)), p = e
            }

            function G(e) {
              h.debugEnabled() && h.debug("set updatingPrevious to " + JSON.stringify(e) + " from " + JSON.stringify(m)), m = e
            }

            function V(e) {
              h.debugEnabled() && h.debug("set updatingTimeoutObject to " + JSON.stringify(e) + " from " + JSON.stringify(g)), g = e
            }

            return h.debugEnabled() && h.debug("init"), n.add({target: l, listeners: U}), {
              destroy: function () {
                n.remove({target: l, listeners: U})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3445: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(1933), n(9474), n(7146), n(561), n(4813)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s, d) {
            var u, c, l, f, E, p, m = e.create("AdjustControllerAdapter"),
              g = {default: i, fastadaptive: a, balancedadaptive: a}, b = "balancedadaptive";
            return m.debugEnabled() && m.debug("init"), l = d.playback.latencyControlMode, f = t.isTridentBrowser, E = n.isManagedMediaSourceH264Supported && t.isIOS, p = t.mustUseHLS || d.playback.allowSafariHlsFallback && t.canUseHLS, c = "default", l !== r.FAST_ADAPTIVE || f ? l !== r.BALANCED_ADAPTIVE || f || (c = b) : E || p ? (c = b, l = r.BALANCED_ADAPTIVE) : c = "fastadaptive", m.debugEnabled() && m.debug("use adjustController type " + c), s.emit(o.CONTROL_MODE_SET, {latencyControlMode: l}), u = g[c].create(s, l), {
              calcBufferGoal: function (e) {
                return u.calcBufferGoal(e)
              }, destroy: function () {
                u.destroy(), u = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 561: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(492), n(9474), n(4234)], void 0 === (i = function (e, t, n, r, i) {
        return {
          create: function (a, o) {
            var s, d = e.create("AdaptiveAdjustController"), u = {real: 0, base: 0, min: 0, max: 0}, c = 0, l = 0,
              f = 0, E = 0, p = 0, m = 1e3, g = 0, b = 0, _ = 0, h = 0, T = .998, A = 0, S = 0,
              y = {fastadaptive: {minClamp: .3, range: .4}, balancedadaptive: {minClamp: .5, range: .7}}, R = [{
                type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case n.PAUSED:
                      c = 0, l = 0, f = 0, E = 0, p = 0, m = 1e3, g = 0, b = 0, _ = 0, h = 0;
                      break;
                    case n.BUFFERING:
                    case n.PLAYING:
                  }
                }
              }, {
                type: i.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer, u.base || (u.base = s.start), u.min = Math.max(s.min + .1 + .125 * (s.min - .2), A), u.max = u.min + S
                }
              }];
            return d.debugEnabled() && d.debug("init"), t.add({
              target: a,
              listeners: R
            }), Object.prototype.hasOwnProperty.call(y, o) || (o = r.FAST_ADAPTIVE, d.debugEnabled() && d.debug("use default mode fast")), A = y[o].minClamp, S = y[o].range, d.debugEnabled() && d.debug("use mode " + o), {
              destroy: function () {
                t.remove({target: a, listeners: R})
              }, calcBufferGoal: function (e) {
                if (f = e.stats.buffer.end, E = window.performance.now(), h < 8) u.base = u.min, h++; else {
                  c && l && (p = p * T + (1e3 * (f - c) - (E - l)), m = Math.min(m, p) * T, g = Math.max(g, p) * T, b = (g - m) / 2, _ = Math.max(Math.abs(m), Math.abs(b))), l = E, c = f;
                  var t = s.min + Math.abs(2 * _) / 1e3;
                  t = Math.min(u.max, t), t = Math.max(u.min, t), t = Math.round(100 * t) / 100, u.base = t
                }
                return u
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7146: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(492), n(5337), n(4234)], void 0 === (i = function (e, t, n, r, i) {
        return {
          create: function (r) {
            var a, o = e.create("DefaultAdjustController"), s = {real: 0, base: 0, min: 0, max: 0}, d = [{
              type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case n.PAUSED:
                  case n.BUFFERING:
                  case n.PLAYING:
                }
              }
            }, {
              type: i.BUFFER_TWEAKS_CREATED, listener: function (e) {
                a = e.data.tweaks.buffer, s.base || (s.base = a.target)
              }
            }];
            return o.debugEnabled() && o.debug("init"), t.add({target: r, listeners: d}), {
              destroy: function () {
                t.remove({target: r, listeners: d})
              }, calcBufferGoal: function () {
                return s
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4842: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f = e.create("HLSDefaultConservativeLatencyController"), E = 0, p = 0, m = 1, g = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case t.PLAYING:
                    break;
                  case t.PAUSED:
                    _()
                }
              }
            }, {
              type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                s = e.data.tweaks.buffer
              }
            }];

            function b(e) {
              var t = 0;
              return e && l ? (t = (window.performance.now() - l) / 1e3, l = 0) : e || l || (l = window.performance.now()), t
            }

            function _() {
              E = 0
            }

            return f.debugEnabled() && f.debug("init"), _(), n.add({
              target: i,
              listeners: g
            }), {
              checkLatency: function (e, t) {
                o = e.stats, m = o.playbackrate.current, d = t.base, c = 1, p = o.buffer.delay.avg;
                var n = Math.abs(m - 1) < 1e-6;
                if (u = d + 0, E = o.buffer.end > E + .1 ? o.buffer.end : E, s.limit < p) 1.1 !== m && (f.debugEnabled() && f.debug("avg over limit, set speed to 1.1"), c = 1.1, b(), a.setRate(m, c)); else if ((u - .2 >= p || s.min + .2 >= p) && !n) {
                  var r = b(!0);
                  r && f.debugEnabled() && f.debug("normalize speed after " + r.toFixed(2) + " seconds", 2), c = 1, a.setRate(m, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: g}), a.destroy(), a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9076: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f, E = e.create("HLSWebkitProgressiveLatencyController"), p = 0, m = 0, g = 1, b = 0,
              _ = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      T()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }];

            function h(e) {
              var t = 0;
              return e && f ? (t = (window.performance.now() - f) / 1e3, f = 0) : e || f || (f = window.performance.now()), t
            }

            function T() {
              p = 0, clearTimeout(l), l = 0
            }

            return E.debugEnabled() && E.debug("init"), T(), n.add({
              target: i,
              listeners: _
            }), {
              checkLatency: function (e, t) {
                o = e.stats, g = o.playbackrate.current, d = t.base, c = 1, m = o.buffer.delay.avg;
                var n = Math.abs(g - 1) < 1e-6;
                if (b = Math.round(1e3 * (n ? o.buffer.delay.max - m : m - o.buffer.delay.min)) / 1e3, u = d + b, p = o.buffer.end > p + .1 ? o.buffer.end : p, s.limit < m || s.limit < m + .25 && 1.1 === g) 1.1 !== g && (E.debugEnabled() && E.debug("avg over limit, set speed to 1.1"), c = 1.1, h(), a.setRate(g, c)); else if (n && u + .25 < m || !n && u < m && s.min + .05 < m) {
                  if (!l) {
                    var r = 1e3 * (f ? 2 + 2 * Math.random() : .5 + 1.5 * Math.random());
                    E.debugEnabled() && E.debug("avg over bufferGoalReal but under limit, make check in " + r + "ms"), l = setTimeout((function () {
                      E.debugEnabled() && E.debug("check timeout fired"), l = 0, u < m && s.min + .05 < m ? (h(), c = 1.05, a.setRate(g, c)) : E.debugEnabled() && E.debug("after check timeout avg not over bufferGoalReal, do nothing", 2)
                    }), r)
                  }
                } else if ((u - .15 >= m || s.min + .05 >= m) && !n) {
                  var i = h(!0);
                  i && E.debugEnabled() && E.debug("normalize speed after " + i.toFixed(2) + " seconds", 2), c = 1, a.setRate(g, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: _})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3184: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f, E = e.create("WSSChromiumProgressiveLatencyController"), p = 0, m = 0, g = 1,
              b = 0, _ = 0, h = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      S()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }];

            function T(e) {
              var t = 0;
              return e && f ? (t = (window.performance.now() - f) / 1e3, f = 0) : e || f || (f = window.performance.now()), t
            }

            function A() {
              return 1 === g
            }

            function S() {
              p = 0, clearTimeout(l), l = 0
            }

            return E.debugEnabled() && E.debug("init"), S(), n.add({target: i, listeners: h}), {
              checkLatency: function (e, t) {
                if (o = e.stats, g = o.playbackrate.current, b = o.currentTime, d = t.base, c = 1, m = o.buffer.delay.avg, _ = Math.round(1e3 * (+A() ? o.buffer.delay.max - m : m - o.buffer.delay.min)) / 1e3, u = d + _, p = o.buffer.end > p + .1 ? o.buffer.end : p, s.max < m && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o)) E.debug("max buffer reached, seeking to goal..."), a.setSeek(b, p - d); else if (s.limit < m) 1.1 !== g && (E.debugEnabled() && E.debug("avg over limit, set speed to 1.1"), c = 1.1, T(), a.setRate(g, c)); else if (A() && u + .1 < m || !A() && u < m) {
                  if (!l) {
                    var n = 1e3 * (f ? 2 + 2 * Math.random() : .5 + 1.5 * Math.random());
                    E.debugEnabled() && E.debug("avg over bufferGoalReal but under limit, make check in " + n + "ms"), l = setTimeout((function () {
                      E.debugEnabled() && E.debug("check timeout fired"), l = 0, A() && u + .1 < m || !A() && u < m ? f || (T(), c = function () {
                        var e = s.limit - u, t = Math.max(0, Math.min(e, o.buffer.delay.avg - u)),
                          n = Math.round(t / e * 100), r = 1 + Math.round(.1 * Math.sqrt(n / 100) * 100) / 100;
                        return E.debugEnabled() && E.debug("avg at " + n + "% between target and limit", 2), E.debugEnabled() && E.debug("after check timeout still avg with " + n + "% over target, set speed to " + r + " with sqrt function", 2), r
                      }(), a.setRate(g, c)) : E.debugEnabled() && E.debug("after check timeout avg not over bufferGoalReal, do nothing", 2)
                    }), n)
                  }
                } else if (u >= m && 1 !== g) {
                  var r = T(!0);
                  r && E.debugEnabled() && E.debug("normalize speed after " + r.toFixed(2) + " seconds", 2), c = 1, a.setRate(g, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: h}), a.destroy(), a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2531: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f = e.create("WSSDefaultConservativeLatencyController"), E = 0, p = 0, m = 1, g = 0,
              b = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      h()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }];

            function _(e) {
              var t = 0;
              return e && l ? (t = (window.performance.now() - l) / 1e3, l = 0) : e || l || (l = window.performance.now()), t
            }

            function h() {
              E = 0
            }

            return f.debugEnabled() && f.debug("init"), h(), n.add({
              target: i,
              listeners: b
            }), {
              checkLatency: function (e, t) {
                if (o = e.stats, m = o.playbackrate.current, g = o.currentTime, d = t.base, c = 1, p = o.buffer.delay.avg, u = d + 0, E = o.buffer.end > E + .1 ? o.buffer.end : E, s.max < p && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o)) f.debug("max buffer reached, seeking to goal..."), a.setSeek(g, E - d); else if (s.limit < p) 1.1 !== m && (f.debugEnabled() && f.debug("avg over limit, set speed to 1.1"), c = 1.1, _(), a.setRate(m, c)); else if (u >= p && 1 !== m) {
                  var n = _(!0);
                  n && f.debugEnabled() && f.debug("normalize speed after " + n.toFixed(2) + " seconds", 2), c = 1, a.setRate(m, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: b}), a.destroy(), a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8538: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f, E, p, m = e.create("WSSFirefoxProgressiveLatencyController"), g = 0, b = 0, _ = 1,
              h = 0, T = 0, A = 0, S = 0, y = !1, R = !1, v = 1, O = 0, I = 6e4, C = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      F()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }, {
                type: r.FRAME_DROP, listener: function (e) {
                  var t = e.data.type;
                  switch (m.debugEnabled() && m.debug("framedrop event with type " + t), t) {
                    case"extreme":
                    case"high":
                    case"medium":
                      R ? m.debugEnabled() && m.debug("frame drop handle blocked") : (m.debugEnabled() && m.debug("frame drop handle unblocked, starting"), U(!0, "framedrop event with type " + t), y ? (m.debugEnabled() && m.debug("frame drop handle still activated, restart cooldown timeout"), P()) : (m.debugEnabled() && m.debug("set buffer goal to buffer goal max"), T = u, m.debugEnabled() && m.debug("check framedrop cooldown factor timeout"), S ? (m.debugEnabled() && m.debug("framedrop cooldown factor timeout is running, clearing"), L(), v <= 4 ? (m.debugEnabled() && m.debug("framedrop cooldown factor lower or 4, multiply"), v *= 2, m.debugEnabled() && m.debug("new framedrop cooldown factor is " + v.toString())) : m.debugEnabled() && m.debug("framedrop cooldown factor still at max (" + v.toString() + "), do nothing")) : m.debugEnabled() && m.debug("framedrop cooldown factor timeout is not running, use current factor (" + v.toString() + ")")))
                  }
                }
              }];

            function N(e) {
              var t = 0;
              return e && E ? (t = (window.performance.now() - E) / 1e3, E = 0) : e || E || (E = window.performance.now()), t
            }

            function D() {
              return 1 === _
            }

            function w() {
              return _ > 1
            }

            function U(e, t) {
              m.debugEnabled() && m.debug("set framedrop blocked to " + e.toString() + " from handle: '" + t + "'"), e ? R = !0 : (R = !1, P())
            }

            function P() {
              M(), L(), m.debugEnabled() && m.debug("set framedrop cooldown timeout with " + (I * v / 1e3).toString() + " s"), A = setTimeout((function () {
                m.debugEnabled() && m.debug("framedrop cooldown timeout reached, set handle to inactive"), M(), y = !1, L(), m.debugEnabled() && m.debug("set framedrop cooldown factor timeout with " + (I * v / 1e3).toString() + " s"), S = setTimeout((function () {
                  m.debugEnabled() && m.debug("framedrop cooldown factor timeout reached, check for decrease cooldown factor"), L(), v > 1 ? (m.debugEnabled() && m.debug("framedrop cooldown factor higher 1, divide"), v /= 2, m.debugEnabled() && m.debug("new framedrop cooldown factor is " + v.toString())) : m.debugEnabled() && m.debug("framedrop cooldown factor still at min (" + v.toString() + "), do nothing")
                }), I * v)
              }), I * v)
            }

            function M() {
              m.debugEnabled() && m.debug("clear framedrop cooldown timeout and set to 0"), clearTimeout(A), A = 0
            }

            function L() {
              m.debugEnabled() && m.debug("clear framedrop cooldown factor timeout and set to 0"), clearTimeout(S), S = 0
            }

            function F() {
              g = 0, clearTimeout(f), f = 0, clearTimeout(A), A = 0, clearTimeout(S), S = 0, y = !1, R = !1, v = 1
            }

            return m.debugEnabled() && m.debug("init"), F(), n.add({target: i, listeners: C}), {
              checkLatency: function (e, t) {
                if (o = e.stats, _ = o.playbackrate.current, h = o.currentTime, d = t.base, u = t.max, l = 1, b = o.buffer.delay.avg, O = Math.round(1e3 * (w() ? o.buffer.delay.max - b : b - o.buffer.delay.min)) / 1e3, R || y || (T *= .998), c = Math.max(d, T) + O, g = o.buffer.end > g + .1 ? o.buffer.end : g, s.max < b && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o)) R && U(!1, "over buffer max"), m.debug("max buffer reached, seeking to goal..."), a.setSeek(h, g - d); else if (s.limit < b) R && U(!1, "between buffer limit and max"), 1.1 !== _ && (m.debugEnabled() && m.debug("avg over limit, set speed to 1.1"), l = 1.1, N(), a.setRate(_, l)); else if (D() && c + .1 < b || w() && c < b) {
                  if (!f) {
                    var n = 1e3 * (E ? 2 + 2 * Math.random() : .5 + 1.5 * Math.random());
                    m.debugEnabled() && m.debug("avg over bufferGoalReal but under limit, make check in " + n + "ms"), f = setTimeout((function () {
                      m.debugEnabled() && m.debug("check timeout fired"), f = 0, D() && c + .1 < b || w() && c < b ? E || (N(), l = function () {
                        var e = s.limit - c, t = Math.max(0, Math.min(e, o.buffer.delay.avg - c)),
                          n = Math.round(t / e * 100), r = 1 + Math.round(.1 * Math.sqrt(n / 100) * 100) / 100;
                        return m.debugEnabled() && m.debug("avg at " + n + "% between target and limit"), m.debugEnabled() && m.debug("after check timeout still avg with " + n + "% over target, set speed to " + r + " with sqrt function"), r
                      }(), a.setRate(_, l)) : m.debugEnabled() && m.debug("after check timeout avg not over bufferGoalReal, do nothing")
                    }), n)
                  }
                } else !R && c >= b && w() ? ((p = N(!0)) && m.debugEnabled() && m.debug("normalize speed after " + p.toFixed(2) + " seconds"), l = 1, a.setRate(_, l)) : R && y && c <= b + .1 ? ((p = N(!0)) && m.debugEnabled() && m.debug("normalize speed after " + p.toFixed(2) + " seconds"), m.debugEnabled() && m.debug("normalize speed after reached bufferGoalReal again after frame drop"), R && U(!1, "buffer target reached after framedrop"), l = 1, a.setRate(_, l)) : R && !y && (m.debugEnabled() && m.debug("slow speed to reach bufferGoalReal after frame drop"), N(), l = .97, a.setRate(_, l), y = !0);
                return c
              }, destroy: function () {
                n.remove({target: i, listeners: C}), a.destroy(), a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9321: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c = e.create("WSSTridentConservativeLatencyController"), l = 0, f = 0, E = 0, p = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case t.PLAYING:
                    break;
                  case t.PAUSED:
                    m()
                }
              }
            }, {
              type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                s = e.data.tweaks.buffer
              }
            }];

            function m() {
              l = 0
            }

            return c.debugEnabled() && c.debug("init"), m(), n.add({
              target: i,
              listeners: p
            }), {
              checkLatency: function (e, t) {
                return o = e.stats, E = o.currentTime, d = t.base, f = o.buffer.delay.avg, u = d + 0, l = o.buffer.end > l + .1 ? o.buffer.end : l, s.max < f && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o) ? (c.debug("max buffer reached, seeking to goal..."), a.setSeek(E, l - d)) : s.limit < f && (c.debugEnabled() && c.debug("seek to buffer goal"), a.setSeek(E, l - u)), u
              }, destroy: function () {
                n.remove({target: i, listeners: p})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2395: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f = e.create("WSSWebkitConservativeLatencyController"), E = 0, p = 0, m = 1, g = 0,
              b = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      h()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }];

            function _(e) {
              var t = 0;
              return e && l ? (t = (window.performance.now() - l) / 1e3, l = 0) : e || l || (l = window.performance.now()), t
            }

            function h() {
              E = 0
            }

            return f.debugEnabled() && f.debug("init"), h(), n.add({
              target: i,
              listeners: b
            }), {
              checkLatency: function (e, t) {
                o = e.stats, m = o.playbackrate.current, g = o.currentTime, d = t.base, c = 1, p = o.buffer.delay.avg;
                var n = Math.abs(m - 1) < 1e-6;
                if (u = d + 0, E = o.buffer.end > E + .1 ? o.buffer.end : E, s.max < p && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o)) f.debug("max buffer reached, seeking to goal..."), a.setSeek(g, E - d); else if (s.limit < p || s.limit < p + .25 && 1.1 === m) 1.1 !== m && (f.debugEnabled() && f.debug("avg over limit, set speed to 1.1"), c = 1.1, _(), a.setRate(m, c)); else if ((u - .15 >= p || s.min + .05 >= p) && !n) {
                  var r = _(!0);
                  r && f.debugEnabled() && f.debug("normalize speed after " + r.toFixed(2) + " seconds", 2), c = 1, a.setRate(m, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: b}), a.destroy(), a = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4422: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i, a) {
            var o, s, d, u, c, l, f, E = e.create("WSSWebkitProgressiveLatencyController"), p = 0, m = 0, g = 1, b = 0,
              _ = 0, h = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case t.PLAYING:
                      break;
                    case t.PAUSED:
                      A()
                  }
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  s = e.data.tweaks.buffer
                }
              }];

            function T(e) {
              var t = 0;
              return e && f ? (t = (window.performance.now() - f) / 1e3, f = 0) : e || f || (f = window.performance.now()), t
            }

            function A() {
              p = 0, clearTimeout(l), l = 0
            }

            return E.debugEnabled() && E.debug("init"), A(), n.add({target: i, listeners: h}), {
              checkLatency: function (e, t) {
                o = e.stats, g = o.playbackrate.current, b = o.currentTime, d = t.base, c = 1, m = o.buffer.delay.avg;
                var n = Math.abs(g - 1) < 1e-6;
                if (_ = Math.round(1e3 * (n ? o.buffer.delay.max - m : m - o.buffer.delay.min)) / 1e3, u = d + _, p = o.buffer.end > p + .1 ? o.buffer.end : p, s.max < m && function (e) {
                  return e && !isNaN(e.currentTime) && e.currentTime > 0
                }(o)) E.debug("max buffer reached, seeking to goal..."), a.setSeek(b, p - d); else if (s.limit < m || s.limit < m + .25 && 1.1 === g) 1.1 !== g && (E.debugEnabled() && E.debug("avg over limit, set speed to 1.1"), c = 1.1, T(), a.setRate(g, c)); else if (n && u + .25 < m || !n && u < m && s.min + .05 < m) {
                  if (!l) {
                    var r = 1e3 * (f ? 2 + 2 * Math.random() : .5 + 1.5 * Math.random());
                    E.debugEnabled() && E.debug("avg over bufferGoalReal but under limit, make check in " + r + "ms"), l = setTimeout((function () {
                      E.debugEnabled() && E.debug("check timeout fired"), l = 0, u < m && s.min + .05 < m ? (T(), c = 1.05, a.setRate(g, c)) : E.debugEnabled() && E.debug("after check timeout avg not over bufferGoalReal, do nothing", 2)
                    }), r)
                  }
                } else if ((u - .15 >= m || s.min + .05 >= m) && !n) {
                  var i = T(!0);
                  i && E.debugEnabled() && E.debug("normalize speed after " + i.toFixed(2) + " seconds", 2), c = 1, a.setRate(g, c)
                }
                return u
              }, destroy: function () {
                n.remove({target: i, listeners: h})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4813: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "adjustControllerAdapter.";
        return {BASE: e, CONTROL_MODE_SET: e + "controlModeSet"}
      }.apply(t, [])) || (e.exports = n)
    }, 1148: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "adjustLatencyHandler.";
        return {BASE: e, SEEK: e + "seek", RATE: e + "rate"}
      }.apply(t, [])) || (e.exports = n)
    }, 4234: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "latencyManager.";
        return {
          BASE: e,
          BUFFER_TWEAKS_CREATED: e + "bufferTweaksCreated",
          FRAME_DROP: e + "frameDrop",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          TIME_OFFSET: e + "timeOffset",
          CONFIG: e + "config",
          PLAY_STATS: e + "playStats",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          DOCUMENT_VISIBLE: e + "documentVisible",
          DOCUMENT_HIDDEN: e + "documentHidden"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2158: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "liveController.";
        return {BASE: e, BUFFER_GOAL_STATS: e + "bufferGoalStats"}
      }.apply(t, [])) || (e.exports = n)
    }, 4285: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(9474), n(8930), n(2531), n(2395), n(9321), n(3184), n(8538), n(4422), n(4842), n(9076)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l) {
        return {
          create: function (f, E) {
            var p, m, g, b, _, h, T, A, S = e.create("LatencyControllerAdapter"), y = {
                wssdefaultconservative: i,
                wsswebkitconservative: a,
                wsstridentconservative: o,
                wsschromiumprogressive: s,
                wssfirefoxprogressive: d,
                wsswebkitprogressive: u,
                hlsdefaultconservative: c,
                hlswebkitprogressive: l
              }, R = "wssdefaultconservative", v = "wsswebkitconservative", O = "wsstridentconservative",
              I = "hlsdefaultconservative", C = "wsschromiumprogressive", N = "wssfirefoxprogressive",
              D = "wsswebkitprogressive", w = "hlswebkitprogressive";
            return S.debugEnabled() && S.debug("init"), _ = t.mustUseHLS || E.playback.allowSafariHlsFallback && t.canUseHLS, b = E.playback.latencyControlMode, h = t.isTridentBrowser, T = t.isWebkitBrowser, A = t.isFirefox, g = r.create(f), m = h ? O : b === n.FAST_ADAPTIVE || b === n.BALANCED_ADAPTIVE ? T && _ ? w : T ? D : A ? N : C : T && _ ? I : T ? v : R, S.debugEnabled() && S.debug("use latencyController type " + m), p = y[m].create(f, g), {
              checkLatency: function (e, t) {
                return p.checkLatency(e, t)
              }, destroy: function () {
                p.destroy(), p = null, g.destroy(), g = null
              }, seek: function (e, t) {
                return g.setSeek(e, t)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7831: function (e, t, n) {
      var r, i;
      r = [n(8333), n(9658), n(5055), n(2450), n(3937), n(3019), n(4234), n(1148), n(4813), n(2158), n(8449)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        "use strict";
        return {
          create: function (l) {
            var f, E, p = new t, m = e.create("LatencyManager"), g = [],
              b = [{from: s.SEEK, to: i.SEEK}, {from: s.RATE, to: i.RATE}, {
                from: u.BUFFER_GOAL_STATS,
                to: i.BUFFER_GOAL_STATS
              }, {from: d.CONTROL_MODE_SET, to: i.CONTROL_MODE_SET}],
              _ = [{from: a.BUFFER_TWEAKS_CREATED, to: o.BUFFER_TWEAKS_CREATED}, {
                from: a.FRAME_DROP,
                to: o.FRAME_DROP
              }, {from: a.RANDOM_ACCESS_POINT, to: o.RANDOM_ACCESS_POINT}, {
                from: a.TIME_OFFSET,
                to: o.TIME_OFFSET
              }, {from: a.CONFIG, to: o.CONFIG}, {
                from: a.PLAY_STATS,
                to: o.PLAY_STATS
              }, {from: a.APPLICATION_STATE_CHANGE, to: o.APPLICATION_STATE_CHANGE}, {
                from: r.VISIBLE,
                to: o.DOCUMENT_VISIBLE
              }, {from: r.HIDDEN, to: o.DOCUMENT_HIDDEN}];
            return m.debugEnabled() && m.debug("init"), f = n.create(l, p, _), E = n.create(p, l, b), g.push(c.create(p)), {
              destroy: function () {
                for (f.destroy(), f = null, E.destroy(), E = null; g.length;) g.pop().destroy()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8449: function (e, t, n) {
      var r, i;
      r = [n(8333), n(492), n(6637), n(4234), n(2158), n(3445), n(4285), n(6631)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        return {
          create: function (d) {
            var u, c, l, f, E, p = e.create("LiveController"), m = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (n.remove({target: d, listeners: g}), e.data.state) {
                  case t.LOADING:
                  case t.PLAYING:
                  case t.BUFFERING:
                    n.add({target: d, listeners: g})
                }
              }
            }, {
              type: r.CONFIG, listener: function (e) {
                l = a.create(d, e.data.config), f = o.create(d, e.data.config), E = s.create(d, f, e.data.config)
              }
            }], g = [{
              type: r.PLAY_STATS, listener: function (e) {
                u = e.data, E.disable(), (c = l.calcBufferGoal(u)).real = f.checkLatency(u, c), d.emit(i.BUFFER_GOAL_STATS, {
                  real: Math.round(100 * c.real) / 100,
                  base: Math.round(100 * c.base) / 100,
                  min: Math.round(100 * c.min) / 100,
                  max: Math.round(100 * c.max) / 100
                }), E.update(u, c), E.enable()
              }
            }];
            return p.debugEnabled() && p.debug("init"), n.add({target: d, listeners: m}), {
              destroy: function () {
                n.remove({target: d, listeners: m}), l.destroy(), f.destroy(), E.destroy()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8930: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(492), n(6637), n(4234), n(1148)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s = e.create("AdjustLatencyHandler"), d = [], u = 0, c = [{
              type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case n.PLAYING:
                    break;
                  case n.PAUSED:
                    l()
                }
              }
            }, {
              type: i.RANDOM_ACCESS_POINT, listener: function (e) {
                for (d.push(e.data.onRandomAccessPoint.streamTime / 1e3 + u / 1e3); d.length > 10;) d.shift()
              }
            }, {
              type: i.TIME_OFFSET, listener: function (e) {
                u = e.data.offset
              }
            }];

            function l() {
              for (; d.length;) d.shift();
              u = 0
            }

            return s.debugEnabled() && s.debug("init"), l(), r.add({
              target: o,
              listeners: c
            }), {
              setSeek: function (e, n) {
                s.debugEnabled() && s.debug("should seeking to " + n), t.isTridentBrowser && (n = function (e, t) {
                  for (var n = 0; n < d.length; ++n) if (d[n] > e && d[n] <= t) return d[n];
                  return -1
                }(e, n), s.debugEnabled() && s.debug("seeking to RAP " + n)), n >= 0 && (s.debugEnabled() && s.debug("seeking to " + n), o.emit(a.SEEK, {position: n}))
              }, setRate: function (e, t) {
                Math.abs(e.toFixed(3) - t) > 0 && (s.debugEnabled() && s.debug("set rate to " + t), o.emit(a.RATE, {rate: t}))
              }, destroy: function () {
                l(), r.remove({target: o, listeners: c})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6631: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(492), n(6637), n(4234)], void 0 === (i = function (e, t, n, r, i) {
        return {
          create: function (a, o, s) {
            var d, u, c, l, f, E, p = e.create("VisibilityLatencyHandler"), m = 0,
              g = t.mustUseHLS || s.playback.allowSafariHlsFallback && t.canUseHLS, b = !0, _ = !0, h = 0,
              T = [150, 500, 2e3, 4e3, 6e3], A = [{
                type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (d = e.data.state) {
                    case n.PLAYING:
                      b = !0;
                      break;
                    case n.PAUSED:
                      b = !1
                  }
                }
              }, {type: i.DOCUMENT_HIDDEN, listener: S}, {type: i.DOCUMENT_VISIBLE, listener: S}];

            function S(e) {
              l = e.name === i.DOCUMENT_HIDDEN, p.debug(l ? "hidden" : "visible"), O(u) && I() ? y(l) : p.debug("seek is not allowed or possible")
            }

            function y(e) {
              if (!b && !e && !_) return p.debug("handling visibility skipped, saved for later"), void (_ = !0);
              if (e) v(), E = performance.now(), m = u.buffer.delay.avg, p.debug("stored bufferValue hidden state: " + m); else {
                var t = performance.now() - E;
                p.debug("checking latency on visibility handler"), t < 1e3 && (h = 1), R(m + .15)
              }
            }

            function R(e) {
              h >= 5 ? v() : (f && clearTimeout(f), f = setTimeout((function () {
                if (p.debug("latencyCheckpointIndex: " + h), p.debug("bufferThreshold: " + e), p.debug("buffer delay: " + u.buffer.delay.avg), !O(u) || !I()) return p.debug("seek is not allowed or possible"), void v();
                u.buffer.delay.avg > e && (p.debug("visibility seek done"), o.seek(u.currentTime, u.buffer.end - c.base), R(e))
              }), T[h]), h++)
            }

            function v() {
              b = !0, h = 0, clearTimeout(f), m = 0, E = 0
            }

            function O(e) {
              return e && !isNaN(e.currentTime) && e.currentTime > 0
            }

            function I() {
              return !g && c && u.duration && !isNaN(u.duration.current) && d !== n.PAUSED
            }

            return p.debugEnabled() && p.debug("init"), r.add({target: a, listeners: A}), {
              destroy: function () {
                r.remove({target: a, listeners: A}), v()
              }, disable: function () {
                b = !1
              }, enable: function () {
                b = !0, _ && (p.debug("handling previously skipped event"), y(l), _ = !1)
              }, update: function (e, t) {
                u = e.stats, c = t
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9665: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(3778), n(3890), n(492), n(3019), n(7771), n(1683)], void 0 === (i = function (e, t, n, r, i, a, o, s, d) {
        return {
          create: function (u, c) {
            var l, f, E, p, m, g, b, _, h, T, A, S, y, R = e.create("MetaData"), v = 0, O = [{
              type: o.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case a.LOADING:
                    C(), n.add({target: u, listeners: I});
                    break;
                  case a.PAUSING:
                    n.remove({target: u, listeners: I})
                }
              }
            }, {
              type: o.TIME_OFFSET, listener: function (e) {
                v = e.data.offset
              }
            }, {
              type: o.STREAM_INFO, listener: function () {
                C()
              }
            }, {
              type: s.UPDATE_SOURCE_SUCCESS, listener: function () {
                C()
              }
            }, {
              type: s.SWITCH_STREAM_SUCCESS, listener: function () {
                C()
              }
            }], I = [{type: o.META_DATA, listener: N}, {type: o.ADJUSTED_META_DATA, listener: N}, {
              type: o.PLAY_STATS,
              listener: function (e) {
                for (T = e.data.stats.currentTime, A = e.data.stats.buffer.delay.current; m.length;) (b = m.shift()).streamTime <= T ? u.emit(d.RECEIVED, b) : g.push(b);
                for (; g.length;) m.push(g.shift())
              }
            }];

            function C() {
              T = 0, A = 0, E = !0, p = {
                handlerName: "",
                streamTime: 0,
                serverTime: 0,
                diffTime: 0,
                message: []
              }, m = [], g = []
            }

            function N(e) {
              R.debugEnabled() && R.debug("onMetaData");
              var t, n, a = e.data[e.data.eventType];
              if (1 === a.chunkIndex) "function" == typeof p.message.push && 0 !== p.message.length && u.emit(d.ERROR, {
                code: r.STREAM.METADATA_STILL_PROCESSING,
                message: i.STREAM.METADATA_STILL_PROCESSING
              }), E = !0, t = l && f ? T + A + .25 : a.streamTime + v / 1e3, n = isNaN(n) ? 3 : parseInt(n, 10), S = Math.floor(t * Math.pow(10, n)) / Math.pow(10, n), y = a.handlerName, p = {
                handlerName: y,
                streamTime: S,
                message: []
              }; else {
                if (0 === p.message.length || "function" != typeof p.message.push) return void (E && (u.emit(d.ERROR, {
                  code: r.STREAM.METADATA_NO_START_INDEX,
                  message: i.STREAM.METADATA_NO_START_INDEX
                }), E = !1, p.message = []));
                if (!E) return
              }
              if (p.message.push(a.message), p.message.length !== a.chunkIndex) E && (u.emit(d.ERROR, {
                code: r.STREAM.METADATA_WRONG_INDEX,
                message: i.STREAM.METADATA_WRONG_INDEX
              }), E = !1, p.message = []); else if (a.chunkCount - a.chunkIndex == 0) try {
                _ = p.message.join(""), y = p.handlerName, R.debugEnabled() && R.debug("handlerName=" + y + ", metaData=" + _), _ = JSON.parse(_), p.message = _, h = {
                  handlerName: p.handlerName,
                  streamTime: p.streamTime,
                  message: p.message
                }, m.push(h)
              } catch (e) {
                u.emit(d.ERROR, {code: r.STREAM.METADATA_INVALID_JSON, message: i.STREAM.METADATA_INVALID_JSON})
              }
            }

            return R.debugEnabled() && R.debug("init"), l = t.mustUseHLS || c.playback.allowSafariHlsFallback && t.canUseHLS, f = c.playback.metadataLowDelay, n.add({
              target: u,
              listeners: O
            }), {
              destroy: function () {
                n.remove({target: u, listeners: O})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6701: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(4762), n(708), n(5739), n(7844), n(6627)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (r) {
            var s = t.create("Adaptive.AdaptionController"), d = !1, u = {}, c = [{
              type: n.CONFIG, listener: function (e) {
                var t = e.data.config.source.options.adaption.rule, n = e.data.config.source.options.adaption;
                d = o.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && o.canUseHLS, n.useHLS = d, f(t)
              }
            }, {
              type: n.UPDATE_SOURCE, listener: function (e) {
                var t = e.data.source.options.adaption.rule, n = e.data.source.options.adaption;
                n.useHLS = d, f(t)
              }
            }, {
              type: n.SWITCH_STREAM, listener: function (e) {
                "direct" === e.data.type && f("none")
              }
            }, {
              type: n.SET_ADAPTION, listener: function (e) {
                var t = e.data.adaption.rule, n = e.data.adaption;
                n.useHLS = d, f(t)
              }
            }], l = {deviationOfMean: i, deviationOfMean2: a};

            function f(e, t) {
              for (var n in u) {
                const t = u[n];
                n !== e ? (s.debugEnabled() && s.debug("component disabled: " + n), t.disable()) : (s.debugEnabled() && s.debug("component enabled: " + n), t.enable())
              }
            }

            return function () {
              for (var t in s.debugEnabled() && s.debug("initialize"), e.add({
                target: r,
                listeners: c
              }), l) u[t] = l[t].create(r)
            }(), {
              destroy: function () {
                for (var t in u) u[t].destroy();
                e.remove({target: r, listeners: c})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 708: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "adaptionController.";
        return {BASE: e, SWITCH_SUGGESTION: e + "switchSuggestion"}
      }.apply(t, [])) || (e.exports = n)
    }, 8134: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "ressourceController.";
        return {
          BASE: e,
          STATS: e + "stats",
          BUFFERING: e + "buffering",
          INITIAL_SWITCH_UP: e + "initialSwitchUp",
          STREAM_INFO: e + "streamInfo",
          STREAM_QUALITY: e + "streamQuality",
          PAUSED: e + "paused",
          BUFFERING_LONG: e + "longBuffering"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3049: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(8197), n(4762), n(8134), n(3349), n(6400)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (n) {
            var i = t.create("Adaptive.RessourceController"), s = [], d = [{
              type: r.CONFIG, listener: function (e) {
                c(e.data.config.source.options.adaption.rule, e.data.config.source.options.adaption)
              }
            }, {
              type: r.UPDATE_SOURCE, listener: function (e) {
                c(e.data.source.options.adaption.rule, e.data.source.options.adaption)
              }
            }, {
              type: r.SWITCH_STREAM, listener: function (e) {
                "direct" === e.data.type && c("none")
              }
            }, {
              type: r.SET_ADAPTION, listener: function (e) {
                c(e.data.adaption.rule, e.data.adaption)
              }
            }], u = {deviationOfMean: a, deviationOfMean2: o};

            function c(e, t) {
              for (; s.length;) s.pop().destroy();
              Object.prototype.hasOwnProperty.call(u, e) && s.push(u[e].create(n, t))
            }

            return i.debugEnabled() && i.debug("initialize"), e.add({target: n, listeners: d}), {
              destroy: function () {
                for (; s.length;) s.pop().destroy();
                e.remove({target: n, listeners: d})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7844: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(4762), n(708), n(8134), n(4035)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s, d, u = t.create("Adaptive.DeviationOfMean2.Adaption"), c = !0, l = !1, f = void 0, E = !1, p = 0,
              m = !1, g = !1, b = !1, _ = [{type: n.UPDATE_SOURCE_SUCCESS, listener: v}, {
                type: n.UPDATE_SOURCE_FAIL,
                listener: O
              }, {type: n.UPDATE_SOURCE_ABORT, listener: O}, {
                type: n.SWITCH_STREAM_SUCCESS,
                listener: v
              }, {type: n.SWITCH_STREAM_FAIL, listener: O}, {
                type: n.SWITCH_STREAM_ABORT,
                listener: O
              }, {
                type: n.LOADED_DATA, listener: function () {
                  u.debugEnabled() && u.debug("onLoadedData"), g = !0
                }
              }, {
                type: n.TIME_OFFSET, listener: function () {
                  u.debugEnabled() && u.debug("onFirstFragmentRendered"), b = !0
                }
              }, {
                type: i.STATS, listener: function (e) {
                  f && (m || v(!1), function (e) {
                    if (!c) {
                      u.debugEnabled() && u.debug("making switch suggestion allowed");
                      var t, n, i = e.buffer.delay.bufferDelaysStandardDeviationsDev.length;
                      u.debugEnabled() && u.debug("bufferDelaysStandardDeviationsLength >= 5 && !wasAbortedHighest ?"), i >= 5 && !C() && (u.debugEnabled() && u.debug("bufferDelaysStandardDeviationsLength >= 5 && !wasAbortedHighest !"), t = S(e.buffer.delay.bufferDelaysStandardDeviationsDev, 5), n = S(e.buffer.delay.bufferDelaysArithmeticMeans, 5), u.debugEnabled() && u.debug("bufferDevationAboveValue && bufferCurrentHasMinimumValue ?"), function (e, t) {
                        u.debugEnabled() && u.debug("bufferDevationAboveValue with limit 0.045");
                        for (var n = !0, r = 0; r <= e.length - 1; r++) if (!T(e[r], .045)) {
                          n = !1;
                          break
                        }
                        return n
                      }(t) && function (e, t) {
                        for (var n = !1, r = 0; r <= e.length - 1; r++) if (h(e[r], .5)) {
                          n = !0;
                          break
                        }
                        return n
                      }(n) && (u.debugEnabled() && u.debug("make suggestion to switch down"), y(!0), R(r.SWITCH_SUGGESTION, {suggestion: "down"}))), u.debugEnabled() && u.debug("bufferDelaysStandardDeviationsLength >= 8 && !wasAbortedLowest ?"), i >= 8 && !N() && (u.debugEnabled() && u.debug("bufferDelaysStandardDeviationsLength >= 8 && !wasAbortedLowest !"), function (e, t) {
                        u.debugEnabled() && u.debug("bufferDevationBelowValue with limit 0.016");
                        for (var n = !0, r = 0; r <= e.length - 1; r++) if (!h(e[r], .016)) {
                          n = !1;
                          break
                        }
                        return n
                      }(t = S(e.buffer.delay.bufferDelaysStandardDeviationsDev, 8)) && (u.debugEnabled() && u.debug("make suggestion to switch up"), y(!0), R(r.SWITCH_SUGGESTION, {suggestion: "up"})))
                    }
                  }(e.data.deviationOfMean2))
                }
              }, {
                type: i.BUFFERING, listener: function (e) {
                  f && (function (e) {
                    var t, n = e.data.startBufferings.length;
                    c || C() || (u.debugEnabled() && u.debug("evaluating buffering events allowed"), n >= 2 && (u.debugEnabled() && u.debug("startBufferingsLength " + n), t = S(e.data.startBufferings, 3), u.debugEnabled() && u.debug("startBufferingsCutOffLength >= 3 && isCriticalEventHistory ?"), t.length >= 3 && A(t, 10) ? (u.debugEnabled() && u.debug("startBufferingsCutOffLength >= 3 && isCriticalEventHistory !"), y(!0), R(r.SWITCH_SUGGESTION, {
                      suggestion: "down",
                      priority: 1
                    })) : t.length >= 2 && (t = S(e.data.startBufferings, 2), u.debugEnabled() && u.debug("startBufferingsCutOffLength >= 2 && isCriticalEventHistory ?"), A(t, 10) && (u.debugEnabled() && u.debug("startBufferingsCutOffLength >= 2 && isCriticalEventHistory !"), y(!0), R(r.SWITCH_SUGGESTION, {
                      suggestion: "down",
                      priority: 0
                    })))))
                  }(e), I())
                }
              }, {
                type: i.STREAM_INFO, listener: function () {
                  f && v(!1)
                }
              }, {
                type: i.STREAM_QUALITY, listener: function (e) {
                  f && (p = e.data.streamQuality.timestamp.standardDeviation, u.debugEnabled() && u.debug("serverStandardDeviation " + p))
                }
              }, {
                type: i.PAUSED, listener: function () {
                  f && (D(), I())
                }
              }, {
                type: i.BUFFERING_LONG, listener: function () {
                  f && (u.debugEnabled() && u.debug("onBufferingLong"), y(!0), R(r.SWITCH_SUGGESTION, {
                    suggestion: "down",
                    priority: 1
                  }))
                }
              }, {
                type: a.SUGGESTION_ABORT, listener: function (e) {
                  f && (D(e.data.reason), O())
                }
              }];

            function h(e, t) {
              return e < t
            }

            function T(e, t) {
              return e > t
            }

            function A(e, t) {
              u.debugEnabled() && u.debug("isCriticalEventHistory with allowedTimeDifferenceSeconds " + t);
              var n = e.length;
              return function (e, t, n) {
                return (t - e) / 1e3 < n
              }(e[0].timestamp, e[n - 1].timestamp, t)
            }

            function S(e, t) {
              var n = e.length;
              return n > 0 ? e.slice(Math.max(n - t, 0), n) : []
            }

            function y(e) {
              u.debug((e ? "allow" : "deny") + " prediction"), e ? (u.debugEnabled() && u.debug("deny prediction"), clearTimeout(d), d = 0, c = !0) : d ? u.debugEnabled() && u.debug("allow prediction already in timeout") : (u.debugEnabled() && u.debug("allow prediction in 3 seconds"), d = setTimeout((function () {
                u.debugEnabled() && u.debug("allow prediction after timeout"), c = !1, d = 0
              }), 3e3))
            }

            function R(e, t) {
              u.debugEnabled() && u.debug("make suggestion to switch " + t.suggestion + (t.priority ? " with priority " + t.priority : " without priority")), o.emit(e, t)
            }

            function v(e) {
              f && (u.debugEnabled() && u.debug("success"), l || e || (m = !0, s && clearTimeout(s), s = setTimeout((function () {
                u.debugEnabled() && u.debug("initialSwitchUpTimeout elapsed"), (g || b) && (u.debugEnabled() && u.debug("initialSwitchUpTimeout to switch up"), y(!0), R(r.SWITCH_SUGGESTION, {suggestion: "up"}), b = !1, g = !1)
              }), 5e3)), D(), y(!1))
            }

            function O() {
              f && (u.debugEnabled() && u.debug("error"), y(!1), I())
            }

            function I() {
              u.debugEnabled() && u.debug("destroy initial switch up"), clearTimeout(s), l = !0
            }

            function C() {
              return "highest" === E
            }

            function N() {
              return "lowest" === E
            }

            function D(e) {
              (E = e || !1) ? u.debugEnabled() && u.debug("aborted with reason: " + E) : u.debugEnabled() && u.debug("reset abort reason"), N() && I()
            }

            return u.debugEnabled() && u.debug("initialize"), e.add({target: o, listeners: _}), {
              destroy: function () {
                e.remove({target: o, listeners: _})
              }, enable: function () {
                f = !0, u.debugEnabled() && u.debug("enable initial switch up"), m = !1, l = !1, clearTimeout(s)
              }, disable: function () {
                f = !1, I()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6400: function (e, t, n) {
      var r, i;
      r = [n(492), n(6637), n(8333), n(5337), n(4762), n(8134)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s, d, u, c, l, f, E, p = n.create("Adaptive.DeviationOfMean2.Ressource"), m = !1, g = [], b = [],
              _ = [], h = [], T = [{
                type: i.APPLICATION_STATE_CHANGE, listener: function (t) {
                  for (s || p.debugEnabled() && p.debug("initial player state"), (s = t.data.state) === e.PAUSED && "playbackrestart" !== t.data.reason && (R(), o.emit(a.PAUSED, {paused: {}})), s === e.PLAYING && b.length && b[b.length - 1].state === e.LOADING && (p.debugEnabled() && p.debug("setRessourceBlockTimeout from playing"), S()); b.length > 100;) b.shift();
                  b.push({state: s, timestamp: performance.now()}), c && v()
                }
              }, {
                type: i.PLAY_STATS, listener: function (e) {
                  var t, n;
                  m || (l.add(e.data.stats.buffer.delay.current), l.count % 10 == 0 && (f.add(l.arithmetic), E.add(f.values[f.values.length - 1]), _.add(E.deviation), h.add(_.deviation), t = l, (n = d.adaptive.buffer.delay).avg = t.arithmetic, n.min = t.minimum, n.max = t.maximum, n.deviation = t.deviation, n.samples = t.values.length, n.count = t.count, n.bufferDelaysArithmeticMeans = f.values, n.bufferDelaysStandardDeviations = _.values, n.bufferDelaysStandardDeviationsDev = h.values, o.emit(a.STATS, {deviationOfMean2: d.adaptive})))
                }
              }, {
                type: i.BUFFERING, listener: function (t) {
                  for (p.debugEnabled() && p.debug("push startBuffering!"), g.push({
                    event: t.data,
                    timestamp: performance.now()
                  }); g.length > 10;) g.shift();
                  m ? p.debugEnabled() && p.debug("block emit startBuffering!") : (p.debugEnabled() && p.debug("emit startBuffering!"), o.emit(a.BUFFERING, {startBufferings: g})), p.debugEnabled() && p.debug("setBufferingLongTimeout"), v(), c = setTimeout((function () {
                    p.debugEnabled() && p.debug("setBufferingLongTimeout fired"), s === e.BUFFERING ? (p.debugEnabled() && p.debug("setBufferingLongTimeout fired and still in buffering state"), o.emit(a.BUFFERING_LONG)) : p.debugEnabled() && p.debug("setBufferingLongTimeout fired and not in buffering state")
                  }), 3e3)
                }
              }, {
                type: i.STREAM_INFO, listener: function () {
                  o.emit(a.STREAM_INFO, {streamInfo: {}}), R()
                }
              }, {
                type: i.STREAM_QUALITY, listener: function (e) {
                  o.emit(a.STREAM_QUALITY, {streamQuality: e.data.onStreamQuality})
                }
              }, {type: i.UPDATE_SOURCE_SUCCESS, listener: A}, {type: i.SWITCH_STREAM_SUCCESS, listener: A}];

            function A() {
              p.debugEnabled() && p.debug("setRessourceBlockTimeout from success"), S()
            }

            function S() {
              p.debugEnabled() && p.debug("setRessourceBlockTimeout"), y(!0), clearTimeout(u), u = setTimeout((function () {
                p.debugEnabled() && p.debug("setRessourceBlockTimeout fired"), y(!1), s === e.BUFFERING ? (p.debugEnabled() && p.debug("setRessourceBlockTimeout fired but in buffering state"), o.emit(a.BUFFERING, {startBufferings: g})) : (p.debugEnabled() && p.debug("setRessourceBlockTimeout fired & not in buffering state"), R())
              }), 2e3)
            }

            function y(e) {
              p.debugEnabled() && p.debug("setRessourceBlock " + (e ? "true" : "false")), m = e
            }

            function R() {
              for (p.debugEnabled() && p.debug("reset stats"), d = {
                adaptive: {
                  buffer: {
                    delay: {
                      samples: 0,
                      frequency: 1,
                      avg: 0,
                      min: 0,
                      max: 0,
                      deviation: 0,
                      count: 0
                    }
                  }
                }
              }, f = r.create(20, 1), E = r.create(10, 1), l = r.create(10, 1), _ = r.create(10, 1), h = r.create(10, 1); g.length;) g.pop()
            }

            function v() {
              p.debugEnabled() && p.debug("clearBufferingLongTimeout"), clearTimeout(c), c = 0
            }

            return p.debugEnabled() && p.debug("initialize"), R(), t.add({
              target: o,
              listeners: T
            }), {
              destroy: function () {
                t.remove({target: o, listeners: T})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5739: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(4762), n(708), n(8134), n(4035)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o, s) {
            var d, u, c = t.create("Adaptive.DeviationOfMean.Adaption"), l = !0, f = s && s.useHLS ? .035 : .02, E = !1,
              p = void 0, m = !1, g = 0, b = !1, _ = !1, h = !1, T = [{type: n.UPDATE_SOURCE_SUCCESS, listener: I}, {
                type: n.UPDATE_SOURCE_FAIL,
                listener: C
              }, {type: n.UPDATE_SOURCE_ABORT, listener: C}, {
                type: n.SWITCH_STREAM_SUCCESS,
                listener: I
              }, {type: n.SWITCH_STREAM_FAIL, listener: C}, {
                type: n.SWITCH_STREAM_ABORT,
                listener: C
              }, {
                type: n.LOADED_DATA, listener: function () {
                  c.debugEnabled() && c.debug("onLoadedData"), _ = !0
                }
              }, {
                type: n.TIME_OFFSET, listener: function () {
                  c.debugEnabled() && c.debug("onFirstFragmentRendered"), h = !0
                }
              }, {
                type: i.STATS, listener: function (e) {
                  p && (b || I(!0), function (e) {
                    if (c.debugEnabled() && c.debug("make switch suggestion ?"), !l) {
                      c.debugEnabled() && c.debug("making switch suggestion allowed");
                      var t, n, i = e.buffer.delay.bufferDelaysStandardDeviations.length;
                      c.debugEnabled() && c.debug("bufferDelaysStandardDeviationsLength >= 5 && !wasAbortedHighest ?"), i >= 5 && !D() && (c.debugEnabled() && c.debug("bufferDelaysStandardDeviationsLength >= 5 && !wasAbortedHighest !"), t = R(e.buffer.delay.bufferDelaysStandardDeviations, 5), n = R(e.buffer.delay.bufferDelaysArithmeticMeans, 5), c.debugEnabled() && c.debug("bufferDevationAboveValue && bufferCurrentHasMinimumValue ?"), function (e, t) {
                        c.debugEnabled() && c.debug("bufferDevationAboveValue with limit 0.075");
                        for (var n = !0, r = 0; r <= e.length - 1; r++) if (!S(e[r], .075)) {
                          n = !1;
                          break
                        }
                        return n
                      }(t) && function (e, t) {
                        c.debugEnabled() && c.debug("bufferCurrentHasMinimumValue with limit 0.5");
                        for (var n = !1, r = 0; r <= e.length - 1; r++) if (A(e[r], .5)) {
                          n = !0;
                          break
                        }
                        return n
                      }(n) && (c.debugEnabled() && c.debug("bufferDevationAboveValue && bufferCurrentHasMinimumValue !"), c.debugEnabled() && c.debug("make suggestion to switch down"), v(!0), O(r.SWITCH_SUGGESTION, {suggestion: "down"}))), c.debugEnabled() && c.debug("bufferDelaysStandardDeviationsLength >= 8 && !wasAbortedLowest ?"), i >= 8 && !w() && (c.debugEnabled() && c.debug("bufferDelaysStandardDeviationsLength >= 8 && !wasAbortedLowest !"), t = R(e.buffer.delay.bufferDelaysStandardDeviations, 8), c.debugEnabled() && c.debug("bufferDevationBelowValue ?"), function (e, t) {
                        c.debugEnabled() && c.debug("bufferDevationBelowValue with limit " + t);
                        for (var n = !0, r = 0; r <= e.length - 1; r++) if (!A(e[r], t)) {
                          n = !1;
                          break
                        }
                        return n
                      }(t, f) && (c.debugEnabled() && c.debug("bufferDevationBelowValue !"), c.debugEnabled() && c.debug("make suggestion to switch up"), v(!0), O(r.SWITCH_SUGGESTION, {suggestion: "up"})))
                    }
                  }(e.data.deviationOfMean))
                }
              }, {
                type: i.BUFFERING, listener: function (e) {
                  p && (function (e) {
                    var t, n = e.data.startBufferings.length;
                    c.debugEnabled() && c.debug("evaluate buffering events ?"), l || D() || (c.debugEnabled() && c.debug("evaluating buffering events allowed"), n >= 2 && (c.debugEnabled() && c.debug("startBufferingsLength " + n), t = R(e.data.startBufferings, 3), c.debugEnabled() && c.debug("startBufferingsCutOffLength >= 3 && isCriticalEventHistory ?"), t.length >= 3 && y(t, 10) ? (c.debugEnabled() && c.debug("startBufferingsCutOffLength >= 3 && isCriticalEventHistory !"), v(!0), O(r.SWITCH_SUGGESTION, {
                      suggestion: "down",
                      priority: 1
                    })) : t.length >= 2 && (t = R(e.data.startBufferings, 2), c.debugEnabled() && c.debug("startBufferingsCutOffLength >= 2 && isCriticalEventHistory ?"), y(t, 10) && (c.debugEnabled() && c.debug("startBufferingsCutOffLength >= 2 && isCriticalEventHistory !"), v(!0), O(r.SWITCH_SUGGESTION, {
                      suggestion: "down",
                      priority: 0
                    })))))
                  }(e), N())
                }
              }, {
                type: i.STREAM_INFO, listener: function () {
                  p && I(!0)
                }
              }, {
                type: i.STREAM_QUALITY, listener: function (e) {
                  p && (g = e.data.streamQuality.timestamp.standardDeviation, c.debugEnabled() && c.debug("serverStandardDeviation " + g))
                }
              }, {
                type: i.PAUSED, listener: function () {
                  p && (U(), N())
                }
              }, {
                type: i.BUFFERING_LONG, listener: function () {
                  p && (c.debugEnabled() && c.debug("onBufferingLong"), v(!0), O(r.SWITCH_SUGGESTION, {
                    suggestion: "down",
                    priority: 1
                  }))
                }
              }, {
                type: a.SUGGESTION_ABORT, listener: function (e) {
                  p && (U(e.data.reason), C())
                }
              }];

            function A(e, t) {
              return e < t
            }

            function S(e, t) {
              return e > t
            }

            function y(e, t) {
              c.debugEnabled() && c.debug("isCriticalEventHistory with allowedTimeDifferenceSeconds " + t);
              var n = e.length;
              return function (e, t, n) {
                return (t - e) / 1e3 < n
              }(e[0].timestamp, e[n - 1].timestamp, t)
            }

            function R(e, t) {
              var n = e.length;
              return n > 0 ? e.slice(Math.max(n - t, 0), n) : []
            }

            function v(e) {
              c.debug((e ? "allow" : "deny") + " prediction"), e ? (c.debugEnabled() && c.debug("deny prediction"), clearTimeout(u), u = 0, l = !0) : u ? c.debugEnabled() && c.debug("allow prediction already in timeout") : (c.debugEnabled() && c.debug("allow prediction in 3 seconds"), u = setTimeout((function () {
                c.debugEnabled() && c.debug("allow prediction after timeout"), l = !1, u = 0
              }), 3e3))
            }

            function O(e, t) {
              c.debugEnabled() && c.debug("make suggestion to switch " + t.suggestion + (t.priority ? " with priority " + t.priority : " without priority")), o.emit(e, t)
            }

            function I(e) {
              p && (c.debugEnabled() && c.debug("success"), E || e || (b = !0, d && clearTimeout(d), d = setTimeout((function () {
                c.debugEnabled() && c.debug("initialSwitchUpTimeout elapsed"), (_ || h) && (c.debugEnabled() && c.debug("initialSwitchUpTimeout to switch up"), v(!0), O(r.SWITCH_SUGGESTION, {suggestion: "up"}), h = !1, _ = !1)
              }), 5e3)), U(), v(!1))
            }

            function C() {
              p && (c.debugEnabled() && c.debug("error"), v(!1), N())
            }

            function N() {
              c.debugEnabled() && c.debug("destroy initial switch up"), clearTimeout(d), E = !0
            }

            function D() {
              return "highest" === m
            }

            function w() {
              return "lowest" === m
            }

            function U(e) {
              (m = e || !1) ? c.debugEnabled() && c.debug("aborted with reason: " + m) : c.debugEnabled() && c.debug("reset abort reason"), w() && N()
            }

            return c.debugEnabled() && c.debug("initialize"), e.add({target: o, listeners: T}), {
              destroy: function () {
                e.remove({target: o, listeners: T})
              }, enable: function () {
                p = !0, c.debugEnabled() && c.debug("reset initial switch up"), b = !1, E = !1, clearTimeout(d)
              }, disable: function () {
                p = !1, N()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3349: function (e, t, n) {
      var r, i;
      r = [n(492), n(6637), n(8333), n(8197), n(5337), n(4762), n(8134)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (r) {
            var s, d, u, c, l, f, E, p = n.create("Adaptive.DeviationOfMean.Ressource"), m = !1, g = [], b = [], _ = [],
              h = [{
                type: a.APPLICATION_STATE_CHANGE, listener: function (t) {
                  for (s || p.debugEnabled() && p.debug("initial player state"), (s = t.data.state) === e.PAUSED && "playbackrestart" !== t.data.reason && (y(), r.emit(o.PAUSED, {paused: {}})), s === e.PLAYING && b.length && b[b.length - 1].state === e.LOADING && (p.debugEnabled() && p.debug("setRessourceBlockTimeout from playing"), A()); b.length > 100;) b.shift();
                  b.push({state: s, timestamp: performance.now()}), c && R()
                }
              }, {
                type: a.PLAY_STATS, listener: function (e) {
                  var t, n;
                  m || (l.add(e.data.stats.buffer.delay.current), l.count % 10 == 0 && (f.add(l.arithmetic), E.add(f.values[f.values.length - 1]), _.add(E.deviation), t = l, (n = d.adaptive.buffer.delay).avg = t.arithmetic, n.min = t.minimum, n.max = t.maximum, n.deviation = t.deviation, n.samples = t.values.length, n.count = t.count, n.bufferDelaysArithmeticMeans = f.values, n.bufferDelaysStandardDeviations = _.values, r.emit(o.STATS, {deviationOfMean: d.adaptive})))
                }
              }, {
                type: a.BUFFERING, listener: function (t) {
                  for (p.debugEnabled() && p.debug("push startBuffering!"), g.push({
                    event: t.data,
                    timestamp: performance.now()
                  }); g.length > 10;) g.shift();
                  m ? p.debugEnabled() && p.debug("block emit startBuffering!") : (p.debugEnabled() && p.debug("emit startBuffering!"), r.emit(o.BUFFERING, {startBufferings: g})), p.debugEnabled() && p.debug("setBufferingLongTimeout"), R(), c = setTimeout((function () {
                    p.debugEnabled() && p.debug("setBufferingLongTimeout fired"), s === e.BUFFERING ? (p.debugEnabled() && p.debug("setBufferingLongTimeout fired and still in buffering state"), r.emit(o.BUFFERING_LONG)) : p.debugEnabled() && p.debug("setBufferingLongTimeout fired and not in buffering state")
                  }), 3e3)
                }
              }, {
                type: a.STREAM_INFO, listener: function () {
                  r.emit(o.STREAM_INFO, {streamInfo: {}}), y()
                }
              }, {
                type: a.STREAM_QUALITY, listener: function (e) {
                  r.emit(o.STREAM_QUALITY, {streamQuality: e.data.onStreamQuality})
                }
              }, {type: a.UPDATE_SOURCE_SUCCESS, listener: T}, {type: a.SWITCH_STREAM_SUCCESS, listener: T}];

            function T() {
              p.debugEnabled() && p.debug("setRessourceBlockTimeout from success"), A()
            }

            function A() {
              p.debugEnabled() && p.debug("setRessourceBlockTimeout"), S(!0), clearTimeout(u), u = setTimeout((function () {
                p.debugEnabled() && p.debug("setRessourceBlockTimeout fired"), S(!1), s === e.BUFFERING ? (p.debugEnabled() && p.debug("setRessourceBlockTimeout fired but in buffering state"), r.emit(o.BUFFERING, {startBufferings: g})) : (p.debugEnabled() && p.debug("setRessourceBlockTimeout fired & not in buffering state"), y())
              }), 2e3)
            }

            function S(e) {
              p.debugEnabled() && p.debug("setRessourceBlock " + (e ? "true" : "false")), m = e
            }

            function y() {
              for (p.debugEnabled() && p.debug("reset stats"), d = {
                adaptive: {
                  buffer: {
                    delay: {
                      samples: 0,
                      frequency: 1,
                      avg: 0,
                      min: 0,
                      max: 0,
                      deviation: 0,
                      count: 0
                    }
                  }
                }
              }, f = i.create(20, 1), E = i.create(10, 1), l = i.create(10, 1), _ = i.create(20, 1); g.length;) g.pop()
            }

            function R() {
              p.debugEnabled() && p.debug("clearBufferingLongTimeout"), clearTimeout(c), c = 0
            }

            return p.debugEnabled() && p.debug("initialize"), y(), t.add({
              target: r,
              listeners: h
            }), {
              destroy: function () {
                t.remove({target: r, listeners: h})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4762: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "sourceManager.";
        return {
          BASE: e,
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_QUALITY: e + "streamQuality",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          STREAM_URL: e + "streamUrl",
          CONFIG: e + "config",
          PLAYING: e + "playing",
          BUFFERING: e + "buffering",
          PLAY_STATS: e + "playStats",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          UPDATE_SOURCE: e + "updateSource",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          SWITCH_STREAM: e + "switchStream",
          SWITCH_STREAM_INIT: e + "switchStreamInit",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort",
          SET_ADAPTION: e + "setAdaption",
          LOADED_DATA: e + "loadedData",
          TIME_OFFSET: e + "timeOffset",
          PUBLIC_EVENT: e + "publicEvent"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4035: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "switchController.";
        return {BASE: e, STREAM_SWITCH: e + "streamSwitch", SUGGESTION_ABORT: e + "suggestionAbort"}
      }.apply(t, [])) || (e.exports = n)
    }, 8307: function (e, t, n) {
      var r, i;
      r = [n(8333), n(9658), n(6627), n(8197), n(6637), n(5055), n(164), n(3019), n(8983), n(7771), n(4762), n(708), n(8134), n(4035), n(6701), n(3049), n(4122)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g) {
        "use strict";
        return {
          create: function (n) {
            var r, i, l = new t, b = e.create("SourceManager"), _ = [],
              h = [{from: f.STATS, to: o.STATS}, {from: E.STREAM_SWITCH, to: o.STREAM_SWITCH}],
              T = [{from: s.CONFIG, to: c.CONFIG}, {from: s.PLAY_STATS, to: c.PLAY_STATS}, {
                from: s.FRAME_DROP,
                to: c.FRAME_DROP
              }, {from: s.RANDOM_ACCESS_POINT, to: c.RANDOM_ACCESS_POINT}, {
                from: s.STREAM_QUALITY,
                to: c.STREAM_QUALITY
              }, {from: s.APPLICATION_STATE_CHANGE, to: c.APPLICATION_STATE_CHANGE}, {
                from: s.UPDATE_SOURCE,
                to: c.UPDATE_SOURCE
              }, {from: s.SWITCH_STREAM, to: c.SWITCH_STREAM}, {
                from: s.PUBLIC_EVENT,
                to: c.PUBLIC_EVENT
              }, {from: s.BUFFERING, to: c.BUFFERING}, {from: s.SET_ADAPTION, to: c.SET_ADAPTION}, {
                from: s.LOADED_DATA,
                to: c.LOADED_DATA
              }, {from: s.TIME_OFFSET, to: c.TIME_OFFSET}, {
                from: u.SERVER_INFO,
                to: c.SERVER_INFO
              }, {from: u.UPDATE_SOURCE_INIT, to: c.UPDATE_SOURCE_INIT}, {
                from: u.UPDATE_SOURCE_SUCCESS,
                to: c.UPDATE_SOURCE_SUCCESS
              }, {from: u.UPDATE_SOURCE_FAIL, to: c.UPDATE_SOURCE_FAIL}, {
                from: u.UPDATE_SOURCE_ABORT,
                to: c.UPDATE_SOURCE_ABORT
              }, {from: u.SWITCH_STREAM_INIT, to: c.SWITCH_STREAM_INIT}, {
                from: u.SWITCH_STREAM_SUCCESS,
                to: c.SWITCH_STREAM_SUCCESS
              }, {from: u.SWITCH_STREAM_FAIL, to: c.SWITCH_STREAM_FAIL}, {
                from: u.SWITCH_STREAM_ABORT,
                to: c.SWITCH_STREAM_ABORT
              }, {from: d.CREATED, to: c.STREAM_INFO}, {from: d.UPDATED, to: c.STREAM_INFO_UPDATE}];
            return b.debugEnabled() && b.debug("init"), r = a.create(n, l, T), i = a.create(l, n, h), _.push(g.create(l)), _.push(p.create(l)), _.push(m.create(l)), {
              destroy: function () {
                for (r.destroy(), r = null, i.destroy(), i = null; _.length;) _.pop().destroy()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4122: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(8197), n(492), n(4762), n(4035), n(708)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s) {
            var d, u, c, l, f, E, p, m, g, b, _, h, T, A, S, y, R, v, O, I, C, N = t.create("SwitchRequestController"),
              D = {}, w = 0, U = !1, P = {}, M = 0, L = !1, F = 0, x = 0, k = [], B = 0, H = 60, G = 120, V = null,
              W = !1, Y = 0, j = !1, K = [{
                type: i.CONFIG, listener: function (e) {
                  var t;
                  q(e.data.config.source), t = e.data.config.playback, c = t.faststart, l = t.autoplay, z("init")
                }
              }, {
                type: i.SWITCH_STREAM, listener: function (e) {
                  if ("recover" === e.data.type) {
                    for (var t = 0; t < Object.keys(P).length; t += 1) {
                      var n = Object.keys(P)[t];
                      if (Object.prototype.hasOwnProperty.call(P, n) && "down" === P[n][0]) {
                        e.data.index = P[n][1];
                        break
                      }
                    }
                    void 0 === e.data.index && (e.data.index = f)
                  }
                  var r;
                  N.debugEnabled() && N.debug("forced to switch to stream with index " + e.data.index), N.debugEnabled() && N.debug("current stream has index " + f + " of " + (p - 1)), (r = e.data.index) < p && r > -1 && (E = e.data.index, "direct" === (U = e.data.type) && (d.options.adaption.rule = "none"), z(U))
                }
              }, {
                type: i.UPDATE_SOURCE, listener: function (e) {
                  q(e.data.source), z(U = "update")
                }
              }, {
                type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (u || N.debugEnabled() && N.debug("initial player state"), u = e.data.state) {
                    case r.PAUSED:
                      re()
                  }
                }
              }, {
                type: i.UPDATE_SOURCE_SUCCESS, listener: function () {
                  U = !1, re()
                }
              }, {
                type: i.UPDATE_SOURCE_FAIL, listener: function () {
                  U = !1
                }
              }, {
                type: i.UPDATE_SOURCE_ABORT, listener: function () {
                  U = !1
                }
              }, {
                type: i.SWITCH_STREAM_INIT, listener: function (e) {
                  var t = e.data.tag;
                  N.debugEnabled() && N.debug('stream switch init with tag "' + t + '"')
                }
              }, {
                type: i.SWITCH_STREAM_SUCCESS, listener: function (e) {
                  delete P[e.data.id];
                  var t = e.data.tag, n = t.split(" streamSwitch "), r = e.data.type;
                  "down" === r && (L = !0, F = J()), "up" === r && (x = J(), k.push(x)), N.debugEnabled() && N.debug('stream switch success with tag "' + t + '"'), N.debugEnabled() && N.debug("switch with id " + n[1] + " was successful, switch index changed from " + f + " to " + D[n[1]]), Q(D[n[1]]), U = !1, re()
                }
              }, {
                type: i.SWITCH_STREAM_FAIL, listener: function (e) {
                  delete P[e.data.id];
                  var t = e.data.tag, n = t.split(" streamSwitch ");
                  N.debugEnabled() && N.debug('stream switch fail with tag "' + t + '"'), N.debugEnabled() && N.debug("switch with id " + n[1] + " has been failed with code " + e.data.code + ", switch index stays at " + f), U = !1, V = e.data.entry.index, O = e.data.type, te("switchStreamFailCount"), N.debugEnabled() && N.debug("switchStreamFailCount: " + Y)
                }
              }, {
                type: i.SWITCH_STREAM_ABORT, listener: function (e) {
                  delete P[e.data.id];
                  var t = e.data.tag, n = t.split(" streamSwitch ");
                  N.debugEnabled() && N.debug('stream switch abort with tag "' + t + '"'), N.debugEnabled() && N.debug("switch with id " + n[1] + " has been aborted" + (e.data && e.data.reason ? " with reason '" + e.data.reason + "'" : "") + ", switch index stays at " + f), U = !1
                }
              }, {
                type: i.SET_ADAPTION, listener: function (e) {
                  d.options.adaption = e.data.adaption
                }
              }, {
                type: o.SWITCH_SUGGESTION, listener: function (e) {
                  var t,
                    n = (t = e.data.suggestion, N.debugEnabled() && N.debug("lastFailedSwitchID: " + V + ", nextStreamIndex: " + E), (null === V || V === E) && t === O || (re(), !1));
                  if (N.debugEnabled() && N.debug("suggest stream to switch " + e.data.suggestion), N.debugEnabled() && N.debug("current stream has index " + f + " of " + (p - 1)), U && (!e.data.priority || e.data.priority && 1 !== e.data.priority)) N.debugEnabled() && N.debug("switch already initialized, abort"), ae("initialized"); else if (U && E === p - 1 && e.data.priority) N.debugEnabled() && N.debug("switch with priority to highest index already initialized, abort"), ae("initialized"); else if ((Y >= 3 || 1 === Y && B > 0) && n) !function () {
                    if (W || j) {
                      if (W && j) {
                        ae("switch fail timeout in progress");
                        var e = J() - R, t = $() - e;
                        N.debugEnabled() && N.debug("switchSuggestionTime " + M.toFixed(2) + "; timeout in sec: " + m + "; time left in sec: " + t.toFixed(2))
                      }
                    } else !function () {
                      j = !0;
                      var e = $();
                      N.debugEnabled() && N.debug("timeout value based on retryCooldownCounter: " + e), R = J(), ae("switch fail timeout started"), te("retryCooldownCounter"), v = setTimeout((function () {
                        ne(), W = !1
                      }), 1e3 * e)
                    }()
                  }(); else {
                    if (U = void 0, e.data.suggestion) if ("down" === e.data.suggestion) f < p - 1 ? void 0 === (E = X("down", e.data.priority, d.options.adaption.downStep)) ? (N.debugEnabled() && N.debug("suggest to switch down to the next possible quality but not possible due to omitted qualities, abort"), ae("omitted")) : (U = "down", W = !1, N.debugEnabled() && N.debug("downswitch suggestion, no timeout applied")) : (N.debugEnabled() && N.debug("suggest to switch down but highest index reached, abort"), ae("highest")); else if ("up" === e.data.suggestion) {
                      M = J(), b = Math.max(x, F), m = L ? $() : 0, _ = x > F ? "up" : "down";
                      var r = M - b;
                      if (0 === f) N.debugEnabled() && N.debug("suggest to switch up but lowest index reached, abort"), ae("lowest"), W = !1; else if (L && r < m) switch (h = m - r, N.debugEnabled() && N.debug("switchSuggestionTime " + M.toFixed(2) + "; lastSwitchTime " + b.toFixed(2) + "; timeout in sec: " + m + "; timeLeft: " + h.toFixed(2)), _) {
                        case"down":
                          N.debugEnabled() && N.debug("suggest to switch up but too less time passed since the last switch down"), ae("toofast");
                          break;
                        case"up":
                          N.debugEnabled() && N.debug("suggest to switch up but too less time passed since the last upswitch"), ae("toofast")
                      } else void 0 === (E = X("up")) ? (N.debugEnabled() && N.debug("suggest to switch up to the next possible quality but not possible due to omitted qualities, abort"), ae("omitted")) : (U = "up", W = !1, N.debugEnabled() && N.debug("after upswitch, no timeout applied"), C = G)
                    }
                    U ? z(U) : N.debugEnabled() && N.debug("switch not initialized")
                  }
                }
              }];

            function q(e) {
              p = (d = e).entries.length, f = d.startIndex, E = d.startIndex
            }

            function z(e) {
              N.debugEnabled() && N.debug("apply switch to stream with index " + E), w = Math.round(1e11 * Math.random()), D[w] = E, P[w] = [e, E], N.debugEnabled() && N.debug("switch with id " + w + " should change switch index from " + f + " to " + E);
              var t, i, o = n.copy(d.options.switch);
              "recover" === e && (o.timeout = 10, o.method = "client"), o.tag = "update" === e ? o.tag : (t = E, ((i = d.entries[t].h5live).rtmp ? i.rtmp.streamname : i.params && i.params.stream) + " streamSwitch " + w), o.pauseOnError = "update" === e || o.pauseOnError, N.debugEnabled() && N.debug('switch has tag "' + o.tag + '"');
              var p = u === r.PLAYING || r.BUFFERING || r.LOADING || r.READY && l, m = {
                source: n.copy(d),
                rule: n.copy(d.options.adaption.rule),
                downStep: n.copy(d.options.adaption.downStep),
                entry: n.copy(d.entries[E]),
                options: n.copy(o),
                faststart: !("init" !== e && "update" !== e || p) && c,
                type: e,
                id: w
              };
              switch (s.emit(a.STREAM_SWITCH, m), e) {
                case"init":
                  N.debugEnabled() && N.debug('stream switch init with tag "' + o.tag + '"'), N.debugEnabled() && N.debug("switch with id " + w + " is type 'init', set initial index to " + E), Q(E), ie();
                  break;
                case"update":
                case"direct":
                case"recover":
                  ie()
              }
            }

            function Q(e) {
              f = e
            }

            function J() {
              return (new Date).getTime() / 1e3
            }

            function X(e, t, n) {
              N.debugEnabled() && N.debug("getPossibleNextStreamIndex switchType: " + e + ", priority: " + t);
              var r, i, a, o = (r = d.options.adaption.omitRenditions, i = [], a = {
                high: 0,
                "medium-high": Math.round(1 * (p - 1) / 5),
                medium: Math.round(1 * (p - 1) / 2),
                "medium-low": Math.round(4 * (p - 1) / 5),
                low: p - 1
              }, Array.isArray(r) && (i = (i = r.map((function (e) {
                return isNaN(e) ? a[e] : parseInt(e, 10)
              }))).filter((function (e) {
                return "number" == typeof e && e >= 0 && e < p
              })).filter((function (e, t, n) {
                return n.indexOf(e) == t
              }))), i), s = "down" === e, u = s ? 1 === t ? p - 1 : Math.min(f + n, p - 1) : f - 1;
              if (!o || 0 === o.length) return N.debugEnabled() && N.debug("no omitted qualities, return startIndex: " + u), u;
              for (var c = new Array(p), l = 0; l < p; l++) c[l] = !0;
              for (var E = 0; E < o.length; E++) c[o[E]] = !1;
              var m = s ? function (e, t) {
                var n;
                for (N.debugEnabled() && N.debug("findDownSwitchCandidate downwards from startIndex: " + e), n = e; n < p; n++) if (t[n]) return n;
                for (N.debugEnabled() && N.debug("findDownSwitchCandidate upwards from startIndex: " + e), n = e - 1; n > f; n--) if (t[n]) return n
              }(u, c) : function (e, t) {
                N.debugEnabled() && N.debug("findUpSwitchCandidate upwards from startIndex: " + e);
                for (var n = e; n >= 0; n--) if (t[n]) return n
              }(u, c);
              return N.debugEnabled() && N.debug("indexCandidate: " + m), m
            }

            function $() {
              if (g = J(), I = m, j) {
                if (W) m = I; else switch (B) {
                  case 0:
                    Z(30);
                    break;
                  case 1:
                    Z(60);
                    break;
                  case 2:
                  default:
                    Z(90)
                }
                return m
              }
              if (g < b) return 0;
              var e = ee(g, F), t = Math.abs(x - F);
              y = ee(g, T), S = ee(g, A);
              var n = I + 10 < e, r = !!(e > (I <= H ? H : C + 60));
              if (W) m = I; else if (x > 0 && !W) if (t < 30 && e <= C + 10) Z(T && (x - T || x - A > 0) && (y > 60 && y < 180 || S < 300) ? 240 : G); else if (!W && n && r) switch (I) {
                case 30:
                case H:
                  Z(30);
                  break;
                case G:
                  Z(H);
                  break;
                case 240:
                  Z(G)
              } else Z(H); else Z(H);
              return m
            }

            function Z(e) {
              m = e, C = 30 === e ? H : e, W = !0, N.debugEnabled() && N.debug("applied timeout: " + e), 240 === m ? A = J() : m === G && (T = J())
            }

            function ee(e, t) {
              return e - t
            }

            function te(e) {
              if (null === V || V === E) switch (e) {
                case"switchStreamFailCount":
                  Y++;
                  break;
                case"retryCooldownCounter":
                  B++
              }
            }

            function ne() {
              Y = 0, j = !1
            }

            function re() {
              v && (clearTimeout(v), v = null), ne(), B = 0
            }

            function ie() {
              M = 0, F = 0, x = 0, b = 0, L = !1, W = !1, k = [], C = 0, ne(), B = 0, N.debugEnabled() && N.debug("reset time values")
            }

            function ae(e) {
              s.emit(a.SUGGESTION_ABORT, {reason: e})
            }

            return N.debugEnabled() && N.debug("initialize"), e.add({target: s, listeners: K}), {
              destroy: function () {
                e.remove({target: s, listeners: K})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5620: function (e, t, n) {
      var r, i;
      r = [n(4556), n(8333), n(6627), n(6637), n(492), n(3019), n(519), n(8983)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        return {
          create: function (d) {
            var u, c, l, f = t.create("StartupStatsCollector"), E = [], p = E[0] = "connecting", m = E[1] = "connected",
              g = E[2] = "firstFragmentReceived", b = E[3] = "firstFrameRendered", _ = E[4] = "playable",
              h = E[5] = "playing", T = {}, A = null, S = !1, y = 0, R = !1, v = [{
                type: a.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (c = e.data.state) {
                    case i.LOADING:
                      w(), r.add({target: d, listeners: u ? N : O});
                      break;
                    default:
                      w(), r.remove({target: d, listeners: u ? N : O})
                  }
                }
              }, {
                type: a.CONFIG, listener: function (e) {
                  l = e.data.config.id, u = n.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && n.canUseHLS, R = e.data.config.playback.keepConnection && !(n.isMediaOverQuicSupported && e.data.config.playback.enableMediaOverQuic), !u && (O = O.concat(R ? C : I)), S = e.data.config.playback.faststart
                }
              }, {
                type: s.CREATED, listener: function (e) {
                  y = e.data.streamInfo.prerollDuration ? e.data.streamInfo.prerollDuration : 0
                }
              }], O = [{type: a.STREAM_FRAGMENT, listener: L}, {
                type: a.LOADED_DATA,
                listener: F
              }, {type: a.CAN_PLAY_THROUGH, listener: x}, {type: a.PLAYING, listener: k}],
              I = [{type: a.NETWORK_CONNECTING, listener: P}, {type: a.NETWORK_CONNECTED, listener: M}],
              C = [{type: a.NETWORK_PLAY, listener: P}, {type: a.NETWORK_PLAY, listener: M}],
              N = [{type: a.PLAY, listener: P}, {type: a.DURATION_CHANGE, listener: M}, {
                type: a.LOADED_META_DATA,
                listener: L
              }, {type: a.LOADED_DATA, listener: F}, {type: a.CAN_PLAY_THROUGH, listener: x}, {
                type: a.PLAYING,
                listener: k
              }];

            function D(t) {
              if (c === i.LOADING) if (f.debugEnabled() && f.debug("enabled, should set stat: " + t), -1 === T[t]) for (var n = function (e) {
                for (var t = [], n = E.indexOf(e); n >= 0;) -1 === T[E[n]] && (e !== h || e === h && -1 !== [g, b, _].indexOf(A)) ? (t.unshift(E[n]), n--) : n = -1;
                return t.length && (A = e), f.debugEnabled() && f.debug(t.length ? 'valid labels are "' + t.join('", "') + '"' : "no valid labels found"), t
              }(t), r = 0, a = n.length; r < a; r += 1) t = n[r], -1 === T[t] && (f.debugEnabled() && f.debug("set stat: " + t), T[t] = e.now(), e.mark(["nano", l, t].join(".")), f.debug(t + ": " + T[t]), U(t)); else f.debugEnabled() && f.debug("stat already set"); else f.debugEnabled() && f.debug("disabled, shouldn't set stat: " + t)
            }

            function w() {
              A = null;
              for (var e = 0; e < E.length; e++) T[E[e]] = -1
            }

            function U(e) {
              for (var t = E.length - 1; t > 0; t--) (T[E[t]] < T[E[t - 1]] || -1 === T[E[t - 1]]) && -1 !== T[E[t]] && (T[E[t - 1]] = T[E[t]]);
              var n = T[p], r = {};
              for (var i in T) Object.prototype.hasOwnProperty.call(T, i) && -1 !== T[i] && (r[i] = Math.round(T[i] - n));
              var a = {stats: r, faststart: S, prerollDuration: 1e3 * y};
              e === h && A === h ? function (e) {
                d.emit(o.COMPLETED, e), f.debugEnabled() && f.debug("created startup stats: " + JSON.stringify(e))
              }(a) : function (e) {
                d.emit(o.ADDED, e), f.debugEnabled() && f.debug("added startup stats: " + JSON.stringify(e))
              }(a)
            }

            function P(e) {
              (!u || u && e.data.external) && D(p)
            }

            function M() {
              D(m), u && B("remove", a.DURATION_CHANGE, M)
            }

            function L() {
              D(g), !u && B("remove", a.STREAM_FRAGMENT, L)
            }

            function F() {
              D(b)
            }

            function x() {
              D(_)
            }

            function k() {
              D(h)
            }

            function B(e, t, n) {
              r[e]({target: d, listeners: [{type: t, listener: n}]})
            }

            return w(), r.add({target: d, listeners: v}), {
              destroy: function () {
                r.remove({target: d, listeners: v})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5444: function (e, t, n) {
      var r, i;
      r = [n(8333), n(1933), n(6627), n(6637), n(3019), n(8983), n(492), n(7605), n(8730)], void 0 === (i = function (e, t, n, r, i, a, o, s, d) {
        return {
          create: function (t) {
            var u, c, l, f, E, p, m = e.create("StreamInfo"), g = [{
              type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                u = e.data.state
              }
            }, {
              type: i.CONFIG, listener: function (e) {
                c = n.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && n.canUseHLS, l = n.isMediaOverQuicSupported && e.data.config.playback.enableMediaOverQuic
              }
            }, {
              type: i.STREAM_INFO, listener: function (e) {
                u !== o.READY && b(a.CREATED, e)
              }
            }, {
              type: i.STREAM_INFO_UPDATE, listener: function (e) {
                u !== o.BUFFERING && u !== o.PLAYING || b(a.UPDATED, e)
              }
            }, {
              type: i.STREAM_URL, listener: function (e) {
                E = e.data.url, p = function (e) {
                  for (var t = {}, n = e.indexOf("?") + 1, r = ("&" + e.substring(n)).split("&"), i = 0; i < r.length; i += 1) {
                    var a = r[i].split("=");
                    2 === a.length && (t[a[0]] = decodeURIComponent(a[1]))
                  }
                  return t
                }(E)
              }
            }, {
              type: i.CAN_PLAY, listener: function (e) {
                c && (m.debugEnabled() && m.debug("create streamInfo for hls on canPlay"), (f = {
                  haveAudio: e.data.haveAudio,
                  haveVideo: e.data.haveVideo,
                  prerollDuration: 0,
                  audioInfo: e.data.haveAudio ? {bitsPerSample: null, channels: null, sampleRate: null} : null,
                  videoInfo: e.data.haveVideo ? {
                    width: e.data.videoWidth,
                    height: e.data.videoHeight,
                    frameRate: null
                  } : null
                }).url = E, f.rtmp = _(), m.debugEnabled() && m.debug("created streamInfo for hls: " + JSON.stringify(f)), setTimeout((function () {
                  t.emit(a.CREATED, {streamInfo: f})
                }), 0))
              }
            }];

            function b(e, n) {
              f = n.data.onStreamInfo, m.debugEnabled() && m.debug("handle streamInfo with " + e + ": " + JSON.stringify(f));
              var r = f && f.mimeType ? f.mimeType : d.MP4_MS;
              if (window.MediaSource && window.MediaSource.isTypeSupported(r) || window.ManagedMediaSource && window.ManagedMediaSource.isTypeSupported(r) || l) {
                var i = {}, o = [];
                for (var u in s) if (Object.prototype.hasOwnProperty.call(s, u)) {
                  var c = s[u];
                  Object.prototype.hasOwnProperty.call(s, u) && Object.prototype.hasOwnProperty.call(f, c) && -1 === o.indexOf(c) && (i[c] = f[c])
                }
                (f = i).url = E, f.rtmp = _(), m.debugEnabled() && m.debug("parsed streamInfo with " + e + ": " + JSON.stringify(f)), t.emit(e, {streamInfo: f})
              } else t.emit(a.MIME_TYPE_UNSUPPORTED)
            }

            function _() {
              return {streamname: p.stream ? p.stream : "", url: p.url ? p.url : ""}
            }

            return m.debugEnabled() && m.debug("init"), r.add({target: t, listeners: g}), {
              destroy: function () {
                r.remove({target: t, listeners: g})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4600: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(3019), n(3667), n(492)], void 0 === (i = function (e, t, n, r, i, a) {
        var o = 2e4, s = 2e4;
        return {
          create: function (t) {
            var d, u = e.create("Timeout"), c = 0, l = 0, f = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (d = e.data.state) {
                  case a.READY:
                  case a.PLAYING:
                  case a.PAUSED:
                    p(), m()
                }
                d === a.BUFFERING ? (clearTimeout(l), l = setTimeout((function () {
                  t.emit(i.BUFFERING_TIMEOUT, {delay: s})
                }), s)) : m(), d === a.LOADING && E(e.data.connectDelay)
              }
            }, {
              type: r.CONFIG, listener: function (e) {
                var t = e.data.config, n = 1e3 * t.playback.timeouts.loading, r = 1e3 * t.playback.timeouts.buffering;
                o = Math.max(Math.min(n, 6e4), 1e4), s = Math.max(Math.min(r, 6e4), 1e4)
              }
            }, {
              type: r.UPDATE_SOURCE_INIT, listener: function () {
                p(), m()
              }
            }, {
              type: r.UPDATE_SOURCE_SUCCESS, listener: function () {
                d !== a.LOADING || c || E(o)
              }
            }, {
              type: r.UPDATE_SOURCE_FAIL, listener: function () {
                d !== a.LOADING || c || E(o)
              }
            }, {
              type: r.UPDATE_SOURCE_ABORT, listener: function () {
                d !== a.LOADING || c || E(o)
              }
            }, {
              type: r.MEDIA_ERROR_RECOVER, listener: function () {
                p(), m()
              }
            }];

            function E(e) {
              clearTimeout(c), c = setTimeout((function () {
                t.emit(i.LOADING_TIMEOUT, {delay: o + e})
              }), o + e)
            }

            function p() {
              clearTimeout(c), c = null
            }

            function m() {
              clearTimeout(l), l = null
            }

            return u.debugEnabled() && u.debug("init"), n.add({target: t, listeners: f}), {
              destroy: function () {
                p(), m(), n.remove({target: t, listeners: f})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4351: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(3019), n(2450)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i) {
            var a, o, s, d = t.create("VisibilityProxy"), u = !1, c = [{
              type: n.APPLICATION_STATE_CHANGE, listener: function (e) {
                s || (d.debugEnabled() && d.debug("initial player state"), l()), s = e.data.state
              }
            }];

            function l() {
              u = document[a], d.debug(u ? "hidden" : "visible"), i.emit(u ? r.HIDDEN : r.VISIBLE)
            }

            return d.debugEnabled() && d.debug("initialize"), e.add({
              target: i,
              listeners: c
            }), void 0 !== document.hidden ? (a = "hidden", o = "visibilitychange") : void 0 !== document.msHidden ? (a = "msHidden", o = "msvisibilitychange") : void 0 !== document.webkitHidden && (a = "webkitHidden", o = "webkitvisibilitychange"), document.addEventListener(o, l), {
              destroy: function () {
                e.remove({target: i, listeners: c}), document.removeEventListener(o, l)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 941: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          validateBuffer: function (e, t) {
            var n = "dynamic" === (t = t || "") ? ["offsetThreshold", "offsetStep", "cooldownTime"] : ["min", "start", "target", "limit", "max"],
              r = n.filter((function (t) {
                return !Object.prototype.hasOwnProperty.call(e, t)
              }));
            if (r.length) return {
              success: !1,
              reason: "The buffer config is invalid, it must contain " + r.join(", ") + ". Reset to default."
            };
            for (var i in n) if (Object.prototype.hasOwnProperty.call(n, i) && "number" != typeof e[n[i]]) return {
              success: !1,
              reason: "The " + (t.length ? t + " " : t) + "buffer config is invalid, the value '" + n[i] + "' have to be a number. Reset to default."
            };
            return {success: !0}
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6432: function (e, t, n) {
      var r, i;
      r = [n(8197)], void 0 === (i = function (e) {
        var t = "?", n = null, r = null;
        return {
          create: function () {
            var i = function () {
              n = null, t = "?", r = null
            };
            return {
              initURL: function (a, o) {
                return i(), r = e.copy(a), n = r.server[o], t = "?", this
              }, processConfigQuery: function (e) {
                for (var n in r.query) if (!1 !== r.query[n] && Object.prototype.hasOwnProperty.call(r.query, n)) {
                  let i = null;
                  i = "cid" === n ? Math.round(1e6 * Math.random()).toString() : "pid" !== n || r.query[n].length ? r.query[n] : e, null === i && void 0 !== i || !i.length || (t += n + "=" + encodeURIComponent(i) + "&", r.query[n] = i)
                }
                return this
              }, processConfigFlags: function (e) {
                return r.query.flags = Object.keys(e).join(","), this
              }, processSecurity: function () {
                for (var e in r.security) Object.prototype.hasOwnProperty.call(r.security, e) && r.security[e].length && (t += e + "=" + encodeURIComponent(r.security[e]) + "&");
                return this
              }, buildConnectionURL: function () {
                return t.lastIndexOf("&") === t.length - 1 && (t = t.substring(0, t.length - 1)), r.url = n + t, this
              }, reset: i, get connectionConfig() {
                return r
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2706: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = null;

        function t() {
          return {
            server: {websocket: "", hls: "", progressive: "", webtransport: ""},
            query: {url: "", stream: "", cid: "", pid: "", token: "", flags: ""},
            security: null
          }
        }

        return {
          create: function (n) {
            var r = function () {
              e = null
            };
            return {
              initConfig: function () {
                return r(), e = new t, n.debugEnabled() && n.debug("set connection config", 3), this
              }, setServer: function (t) {
                if ("object" != typeof t) return this;
                for (var r = ["websocket", "hls", "progressive", "webtransport"], i = 0; i < r.length; i++) t[r[i]] && "string" == typeof t[r[i]] && 0 !== t[r[i]].length && (e.server[r[i]] = t[r[i]]);
                return n.debugEnabled() && n.debug("set connection server: " + JSON.stringify(e.server), 3), this
              }, setRtmp: function (t) {
                for (var r in t) if (Object.prototype.hasOwnProperty.call(t, r)) {
                  var i = r.replace("name", "");
                  Object.prototype.hasOwnProperty.call(e.query, i) && (e.query[i] = t[r], n.debugEnabled() && n.debug("set connection config rtmp: " + i + ":" + e.query[i]))
                }
                return this
              }, setToken: function (t) {
                return t ? (Object.prototype.hasOwnProperty.call(e.query, "token") && (e.query.token = t, n.debugEnabled() && n.debug("set connection config token: " + e.query.token)), this) : this
              }, setQueryParams: function (t) {
                if ("object" != typeof t) return this;
                for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e.query[r] = t[r], n.debugEnabled() && n.debug("set connection param: " + r + ":" + e.query[r]));
                return this
              }, addQueryParam: function (t, n) {
                return t && (e.query[t] = n), this
              }, setSecurity: function (t) {
                if (t) for (var r in e.security = {}, n.debugEnabled() && n.debug("set security config", 3), t) Object.prototype.hasOwnProperty.call(t, r) && t[r].length && (e.security[r] = t[r], n.debugEnabled() && n.debug("set security config " + r + ": " + e.security[r]));
                return this
              }, reset: r, get connectionConfig() {
                return e
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3763: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "",
          LOAD_START: "loadstart",
          PROGRESS: "progress",
          SUSPEND: "suspend",
          ABORT: "abort",
          EMPTIED: "emptied",
          STALLED: "stalled",
          PLAY: "play",
          PAUSE: "pause",
          LOADED_META_DATA: "loadedmetadata",
          LOADED_DATA: "loadeddata",
          WAITING: "waiting",
          ERROR: "error",
          PLAYING: "playing",
          CAN_PLAY: "canplay",
          CAN_PLAY_THROUGH: "canplaythrough",
          SEEKING: "seeking",
          SEEKED: "seeked",
          TIME_UPDATE: "timeupdate",
          ENDED: "ended",
          RATE_CHANGE: "ratechange",
          DURATION_CHANGE: "durationchange",
          VOLUME_CHANGE: "volumechange"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5304: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {ABORT_ERROR: "AbortError", NOT_ALLOWED_ERROR: "NotAllowedError"}
      }.apply(t, [])) || (e.exports = n)
    }, 855: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          MEDIA_ERR_ABORTED: MediaError.MEDIA_ERR_ABORTED,
          MEDIA_ERR_NETWORK: MediaError.MEDIA_ERR_NETWORK,
          MEDIA_ERR_DECODE: MediaError.MEDIA_ERR_DECODE,
          MEDIA_ERR_SRC_NOT_SUPPORTED: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
          MEDIA_ERR_HLS_VIDEO_DECODE: 5,
          MEDIA_ERR_MEDIA_SOURCE_ENDED: 100,
          MEDIA_ERR_HLS_BUFFER_UNDERRUN: 101,
          MEDIA_ERR_HLS_MAX_RANGE: 102,
          MEDIA_ERR_HLS_JUMP: 1008,
          MEDIA_ERR_DECODE_CONFIG_ERROR: 3003
        })
      }.apply(t, [])) || (e.exports = n)
    }, 5865: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {BASE: "", SOURCE_OPEN: "sourceopen", SOURCE_ENDED: "sourceended", SOURCE_CLOSED: "sourceclosed"}
      }.apply(t, [])) || (e.exports = n)
    }, 7990: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "",
          ABORT: "abort",
          ERROR: "error",
          UPDATE: "update",
          UPDATE_START: "updatestart",
          UPDATE_END: "updateend"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8250: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaControl.";
        return {
          BASE: e,
          CREATE_VIDEO: e + "createVideo",
          DESTROY_VIDEO: e + "destroyVideo",
          VIDEO_SOURCE: e + "videoSource",
          UPDATE_SOURCE: e + "updateSource",
          PLAY: e + "play",
          PAUSE: e + "pause",
          SEEK: e + "seek",
          MUTE: e + "mute",
          UNMUTE: e + "unmute",
          SET_VOLUME: e + "volume",
          SET_RATE: e + "playbackRate"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6273: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaErrorHandler.";
        return {
          BASE: e,
          ERROR: e + "error",
          RECOVER: e + "recover",
          RECOVERED: e + "recovered",
          QUEUED: e + "queued",
          UNQUEUED: e + "unqueued",
          OFFLINE_BUFFER_UNDERRUN: e + "offlinebufferunderrun"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9437: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaManager.";
        return {
          BASE: e,
          CONFIG: e + "config",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          STARTUP_STATS_ADDED: e + "startupStatsAdded",
          STARTUP_STATS_COMPLETED: e + "startupStatsCompleted",
          DOCUMENT_VISIBLE: e + "documentVisible",
          DOCUMENT_HIDDEN: e + "documentHidden",
          NETWORK_ONLINE: e + "networkOnline",
          NETWORK_OFFLINE: e + "networkOffline",
          SWITCH_STREAM_INIT: e + "switchStreamInit",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          BUFFER_TWEAKS_CREATED: e + "bufferTweaksCreated",
          WEB_TRANSPORT_META_DATA: e + "wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: e + "wtGOPCache",
          BUFFER_GOAL_STATS: e + "bufferGoalStats"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1667: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "statsCollector.";
        return {BASE: e, PLAY_STATS: e + "playStats", MEDIA_ERROR_RECOVER_STATS: e + "mediaErrorRecoverStats"}
      }.apply(t, [])) || (e.exports = n)
    }, 1358: function (e, t, n) {
      var r, i;
      r = [n(9658), n(6627), n(6637), n(5055), n(9673), n(680), n(594), n(1376), n(8250), n(9437), n(1667), n(4856), n(5075), n(2657), n(3242), n(711), n(1264), n(6273)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b) {
        "use strict";
        return {
          create: function (n, _) {
            var h, T, A = new e, S = [], y = [{from: f.LOADED_META_DATA, to: o.LOADED_META_DATA}, {
                from: f.LOADED_DATA,
                to: o.LOADED_DATA
              }, {from: f.PLAYING, to: o.PLAYING}, {from: f.CAN_PLAY, to: o.CAN_PLAY}, {
                from: f.CAN_PLAY_THROUGH,
                to: o.CAN_PLAY_THROUGH
              }, {from: f.DURATION_CHANGE, to: o.DURATION_CHANGE}, {
                from: f.VOLUME_CHANGE,
                to: o.VOLUME_CHANGE
              }, {from: f.PLAY_START_ABORT_ERROR, to: o.PLAY_START_ABORT_ERROR}, {
                from: f.PLAY_START_NOT_ALLOWED_ERROR,
                to: o.PLAY_START_NOT_ALLOWED_ERROR
              }, {from: f.VIEWPORT_VISIBLE, to: o.VIEWPORT_VISIBLE}, {
                from: f.VIEWPORT_HIDDEN,
                to: o.VIEWPORT_HIDDEN
              }, {from: f.UPDATE_SOURCE_ABORT, to: o.UPDATE_SOURCE_ABORT}, {
                from: f.UPDATE_SOURCE_FAIL,
                to: o.UPDATE_SOURCE_FAIL
              }, {from: f.UPDATE_SOURCE_TIMEOUT, to: o.UPDATE_SOURCE_TIMEOUT}, {
                from: f.ACTIVE_VIDEO_ELEMENT_CHANGE,
                to: o.ACTIVE_VIDEO_ELEMENT_CHANGE
              }, {from: f.SWITCH_STREAM, to: i.SWITCH_STREAM}, {
                from: f.PLAYBACK_SUSPENDED,
                to: o.PLAYBACK_SUSPENDED
              }, {from: f.QUALITY_STATS, to: o.QUALITY_STATS}, {
                from: f.FRAME_DROP,
                to: o.FRAME_DROP
              }, {from: f.FRAME_CORRUPTED, to: o.FRAME_CORRUPTED}, {
                from: f.SOURCE_ENDED,
                to: o.PLAYBACK_FINISHED
              }, {from: f.PLAYBACK_STARTED, to: o.PLAYBACK_STARTED}, {
                from: f.BUFFERING,
                to: o.BUFFERING
              }, {from: f.TIME_OFFSET, to: o.TIME_OFFSET}, {
                from: p.LOADED_META_DATA,
                to: o.LOADED_META_DATA
              }, {from: p.ADJUSTED_META_DATA, to: o.ADJUSTED_META_DATA}, {
                from: p.LOADED_DATA,
                to: o.LOADED_DATA
              }, {from: p.PLAYING, to: o.PLAYING}, {from: p.CAN_PLAY, to: o.CAN_PLAY}, {
                from: p.CAN_PLAY_THROUGH,
                to: o.CAN_PLAY_THROUGH
              }, {from: p.DURATION_CHANGE, to: o.DURATION_CHANGE}, {
                from: p.VOLUME_CHANGE,
                to: o.VOLUME_CHANGE
              }, {from: p.PLAY_START_ABORT_ERROR, to: o.PLAY_START_ABORT_ERROR}, {
                from: p.PLAY_START_NOT_ALLOWED_ERROR,
                to: o.PLAY_START_NOT_ALLOWED_ERROR
              }, {from: p.VIEWPORT_VISIBLE, to: o.VIEWPORT_VISIBLE}, {
                from: p.VIEWPORT_HIDDEN,
                to: o.VIEWPORT_HIDDEN
              }, {from: p.UPDATE_SOURCE_ABORT, to: o.UPDATE_SOURCE_ABORT}, {
                from: p.UPDATE_SOURCE_FAIL,
                to: o.UPDATE_SOURCE_FAIL
              }, {from: p.UPDATE_SOURCE_TIMEOUT, to: o.UPDATE_SOURCE_TIMEOUT}, {
                from: p.ACTIVE_VIDEO_ELEMENT_CHANGE,
                to: o.ACTIVE_VIDEO_ELEMENT_CHANGE
              }, {from: p.SWITCH_STREAM, to: d.SWITCH_STREAM}, {
                from: p.PLAYBACK_SUSPENDED,
                to: o.PLAYBACK_SUSPENDED
              }, {from: p.QUALITY_STATS, to: o.QUALITY_STATS}, {
                from: p.FRAME_DROP,
                to: o.FRAME_DROP
              }, {from: p.FRAME_CORRUPTED, to: o.FRAME_CORRUPTED}, {
                from: p.SOURCE_ENDED,
                to: o.PLAYBACK_FINISHED
              }, {from: p.PLAYBACK_STARTED, to: o.PLAYBACK_STARTED}, {
                from: p.BUFFERING,
                to: o.BUFFERING
              }, {from: p.TIME_OFFSET, to: o.TIME_OFFSET}, {
                from: c.PLAY_STATS,
                to: o.PLAY_STATS
              }, {from: c.MEDIA_ERROR_RECOVER_STATS, to: o.MEDIA_ERROR_RECOVER_STATS}, {
                from: b.ERROR,
                to: o.MEDIA_ERROR
              }, {from: b.RECOVER, to: o.MEDIA_ERROR_RECOVER}, {
                from: b.RECOVERED,
                to: o.MEDIA_ERROR_RECOVERED
              }, {from: b.OFFLINE_BUFFER_UNDERRUN, to: o.OFFLINE_BUFFER_UNDERRUN}],
              R = [{from: i.CREATE_VIDEO, to: d.CREATE_VIDEO}, {
                from: i.DESTROY_VIDEO,
                to: d.DESTROY_VIDEO
              }, {from: i.VIDEO_SOURCE, to: d.VIDEO_SOURCE}, {from: i.PLAY, to: d.PLAY}, {
                from: i.PAUSE,
                to: d.PAUSE
              }, {from: i.SEEK, to: d.SEEK}, {from: i.MUTE, to: d.MUTE}, {
                from: i.UNMUTE,
                to: d.UNMUTE
              }, {from: i.SET_VOLUME, to: d.SET_VOLUME}, {from: i.SET_RATE, to: d.SET_RATE}, {
                from: i.UPDATE_SOURCE,
                to: d.UPDATE_SOURCE
              }, {from: i.CONFIG, to: u.CONFIG}, {from: s.SERVER_INFO, to: u.SERVER_INFO}, {
                from: s.STREAM_FRAGMENT,
                to: u.STREAM_FRAGMENT
              }, {from: s.RANDOM_ACCESS_POINT, to: u.RANDOM_ACCESS_POINT}, {
                from: s.ONLINE,
                to: u.NETWORK_ONLINE
              }, {from: s.OFFLINE, to: u.NETWORK_OFFLINE}, {
                from: s.WEB_TRANSPORT_META_DATA,
                to: u.WEB_TRANSPORT_META_DATA
              }, {from: s.WEB_TRANSPORT_GOP_CACHE, to: u.WEB_TRANSPORT_GOP_CACHE}, {
                from: a.STATE_CHANGE,
                to: u.APPLICATION_STATE_CHANGE
              }, {from: a.STARTUP_STATS_ADDED, to: u.STARTUP_STATS_ADDED}, {
                from: a.STARTUP_STATS_COMPLETED,
                to: u.STARTUP_STATS_COMPLETED
              }, {from: a.DOCUMENT_VISIBLE, to: u.DOCUMENT_VISIBLE}, {
                from: a.DOCUMENT_HIDDEN,
                to: u.DOCUMENT_HIDDEN
              }, {from: a.STREAM_INFO, to: u.STREAM_INFO}, {
                from: a.STREAM_INFO_UPDATE,
                to: u.STREAM_INFO_UPDATE
              }, {from: a.SWITCH_STREAM_INIT, to: u.SWITCH_STREAM_INIT}, {
                from: a.SWITCH_STREAM_SUCCESS,
                to: u.SWITCH_STREAM_SUCCESS
              }, {from: a.SWITCH_STREAM_ABORT, to: u.SWITCH_STREAM_ABORT}, {
                from: a.SWITCH_STREAM_FAIL,
                to: u.SWITCH_STREAM_FAIL
              }, {from: a.UPDATE_SOURCE_INIT, to: u.UPDATE_SOURCE_INIT}, {
                from: a.UPDATE_SOURCE_SUCCESS,
                to: u.UPDATE_SOURCE_SUCCESS
              }, {from: a.BUFFER_TWEAKS_CREATED, to: u.BUFFER_TWEAKS_CREATED}, {
                from: a.BUFFER_GOAL_STATS,
                to: u.BUFFER_GOAL_STATS
              }];
            return h = r.create(n, A, R), T = r.create(A, n, y), t.isMediaOverQuicSupported && _.playback.enableMediaOverQuic ? S.push(m.create(A)) : S.push(E.create(A)), S.push(g.create(A)), S.push(l.create(A)), {
              destroy: function () {
                for (; S.length;) S.pop().destroy();
                h.destroy(), h = null, T.destroy(), T = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 476: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(5698), n(291)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i) {
            var a, o = e.create("FakeAudioContext"), s = [{
              type: n.STREAM_INFO, listener: function (e) {
                d(), e.data.streamInfo.haveAudio || (window.AudioContext = window.AudioContext || window.webkitAudioContext || function () {
                  return {
                    close: function () {
                    }
                  }
                }, a = new AudioContext)
              }
            }, {type: r.PAUSE, listener: d}];

            function d() {
              a && "function" == typeof a.close && (a.close(), a = null)
            }

            return o.debugEnabled() && o.debug("initialize"), t.add({target: i, listeners: s}), {
              destroy: function () {
                d(), t.remove({target: i, listeners: s})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4972: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(5698), n(5706), n(1447), n(855), n(492)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        return {
          create: function (d) {
            var u, c = e.create("FrameCorruptedHandler"), l = !1, f = !1, E = !1, p = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (u = e.data.state) {
                  case s.PLAYING:
                  case s.BUFFERING:
                    break;
                  case s.PAUSED:
                    E = !1
                }
              }
            }, {
              type: r.CONFIG, listener: function (e) {
                f = t.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && t.canUseHLS
              }
            }, {type: r.DOCUMENT_VISIBLE, listener: m}, {
              type: r.DOCUMENT_HIDDEN,
              listener: m
            }, {
              type: a.FRAME_CORRUPTED, listener: function (e) {
                if (!E && (c.debugEnabled() && c.debug("frame corrupted"), c.debugEnabled() && c.debug(JSON.stringify(e.data)), "extreme" === e.data.type && !l && f && u === s.PLAYING)) {
                  c.debugEnabled() && c.debug("visible and extreme frame corrupted detected (hls)");
                  var t = {code: o.MEDIA_ERR_HLS_VIDEO_DECODE};
                  d.emit(i.ERROR, t)
                }
              }
            }, {
              type: r.MEDIA_ERROR_RECOVER, listener: function () {
                c.debugEnabled() && c.debug("media error recover"), E = !0
              }
            }, {
              type: r.MEDIA_ERROR_RECOVERED, listener: function () {
                c.debugEnabled() && c.debug("media error recovered"), E = !1
              }
            }];

            function m(e) {
              l = e.name === r.DOCUMENT_HIDDEN, c.debug(l ? "hidden" : "visible")
            }

            return c.debugEnabled() && c.debug("initialize"), n.add({target: d, listeners: p}), {
              destroy: function () {
                n.remove({target: d, listeners: p})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1705: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(5698), n(683), n(1447), n(5997), n(492)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s) {
            var d, u = e.create("FrameDropHandler"), c = [], l = !1, f = 0, E = [{
              type: n.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (d = e.data.state) {
                  case o.PLAYING:
                  case o.BUFFERING:
                    break;
                  case o.PAUSED:
                    g()
                }
              }
            }, {
              type: n.RANDOM_ACCESS_POINT, listener: function (e) {
                for (c.push(e.data.onRandomAccessPoint.streamTime / 1e3 + f / 1e3); c.length > 10;) c.shift()
              }
            }, {
              type: r.TIME_OFFSET, listener: function (e) {
                f = e.data.offset
              }
            }, {
              type: i.FRAME_DROP, listener: function (e) {
                var t;
                u.debugEnabled() && u.debug("frame drop"), u.debugEnabled() && u.debug(JSON.stringify(e.data)), "extreme" !== e.data.type || l || d !== o.PLAYING || (u.debugEnabled() && u.debug("visible and extreme frame drop detected (edge)"), u.debugEnabled() && u.debug("try seeking to last RAP to get stable playback"), t = c.length ? c[c.length - 1] : 0, u.debugEnabled() && u.debug("seeking to " + t), s.emit(n.SEEK, {position: t}))
              }
            }], p = [{type: a.VIEWPORT_VISIBLE, listener: m}, {type: a.VIEWPORT_HIDDEN, listener: m}];

            function m(e) {
              l = e.name !== a.VIEWPORT_VISIBLE, u.debugEnabled() && u.debug("viewport changed to " + (l ? "hidden" : "visible"))
            }

            function g() {
              for (; c.length;) c.shift();
              f = 0
            }

            return u.debugEnabled() && u.debug("initialize"), g(), t.add({target: s, listeners: E}), t.add({
              target: s,
              listeners: p
            }), {
              destroy: function () {
                t.remove({target: s, listeners: E}), t.remove({target: s, listeners: p})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2885: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(5698), n(291), n(5980), n(492)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s) {
            var d, u, c = .3, l = e.create("GapHandler"), f = 0, E = 0, p = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                d = e.data.state, n.remove({
                  target: s,
                  listeners: m
                }), (t.isTridentBrowser && d === o.PLAYING || !t.isTridentBrowser && d !== o.BUFFERING && d !== o.PAUSED) && (f = 0, n.add({
                  target: s,
                  listeners: m
                }))
              }
            }], m = [{
              type: a.PRIVATE_MEDIA_STATS, listener: function (e) {
                if (function (e) {
                  return e && e.length > 0
                }(e.data.mediaStats.buffered)) {
                  var t = e.data.mediaStats.buffered, n = e.data.mediaStats.exactCurrentTime, r = b(n, t),
                    a = function (e, t) {
                      for (var n = 0; t && n < t.length - 1 && t.start(n) <= e;) n++;
                      return n
                    }(n, t), o = function (e) {
                      return e && e.length - 1
                    }(t), d = (R = u, v = n, Math.abs(R - v) < .001), p = function (e, t) {
                      var n = b(e, t);
                      return t && n < t.length - 1 && e > t.end(n) && e < t.start(n + 1)
                    }(n, t);
                  if (0 < E && E--, d || p) {
                    var m = !1, h = "", T = void 0;
                    if (f < 10 && f++, 0 < E || f < 2) return;
                    var A = .1 * f;
                    if (a > r && _(t, a) > c && g(n, t, A) ? (m = !0, h = "next", T = t.start(a)) : a > r && o > a && _(t, a) < c && _(t, o) > c && g(n, t, A) ? (m = !0, h = "last", T = t.start(o)) : a === r && _(t, o) > c && function (e, t) {
                      return t && e < t.start(b(e, t))
                    }(n, t) ? (m = !0, h = "current", T = t.start(r)) : 10 === f && (m = !0, h = "max", T = n + .1), m && !isNaN(T)) {
                      if (l.debugEnabled()) {
                        var S = T - n, y = t.end(r) - n;
                        l.debug("seek from/to " + n.toFixed(3) + "/" + T.toFixed(3) + " equalTime:" + d + " betweenRanges:" + p + " target:" + h + " " + S.toFixed(3) + " " + y.toFixed(3), 3), function (e, t) {
                          for (var n = e, r = "ranges"; n < t.length;) r += " " + t.start(n).toFixed(3) + "-" + t.end(n).toFixed(3), n++;
                          l.debug(r, 3)
                        }(r, t)
                      }
                      s.emit(i.SEEK, {position: T}), s.emit(i.PLAY, {external: !1}), E = 10, f = 0
                    }
                  } else f = 0;
                  u = n
                }
                var R, v
              }
            }];

            function g(e, t, n) {
              return t && e + n >= t.end(b(e, t))
            }

            function b(e, t) {
              for (var n = 0; t && n < t.length - 1 && t.start(n + 1) <= e;) n++;
              return n
            }

            function _(e, t) {
              return e && t < e.length ? e.end(t) - e.start(t) : 0
            }

            return l.debugEnabled() && l.debug("initialize"), n.add({target: s, listeners: p}), {
              destroy: function () {
                n.remove({target: s, listeners: p}), n.remove({target: s, listeners: m})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3824: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(8197), n(6835), n(6637), n(5698), n(5997), n(4210), n(291), n(7628), n(3778), n(3890), n(492), n(5493)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E) {
        var p = e.create("MediaElementHandler");
        return {
          create: function (e) {
            var m, g, b, _, h, T, A, S, y, R, v, O, I, C, N, D, w, U, P, M, L, F, x, k, B, H = [{
                type: a.CONFIG, listener: function (e) {
                  var n;
                  Se(e) && (n = e.data.config, h = n, m = t.mustUseHLS || h.playback.allowSafariHlsFallback && t.canUseHLS, g = 0, L = 0, Ke(A = h.source.startIndex), h.playback && (Y = !!h.playback.muted, z = !!h.playback.automute, Q = h.playback.crossOrigin, q = h.playback.volume))
                }
              }, {
                type: d.CREATE_VIDEO, listener: function (t) {
                  var n, r;
                  Se(t) && (t.data.elementIds && (N = t.data.elementIds), t.data.container && (D = t.data.container)), L = N.length;
                  for (var i = 0; i < L; i++) r = {
                    elementId: N[i],
                    index: i
                  }, n = u.create(e, r.elementId, D, r.index, m, Y, z, !1, q, Q), V.push(n), ae[i] = [];
                  e.emit(o.ELEMENT_CREATED, {video: me(V[g])}), ge(V[g], q), e.emit(o.VOLUME_CHANGE, {
                    muted: Y,
                    volume: q
                  }), be(V[g]), Ge(g), he(V[g]), k = je(), B = je()
                }
              }, {
                type: d.DESTROY_VIDEO, listener: function () {
                  for (var e = 0; e < V.length; e++) (t = V[e]) ? t.destroyVideo() : p.debugEnabled() && p.debug("mediaElement could not be found");
                  var t
                }
              }, {
                type: d.VIDEO_SOURCE, listener: function (e) {
                  var t, n, r = Be();
                  p.debugEnabled() && p.debug("received video source"), p.debugEnabled() && p.debug("src: " + e.data.src), p.debugEnabled() && p.debug("type: " + e.data.type), Se(e) && (O = v || e.data.src, t = !(v = e.data.src).length, I = e.data.type, n = (r || j) && W ? C : g, p.debugEnabled() && p.debug("sourceTemplate set"), V.length && (!m || m && (t || !F && (W && j || !W && !j))) && (Pe(V[n]), Me(V[n]), m || Ae(V[n]), m && j && fe(V[C]), W && !t && (p.debugEnabled() && p.debug("call play while playing after video source received"), ce(V[n], void 0, r)), Re(), ve(), t || (p.debugEnabled() && p.debug("add time update interval for play stats"), Oe(), void 0 !== pe(V[n]) && (p.debugEnabled() && p.debug("add quality update interval"), Ie()))))
                }
              }, {
                type: d.PLAY, listener: function (e) {
                  if (V[g]) {
                    if (m) {
                      be(V[g]);
                      var t = g ? 0 : 1;
                      _e(V[t]), (!e || e && e.data.external) && ((n = V[t]) ? (n.setMute(), n.unlock()) : p.debugEnabled() && p.debug("mediaElement could not be found")), (!e || e && e.data.external) && !Y && ue()
                    }
                    var n;
                    p.debugEnabled() && p.debug("onPlay index: " + g), ce(V[g], e, !1), !isNaN(C) && Te(V[C]) && e.data.buffer && (p.debugEnabled() && p.debug("call raw play on paused switch element after buffering during switch"), ce(V[C], e, !1))
                  } else p.debugEnabled() && p.debug("mediaElement could not be found")
                }
              }, {
                type: d.PAUSE, listener: function (e) {
                  p.debugEnabled() && p.debug("onPause index: " + g), le(V[g], e, e.data.buffer), isNaN(C) || le(V[C], e, e.data.buffer), e.data.buffer || (Ye(), p.debugEnabled() && p.debug("reset time offset"), k = je()), function () {
                    for (var e in ae) if (Object.prototype.hasOwnProperty.call(ae, e)) for (; ae[e].length;) ae[e].pop()
                  }()
                }
              }, {
                type: d.MUTE, listener: function () {
                  p.debugEnabled() && p.debug("mute index: " + g), fe(V[g], !0)
                }
              }, {type: d.UNMUTE, listener: ue}, {
                type: d.SEEK, listener: function (e) {
                  p.debugEnabled() && p.debug("onSeek index: " + g), function (e, t) {
                    e ? e.seek(t) : p.debugEnabled() && p.debug("mediaElement could not be found")
                  }(V[g], e)
                }
              }, {
                type: d.SET_VOLUME, listener: function (e) {
                  Se(e) && (p.debugEnabled() && p.debug("onSetVolume index: " + g), q = Math.min(1, Math.max(0, e.data.volume)), ge(V[g], q))
                }
              }, {
                type: d.SET_RATE, listener: function (e) {
                  if (Se(e)) {
                    p.debugEnabled() && p.debug("onSetRate index: " + g);
                    var t = e.data.rate;
                    !function (e, t) {
                      e ? e.setRate(t) : p.debugEnabled() && p.debug("mediaElement could not be found")
                    }(V[g], t)
                  }
                }
              }, {type: s.LOAD_START, listener: de}, {type: s.PROGRESS, listener: de}, {
                type: s.SUSPEND,
                listener: de
              }, {type: s.ABORT, listener: de}, {type: s.EMPTIED, listener: de}, {
                type: s.STALLED,
                listener: de
              }, {type: s.PLAY, listener: de}, {type: s.PAUSE, listener: de}, {
                type: s.LOADED_META_DATA,
                listener: de
              }, {type: s.LOADED_DATA, listener: de}, {type: s.WAITING, listener: de}, {
                type: s.ERROR,
                listener: de
              }, {type: s.PLAYING, listener: de}, {type: s.CAN_PLAY, listener: de}, {
                type: s.CAN_PLAY_THROUGH,
                listener: de
              }, {type: s.SEEKING, listener: de}, {type: s.SEEKED, listener: de}, {
                type: s.TIME_UPDATE,
                listener: de
              }, {type: s.QUALITY_UPDATE, listener: de}, {type: s.ENDED, listener: de}, {
                type: s.RATE_CHANGE,
                listener: de
              }, {type: s.DURATION_CHANGE, listener: de}, {
                type: s.VOLUME_CHANGE,
                listener: de
              }, {type: s.ELEMENT_CREATED, listener: de}, {
                type: s.PLAY_START_SUCCESS,
                listener: de
              }, {type: s.PLAY_START_ABORT_ERROR, listener: de}, {
                type: s.PLAY_START_NOT_ALLOWED_ERROR,
                listener: de
              }, {type: s.VIEWPORT_VISIBLE, listener: de}, {
                type: s.VIEWPORT_HIDDEN,
                listener: de
              }, {
                type: a.SWITCH_STREAM_INIT, listener: function (e) {
                  W && Le(e)
                }
              }, {
                type: a.SWITCH_STREAM_SUCCESS, listener: function (e) {
                  m && Se(e) && (W ? w && e.data.id === w.id && j && (K = !0, j = !1, (J = !0) && p.debugEnabled() && p.debug("initialized true - onSwitchStreamSuccess"), Ke(w.entry.index)) : Object.prototype.hasOwnProperty.call(e.data, "entry") && Object.prototype.hasOwnProperty.call(e.data.entry, "index") && Ke(e.data.entry.index))
                }
              }, {
                type: a.UPDATE_SOURCE_INIT, listener: function (e) {
                  W && (Le(e), P = void 0)
                }
              }, {
                type: a.UPDATE_SOURCE_SUCCESS, listener: function (e) {
                  m && Se(e) && (W ? w && e.data.id === w.id && j && (K = !0, j = !1, (J = !0) && p.debugEnabled() && p.debug("initialized true - onUpdateSourceSuccess"), Ke(M)) : Object.prototype.hasOwnProperty.call(e.data, "source") && Object.prototype.hasOwnProperty.call(e.data.source, "startIndex") && Ke(e.data.source.startIndex))
                }
              }, {
                type: a.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case f.PAUSED:
                      (j || K) && void 0 !== C && -1 === [E.BUFFER, E.STREAM_NOT_FOUND].indexOf(e.data.reason) ? (be(V[C]), _e(V[g]), Ge(C), g = C, F ? (Ke(F.source.startIndex), A = F.source.startIndex) : Ke(M), we(), De(), F = void 0) : (_e(V[C]), we(), De(), E.STREAM_NOT_FOUND === e.data.reason && P && (Ke(P), P = void 0)), W = !1, (J = !1) && p.debugEnabled() && p.debug("initialized true - mediaElementPrepareSwitch"), ie = !1, qe(!1), Qe(!1), Je(!1), Xe(!1), $e(!1), Ze(!1), ze(!1);
                      break;
                    case f.PLAYING:
                  }
                }
              }, {
                type: a.MEDIA_ERROR_RECOVER, listener: function (t) {
                  if (p.debugEnabled() && p.debug("media error recover"), m) switch (p.debugEnabled() && p.debug("recovering..."), qe(t.data.code), t.data.code) {
                    case c.MEDIA.DECODE_ERROR:
                      p.debugEnabled() && p.debug("switch stream to recover after media error decode error"), e.emit(o.SWITCH_STREAM, {type: "recover"});
                      break;
                    case c.MEDIA.HLS_VIDEO_DECODE_ERROR:
                      p.debugEnabled() && p.debug("switch stream to recover after media error hls video decode error"), e.emit(o.SWITCH_STREAM, {type: "recover"});
                      break;
                    case c.MEDIA.HLS_BUFFER_UNDERRUN:
                      t.data.reconnect ? (p.debugEnabled() && p.debug("get timeOffset from previous stats after media error hls ended"), Ve(G[0]), p.debugEnabled() && p.debug("switch stream to recover after media error hls ended"), e.emit(o.SWITCH_STREAM, {type: "recover"})) : (p.debugEnabled() && p.debug("call raw play to recover after media error hls ended"), Ve(), ce(V[g], {data: {hlsended: !0}}, !1), te && ne && (p.debugEnabled() && p.debug("was canPlay during switch & media error queued"), Ze(!1), Qe(!0)));
                      break;
                    case c.MEDIA.HLS_MAX_RANGE:
                      p.debugEnabled() && p.debug("get timeOffset from previous stats after media error playback error"), Ve(G[0]), p.debugEnabled() && p.debug("switch stream to recover after media error hls max range"), e.emit(o.SWITCH_STREAM, {type: "recover"});
                      break;
                    case c.PLAYER.PLAYBACK_ERROR:
                      p.debugEnabled() && p.debug("get timeOffset from previous stats after media error playback error"), Ve(G[0]), p.debugEnabled() && p.debug("call raw pause after media error playback error"), le(V[g], {data: {error: !0}}, !0), p.debugEnabled() && p.debug("switch stream to recover after media error playback error"), e.emit(o.SWITCH_STREAM, {type: "recover"})
                  }
                }
              }, {
                type: a.MEDIA_ERROR_QUEUED, listener: function (e) {
                  if (p.debugEnabled() && p.debug("media error queued"), ze(!0), j) switch (p.debugEnabled() && p.debug("media error queued & switch initialized"), e.data.code) {
                    case c.MEDIA.HLS_VIDEO_DECODE_ERROR:
                    case c.MEDIA.HLS_BUFFER_UNDERRUN:
                      break;
                    case c.PLAYER.PLAYBACK_ERROR:
                      le(V[g], {data: {error: !0}}, !0)
                  }
                }
              }, {
                type: a.MEDIA_ERROR_UNQUEUED, listener: function () {
                  p.debugEnabled() && p.debug("media error unqueued"), ze(!1), Ze(!1)
                }
              }], G = [], V = [], W = !1, Y = !1, j = !1, K = !1, q = 1, z = !1, Q = "not-set", J = !1, X = !1, $ = !1,
              Z = !1, ee = !1, te = !1, ne = !1, re = !1, ie = !1, ae = {0: []}, oe = !1, se = !1;

            function de(t) {
              if (t && t.name && t.data) {
                var n = t.data.index;
                R = he(V[n]);
                var i = t.data, a = tt(R, t.data, !1), d = t.name, u = function (e) {
                  return "mediaElementHandler." + function (e) {
                    var t = e.indexOf(".") + 1;
                    return e.substring(t)
                  }(e)
                }(d);
                if (d !== s.TIME_UPDATE) for (ae[n].unshift(d); ae[n].length > 20;) ae[n].pop();
                if (g === n) switch (d) {
                  case s.SEEKING:
                    ie === c.MEDIA.HLS_BUFFER_UNDERRUN && Xe(!0), e.emit(u, a);
                    break;
                  case s.SEEKED:
                    ie === c.MEDIA.HLS_BUFFER_UNDERRUN && $e(!0), e.emit(u, a);
                    break;
                  case s.CAN_PLAY:
                    if (ie === c.MEDIA.HLS_BUFFER_UNDERRUN) {
                      if (Te(V[n]) && (p.debugEnabled() && p.debug("video paused at can play in recovery on current media element"), p.debugEnabled() && p.debug("call raw play"), ce(V[n], {data: {hlsended: !0}}, !1)), ee && G[0].currentTime > i.currentTime && i.currentTime < 1) return Xe(!1), $e(!1), p.debugEnabled() && p.debug("pause because seek back during buffer recovery detected"), le(V[g], {data: {error: !0}}, !0), p.debugEnabled() && p.debug("switch stream to recover after seek back during buffering"), void e.emit(o.SWITCH_STREAM, {
                        index: U,
                        type: "recover"
                      });
                      p.debugEnabled() && p.debug("now wait for progress for completion"), Qe(!0)
                    }
                    J || (!m || j || !W) && m || (e.emit(u, a), (J = !0) && p.debugEnabled() && p.debug("initialized true - onMediaElementEvent CAN_PLAY on currentMediaElementIndex: " + g), we()), Ze(!(!j || !ne));
                    break;
                  case s.PROGRESS:
                    ie && !j && ie === c.MEDIA.HLS_BUFFER_UNDERRUN && X && (Te(V[n]) || (p.debugEnabled() && p.debug("video not paused & wait for progress in recovery on current media element"), Z && !ee ? p.debugEnabled() && p.debug("ongoing seek, wait for seeked in next progress") : Z && ee ? (p.debugEnabled() && p.debug("media error " + ie + " recovered in progress after seek"), Xe(!1), $e(!1), e.emit(o.MEDIA_ERROR_RECOVERED, {data: {code: ie}}), qe(!1), Qe(!1), p.debugEnabled() && p.debug("merge pending time offset after seeked"), We(!0), Ye()) : Z || ee || (p.debugEnabled() && p.debug("media error " + ie + " recovered in progress without seek"), e.emit(o.MEDIA_ERROR_RECOVERED, {data: {code: ie}}), qe(!1), Qe(!1), Ye()))), e.emit(u, a);
                    break;
                  case s.PAUSE:
                    ie === c.MEDIA.HLS_BUFFER_UNDERRUN && p.debugEnabled() && p.debug("pause event during recovery of 3101"), e.emit(u, a);
                    break;
                  default:
                    e.emit(u, a)
                } else if (n === C && C !== g && W) switch (p.debugEnabled() && p.debug("onMediaElementEvent switchMediaElementIndex: " + C), d) {
                  case s.PLAY:
                  case s.DURATION_CHANGE:
                  case s.LOADED_META_DATA:
                  case s.LOADED_DATA:
                    e.emit(u, a);
                    break;
                  case s.CAN_PLAY:
                    p.debugEnabled() && p.debug("onMediaElementEvent CAN_PLAY on switchMediaElementIndex: " + C), J || (p.debugEnabled() && p.debug("onMediaElementEvent emit CAN_PLAY"), e.emit(u, a), (J = !0) && p.debugEnabled() && p.debug("initialized true - onMediaElementEvent CAN_PLAY on switchMediaElementIndex: " + C));
                    break;
                  case s.CAN_PLAY_THROUGH:
                    p.debugEnabled() && p.debug("onMediaElementEvent CAN_PLAY_THROUGH on switchMediaElementIndex: " + C), K && (p.debugEnabled() && p.debug("onMediaElementEvent CAN_PLAY_THROUGH wait for progress"), Je(!0), e.emit(u, a));
                    break;
                  case s.PROGRESS:
                    p.debugEnabled() && p.debug("onMediaElementEvent PROGRESS on switchMediaElementIndex: " + C), K && $ && (p.debugEnabled() && p.debug("onMediaElementEvent PROGRESS call mediaElementSwitch"), Je(!1), function () {
                      if (m && void 0 !== C && K) if (p.debugEnabled() && p.debug("switch mediaElement after successfull " + (Be() ? "updateSource" : "switchStream")), se) p.debugEnabled() && p.debug("there is a lock on media element switch, skipping the execution"); else {
                        p.debugEnabled() && p.debug("starting to complete switch"), et(!0), De();
                        var e = Ue.bind(this, V[C]), t = ye.bind(this, V[C]);
                        r.performInSyncedUIBehavior(e, t, 150).then((function () {
                          try {
                            p.debugEnabled() && p.debug("switch mediaElement UI preparation is done"), Fe(), et(!1)
                          } catch (e) {
                            p.debugEnabled() && p.debug("error in performInSyncedUIBehavior success calback")
                          }
                        })).catch((function () {
                          try {
                            p.debugEnabled() && p.debug("switch mediaElement UI preparation is failed"), Fe(), et(!1)
                          } catch (e) {
                            p.debugEnabled() && p.debug("error in performInSyncedUIBehavior catch calback")
                          }
                        }))
                      }
                    }());
                    break;
                  case s.PLAYING:
                    e.emit(u, a)
                }
              }
            }

            function ue() {
              p.debugEnabled() && p.debug("unmute index: " + g);
              for (var e = 0; e < V.length; e++) Ee(V[e], !0);
              setTimeout((function () {
                for (var e = 0; e < V.length; e++) e !== g && fe(V[e], !1)
              }), 50)
            }

            function ce(e, t, n) {
              e ? (e.play(t), n || (W = !0)) : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function le(e, t, n) {
              e ? (e.pause(t), n || (W = !1)) : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function fe(e, t) {
              e ? (t && (Y = !0), e.setMute()) : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function Ee(e, t) {
              e ? (t && (Y = !1), e.setUnmute()) : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function pe(e) {
              if (e) return e.getVideoPlaybackQuality();
              p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function me(e) {
              if (e) return e.getVideoElement();
              p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function ge(e, t) {
              e ? (e.setVolume(t), q = t) : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function be(e) {
              e ? e.show() : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function _e(e) {
              e ? e.hide() : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function he(e) {
              return e ? (oe || (x = e.getMediaElementPayload()), x.timeOffset = k, x) : (p.debugEnabled() && p.debug("mediaElement could not be found"), {index: 0})
            }

            function Te(e) {
              if (e) return e.getVideoPausedState();
              p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function Ae(e) {
              e ? e.loadVideo() : p.debugEnabled() && p.debug("mediaElement could not be found")
            }

            function Se(e, t) {
              var n = e && Object.prototype.hasOwnProperty.call(e, "data");
              return t ? n && Object.prototype.hasOwnProperty.call(e.data, t) : n
            }

            function ye(e) {
              return e ? e.isShownOnTop() : (p.debugEnabled() && p.debug("mediaElement could not be found"), !1)
            }

            function Re() {
              clearInterval(b), b = void 0
            }

            function ve() {
              clearInterval(_), _ = void 0
            }

            function Oe() {
              b = setInterval(Ce, 100)
            }

            function Ie() {
              _ = setInterval(Ne, 1e3)
            }

            function Ce() {
              for (S = he(V[g]); G.length > 2;) G.shift();
              G.push(S), e.emit(s.TIME_UPDATE, S)
            }

            function Ne() {
              (y = he(V[g])).quality = pe(V[g]), e.emit(s.QUALITY_UPDATE, y)
            }

            function De() {
              T && (clearTimeout(T), T = 0)
            }

            function we() {
              p.debugEnabled() && p.debug("reset switch variables"), C = void 0, (J = !0) && p.debugEnabled() && p.debug("initialized true - resetSwitchVariables"), j = !1, K = !1, w = void 0, M = void 0
            }

            function Ue(e) {
              e && e.showOnTop()
            }

            function Pe(e, t) {
              e && e.setSource({source: t ? O : v})
            }

            function Me(e) {
              e && e.setType({type: I})
            }

            function Le(e) {
              var t, r, i, a;
              if (m && Se(e) && Object.prototype.hasOwnProperty.call(e.data, "entry")) if (i = e.data.entry.index, t = F ? "update" === F.type : Be(), r = "update" === e.data.type, p.debugEnabled() && p.debug((r ? "updateSourceInit" : "switchStreamInit") + " with entryIndex: " + i), re) p.debugEnabled() && p.debug((r ? "updating" : "switching") + " is disabled, abort"); else {
                if (!r && ie && "recover" !== e.data.type) return p.debugEnabled() && p.debug("abort switch attempt during recovery"), (a = n.copy(e.data)).reason = "recover", void ke(a);
                if (j && (!t || t && r) || F && (!t || t && r)) p.debugEnabled() && p.debug("abort ongoing " + (t ? "update" : "switch") + " process"), (a = n.copy(F || w)).reason = "superseded", ke(a), De(), F ? F = void 0 : (le(V[C], void 0, !0), we()); else if (j && t && !r || F && t && !r) return void (p.debugEnabled() && p.debug("ongoing updateSource process!"));
                r || U !== i || "recover" === e.data.type ? (p.debugEnabled() && p.debug("new " + (r ? "update" : "switch")), K ? (p.debugEnabled() && p.debug("do not handle switch, still ongoing switch!"), p.debugEnabled() && p.debug("add to queue!"), F = e.data) : (p.debugEnabled() && p.debug("handle switch without ongoing"), He(e.data, i, r))) : (p.debugEnabled() && p.debug("abort switch attempt on equal index"), (a = n.copy(e.data)).reason = "equalsource", we(), De(), ke(a)), re = !0, setTimeout((function () {
                  re = !1
                }), 500)
              }
            }

            function Fe() {
              p.debugEnabled() && p.debug("starting to swap media elements"), be(V[C]), _e(V[g]), Ge(C), me(V[g]) && (Y = me(V[g]).muted), fe(V[g]), Y ? fe(V[C]) : Ee(V[C]), ie && (p.debugEnabled() && p.debug("media error " + ie + " recovered in switch success"), e.emit(o.MEDIA_ERROR_RECOVERED, {data: {code: ie}}), qe(!1)), oe || Ve(), We(!0), Ye(), p.debugEnabled() && p.debug("handle switch pause on currentMediaElementIndex: " + g), le(V[g], void 0, !0), ge(V[C], q), g = C, F ? (K = !1, function () {
                if (F) {
                  var e = "update" === F.type, t = F.entry.index, r = n.copy(F);
                  F = void 0, p.debugEnabled() && p.debug("handleQueuedSwitch"), He(r, t, e, !0)
                }
              }()) : we()
            }

            function xe() {
              if (void 0 !== C && C !== g && j && !K) {
                var t = n.copy(w);
                le(V[C], void 0, !0), Be() && (Ke(void 0), e.emit(o.UPDATE_SOURCE_TIMEOUT, {
                  code: c.STREAM.MEDIA_NOT_AVAILABLE,
                  message: l.STREAM.MEDIA_NOT_AVAILABLE
                })), F = void 0, we(), function (t) {
                  e.emit(o.UPDATE_SOURCE_FAIL, {
                    tag: t.options.tag,
                    count: t.options.count,
                    code: c.NETWORK.SOURCE_TIMEOUT,
                    message: l.NETWORK.SOURCE_TIMEOUT,
                    type: t.type,
                    id: t.id
                  })
                }(t)
              }
            }

            function ke(t) {
              setTimeout((function () {
                e.emit(o.UPDATE_SOURCE_ABORT, {
                  source: t.source,
                  entry: t.entry,
                  rule: t.rule,
                  reason: t.reason,
                  tag: t.tag,
                  count: t.count,
                  type: t.type,
                  id: t.id
                })
              }), 0)
            }

            function Be() {
              return w && Object.prototype.hasOwnProperty.call(w, "type") && "update" === w.type
            }

            function He(e, t, n, r) {
              C = g ? 0 : 1, p.debugEnabled() && p.debug("mediaElementPrepareSwitch on switchMediaElementIndex: " + C), (J = !1) && p.debugEnabled() && p.debug("initialized true - mediaElementPrepareSwitch"), j = !0, w = e, n ? (A = w.source.startIndex, M = A, r && (Pe(V[C], A), Me(V[C]), m || Ae(V[C]), m && j && fe(V[C]), ce(V[C], void 0, !0), Re(), ve(), v.length && (p.debugEnabled() && p.debug("add time update interval for play stats"), Oe(), void 0 !== pe(V[C]) && (p.debugEnabled() && p.debug("add quality update interval"), Ie())))) : W && (C = g ? 0 : 1, M = t, r && (Pe(V[C], t), Me(V[C]), m || Ae(V[C]), m && j && fe(V[C]), ce(V[C], void 0, !0))), W && function (e) {
                T && De();
                var t = e && Object.prototype.hasOwnProperty.call(e, "options") && Object.prototype.hasOwnProperty.call(e.options, "timeout") ? 1e3 * e.options.timeout : 1e4;
                T = setTimeout((function () {
                  xe()
                }), t)
              }(w)
            }

            function Ge(t) {
              for (var n = V.map((function (e) {
                return e.getVideoElement()
              })), r = 0; r < n.length; r += 1) void 0 !== typeof n[r] && n[r] || n.pop();
              n.length - 1 < t && (t = -1), e.emit(o.ACTIVE_VIDEO_ELEMENT_CHANGE, {
                videoElementList: n,
                activeVideoElement: t < 0 ? null : n[t]
              })
            }

            function Ve(e) {
              p.debugEnabled() && p.debug("set pending time offset"), e || (e = he(V[g])), oe = !0, B.currentTime = e.currentTime, p.debugEnabled() && p.debug("new pending time offset: " + JSON.stringify(B))
            }

            function We(e) {
              p.debugEnabled() && p.debug("apply pending time offset"), k = tt(k, B, e), p.debugEnabled() && p.debug("new time offset: " + JSON.stringify(k))
            }

            function Ye() {
              p.debugEnabled() && p.debug("reset pending time offset"), oe = !1, B = je()
            }

            function je() {
              return !!m && {currentTime: 0}
            }

            function Ke(e) {
              P = U, U = e
            }

            function qe(e) {
              p.debugEnabled() && p.debug("set inRecovery to " + e), ie = e
            }

            function ze(e) {
              p.debugEnabled() && p.debug("set isMediaErrorQueued to " + e), ne = e
            }

            function Qe(e) {
              p.debugEnabled() && p.debug("set waitForProgress to " + e), X = e
            }

            function Je(e) {
              p.debugEnabled() && p.debug("set waitForProgressSwitch to " + e), $ = e
            }

            function Xe(e) {
              p.debugEnabled() && p.debug("set wasSeeking to " + e), Z = e
            }

            function $e(e) {
              p.debugEnabled() && p.debug("set wasSeeked to " + e), ee = e
            }

            function Ze(e) {
              p.debugEnabled() && p.debug("set wasCanPlayDuringSwitch to " + e), te = e
            }

            function et(e) {
              p.debugEnabled() && p.debug("set lockMediaElementSwitch to " + e), se = e
            }

            function tt(e, t, n) {
              return e
            }

            return i.add({target: e, listeners: H}), {
              destroy: function () {
                ve(), Re(), i.remove({target: e, listeners: H}), function (e) {
                  if (e) {
                    for (var t = 0; t < e.length; t++) e[t].destroy();
                    Ge(-1), e = []
                  } else p.debugEnabled() && p.debug("mediaElement could not be found")
                }(V)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7022: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(5698), n(560), n(5980), n(291), n(492)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        return {
          create: function (d) {
            var u, c, l = e.create("MediaElementPlaybackControl"), f = {}, E = {}, p = !1, m = !0, g = !1, b = !1,
              _ = -1, h = null, T = [], A = [], S = !0, y = 0, R = !1, v = .2, O = .2, I = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (u = e.data.state, h = null, u) {
                    case s.PLAYING:
                      c = !1;
                      break;
                    case s.LOADING:
                      l.debugEnabled() && l.debug("add play state listeners"), n.add({target: d, listeners: C});
                      break;
                    case s.PAUSED:
                      c = !1;
                      break;
                    case s.PAUSING:
                      n.remove({
                        target: d,
                        listeners: C
                      }), l.warnEnabled() && l.warn("entering paused state"), _ = -1, p = !1, S = !1, m = !0, R = !1
                  }
                }
              }, {
                type: r.STARTUP_STATS_COMPLETED, listener: function (e) {
                  h = e.data
                }
              }, {type: r.STREAM_INFO, listener: N}, {type: r.STREAM_INFO_UPDATE, listener: N}, {
                type: r.CONFIG,
                listener: function (e) {
                  g = t.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && t.canUseHLS
                }
              }, {
                type: r.BUFFER_TWEAKS_CREATED, listener: function (e) {
                  l.debugEnabled() && l.debug("buffer tweaks created"), u === s.PLAYING && f.buffer && f.buffer.start < e.data.tweaks.buffer.start && setTimeout((function () {
                    S = !1, m = !0, l.debugEnabled() && l.debug("new tweaks, pausing to raise buffer"), P(), w()
                  }), 10), f.buffer = e.data.tweaks.buffer, O = f.buffer.start - f.buffer.min >= .5 ? .2 : 0
                }
              }, {
                type: o.PLAY, listener: function (e) {
                  l.debugEnabled() && l.debug("on play"), setTimeout((function () {
                    -1 === _ && e.data.external && !e.data.invalidState && (g ? b = !0 : D())
                  }), 10)
                }
              }, {
                type: r.MEDIA_ERROR_RECOVER, listener: function () {
                  l.debugEnabled() && l.debug("media error recover"), c = !0
                }
              }, {
                type: r.MEDIA_ERROR_RECOVERED, listener: function () {
                  l.debugEnabled() && l.debug("media error recovered"), c = !1
                }
              }], C = [{
                type: a.PRIVATE_MEDIA_STATS, listener: function (e) {
                  if (!(E = e.data.mediaStats).buffered || !E.buffered.length) return l.detailEnabled() && l.detail("no data in play stats"), void (g && b && isFinite(E.duration) && (b = !1, D()));
                  var n = E.exactCurrentTime;
                  L(T, n, 5);
                  var r = M(T), a = E.buffered, s = function (e, n) {
                    for (var r = 0; e && r < e.length; ++r) if (e.start(r) <= n + 1e-6 && e.end(r) >= n - 1e-6 || t.isTridentBrowser && n <= .3 && e.start(r) <= 5 && e.end(r) - e.start(r) > .2) return r;
                    return -1
                  }(a, n), u = {
                    startRange: a.start(a.length - 1),
                    endRange: a.end(a.length - 1),
                    rangeLength: a.end(a.length - 1) - a.start(a.length - 1),
                    rangeIndex: s,
                    hasRangeIndex: -1 !== s,
                    bufferedPartsCount: a.length
                  }, I = g && !p ? u.endRange - n : E.bufferDelay;
                  L(A, E.bufferEnd, 5);
                  var C = M(A), N = {
                    currentTime: n,
                    bufferDelayCurrent: I,
                    hasEnoughToStart: I >= f.buffer.start - v,
                    hasEnoughToResume: I >= f.buffer.start - O,
                    hasEnoughPrerollToStart: I >= y - (f.buffer.start - v - f.buffer.min),
                    hasStartHigherPreroll: f.buffer.start - v > y,
                    hasEnoughToPlay: I > f.buffer.min,
                    bufferLength: E.bufferEnd - E.bufferStart,
                    bothCurrentTimeAndBufferEndNotMoving: r && C,
                    currentTimeNotMoving: r,
                    bufferEndNotMoving: C
                  };
                  null === function (e, n) {
                    var r = null;
                    return !g && !e.hasRangeIndex && !p && n.bufferLength > .45 ? (r = Math.min(e.startRange + .3, e.endRange), U(t.isTridentBrowser ? 0 : r, "seek to range: " + e.startRange + " < " + r + " > " + e.endRange + ", currentTime: " + n.currentTime)) : !g && !p && t.isFirefox && e.bufferedPartsCount > 1 && e.rangeIndex !== e.bufferedPartsCount - 1 && e.rangeLength > .3 && U(r = e.startRange, "seek to startable range start: " + r), r
                  }(u, N) && (function (e, n, r, i) {
                    if (-1 === _ && e.hasRangeIndex && n.hasEnoughToStart) {
                      l.debugEnabled() && l.debug("start buffer of " + (r.buffer.start - v) + " reached");
                      var a = !g && t.isSafari, o = a && n.currentTime < .2;
                      if (!y || y && n.hasStartHigherPreroll) {
                        if (l.debugEnabled() && l.debug(" start buffer case"), o) return U(_ = .3, "initial safari stream startTime set to " + _ + ", seeking", !0), !0;
                        _ = n.currentTime, l.debugEnabled() && l.debug("default stream startTime set to " + _)
                      } else if (y && n.hasEnoughPrerollToStart && !n.hasStartHigherPreroll && (l.debugEnabled() && l.debug("preroll buffer of " + y + " reached"), U(_ = a ? i.bufferEnd - .15 : y - (r.buffer.start - r.buffer.min), "initial preroll stream startTime set to " + _ + ", seeking", !0), a)) return !0
                    }
                  }(u, N, f, E) || function (e, t) {
                    m && R && (!p && e.hasEnoughToStart || p && e.hasEnoughToResume && !e.bufferEndNotMoving) && -1 !== _ && (l.debugEnabled() && l.debug("on operatePlayback : starting stream at " + _ + " with latency " + e.bufferDelayCurrent), d.emit(o.PLAY, {
                      external: !1,
                      buffer: !0
                    }), m = !1, p && (l.debugEnabled() && l.debug("on operatePlayback : resuming playback, emitting playbackStarted"), d.emit(i.PLAYBACK_STARTED))), m || (!p && -1 !== _ && _ < e.currentTime - .1 && (p = !0, g && e.currentTime < 1 && t.duration > 1 && (l.debugEnabled() && l.debug("useHLS: buffer higher 1 at start"), e.currentTime < .5 && U(1, "useHLS: maybe preroll detected, seek to 1"))), p && h && (l.debugEnabled() && l.debug("on operatePlayback : starting playback, emitting playbackStarted with stats"), d.emit(i.PLAYBACK_STARTED, h)), e.currentTime > f.buffer.start && !c && (!e.hasEnoughToPlay || p && e.bothCurrentTimeAndBufferEndNotMoving) && (S ? (S = !1, m = !0, l.debugEnabled() && l.debug("pausing to buffer during playback"), P(), w()) : S = !0))
                  }(N, E))
                }
              }];

            function N(e) {
              y = e.data.streamInfo.prerollDuration ? e.data.streamInfo.prerollDuration : 0, R = !0
            }

            function D() {
              l.debugEnabled() && l.debug("pausing to raise buffer at start"), w()
            }

            function w() {
              d.emit(o.PAUSE, {external: !1, buffer: !0})
            }

            function U(e, t, n) {
              l.warnEnabled() && l.warn(t), d.emit(o.SEEK, {position: e, fast: !0 === n})
            }

            function P() {
              d.emit(i.BUFFERING)
            }

            function M(e) {
              var t = !0;
              if (e.length) {
                for (var n = e[0], r = 1; r < e.length; r++) if (e[r] !== n) {
                  t = !1;
                  break
                }
              } else t = !1;
              return t
            }

            function L(e, t, n) {
              e.length === n && e.shift(), e.push(t)
            }

            return n.add({target: d, listeners: I}), {
              destroy: function () {
                n.remove({target: d, listeners: I})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7628: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(803), n(6637), n(5304), n(3763), n(4210)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s, d, u, c, l, f, E, p, m, g) {
            var b, _, h, T, A, S, y = e.create("MediaElementProxy " + d), R = !1, v = 0, O = !0, I = !1, C = "10",
              N = [];

            function D() {
              b && (r.remove({
                target: b,
                listeners: N
              }), t.isTridentBrowser && (S = void 0, ["scroll", "resize"].forEach((function (e) {
                window.removeEventListener && window.removeEventListener(e, x, !1), window.detachEvent && window.detachEvent("on" + e, x)
              }))), V({source: ""}), W(), b.firstChild && b.removeChild(b.firstChild), b.parentNode && b.parentNode.removeChild(b), R && (y.debugEnabled() && y.debug("releasing external video"), b.style.cssText = T, T = null, A && A.appendChild(b)), b = null, h && (h.parentNode && h.parentNode.removeChild(h), h = null))
            }

            function w() {
              y.debugEnabled() && y.debug("mute"), b && (b.muted = !0)
            }

            function U() {
              y.debugEnabled() && y.debug("unmute"), b && (b.muted = !1)
            }

            function P(e) {
              y.debugEnabled() && y.debug("onPlay"), function (e) {
                return new Promise((function (t) {
                  l && (!e || K(e, "external", !0) || K(e, "unlocked", !0) || K(e, "buffer", !1)) ? v || (y.debugEnabled() && y.debug("set load timeout before call play"), v = setTimeout((function () {
                    if (v = 0, b) {
                      y.debugEnabled() && y.debug("load before call play");
                      try {
                        W(), L(1)
                      } catch (e) {
                        y.debugEnabled() && y.debug("err in onPlay Promise resolve")
                      }
                      t(e)
                    }
                  }), 250)) : t(e)
                }))
              }(e).then((function e(t) {
                if (l && (O = !1), b) return y.debugEnabled() && y.debug("call play at currentTime " + b.currentTime), n.play(b).then((function () {
                  K(t, "unlocked", !0) ? (I = !0, y.debugEnabled() && y.debug("unlocked set to true"), y.debugEnabled() && y.debug("play promise resolved, video element unlocked"), M(t)) : K(t, "invalidState", !0) ? (y.debugEnabled() && y.debug("invalid state set to true"), y.debugEnabled() && y.debug("play promise resolved, media source open"), s.emit(o.PLAY_START_SUCCESS, k())) : (y.debugEnabled() && y.debug("play promise resolved"), p = !1, K(t, "buffer", !0) && y.debugEnabled() && y.debug("play hook after buffering"), y.debugEnabled() && y.debug("resolve play at currentTime " + b.currentTime))
                })).catch((function (n) {
                  var r;
                  if (K(t, "unlocked", !0)) y.debugEnabled() && y.debug("play promise rejected, video element not activated"); else if (b) if (n.error.name === i.ABORT_ERROR) {
                    y.debugEnabled() && y.debug("play promise rejected, abort error: " + n.error.message);
                    var d = "unknown";
                    /video-only background media was paused/.test(n.error.message) ? d = "background" : /paused by a call to pause/.test(n.error.message) && (d = "pausecall"), (r = k()).error = n.error, r.reason = d, s.emit(o.PLAY_START_ABORT_ERROR, r)
                  } else n.error.name === i.NOT_ALLOWED_ERROR && (y.debugEnabled() && y.debug("play promise rejected, not allowed error: " + n.error.message), K(t, "invalidState", !0) || b.muted || !E || p ? !K(t, "invalidState", !0) && b.muted && p && (y.debugEnabled() && y.debug("unmute to reset"), U(), b.muted || (F({type: a.VOLUME_CHANGE}), p = !1)) : (y.debugEnabled() && y.debug("mute to play"), w(), b.muted && (p = !0, setTimeout(e.bind(null, {data: {external: !1}}), 0))), (K(t, "external", !1) || p || (!b.muted && !E || b.muted) && l) && ((r = k()).error = n.error, r.automuted = p, s.emit(o.PLAY_START_NOT_ALLOWED_ERROR, r))); else y.debugEnabled() && y.debug("play promise rejected, video element reference not valid");
                  y.debugEnabled() && y.debug(n.error.name + ": " + n.error.message)
                }))
              }))
            }

            function M(e) {
              y.debugEnabled() && y.debug("onPause"), b && (v && (clearTimeout(v), v = 0), b.pause(), !l || e && !K(e, "buffer", void 0) || (O = !0, K(e, "unlocked", !0) ? y.debugEnabled() && y.debug("paused after state check") : K(e, "error", !0) && y.debugEnabled() && y.debug("pause after media error"), V({source: ""}), W(), h && h.tagName && "IFRAME" === h.tagName && (h.contentWindow && h.contentWindow.location ? (u.appendChild(b), h.contentWindow.location.reload(!0)) : B())), L(1))
            }

            function L(e) {
              (l || t.isIOS || t.isIOSDesktopMode) && 1 === e && (e = 1 + 1e-7), b && e && b.playbackRate !== e && (y.debugEnabled() && y.debug("set rate to: " + e), b.playbackRate = e)
            }

            function F(e) {
              var t = k();
              switch (e.type) {
                case a.ERROR:
                  t.code = b.error && "number" == typeof b.error.code ? b.error.code : 200;
                  break;
                case a.VOLUME_CHANGE:
                  t.muted = b.muted, t.volume = b.volume;
                  break;
                case a.CAN_PLAY:
                  t.haveVideo = void 0 !== b.videoTracks && b.videoTracks.length > 0, t.haveAudio = void 0 !== b.audioTracks && b.audioTracks.length > 0, t.videoWidth = b.videoWidth, t.videoHeight = b.videoHeight
              }
              y.detailEnabled() && y.detail(e.type + " - (index: " + c + ", paused: " + Y() + ", currentTime: " + t.currentTime + ", latency: " + ((t.useDuration ? t.duration : t.buffered.length ? t.buffered.end(t.buffered.length - 1) : 0) - t.currentTime) + ")"), (!l || e.type !== a.CAN_PLAY || l && e.type === a.CAN_PLAY && !O) && s.emit("mediaElementProxy." + e.type, t)
            }

            function x() {
              var e = b && "function" == typeof b.getBoundingClientRect ? b.getBoundingClientRect() : {
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0
                }, t = window.innerHeight || document.documentElement.clientHeight,
                n = window.innerWidth || document.documentElement.clientWidth, r = e.top <= t && e.top + e.height >= 0,
                i = e.left <= n && e.left + e.width >= 0, a = r && i;
              a !== S && (y.debugEnabled() && y.debug("viewport changed to " + (a ? "visible" : "hidden")), S = a, s.emit(a ? o.VIEWPORT_VISIBLE : o.VIEWPORT_HIDDEN, k()))
            }

            function k() {
              return {
                currentTime: b.currentTime,
                buffered: b.buffered,
                played: b.played,
                playbackRate: b.playbackRate,
                index: c,
                duration: b.duration,
                useDuration: l && Number.isFinite(b.duration) && b.duration < 4e6,
                paused: b.paused
              }
            }

            function B() {
              y.debugEnabled() && y.debug("iOS11 detected, using iframe hack");
              var e = {
                name: "h5live-iframe-" + c,
                frameBorder: 0,
                scrolling: "no",
                style: {cssText: "z-index: 0;width: 100%;height: 100%;position: absolute;display: none;top: 0;left: 0;"},
                h5liveIndex: c,
                h5liveActive: !1
              };
              h || (h = u.querySelector('iframe[name="' + e.name + '"]')), h && h.name === e.name && (h.contentDocument && h.contentDocument.body && h.contentDocument.body.firstChild && h.contentDocument.body.removeChild(h.contentDocument.body.firstChild), h.removeEventListener("load", H), h.parentNode && h.parentNode.removeChild(h), h = null), G(h = document.createElement("iframe"), e), h.addEventListener("load", H), u.appendChild(h)
            }

            function H(e) {
              var t = e.target.contentDocument.body;
              t && (G(t, {
                style: {
                  height: "100%",
                  width: "100%",
                  overflow: "hidden",
                  position: "absolute",
                  margin: "0",
                  padding: "0"
                }
              }), t.firstChild || (t.appendChild(b), r.remove({target: b, listeners: N}), r.add({
                target: b,
                listeners: N
              })))
            }

            function G(e, t) {
              Object.keys(t).forEach((function (n) {
                "object" != typeof t[n] ? e[n] = t[n] : Object.keys(t[n]).forEach((function (r) {
                  e[n][r] = t[n][r]
                }))
              }))
            }

            function V(e) {
              e && Object.prototype.hasOwnProperty.call(e, "source") && (_.src = e.source)
            }

            function W() {
              b && b.load()
            }

            function Y() {
              return b ? b.paused : void 0
            }

            function j(e, t) {
              e.h5liveActive = t
            }

            function K(e, t, n) {
              return !!e && "object" == typeof e.data && e.data[t] === n
            }

            return function () {
              var e = [a.TIME_UPDATE];
              for (var t in a) Object.prototype.hasOwnProperty.call(a, t) && -1 === e.indexOf(a[t]) && N.push({
                type: a[t],
                listener: F
              })
            }(), function () {
              var e = {
                id: d,
                autoplay: !1,
                controls: !1,
                playsInline: !0,
                muted: f,
                volume: 1,
                style: {backgroundColor: "transparent"},
                h5liveIndex: c,
                h5liveActive: !1
              };
              switch (g) {
                case"anonymous":
                case"use-credentials":
                  e.crossOrigin = g
              }
              t.mustUseHLS && (e.style.width = "100vw", e.style.height = "100vh"), (b = document.getElementById(d)) && (b.disableRemotePlayback = !0), R = !!b, y.debugEnabled() && y.debug("using " + (R ? "external " : "generated ") + "video element"), R ? (A = b.parentNode, T = b.style.cssText, b.style.cssText = "") : (b = document.createElement("video")) && (b.disableRemotePlayback = !0), G(b, e)
            }(), _ = document.createElement("source"), b.appendChild(_), t.mustUseHLS ? B() : (y.debugEnabled() && y.debug("appending video to container"), u.appendChild(b), r.add({
              target: b,
              listeners: N
            }), t.isTridentBrowser && (["scroll", "resize"].forEach((function (e) {
              window.addEventListener && window.addEventListener(e, x, !1), window.attachEvent && window.attachEvent("on" + e, x)
            })), x())), {
              destroy: function () {
                D()
              }, play: P, pause: M, loadVideo: W, setSource: V, setType: function (e) {
                b && e && (b.type = e)
              }, setVolume: function (e) {
                b && !isNaN(e) && e >= 0 && e <= 1 && b.volume !== e && (y.debugEnabled() && y.debug("set volume: " + e), b.volume = e)
              }, setMute: w, setUnmute: U, setRate: L, destroyVideo: D, seek: function (e) {
                if (b && e && e.data && !isNaN(e.data.position) && e.data.position >= 0) {
                  var t = Math.round(1e6 * e.data.position) / 1e6;
                  y.debugEnabled() && y.debug("seek to: " + e.data.position + " (rounded: " + t + "), from: " + b.currentTime), e.data.fast && void 0 !== b.fastSeek ? b.fastSeek(t) : b.currentTime = t
                }
              }, getVideoPlaybackQuality: function () {
                return b && "function" == typeof b.getVideoPlaybackQuality ? b.getVideoPlaybackQuality() : void 0
              }, getVideoElement: function () {
                return b || void 0
              }, getMediaElementPayload: k, show: function () {
                h && (h.style.display = "block", h.style.zIndex = "1", j(h, !0)), b && (b.style.display = "block", b.style.zIndex = "1", j(b, !0))
              }, hide: function () {
                h && (h.style.display = "block", h.style.zIndex = "0", j(h, !1)), b && (b.style.display = "block", b.style.zIndex = "0", j(b, !1))
              }, getIndex: function () {
                return c
              }, setIndex: function (e) {
                c = e
              }, showOnTop: function () {
                y.debugEnabled() && y.debug("show index " + c + " on top"), h ? (h.style.display = "block", h.style.zIndex = C) : b && (b.style.display = "block", b.style.zIndex = C)
              }, isShownOnTop: function () {
                var e = !1;
                return h ? e = h.style.zIndex === C : b && (e = b.style.zIndex === C), e
              }, unlock: function () {
                I ? y.debugEnabled() && y.debug("skip check because is unlocked") : (y.debugEnabled() && y.debug("2nd vid try unlock with silent play attempt"), P({data: {unlocked: !0}}))
              }, getVideoPausedState: Y
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 232: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(6627), n(492), n(5698), n(5997), n(5980)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (s) {
            var d, u, c, l, f, E, p, m = t.create("MediaElementStatsCreator"), g = [], b = !1, _ = !1, h = !1, T = !1,
              A = [{
                type: i.APPLICATION_STATE_CHANGE, listener: function (t) {
                  switch (c = t.data.state) {
                    case r.PAUSED:
                      m.debugEnabled() && m.debug("remove stats listener"), e.remove({target: s, listeners: S});
                      break;
                    case r.PLAYING:
                      break;
                    case r.LOADING:
                      O(), m.debugEnabled() && m.debug("hls: add stats listener"), l && e.add({target: s, listeners: S})
                  }
                }
              }, {
                type: i.CONFIG, listener: function (e) {
                  l = n.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && n.canUseHLS
                }
              }], S = [{
                type: a.TIME_UPDATE, listener: function (e) {
                  p !== e.data.index && (m.debugEnabled() && m.debug("new mediaElementIndex, changed from " + p + " to " + e.data.index), p = e.data.index);
                  var t, n, i = e.data.played.length - 1, a = e.data.buffered.length - 1, o = e.data.currentTime;
                  if (f = o, e.data.timeOffset && (E = e.data.timeOffset, f += E.currentTime), c !== r.PLAYING && c !== r.BUFFERING || 0 !== f ? f = c === r.LOADING ? 0 : f : m.detailEnabled() && m.detail("playing but currentTime = 0"), 0 === f && m.detailEnabled() && m.detail("currentTime = 0"), i >= 0 && (d.playedStart = 0, d.playedEnd = o), a >= 0) {
                    var s = e.data.buffered.start(a), A = e.data.buffered.end(a),
                      S = e.data.duration ? e.data.duration : 0;
                    if (n = A, 2 === (t = g).length && t.shift(), t.push(n), !function (e) {
                      var t = !0;
                      if (e.length) {
                        for (var n = e[0], r = 1; r < e.length; r++) if (e[r] !== n) {
                          t = !1;
                          break
                        }
                      } else t = !1;
                      return t
                    }(g)) {
                      var y = l ? parseFloat((S - A).toFixed(3)) : 0;
                      d.durationDelta = y
                    }
                    e.data.useDuration && (A = S, b || (b = e.data.useDuration)), e.data.timeOffset && (s += E.currentTime, A += E.currentTime), function (e, t) {
                      var n = !0;
                      return l && !b && (n = !1), v(d.bufferEnd, e) ? (_ = v(d.currentTime, t), h = e - t < 0, _ || h ? T || (_ && m.debugEnabled() && m.debug("bufferEnd & currentTime not moving, do update (bufferEnd old/new: " + d.bufferEnd.toFixed(3) + " - " + e.toFixed(3) + ", currentTime old/new: " + d.currentTime.toFixed(3) + " - " + t.toFixed(3) + ")"), h && m.debugEnabled() && m.debug("bufferEnd not moving & buffer dried out, do update (bufferEnd old/new: " + d.bufferEnd.toFixed(3) + " - " + e.toFixed(3) + ", currentTime old/new: " + d.currentTime.toFixed(3) + " - " + t.toFixed(3) + ")"), T = !0, n = !0) : T && (m.debugEnabled() && m.debug("bufferEnd not moving, but currentTime is no longer stuck (bufferEnd old/new: " + d.bufferEnd.toFixed(3) + " - " + e.toFixed(3) + ", currentTime old/new: " + d.currentTime.toFixed(3) + " - " + t.toFixed(3) + ")"), T = !1)) : (n = !0, T && (m.debugEnabled() && m.debug("bufferEnd is no longer stuck (bufferEnd old/new: " + d.bufferEnd.toFixed(3) + "/" + e.toFixed(3) + ")"), T = !1)), n
                    }(A, f) && (d.bufferUpdate = A - d.bufferEnd, d.bufferStart = s, d.bufferEnd = A, d.bufferDelay = A - f)
                  }
                  d.currentTime = f, d.playbackRate = e.data.playbackRate, d.duration = e.data.duration, u.exactCurrentTime = o, u.buffered = e.data.buffered, u.mediaElementIndex = p, R()
                }
              }, {
                type: i.MEDIA_ERROR_RECOVER, listener: function () {
                  s.emit(o.MEDIA_ERROR_RECOVER_STATS, {bufferEnd: d.bufferEnd})
                }
              }], y = [{
                type: i.STREAM_INFO, listener: function () {
                  l || (m.debugEnabled() && m.debug("wss: add stats listener"), e.add({target: s, listeners: S}))
                }
              }];

            function R() {
              s.emit(o.PRIVATE_MEDIA_STATS, {
                mediaStats: {
                  bufferStart: d.bufferStart,
                  bufferEnd: d.bufferEnd,
                  bufferDelay: d.bufferDelay,
                  bufferUpdate: d.bufferUpdate,
                  duration: d.duration,
                  durationDelta: d.durationDelta,
                  currentTime: d.currentTime,
                  playbackRate: d.playbackRate,
                  playedStart: d.playedStart,
                  playedEnd: d.playedEnd,
                  buffered: u.buffered,
                  exactCurrentTime: u.exactCurrentTime,
                  mediaElementIndex: u.mediaElementIndex
                }
              }), s.emit(o.PUBLIC_MEDIA_STATS, {
                mediaStats: {
                  bufferStart: d.bufferStart,
                  bufferEnd: d.bufferEnd,
                  bufferDelay: d.bufferDelay,
                  bufferUpdate: d.bufferUpdate,
                  duration: d.duration,
                  durationDelta: d.durationDelta,
                  currentTime: d.currentTime,
                  playbackRate: d.playbackRate,
                  playedStart: d.playedStart,
                  playedEnd: d.playedEnd
                }
              })
            }

            function v(e, t) {
              return e - t == 0
            }

            function O() {
              d = {
                bufferStart: 0,
                bufferEnd: 0,
                bufferDelay: 0,
                bufferUpdate: 0,
                duration: 0,
                durationDelta: 0,
                currentTime: 0,
                playbackRate: 0,
                playedStart: 0,
                playedEnd: 0
              }, u = {buffered: null, exactCurrentTime: 0, mediaElementIndex: null}, R()
            }

            return O(), e.add({target: s, listeners: A}), e.add({target: s, listeners: y}), {
              destroy: function () {
                e.remove({target: s, listeners: A}), e.remove({target: s, listeners: y})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1833: function (e, t, n) {
      var r, i;
      r = [n(1933), n(8333), n(6627), n(6637), n(5706), n(5698), n(5997), n(5980), n(291), n(855), n(492)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        return {
          create: function (l) {
            var f, E, p = t.create("PauseHandler"), m = 0, g = 0, b = 0, _ = !1, h = !1, T = !1, A = [], S = !1, y = !1,
              R = !1, v = !1, O = [{type: o.PAUSE, listener: N}, {type: o.WAITING, listener: N}, {
                type: o.ENDED,
                listener: N
              }, {type: o.PLAY_START_ABORT_ERROR, listener: N}, {
                type: o.VOLUME_CHANGE, listener: function (e) {
                  y && !e.data.muted && (R = !0, setTimeout((function () {
                    R = !1
                  }), 50)), y = e.data.muted
                }
              }, {
                type: a.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (f = e.data.state) {
                    case c.PLAYING:
                      for (D(), w(); A.length;) A.pop();
                      S = !1;
                      break;
                    case c.LOADING:
                      p.debugEnabled() && p.debug("add play state listeners"), r.add({target: l, listeners: I});
                      break;
                    case c.PAUSING:
                      r.remove({target: l, listeners: I});
                      break;
                    case c.PAUSED:
                      for (D(), w(); A.length;) A.pop();
                      T = !1, S = !1
                  }
                }
              }, {
                type: a.CONFIG, listener: function (e) {
                  E = n.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && n.canUseHLS, y = e.data.config.playback.muted
                }
              }, {type: a.DOCUMENT_VISIBLE, listener: C}, {
                type: a.DOCUMENT_HIDDEN,
                listener: C
              }, {
                type: a.MEDIA_ERROR_RECOVER, listener: function () {
                  p.debugEnabled() && p.debug("media error recover"), T = !0
                }
              }, {
                type: a.MEDIA_ERROR_RECOVERED, listener: function () {
                  p.debugEnabled() && p.debug("media error recovered"), T = !1
                }
              }, {
                type: d.PAUSE, listener: function (e) {
                  e.data.buffer && (v = !0, setTimeout((function () {
                    v = !1
                  }), 50))
                }
              }], I = [{
                type: s.PRIVATE_MEDIA_STATS, listener: function (e) {
                  b = e.data.mediaStats.bufferDelay
                }
              }];

            function C(t) {
              _ = t.name === a.DOCUMENT_HIDDEN, h = t.name === a.DOCUMENT_VISIBLE, p.debug(_ ? "hidden" : "visible"), h && y && !0 === S && f === c.LOADING ? (p.debugEnabled() && p.debug("was hidden playback attempt, now visible, loading, play hook"), l.emit(d.PLAY, {external: !1})) : _ && (e.mobile || n.isIOSDesktopMode && !n.isIPadDesktopMode) && (f === c.PLAYING || f === c.LOADING || f === c.BUFFERING) && l.emit(i.SUSPENDED)
            }

            function N(t) {
              var n = t.name;
              if (p.debugEnabled() && p.debug(n + " triggered while isRecovering = " + T.toString() + ", pauseTimeout = " + (g ? "true" : "false") + ", waitTimeout = " + (m ? "true" : "false")), T) p.debugEnabled() && p.debug("skip check while recovery is ongoing"); else {
                var r = A.length;
                if (_ && e.mobile && f === c.PLAYING) p.debugEnabled() && p.debug("hidden, suspend"), l.emit(i.SUSPENDED); else if (n === o.PLAY_START_ABORT_ERROR) "background" === t.data.reason && _ && (S = !0); else if (n === o.PAUSE) {
                  if (R) return p.debugEnabled() && p.debug("was unmuted right before pause, make play hook to check if allowed"), void l.emit(d.PLAY, {external: !1});
                  if (E) {
                    if (p.debugEnabled() && p.debug("hls pause"), !v) return p.debugEnabled() && p.debug("pause but not triggered"), w(), p.debugEnabled && p.debug("setPauseTimeout"), void (g = setTimeout((function () {
                      D(), f === c.PLAYING ? (p.debugEnabled() && p.debug("pause timeout fired"), A[0] === o.PAUSE ? (p.debugEnabled() && p.debug("last event still pause, emit error"), l.emit(i.ERROR, {code: u.MEDIA_ERR_HLS_BUFFER_UNDERRUN})) : p.debugEnabled() && p.debug("last event not pause after pause timeout fired (" + A[0] + ")")) : p.debugEnabled() && p.debug("pause timeout fired, but not playing or buffering")
                    }), 200));
                    p.debugEnabled() && p.debug("pause seems to be triggered by buffer, do nothing")
                  }
                } else {
                  if (E && n === o.ENDED && r >= 1 && A[0] === o.PAUSE) return void (f === c.PLAYING || f === c.BUFFERING ? (p.debugEnabled() && p.debug("pause ended case, clear all timeouts"), D(), w(), l.emit(i.ERROR, {code: u.MEDIA_ERR_HLS_BUFFER_UNDERRUN})) : p.debugEnabled() && p.debug("pause ended case, but not playing or buffering"));
                  if (!m && !E) return p.debugEnabled() && p.debug("set wait timeout on " + n), D(), void function (e, t) {
                    p.debugEnabled && p.debug("setWaitTimeout"), m = setTimeout(function (e, t) {
                      w(), f === c.PLAYING ? (p.debugEnabled() && p.debug("nanoplayer: recover unexpected pause type " + e + ", bufferDelay = " + t, 3), l.emit(d.PLAY, {external: !1})) : p.debugEnabled() && p.debug("wait timeout fired, but not playing")
                    }.bind(null, e, t), 200)
                  }(n, b)
                }
                A.unshift(n)
              }
            }

            function D() {
              p.debugEnabled && p.debug("clearPauseTimeout"), clearTimeout(g), g = 0
            }

            function w() {
              p.debugEnabled && p.debug("clearWaitTimeout"), clearTimeout(m), m = 0
            }

            return p.debugEnabled() && p.debug("initialize"), r.add({target: l, listeners: O}), {
              destroy: function () {
                r.remove({target: l, listeners: O})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 230: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(492), n(5698), n(5997), n(1447)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s, d, u = e.create("QualityHandler"), c = {
                extreme: {ratioThreshold: .95, samplesRange: 3, samplesMatchAllowed: 1, level: 4},
                high: {ratioThreshold: .2, samplesRange: 5, samplesMatchAllowed: 1, level: 3},
                medium: {ratioThreshold: .1, samplesRange: 10, samplesMatchAllowed: 3, level: 2},
                low: {ratioThreshold: .02, samplesRange: 10, samplesMatchAllowed: 1, level: 1}
              }, l = {extreme: {ratioThreshold: .9, samplesRange: 1, samplesMatchAllowed: 0, level: 4}}, f = [], E = [],
              p = !1, m = ["extreme", "high", "medium", "low"], g = 0, b = 0, _ = 0, h = ["extreme"], T = 0, A = 0,
              S = 0, y = 0, R = [{
                type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (d = e.data.state) {
                    case n.PLAYING:
                      p && C();
                      break;
                    case n.PAUSED:
                      N()
                  }
                }
              }, {type: r.STREAM_INFO, listener: I}, {
                type: r.STREAM_INFO_UPDATE, listener: function (e) {
                  I(e)
                }
              }, {
                type: r.MEDIA_ERROR_RECOVER, listener: function () {
                  u.detailEnabled() && u.detail("media error recover"), N()
                }
              }, {
                type: r.MEDIA_ERROR_RECOVERED, listener: function () {
                  u.detailEnabled() && u.detail("media error recovered"), C()
                }
              }], v = [{
                type: i.QUALITY_UPDATE, listener: function e(t) {
                  for (var r in t.data.quality) if (Object.prototype.hasOwnProperty.call(s, r)) {
                    if ("totalVideoFrames" === r && (s.totalVideoFramesCurrent = t.data.quality.totalVideoFrames - s.totalVideoFrames, y = s.totalVideoFramesCurrent), "droppedVideoFrames" === r) {
                      for (s.droppedVideoFramesCurrent = t.data.quality.droppedVideoFrames - s.droppedVideoFrames; f.length > 9;) f.shift();
                      f.push({count: s.droppedVideoFramesCurrent, time: t.data.currentTime})
                    }
                    if ("corruptedVideoFrames" === r) {
                      for (s.corruptedVideoFramesCurrent = t.data.quality.corruptedVideoFrames - s.corruptedVideoFrames; E.length > 0;) E.shift();
                      E.push({count: s.corruptedVideoFramesCurrent, time: t.data.currentTime})
                    }
                    s[r] = t.data.quality[r]
                  }
                  if (s.droppedVideoFramesLevel = _, s.corruptedVideoFramesLevel = S, y < 0) return O(), e(t);
                  y > 0 && function () {
                    var e, t, r = 0, i = 0, s = 0;
                    if (d === n.PLAYING) {
                      for (u.detailEnabled() && u.detail("check with current dropped level " + g), u.detailEnabled() && u.detail("skip check lower " + (g + 1)), r = 0; r < m.length - g; r += 1) if (e = D(m[r])) {
                        u.detailEnabled() && u.detail("frame drop detected with type '" + e.type + "'"), u.detail(e.frames.dropped + " frames in last " + e.samples.all.length + " seconds dropped"), o.emit(a.FRAME_DROP, e), i = e.level, u.detailEnabled() && u.detail("change current dropped level " + g + " to " + i), g = i, b && u.detailEnabled() && u.detail("reset dropped level timeout running, clear timeout"), clearTimeout(b), b = setTimeout((function () {
                          u.detailEnabled() && u.detail("reset current dropped level " + g + " to 0"), b = 0, g = 0
                        }), 1e3 * e.samples.all.length), u.detailEnabled() && u.detail("reset dropped level in " + e.samples.all.length + " sec");
                        break
                      }
                      for (u.detailEnabled() && u.detail("check with current corrupted level " + T), u.detailEnabled() && u.detail("skip check lower " + (T + 1)), r = 0; r < h.length - T; r += 1) if (t = w(h[r])) {
                        u.detailEnabled() && u.detail("frame drop detected with type '" + t.type + "'"), u.detail(t.frames.corrupted + " frames in last " + t.samples.all.length + " seconds corrupted"), o.emit(a.FRAME_CORRUPTED, t), s = t.level, u.detailEnabled() && u.detail("change current corrupted level " + T + " to " + s), T = s, A && u.detailEnabled() && u.detail("reset corrupted level timeout running, clear timeout"), clearTimeout(A), A = setTimeout((function () {
                          u.detailEnabled() && u.detail("reset current corrupted level " + T + " to 0"), A = 0, T = 0
                        }), 1e3 * t.samples.all.length), u.detailEnabled() && u.detail("reset corrupted level in " + t.samples.all.length + " sec");
                        break
                      }
                    }
                    _ = i, S = s
                  }(), o.emit(a.QUALITY_STATS, s)
                }
              }];

            function O() {
              for (s = {
                droppedVideoFrames: 0,
                droppedVideoFramesCurrent: 0,
                droppedVideoFramesLevel: 0,
                corruptedVideoFrames: 0,
                corruptedVideoFramesCurrent: 0,
                corruptedVideoFramesLevel: 0,
                creationTime: 0,
                totalVideoFrames: 0,
                totalVideoFramesCurrent: 0
              }, clearTimeout(b), g = 0, b = 0, _ = 0; f.length;) f.pop();
              for (clearTimeout(A), T = 0, A = 0, S = 0; E.length;) E.pop();
              y = 0
            }

            function I(e) {
              p = e.data.streamInfo.haveVideo
            }

            function C() {
              N(), t.add({target: o, listeners: v})
            }

            function N() {
              t.remove({target: o, listeners: v}), O()
            }

            function D(e) {
              if (u.detailEnabled() && u.detail("check dropped type '" + e + "'"), f.length > c[e].samplesRange - 1) {
                var t = f.slice(-c[e].samplesRange), n = t.filter((function (t) {
                  return t.count >= y * c[e].ratioThreshold
                }));
                if (n.length > c[e].samplesMatchAllowed) {
                  var r = 0;
                  return t.forEach((function (e) {
                    r += e.count
                  })), {
                    type: e,
                    level: c[e].level,
                    framerate: y,
                    samples: {all: t, matched: n, limit: Math.ceil(y * c[e].ratioThreshold)},
                    frames: {dropped: r}
                  }
                }
              }
              return !1
            }

            function w(e) {
              if (u.detailEnabled() && u.detail("check corrupted type '" + e + "'"), E.length > l[e].samplesRange - 1) {
                var t = E.slice(-l[e].samplesRange), n = t.filter((function (t) {
                  return t.count >= y * l[e].ratioThreshold
                }));
                if (n.length > l[e].samplesMatchAllowed) {
                  var r = 0;
                  return t.forEach((function (e) {
                    r += e.count
                  })), {
                    type: e,
                    level: l[e].level,
                    framerate: y,
                    samples: {all: t, matched: n, limit: Math.ceil(y * l[e].ratioThreshold)},
                    frames: {corrupted: r}
                  }
                }
              }
              return !1
            }

            return t.add({target: o, listeners: R}), {
              destroy: function () {
                t.remove({target: o, listeners: R}), t.remove({target: o, listeners: v}), O()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 42: function (e, t, n) {
      var r, i;
      r = [n(5698)], void 0 === (i = function (e) {
        return {
          create: function (t) {
            function n(e) {
              window.fragments || (window.fragments = []), window.fragments.push(e.data.fragment)
            }

            var r;
            return r = "nanoDump", -1 !== document.cookie.indexOf(r + "=") && document.cookie.split(r + "=")[1].split(";")[0] && t.addListener(e.STREAM_FRAGMENT, n), {
              destroy: function () {
                t.removeListener(e.STREAM_FRAGMENT, n)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 291: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementControl.";
        return {
          BASE: e,
          CREATE_VIDEO: e + "createVideo",
          DESTROY_VIDEO: e + "destroyVideo",
          VIDEO_SOURCE: e + "videoSource",
          UPDATE_SOURCE: e + "updateSource",
          PLAY: e + "play",
          PAUSE: e + "pause",
          SEEK: e + "seek",
          MUTE: e + "mute",
          UNMUTE: e + "unmute",
          SET_VOLUME: e + "volume",
          SET_RATE: e + "playbackRate"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5706: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementError.";
        return {BASE: e, ERROR: e + "error", SUSPENDED: e + "suspended"}
      }.apply(t, [])) || (e.exports = n)
    }, 5997: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementHandler.";
        return {
          BASE: e,
          LOAD_START: e + "loadstart",
          PROGRESS: e + "progress",
          SUSPEND: e + "suspend",
          ABORT: e + "abort",
          EMPTIED: e + "emptied",
          STALLED: e + "stalled",
          PLAY: e + "play",
          PAUSE: e + "pause",
          LOADED_META_DATA: e + "loadedmetadata",
          LOADED_DATA: e + "loadeddata",
          WAITING: e + "waiting",
          ERROR: e + "error",
          PLAYING: e + "playing",
          CAN_PLAY: e + "canplay",
          CAN_PLAY_THROUGH: e + "canplaythrough",
          SEEKING: e + "seeking",
          SEEKED: e + "seeked",
          TIME_UPDATE: e + "timeupdate",
          ENDED: e + "ended",
          RATE_CHANGE: e + "ratechange",
          DURATION_CHANGE: e + "durationchange",
          VOLUME_CHANGE: e + "volumechange",
          QUALITY_UPDATE: e + "qualityupdate",
          VIDEO_SOURCE: e + "videoSource",
          ELEMENT_CREATED: e + "elementCreated",
          PLAY_START_SUCCESS: e + "playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: e + "playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: e + "playStartAbortError",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_TIMEOUT: e + "updateSourceTimeout",
          MEDIA_ERROR_RECOVERED: e + "recovered",
          ACTIVE_VIDEO_ELEMENT_CHANGE: e + "activeVideoElementChange",
          SWITCH_STREAM: e + "switchStream"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5698: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementManager.";
        return {
          BASE: e,
          CONFIG: e + "config",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          STARTUP_STATS_ADDED: e + "startupStatsAdded",
          STARTUP_STATS_COMPLETED: e + "startupStatsCompleted",
          DOCUMENT_VISIBLE: e + "documentVisible",
          DOCUMENT_HIDDEN: e + "documentHidden",
          NETWORK_ONLINE: e + "networkOnline",
          NETWORK_OFFLINE: e + "networkOffline",
          SWITCH_STREAM_INIT: e + "switchStreamInit",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          BUFFER_TWEAKS_CREATED: e + "bufferTweaksCreated",
          MEDIA_ERROR: e + "mediaError",
          MEDIA_ERROR_RECOVER: e + "mediaErrorRecover",
          MEDIA_ERROR_RECOVERED: e + "mediaErrorRecovered",
          MEDIA_ERROR_QUEUED: e + "mediaErrorQueued",
          MEDIA_ERROR_UNQUEUED: e + "mediaErrorUnqueued"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 560: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementPlaybackControl.";
        return {BASE: e, PLAYBACK_STARTED: e + "playbackStarted", BUFFERING: e + "buffering"}
      }.apply(t, [])) || (e.exports = n)
    }, 5075: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementPlayback.";
        return {
          BASE: e,
          LOAD_START: e + "loadstart",
          PROGRESS: e + "progress",
          SUSPEND: e + "suspend",
          ABORT: e + "abort",
          EMPTIED: e + "emptied",
          STALLED: e + "stalled",
          PLAY: e + "play",
          PAUSE: e + "pause",
          LOADED_META_DATA: e + "loadedmetadata",
          LOADED_DATA: e + "loadeddata",
          WAITING: e + "waiting",
          MEDIA_ERROR: e + "mediaerror",
          MEDIA_ERROR_RECOVER: e + "mediaerrorrecover",
          MEDIA_ERROR_RECOVERED: e + "mediaerrorrecovered",
          PLAYING: e + "playing",
          CAN_PLAY: e + "canplay",
          CAN_PLAY_THROUGH: e + "canplaythrough",
          SEEKING: e + "seeking",
          SEEKED: e + "seeked",
          TIME_UPDATE: e + "timeupdate",
          ENDED: e + "ended",
          RATE_CHANGE: e + "ratechange",
          DURATION_CHANGE: e + "durationchange",
          VOLUME_CHANGE: e + "volumechange",
          ELEMENT_CREATED: e + "elementCreated",
          QUALITY_STATS: e + "qualitystats",
          PLAY_STATS: e + "playStats",
          MEDIA_ERROR_RECOVER_STATS: e + "mediaErrorRecoverStats",
          FRAME_DROP: e + "framedrop",
          PLAYBACK_FINISHED: e + "playbackFinished",
          PLAYBACK_ERROR: e + "playbackError",
          PLAYBACK_STARTED: e + "playbackStarted",
          PLAYBACK_SUSPENDED: e + "playbackSuspended",
          BUFFERING: e + "buffering",
          PLAY_START_SUCCESS: e + "playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: e + "playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: e + "playStartAbortError",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden",
          ELEMENTS_UPDATED: e + "elementsUpdated",
          TIME_OFFSET: e + "timeOffset",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_TIMEOUT: e + "updateSourceTimeout",
          ACTIVE_VIDEO_ELEMENT_CHANGE: e + "activeVideoElementChange",
          SOURCE_ENDED: e + "sourceEnded",
          SWITCH_STREAM: e + "switchStream",
          FRAME_CORRUPTED: e + "frameCorrupted"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4210: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementProxy.";
        return {
          BASE: e,
          LOAD_START: e + "loadstart",
          PROGRESS: e + "progress",
          SUSPEND: e + "suspend",
          ABORT: e + "abort",
          EMPTIED: e + "emptied",
          STALLED: e + "stalled",
          PLAY: e + "play",
          PAUSE: e + "pause",
          LOADED_META_DATA: e + "loadedmetadata",
          LOADED_DATA: e + "loadeddata",
          WAITING: e + "waiting",
          ERROR: e + "error",
          PLAYING: e + "playing",
          CAN_PLAY: e + "canplay",
          CAN_PLAY_THROUGH: e + "canplaythrough",
          SEEKING: e + "seeking",
          SEEKED: e + "seeked",
          TIME_UPDATE: e + "timeupdate",
          ENDED: e + "ended",
          RATE_CHANGE: e + "ratechange",
          DURATION_CHANGE: e + "durationchange",
          VOLUME_CHANGE: e + "volumechange",
          QUALITY_UPDATE: e + "qualityupdate",
          ELEMENT_CREATED: e + "elementCreated",
          PLAY_START_SUCCESS: e + "playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: e + "playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: e + "playStartAbortError",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5980: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaElementStatsCreator.";
        return {
          BASE: e,
          PUBLIC_MEDIA_STATS: e + "publicMediaStats",
          PRIVATE_MEDIA_STATS: e + "privateMediaStats",
          MEDIA_ERROR_RECOVER_STATS: e + "mediaErrorRecoverStats"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 391: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "mediaSourceHandler.";
        return {
          BASE: e,
          SOURCE_OPEN: e + "sourceopen",
          SOURCE_ENDED: e + "sourceended",
          SOURCE_CLOSED: e + "sourceclosed",
          SOURCE_READY: e + "sourceready",
          ERROR: e + "error",
          MEDIA_ERROR_RECOVERED: e + "mediaerrorrecovered"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1447: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "qualityHandler.";
        return {
          BASE: e,
          QUALITY_STATS: e + "qualitystats",
          FRAME_DROP: e + "framedrop",
          FRAME_CORRUPTED: e + "framecorrupted"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 683: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "sourceBufferQueue.";
        return {BASE: e, TIME_OFFSET: e + "timeOffset", FIRST_FRAGMENT: e + "firstFragment"}
      }.apply(t, [])) || (e.exports = n)
    }, 1137: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(5706), n(5698), n(855), n(492)], void 0 === (i = function (e, t, n, r, i, a) {
        return {
          create: function (o) {
            var s, d, u, c, l, f = e.create("HLSInterruptHandler"), E = !1, p = [{
              type: r.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (s = e.data.state) {
                  case a.LOADING:
                    f.debugEnabled() && f.debug("loading"), E || (f.debugEnabled() && f.debug("not online at loading, set waitForOnline to true"), d = !0, m(!0));
                    break;
                  case a.PLAYING:
                    f.debugEnabled() && f.debug("playing"), g();
                    break;
                  case a.BUFFERING:
                    f.debugEnabled() && f.debug("buffering"), l || (f.debugEnabled() && f.debug("set buffering timeout"), l = setTimeout((function () {
                      f.debugEnabled() && f.debug("buffering timeout fired"), clearTimeout(l), l = 0, s !== a.BUFFERING || c || (E ? (f.debugEnabled() && f.debug("online at buffering timeout"), performance.now() - u.online < 5e3 && (f.debugEnabled() && f.debug("was offline before buffering timeout"), m(!1))) : (f.debugEnabled() && f.debug("not online at buffering timeout, set waitForOnline to true"), d = !0, m(!0)))
                    }), 2e3))
                }
              }
            }, {
              type: r.NETWORK_ONLINE, listener: function () {
                f.debugEnabled() && f.debug("network online"), E = !0, u.online = performance.now(), s !== a.LOADING && s !== a.BUFFERING || !d || c || (f.debugEnabled() && f.debug("active state & waited for online"), m(!1))
              }
            }, {
              type: r.NETWORK_OFFLINE, listener: function () {
                f.debugEnabled() && f.debug("network offline"), E = !1, u.offline = performance.now()
              }
            }, {
              type: r.MEDIA_ERROR_RECOVER, listener: function () {
                f.debugEnabled() && f.debug("media error recover"), c = !0
              }
            }, {
              type: r.MEDIA_ERROR_RECOVERED, listener: function () {
                f.debugEnabled() && f.debug("media error recovered"), c = !1
              }
            }];

            function m(e) {
              f.debugEnabled() && f.debug("emit buffer underrun"), setTimeout((function () {
                o.emit(n.ERROR, {code: i.MEDIA_ERR_HLS_BUFFER_UNDERRUN, reconnect: !0, waiting: !!e}), !e && g()
              }), 200)
            }

            function g() {
              f.debugEnabled() && f.debug("reset"), d = !1, u = {online: 0, offline: 0}, c = !1
            }

            return f.debugEnabled() && f.debug("initialize"), t.add({
              target: o,
              listeners: p
            }), g(), {
              destroy: function () {
                t.remove({target: o, listeners: p})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4601: function (e, t, n) {
      var r, i;
      r = [n(8333), n(8197), n(6637), n(492), n(855), n(5706), n(5698), n(5980)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        return {
          create: function (d) {
            var u, c, l, f = 8, E = e.create("HLSJumpHandler"), p = !1, m = [{
              type: o.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (n.remove({target: d, listeners: g}), e.data.state) {
                  case r.PAUSED:
                    l = !1;
                    break;
                  case r.BUFFERING:
                    E.debugEnabled() && E.debug("entering buffering state"), u = null;
                    break;
                  case r.PAUSING:
                    E.debugEnabled() && E.debug("entering paused state"), u = null;
                    break;
                  case r.PLAYING:
                    n.add({target: d, listeners: g})
                }
              }
            }, {
              type: o.BUFFER_TWEAKS_CREATED, listener: function (e) {
                f = Math.max(e.data.tweaks.buffer.max, f)
              }
            }, {
              type: o.MEDIA_ERROR_RECOVER, listener: function () {
                E.debugEnabled() && E.debug("media error recover"), l = !0, u = null
              }
            }, {
              type: o.MEDIA_ERROR_RECOVERED, listener: function () {
                E.debugEnabled() && E.debug("media error recovered"), l = !1
              }
            }, {
              type: o.MEDIA_ERROR_QUEUED, listener: function () {
                E.debugEnabled() && E.debug("media error queued"), p = !0
              }
            }, {
              type: o.MEDIA_ERROR_UNQUEUED, listener: function () {
                E.debugEnabled() && E.debug("media error unqueued"), p = !1
              }
            }], g = [{
              type: s.PRIVATE_MEDIA_STATS, listener: function (e) {
                if (!l && !p) {
                  if (c === e.data.mediaStats.mediaElementIndex && u && void 0 !== u.currentTime) {
                    var n = e.data.mediaStats.currentTime < u.currentTime - 2,
                      r = e.data.mediaStats.currentTime + f < e.data.mediaStats.bufferEnd && u.currentTime + f < u.bufferEnd;
                    if (n || r) {
                      var o = {code: !1, currentTime: {last: u.currentTime, current: e.data.mediaStats.currentTime}};
                      n ? (o.code = i.MEDIA_ERR_HLS_JUMP, E.debugEnabled() && E.debug("hls jump")) : r && (o.code = i.MEDIA_ERR_HLS_MAX_RANGE, E.debugEnabled() && E.debug("hls max range")), d.emit(a.ERROR, o)
                    }
                  }
                  c = e.data.mediaStats.mediaElementIndex, u = t.copy(e.data.mediaStats)
                }
              }
            }];
            return E.debugEnabled() && E.debug("initialize"), n.add({target: d, listeners: m}), {
              destroy: function () {
                n.remove({target: d, listeners: m})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2657: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(9658), n(1933), n(6637), n(5055), n(8250), n(9437), n(6273), n(5698), n(5075), n(560), n(391), n(1447), n(5980), n(683), n(5997), n(291), n(5706), n(7022), n(476), n(2885), n(1833), n(230), n(1705), n(4972), n(232), n(42), n(3824), n(2869), n(4601), n(1137)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b, _, h, T, A, S, y, R, v, O, I, C, N, D, w) {
        "use strict";
        return {
          create: function (e) {
            var r, U, P = new n, M = [], L = [{
              type: u.CONFIG, listener: function (e) {
                t.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && t.canUseHLS ? (M.push(D.create(P)), M.push(w.create(P))) : (M.push(N.create(P)), M.push(A.create(P)), M.push(I.create(P)))
              }
            }], F = [{from: g.LOAD_START, to: c.LOAD_START}, {from: g.PROGRESS, to: c.PROGRESS}, {
              from: g.SUSPEND,
              to: c.SUSPEND
            }, {from: g.ABORT, to: c.ABORT}, {from: g.EMPTIED, to: c.EMPTIED}, {
              from: g.STALLED,
              to: c.STALLED
            }, {from: g.PLAY, to: c.PLAY}, {from: g.PAUSE, to: c.PAUSE}, {
              from: g.LOADED_META_DATA,
              to: c.LOADED_META_DATA
            }, {from: g.LOADED_DATA, to: c.LOADED_DATA}, {from: g.WAITING, to: c.WAITING}, {
              from: g.PLAYING,
              to: c.PLAYING
            }, {from: g.CAN_PLAY, to: c.CAN_PLAY}, {from: g.CAN_PLAY_THROUGH, to: c.CAN_PLAY_THROUGH}, {
              from: g.SEEKING,
              to: c.SEEKING
            }, {from: g.SEEKED, to: c.SEEKED}, {from: g.TIME_UPDATE, to: c.TIME_UPDATE}, {
              from: g.ENDED,
              to: c.ENDED
            }, {from: g.RATE_CHANGE, to: c.RATE_CHANGE}, {
              from: g.DURATION_CHANGE,
              to: c.DURATION_CHANGE
            }, {from: g.VOLUME_CHANGE, to: c.VOLUME_CHANGE}, {
              from: g.ELEMENT_CREATED,
              to: c.ELEMENT_CREATED
            }, {from: g.PLAY_START_SUCCESS, to: c.PLAY_START_SUCCESS}, {
              from: g.PLAY_START_ABORT_ERROR,
              to: c.PLAY_START_ABORT_ERROR
            }, {from: g.PLAY_START_NOT_ALLOWED_ERROR, to: c.PLAY_START_NOT_ALLOWED_ERROR}, {
              from: g.VIEWPORT_VISIBLE,
              to: c.VIEWPORT_VISIBLE
            }, {from: g.VIEWPORT_HIDDEN, to: c.VIEWPORT_HIDDEN}, {
              from: g.UPDATE_SOURCE_ABORT,
              to: c.UPDATE_SOURCE_ABORT
            }, {from: g.UPDATE_SOURCE_FAIL, to: c.UPDATE_SOURCE_FAIL}, {
              from: g.UPDATE_SOURCE_TIMEOUT,
              to: c.UPDATE_SOURCE_TIMEOUT
            }, {from: g.ACTIVE_VIDEO_ELEMENT_CHANGE, to: c.ACTIVE_VIDEO_ELEMENT_CHANGE}, {
              from: g.ERROR,
              to: c.MEDIA_ERROR
            }, {from: g.MEDIA_ERROR_RECOVERED, to: c.MEDIA_ERROR_RECOVERED}, {
              from: g.SWITCH_STREAM,
              to: c.SWITCH_STREAM
            }, {from: _.ERROR, to: c.MEDIA_ERROR}, {
              from: _.SUSPENDED,
              to: c.PLAYBACK_SUSPENDED
            }, {from: E.QUALITY_STATS, to: c.QUALITY_STATS}, {
              from: E.FRAME_DROP,
              to: c.FRAME_DROP
            }, {from: E.FRAME_CORRUPTED, to: c.FRAME_CORRUPTED}, {
              from: p.PUBLIC_MEDIA_STATS,
              to: c.PLAY_STATS
            }, {from: p.MEDIA_ERROR_RECOVER_STATS, to: c.MEDIA_ERROR_RECOVER_STATS}, {
              from: f.SOURCE_ENDED,
              to: c.PLAYBACK_FINISHED
            }, {from: f.ERROR, to: c.MEDIA_ERROR}, {
              from: f.MEDIA_ERROR_RECOVERED,
              to: c.MEDIA_ERROR_RECOVERED
            }, {from: l.PLAYBACK_STARTED, to: c.PLAYBACK_STARTED}, {
              from: l.BUFFERING,
              to: c.BUFFERING
            }, {from: m.TIME_OFFSET, to: c.TIME_OFFSET}], x = [{from: o.CREATE_VIDEO, to: b.CREATE_VIDEO}, {
              from: o.DESTROY_VIDEO,
              to: b.DESTROY_VIDEO
            }, {from: o.VIDEO_SOURCE, to: b.VIDEO_SOURCE}, {from: o.PLAY, to: b.PLAY}, {
              from: o.PAUSE,
              to: b.PAUSE
            }, {from: o.SEEK, to: b.SEEK}, {from: o.MUTE, to: b.MUTE}, {
              from: o.UNMUTE,
              to: b.UNMUTE
            }, {from: o.SET_VOLUME, to: b.SET_VOLUME}, {from: o.SET_RATE, to: b.SET_RATE}, {
              from: o.UPDATE_SOURCE,
              to: b.UPDATE_SOURCE
            }, {from: s.CONFIG, to: u.CONFIG}, {from: s.SERVER_INFO, to: u.SERVER_INFO}, {
              from: s.STREAM_FRAGMENT,
              to: u.STREAM_FRAGMENT
            }, {from: s.RANDOM_ACCESS_POINT, to: u.RANDOM_ACCESS_POINT}, {
              from: s.NETWORK_ONLINE,
              to: u.NETWORK_ONLINE
            }, {from: s.NETWORK_OFFLINE, to: u.NETWORK_OFFLINE}, {from: d.ERROR, to: u.MEDIA_ERROR}, {
              from: d.RECOVER,
              to: u.MEDIA_ERROR_RECOVER
            }, {from: d.RECOVERED, to: u.MEDIA_ERROR_RECOVERED}, {
              from: d.QUEUED,
              to: u.MEDIA_ERROR_QUEUED
            }, {from: d.UNQUEUED, to: u.MEDIA_ERROR_UNQUEUED}, {
              from: s.APPLICATION_STATE_CHANGE,
              to: u.APPLICATION_STATE_CHANGE
            }, {from: s.STARTUP_STATS_ADDED, to: u.STARTUP_STATS_ADDED}, {
              from: s.STARTUP_STATS_COMPLETED,
              to: u.STARTUP_STATS_COMPLETED
            }, {from: s.DOCUMENT_VISIBLE, to: u.DOCUMENT_VISIBLE}, {
              from: s.DOCUMENT_HIDDEN,
              to: u.DOCUMENT_HIDDEN
            }, {from: s.STREAM_INFO, to: u.STREAM_INFO}, {
              from: s.STREAM_INFO_UPDATE,
              to: u.STREAM_INFO_UPDATE
            }, {from: s.SWITCH_STREAM_INIT, to: u.SWITCH_STREAM_INIT}, {
              from: s.SWITCH_STREAM_SUCCESS,
              to: u.SWITCH_STREAM_SUCCESS
            }, {from: s.SWITCH_STREAM_ABORT, to: u.SWITCH_STREAM_ABORT}, {
              from: s.SWITCH_STREAM_FAIL,
              to: u.SWITCH_STREAM_FAIL
            }, {from: s.UPDATE_SOURCE_INIT, to: u.UPDATE_SOURCE_INIT}, {
              from: s.UPDATE_SOURCE_SUCCESS,
              to: u.UPDATE_SOURCE_SUCCESS
            }, {from: s.BUFFER_TWEAKS_CREATED, to: u.BUFFER_TWEAKS_CREATED}];
            return i.add({
              target: P,
              listeners: L
            }), r = a.create(e, P, x), U = a.create(P, e, F), M.push(C.create(P)), M.push(O.create(P)), M.push(h.create(P)), M.push(S.create(P)), M.push(y.create(P)), M.push(v.create(P)), t.useFakeAudio && M.push(T.create(P)), t.isTridentBrowser && M.push(R.create(P)), {
              destroy: function () {
                for (; M.length;) M.pop().destroy();
                r.destroy(), r = null, U.destroy(), U = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2869: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(8730), n(3778), n(492), n(5865), n(855), n(5698), n(5997), n(391), n(683), n(5980), n(291), n(8072)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E) {
        return {
          create: function (p) {
            var m, g, b, _, h, T, A, S = e.create("MediaSourceHandler"), y = !1, R = i.IDLE, v = !1, O = 0, I = !1,
              C = !1, N = [{type: s.STREAM_INFO, listener: F}, {
                type: s.STREAM_INFO_UPDATE,
                listener: F
              }, {
                type: s.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (R = e.data.state) {
                    case i.PAUSED:
                      O = 0, C = !1;
                      break;
                    case i.PLAYING:
                  }
                }
              }, {type: s.DOCUMENT_VISIBLE, listener: x}, {
                type: s.DOCUMENT_HIDDEN,
                listener: x
              }, {
                type: d.ELEMENT_CREATED, listener: function () {
                  M()
                }
              }, {
                type: d.PLAY_START_SUCCESS, listener: function () {
                  S.debugEnabled() && S.debug("onPlayStartSuccess"), I = !0, v = !0, L()
                }
              }, {
                type: s.MEDIA_ERROR, listener: function (e) {
                  (A = e.data.code) === r.MEDIA.DECODE_ERROR ? h = !0 : A === r.MEDIA.MEDIA_SOURCE_ENDED && (T = !0)
                }
              }, {
                type: s.MEDIA_ERROR_RECOVER, listener: function (e) {
                  A = e.data.code, S.debugEnabled() && S.debug("media error recover after error " + A), C = !0, I = !0, v = !0, L()
                }
              }, {
                type: c.FIRST_FRAGMENT, listener: function (e) {
                  _ = e.data, !1 === y && p.emit(f.PLAY, {external: !1, invalidState: !0})
                }
              }, {
                type: l.MEDIA_ERROR_RECOVER_STATS, listener: function (e) {
                  O = e.data.bufferEnd
                }
              }], D = [{
                type: a.SOURCE_OPEN, listener: function () {
                  S.debugEnabled() && S.debug("open"), y = !0, C && p.emit(u.MEDIA_ERROR_RECOVERED, {code: A})
                }
              }, {
                type: a.SOURCE_ENDED, listener: function () {
                  var e;
                  S.debugEnabled() && S.debug("ended"), y = !1, p.emit(u.ERROR, {code: o.MEDIA_ERR_MEDIA_SOURCE_ENDED}), p.emit(u.SOURCE_ENDED, ((e = e || {}).readyState = m.readyState, e))
                }
              }, {
                type: a.SOURCE_CLOSED, listener: function () {
                  y = !1, S.debugEnabled() && S.debug("closed")
                }
              }], w = [];

            function U() {
              S.debugEnabled() && S.debug("create mediasource"), m = window.ManagedMediaSource ? new window.ManagedMediaSource : new window.MediaSource, t.add({
                target: m,
                listeners: D
              }), w.push(E.create(p, m, O, v ? g : null, I ? _ : null, R)), v = !1, I = !1, h = !1, T = !1
            }

            function P() {
              if (m) {
                for (S.debugEnabled() && S.debug("destroy mediasource"), t.remove({
                  target: m,
                  listeners: D
                }); w.length;) w.pop().destroy();
                m = null
              }
            }

            function M() {
              S.debugEnabled() && S.debug("bind mediasource"), p.emit(f.VIDEO_SOURCE, {
                src: window.URL.createObjectURL(m),
                type: n.MP4
              })
            }

            function L() {
              S.debugEnabled() && S.debug("resetMediaSourceOnTheFly");
              var e = m && m.activeSourceBuffers.length,
                t = e && m.activeSourceBuffers[m.activeSourceBuffers.length - 1].buffered.length,
                n = t ? m.activeSourceBuffers[m.activeSourceBuffers.length - 1].buffered.end(m.activeSourceBuffers[m.activeSourceBuffers.length - 1].buffered.length - 1) : 0;
              S.debugEnabled() && S.debug("hasActiveSourceBuffer " + e), S.debugEnabled() && S.debug("hasActiveSourceBufferData " + t), S.debugEnabled() && S.debug("lastBufferEndActiveSourceBuffer " + n), S.debugEnabled() && S.debug("old lastBufferEnd " + O), n && (S.debugEnabled() && S.debug("set lastBufferEnd to lastBufferEndActiveSourceBuffer"), O = n), S.debugEnabled() && S.debug("new lastBufferEnd " + O), S.debugEnabled() && S.debug("resetMediaSource"), P(), U(), M()
            }

            function F(e) {
              S.debugEnabled() && S.debug("streamInfo"), S.debugEnabled() && S.debug("lastBufferEnd " + O), g && g.mimeType !== e.data.streamInfo.mimeType || h || T ? (S.debugEnabled() && S.debug(h ? T ? "was media source error" : "was media decode error" : "new mime type received"), g = e.data.streamInfo, v = !0, L()) : g = e.data.streamInfo
            }

            function x(e) {
              b = e.name === s.DOCUMENT_HIDDEN, S.debug(b ? "hidden" : "visible")
            }

            return S.debugEnabled() && S.debug("create"), t.add({target: p, listeners: N}), U(), {
              destroy: function () {
                S.debugEnabled() && S.debug("destroy"), P(), t.remove({target: p, listeners: N})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8072: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(7990), n(5865), n(5980), n(5698), n(391), n(683), n(291), n(492)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        return {
          create: function (l, f, E, p, m, g) {
            var b, _, h, T, A, S = e.create("SourceBufferQueue " + (new Date).getTime()), y = 0, R = 0, v = 0, O = !1,
              I = [], C = "append", N = "remove", D = "reset", w = "seek", U = "offset", P = !1, M = 0, L = !1, F = -1,
              x = null, k = "", B = 0, H = 0, G = !1, V = [{type: o.STREAM_INFO, listener: ee}, {
                type: o.STREAM_INFO_UPDATE,
                listener: ee
              }, {type: o.STREAM_FRAGMENT, listener: j}, {type: o.RANDOM_ACCESS_POINT, listener: K}], W = [{
                type: a.PRIVATE_MEDIA_STATS, listener: function (e) {
                  _ = e.data.mediaStats.exactCurrentTime, g !== c.PAUSED && S.detailEnabled() && S.detail("current time " + _)
                }
              }, {
                type: o.APPLICATION_STATE_CHANGE, listener: function (e) {
                  (g = e.data.state) === c.PAUSED && function () {
                    for (S.debugEnabled() && S.debug("pause"), L = !1, G = !1, P = !1; I.length;) I.pop();
                    q(0, 1 / 0), y = 0, E = 0
                  }()
                }
              }], Y = [{type: r.UPDATE_END, listener: Z}];

            function j(e) {
              if ("mp4" === e.data.type) {
                if (T = e.data.fragment, !L) {
                  if (e.data.id) S.debugEnabled() && S.debug("initializing from RAP with stored " + e.data.boxType + " " + e.data.id), L = !0; else {
                    for (var t = "", n = 4; n < 8; ++n) t += String.fromCharCode(T[n]);
                    if (-1 === ["moov", "ftyp"].indexOf(t)) return void (S.debugEnabled() && S.debug("dropping fragment: " + t));
                    S.debugEnabled() && S.debug("initialized with " + t), x = {
                      type: "mp4",
                      boxType: t,
                      fragment: T,
                      id: Math.floor(1e11 * (Math.random() + 1))
                    }, S.debugEnabled() && S.debug("set & emit first fragment with id " + x.id), l.emit(d.FIRST_FRAGMENT, x), L = !0
                  }
                  L && B && (ie(!0, '"initialized with prerollDuration"', !0), G = !0)
                }
                !function (e) {
                  J({command: C, fragment: e})
                }(T), G && 2 == ++H && (G = !1, S.debugEnabled() && S.debug("prerollFragment equals prerollFragmentsCount"), Z())
              }
            }

            function K(e) {
              if (S.debugEnabled() && S.debug("random access point streamtime " + e.data.onRandomAccessPoint.streamTime), !L && k !== o.STREAM_INFO_UPDATE) {
                x && (S.debugEnabled() && S.debug("not initialized & have first fragment at RAP with id " + x.id), j({data: x})), (F = Math.floor(e.data.onRandomAccessPoint.streamTime)) > 0 && F <= 500 && (S.debugEnabled() && S.debug("start time " + F + " within a range of 500 ms, normalize to 0"), F = 0), F = Math.floor(F) / 1e3, S.debugEnabled() && S.debug("set start time to random access point");
                var t = parseFloat(F.toString());
                b && b.buffered && b.buffered.length && (F = -1), t > 0 ? (S.debugEnabled() && S.debug("time !== 0, from stream info update?"), F = E, Q(E - t)) : 0 === t && (S.debugEnabled() && S.debug("time === 0, from stream info?"), b && b.buffered && b.buffered.length ? Q(b.buffered.end(b.buffered.length - 1)) : Q(E))
              }
            }

            function q(e, t) {
              J({command: N, from: e, to: t})
            }

            function z(e) {
              J({command: w, position: e})
            }

            function Q(e) {
              J({command: U, offset: e})
            }

            function J(e) {
              e.count = R++, O ? function (e) {
                if (S.detailEnabled() && S.detail("queue " + e.command + " " + e.count), e.force) I.unshift(e); else if (e.command === C && I.length && I[I.length - 1].command === C) {
                  if (v + 1 < 30) {
                    var t = I[I.length - 1].fragment, n = e.fragment, r = new Uint8Array(t.byteLength + n.byteLength);
                    r.set(new Uint8Array(t), 0), r.set(new Uint8Array(n), t.byteLength), I[I.length - 1].fragment = r, I[I.length - 1].count = I[I.length - 1].count.toString() + " & " + e.count, v++
                  } else v = 0, S.detailEnabled() && S.detail("joined fragments threshold (30) reached so begin new one"), I.push(e);
                  S.detailEnabled() && S.detail("joined fragments count " + v)
                } else v = 0, S.detailEnabled() && S.detail("joined fragments count " + v), I.push(e)
              }(e) : $(e)
            }

            function X(e, t) {
              return e && t && "open" === e.readyState
            }

            function $(e) {
              if (S.detailEnabled() && S.detail("execute " + e.command + " " + e.count), S.detailEnabled()) {
                var t = "ranges ";
                if (!b || b && !b.buffered.length) t += "0"; else for (var n = 0, r = b.buffered.length; n < r; n += 1) t += n + " " + b.buffered.start(n) + " - " + b.buffered.end(n), n !== r - 1 && (t += ", ");
                S.detail(t)
              }
              switch (e.command) {
                case C:
                  if (!X(f, b)) return void (S.debugEnabled() && S.debug("Invalid source buffer for APPEND"));
                  if (ie(!0, '"APPEND"'), P) {
                    S.detailEnabled() && S.detail("append " + e.count);
                    try {
                      b.appendBuffer(e.fragment)
                    } catch (e) {
                      S.debugEnabled() && S.debug("sourceBuffer append exception"), S.debugEnabled() && S.debug(e.message)
                    }
                    re() || y++
                  } else S.debugEnabled() && S.debug("append disabled"), S.debugEnabled() && S.debug("trigger manual update end from append"), Z();
                  break;
                case N:
                  if (!X(f, b)) return void (S.debugEnabled() && S.debug("Invalid source buffer for REMOVE"));
                  if (ie(!0, '"REMOVE"'), b.buffered.length && b.buffered.end(b.buffered.length - 1) > 0) try {
                    b.remove(e.from, e.to)
                  } catch (t) {
                    S.debugEnabled() && S.debug("removed buffer from " + e.from + " to " + e.to + " " + e.count)
                  } else S.debugEnabled() && S.debug("no buffered range or end is zero"), S.debugEnabled() && S.debug("trigger manual update end from remove"), Z();
                  break;
                case D:
                  ie(!0, '"RESET"'), M = 1, S.debugEnabled() && S.debug("append enabled after reset"), P = !0, e.zeroing ? (S.debugEnabled() && S.debug("zeroing mse duration"), f.duration = 0) : (S.debugEnabled() && S.debug("no zeroing of duration"), S.debugEnabled() && S.debug("trigger manual update end from reset"), Z());
                  break;
                case w:
                  if (!X(f, b)) return void (S.debugEnabled() && S.debug("Invalid source buffer for SEEK"));
                  ie(!0, '"SEEK"'), S.debugEnabled() && S.debug("seek to position " + e.position + " " + e.count);
                  try {
                    b.buffered.length && b.buffered.start(b.buffered.length - 1) > e.position && (e.position = b.buffered.start(b.buffered.length - 1), S.debugEnabled() && S.debug("out of last buffer range, seek to buffer start " + e.position)), l.emit(u.SEEK, {position: e.position}), S.debugEnabled() && S.debug("seeked"), S.debugEnabled() && S.debug("trigger manual update end from seek"), Z()
                  } catch (e) {
                    S.debugEnabled() && S.debug("seek err")
                  }
                  break;
                case U:
                  if (!X(f, b)) return void (S.debugEnabled() && S.debug("Invalid source buffer for OFFSET"));
                  if (ie(!0, '"OFFSET"'), b) try {
                    S.debugEnabled() && S.debug("offset " + e.offset + " " + e.count), b.timestampOffset = e.offset, l.emit(d.TIME_OFFSET, {offset: Math.round(1e3 * b.timestampOffset)}), S.debugEnabled() && S.debug("offset added")
                  } catch (e) {
                    S.debugEnabled() && S.debug("offset err")
                  } else S.debugEnabled() && S.debug("no source buffer for offset");
                  S.debugEnabled() && S.debug("trigger manual update end from offset"), Z()
              }
            }

            function Z() {
              if (F > -1 && b && b.buffered && b.buffered.length) {
                var e = parseFloat(F.toString());
                F = -1, S.debugEnabled() && S.debug("have buffer and start time on update end"), e > 0 ? (S.debugEnabled() && S.debug("update end && time !== 0, from stream info update?"), z(e)) : 0 === e && (S.debugEnabled() && S.debug("update end && time === 0, from stream info?"), S.debugEnabled() && S.debug("seek to lastBufferEnd"), z(E))
              }
              ie(!1, '"onUpdateEnd"'), M && (M = 0, S.debugEnabled() && S.debug("source ready"), l.emit(s.SOURCE_READY)), I.length ? $(I.shift()) : !A && b && b.buffered.length && b.buffered.start(0) < _ - 30 && re() && (A = setTimeout((function () {
                clearTimeout(A), A = 0
              }), 1e4), S.debugEnabled() && S.debug("remove buffer"), q(b.buffered.start(0), _ - 20))
            }

            function ee(e, n) {
              S.debugEnabled() && S.debug("stream info"), p = e.data.streamInfo, h = p && p.mimeType ? p.mimeType : 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"', k = e.name, B = p.prerollDuration ? p.prerollDuration : 0, H = 0, G = !1, n ? S.debugEnabled() && S.debug("triggered streamInfo") : (S.debugEnabled() && S.debug("untriggered streamInfo"), x && (S.debugEnabled() && S.debug("deleting stored first fragment"), x = null)), f && "open" === f.readyState ? (S.debugEnabled() && S.debug("playerState " + Object.keys(c)[g - 1]), S.debugEnabled() && S.debug("sourceBuffer " + (b ? "existing" : "not existing")), -1 !== [c.PLAYING, c.BUFFERING].indexOf(g) ? (S.debugEnabled() && S.debug("initialized false after stream info"), L = !1, G = !1) : b ? (S.debugEnabled() && S.debug("reset after stream info"), J({
                command: D,
                zeroing: t.isTridentBrowser && !isNaN(f.duration) && f.duration > 0
              })) : (S.debugEnabled() && S.debug("init sourcebuffer after stream info"), ne())) : (S.debugEnabled() && S.debug("add source open listener after stream info"), f.addEventListener(i.SOURCE_OPEN, te)), p.haveVideo || K({data: {onRandomAccessPoint: {streamTime: 0}}})
            }

            function te() {
              S.debugEnabled() && S.debug("mediasource open"), f.removeEventListener(i.SOURCE_OPEN, te), S.debugEnabled() && S.debug("init sourcebuffer"), ne()
            }

            function ne() {
              !b && f && "open" === f.readyState && (S.debugEnabled() && S.debug("create source buffer with mime type '" + h + "'"), b = f.addSourceBuffer(h), n.add({
                target: l,
                listeners: W
              }), n.add({
                target: b,
                listeners: Y
              }), S.debugEnabled() && S.debug("append enabled init source buffer"), P = !0, O && Z(), l.emit(s.SOURCE_READY))
            }

            function re() {
              return 300 < y
            }

            function ie(e, t, n) {
              O = e, n ? S.debugEnabled() && S.debug("set updating to " + e + " from " + (t || "unknown")) : S.detailEnabled() && S.detail("set updating to " + e + " from " + (t || "unknown"))
            }

            return S.debugEnabled() && S.debug("init sourceBufferQueue"), S.debugEnabled() && S.debug("lastBufferEnd " + E), S.debugEnabled() && S.debug("streamInfo " + JSON.stringify(p)), S.debugEnabled() && S.debug("firstFragment " + !!m), S.debugEnabled() && S.debug("playerState " + Object.keys(c)[g - 1]), m && (x = m, S.debugEnabled() && S.debug("created with first fragment " + x.id)), n.add({
              target: l,
              listeners: V
            }), p && (ie(!0, '"init with streamInfo"', !0), ee({data: {streamInfo: p}}, !0)), {
              destroy: function () {
                for (; I.length;) I.pop();
                n.remove({target: l, listeners: V}), n.remove({target: l, listeners: W}), b && n.remove({
                  target: b,
                  listeners: Y
                }), f.removeEventListener(i.SOURCE_OPEN, te), b = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1264: function (e, t, n) {
      var r, i;
      r = [n(8333), n(3778), n(3890), n(492), n(6637), n(855), n(9437), n(6273), n(5075), n(3242)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u) {
        return {
          create: function (c) {
            var l = e.create("MediaErrorHandler"), f = null, E = 0, p = 0, m = 0, g = [],
              b = [t.MEDIA.DECODE_ERROR, t.MEDIA.HLS_VIDEO_DECODE_ERROR, t.MEDIA.MEDIA_SOURCE_ENDED, t.MEDIA.HLS_BUFFER_UNDERRUN, t.MEDIA.HLS_MAX_RANGE, t.PLAYER.PLAYBACK_ERROR],
              _ = [], h = [], T = null, A = 0, S = 3, y = [{type: d.MEDIA_ERROR, listener: R}, {
                type: d.MEDIA_ERROR_RECOVERED,
                listener: v
              }, {type: u.MEDIA_ERROR, listener: R}, {
                type: u.MEDIA_ERROR_RECOVERED,
                listener: v
              }, {
                type: o.APPLICATION_STATE_CHANGE, listener: function (e) {
                  switch (e.data.state) {
                    case r.PAUSED:
                      !function () {
                        for (l.debugEnabled() && l.debug("reset media error recover values"); g.length;) g.shift();
                        f = null, E = 0, p = 0, L()
                      }();
                      break;
                    case r.PLAYING:
                  }
                }
              }, {
                type: o.CONFIG, listener: function (e) {
                  var t;
                  isNaN(e.data.config.playback.mediaErrorRecoveries) ? S = 0 : (0, 1 / 0, t = e.data.config.playback.mediaErrorRecoveries, S = isNaN(t) ? 0 : Math.min(Infinity, Math.max(0, t)))
                }
              }, {
                type: o.SWITCH_STREAM_INIT, listener: function (e) {
                  U(e.data.type) ? L() : (L(), F(_, e.data.id))
                }
              }, {
                type: o.SWITCH_STREAM_SUCCESS, listener: function (e) {
                  U(e.data.type) || (x(_, e.data.id), L(), M())
                }
              }, {
                type: o.SWITCH_STREAM_FAIL, listener: function (e) {
                  U(e.data.type) ? O() : (x(_, e.data.id), P())
                }
              }, {
                type: o.SWITCH_STREAM_ABORT, listener: function (e) {
                  U(e.data.type) ? O() : (x(_, e.data.id), P())
                }
              }, {
                type: o.UPDATE_SOURCE_INIT, listener: function (e) {
                  L(), M(), F(h, e.data.id)
                }
              }, {
                type: o.UPDATE_SOURCE_SUCCESS, listener: function (e) {
                  L(), M(), x(h, e.data.id)
                }
              }, {
                type: o.UPDATE_SOURCE_FAIL, listener: function (e) {
                  L(), M(), x(h, e.data.id)
                }
              }, {
                type: o.UPDATE_SOURCE_ABORT, listener: function (e) {
                  L(), M(), x(h, e.data.id)
                }
              }];

            function R(e) {
              switch (f = e.data, l.debugEnabled() && l.debug("media error occured with native code " + f.code), f.code) {
                case a.MEDIA_ERR_ABORTED:
                  f.code = t.MEDIA.ABORTED, f.message = n.MEDIA.ABORTED;
                  break;
                case a.MEDIA_ERR_NETWORK:
                  f.code = t.MEDIA.DOWNLOAD_ERROR, f.message = n.MEDIA.DOWNLOAD_ERROR;
                  break;
                case a.MEDIA_ERR_DECODE:
                  D() && l.debugEnabled() && l.debug("in switch or update, but continue handling from error " + f.code), f.code = t.MEDIA.DECODE_ERROR, f.message = n.MEDIA.DECODE_ERROR;
                  break;
                case a.MEDIA_ERR_HLS_VIDEO_DECODE:
                  if (D()) return void (l.debugEnabled() && l.debug("return from error " + f.code));
                  f.code = t.MEDIA.HLS_VIDEO_DECODE_ERROR, f.message = n.MEDIA.HLS_VIDEO_DECODE_ERROR;
                  break;
                case a.MEDIA_ERR_SRC_NOT_SUPPORTED:
                  f.code = t.MEDIA.NOT_SUPPORTED, f.message = n.MEDIA.NOT_SUPPORTED;
                  break;
                case a.MEDIA_ERR_MEDIA_SOURCE_ENDED:
                  D() && l.debugEnabled() && l.debug("in switch or update, but continue handling from error " + f.code), f.code = t.MEDIA.MEDIA_SOURCE_ENDED, f.message = n.MEDIA.MEDIA_SOURCE_ENDED;
                  break;
                case a.MEDIA_ERR_HLS_JUMP:
                  if (w(e, t.PLAYER.PLAYBACK_ERROR)) return void (l.debugEnabled() && l.debug("return from error " + f.code));
                  f.code = t.PLAYER.PLAYBACK_ERROR, f.message = n.PLAYER.PLAYBACK_ERROR;
                  break;
                case a.MEDIA_ERR_HLS_BUFFER_UNDERRUN:
                  if (f.waiting && E < S) return void c.emit(s.OFFLINE_BUFFER_UNDERRUN);
                  if (!f.reconnect && w(e, t.MEDIA.HLS_BUFFER_UNDERRUN)) return void (l.debugEnabled() && l.debug("return from error " + f.code));
                  f.code = t.MEDIA.HLS_BUFFER_UNDERRUN, f.message = n.MEDIA.HLS_BUFFER_UNDERRUN;
                  break;
                case a.MEDIA_ERR_HLS_MAX_RANGE:
                  if (w(e, t.MEDIA.HLS_MAX_RANGE)) return void (l.debugEnabled() && l.debug("return from error " + f.code));
                  f.code = t.MEDIA.HLS_MAX_RANGE, f.message = n.MEDIA.HLS_MAX_RANGE
              }
              (function (e) {
                var t;
                if (-1 === b.indexOf(e)) t = !1, l.debugEnabled() && l.debug("media error with code " + e + " not recoverable, trigger error"); else if (E >= S) t = !1, l.debugEnabled() && l.debug("media error with code " + e + " recoverable, but recover threshold " + S + " reached within " + (E ? (Math.floor(performance.now()) - g[0]) / 1e3 : 0) + " seconds, trigger error"); else {
                  for (t = !0, g.push(Math.floor(performance.now())); g[g.length - 1] - g[0] > 6e4;) g.shift();
                  E = g.length, p++;
                  var n = 6e4 - (g[E - 1] - g[0]), r = S - E;
                  l.debugEnabled() && l.debug("recovering from media error " + e + ", recovery " + E + "/" + S + " within the last 60 seconds (" + p + " total)"), l.debugEnabled() && l.debug(r + (r <= 1 ? " recoveries" : " recovery") + " allowed within remaining time of " + n / 1e3 + " seconds"), L(), m = setTimeout(O, 1e4), c.emit(s.RECOVER, {
                    count: E,
                    max: S,
                    total: p,
                    code: e,
                    remainingTime: n,
                    reconnect: !!f.reconnect
                  })
                }
                return t
              })(f.code) || (l.debugEnabled() && l.debug('trigger "' + s.ERROR + '" with translated code ' + f.code + ' and message "' + f.message + '"'), c.emit(s.ERROR, f))
            }

            function v(e) {
              l.debugEnabled() && l.debug("recovery succeed from error " + e.data.code), L(), c.emit(s.RECOVERED, {data: {code: e.data.code}})
            }

            function O() {
              L(), l.debugEnabled() && l.debug("recovery failed from error with translated code " + f.code + ' and message "' + f.message + '"'), setTimeout(I, 200)
            }

            function I() {
              c.emit(s.ERROR, f)
            }

            function C() {
              l.debugEnabled() && l.debug("inSwitch has length " + _.length);
              var e = !1;
              return _.length && (e = !0), e
            }

            function N() {
              l.debugEnabled() && l.debug("inUpdate has length " + h.length);
              var e = !1;
              return h.length && (e = !0), e
            }

            function D() {
              l.debugEnabled() && l.debug("check if switch or update");
              var e = !1;
              return C() ? (l.debugEnabled() && l.debug("still in switch"), e = !0) : N() && (l.debugEnabled() && l.debug("still in update"), e = !0), e
            }

            function w(e, t) {
              var n = !1;
              return C() ? (l.debugEnabled() && l.debug("still in switch, queue error with transformed code " + t), function (e, t) {
                l.debugEnabled() && l.debug("media error with code " + t + '" queued during ongoing switch or update'), T || c.emit(s.QUEUED, {code: t}), T = e
              }(e, t), n = !0) : N() && (l.debugEnabled() && l.debug("still in update, do nothing"), n = !0), n
            }

            function U(e) {
              return "recover" === e
            }

            function P() {
              l.debugEnabled() && l.debug("check queued media error"), D() ? l.debugEnabled() && l.debug("abort queued check, still ongoing switch or update") : T && !A && (l.debugEnabled() && l.debug("set timeout for handling queued media error again"), A = setTimeout((function () {
                l.debugEnabled() && l.debug("timeout fired queued media error"), clearTimeout(A), A = 0, R(T), M()
              }), 250))
            }

            function M() {
              T = null, c.emit(s.UNQUEUED)
            }

            function L() {
              clearTimeout(m), m = 0
            }

            function F(e, t) {
              return e.push(t), e
            }

            function x(e, t) {
              for (var n = 0; n < e.length;) e[n] === t ? e.splice(n, 1) : ++n;
              return e
            }

            return l.debugEnabled() && l.debug("initialize"), i.add({target: c, listeners: y}), {
              destroy: function () {
                i.remove({target: c, listeners: y})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4221: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        return {
          create: function (t, n) {
            var r = e.create("MoQBufferQueue" + (n ? "-" + n : "")), i = [], a = [], o = ["Audio", "Video"], s = null,
              d = null, u = null, c = !1;

            function l() {
              i = [], a = [], d = null, u = null, s = null, c = !1
            }

            function f() {
              p(E())
            }

            function E() {
              for (var e = i, t = -1, n = e.length - 1; n >= 0; n--) if (e[n].isKeyframe) {
                t = n;
                break
              }
              return -1 !== t ? e.splice(0, t) : e.length > 1 && e.splice(0, e.length - 1), d && e.unshift(d), e.length > 1 ? e[1].timestamp : 0
            }

            function p(e) {
              var t = a;
              if (e >= 0) for (; t.length > 0 && t[0].timestamp < e;) t.shift(); else t.length > 1 && t.splice(0, t.length - 1);
              u && t.unshift(u)
            }

            function m() {
              return s
            }

            function g() {
              var e, t = null;
              for (e = 0; e < i.length; e++) i[e].isCodecConfig || i[e].timestamp >= 0 && (!t || i[e].timestamp < t) && (t = i[e].timestamp);
              for (e = 0; e < a.length; e++) a[e].timestamp >= 0 && (!t || a[e].timestamp < t) && (t = a[e].timestamp);
              return t
            }

            return r.debugEnabled() && r.debug("init"), {
              destroy: function () {
                r.debugEnabled() && r.debug("destroying"), l()
              }, setReferenceType: function (e) {
                -1 !== o.indexOf(e) && (s = e)
              }, getReferenceType: m, getNextVideoFrame: function () {
                return 0 === i.length ? null : i.shift()
              }, getNextAudioFrame: function () {
                return 0 === a.length ? null : a.shift()
              }, getNextVideoFrameByTimestamp: function (e) {
                return i.length && i[0].timestamp <= e ? i.shift() : null
              }, getNextAudioFrameByTimestamp: function (e) {
                return a.length && a[0].timestamp <= e ? a.shift() : null
              }, getNextTimestamp: g, getLastTimestamp: function () {
                var e = null;
                return i.length && (e = i[i.length - 1].timestamp), a.length && (!e || a[a.length - 1].timestamp > e) && (e = a[a.length - 1].timestamp), e
              }, appendVideoFragment: function (e) {
                i.length, i.push(e), e.isCodecConfig && (d = e)
              }, appendVideoFragmentToTheFront: function (e) {
                i.unshift(e), e.isCodecConfig && (d = e)
              }, appendAudioFragment: function (e) {
                a.length, 1 === a.length && a[0].isCodecConfig && (a[0].timestamp = e.timestamp, u.timestamp = e.timestamp), a.push(e), e.isCodecConfig && (u = e)
              }, getVideoBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = i;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, getAudioBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = a;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, getBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = "Audio" === s ? a : i;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, setPlaybackRate: function () {
              }, reset: function () {
                l()
              }, seek: function (e) {
                for (var t = -1, n = 0; n < i.length && (i[n].isKeyframe && i[n].timestamp <= e && (t = n), !(i[n].timestamp > e)); n++) ;
                if (-1 !== t) {
                  i.splice(0, t);
                  var r = i[0].timestamp, o = a.findIndex((e => e.timestamp >= r));
                  return -1 !== o && a.splice(0, o), {success: !0, timestamp: i[0].timestamp}
                }
                return l(), {success: !1, timestamp: e}
              }, clearBuffers: l, getSeekableRange: function () {
                var e = "Audio" === s ? a : i;
                return 0 === e.length ? null : {start: e[0].timestamp, end: e[e.length - 1].timestamp}
              }, reduceBuffers: f, ready: function () {
                return null !== m() && c
              }, prepareBuffers: function () {
                return f(), c = !0, t.emit("ready"), g()
              }, trimVideoFrames: E, trimAudioFrames: p, getVideoBuffer: function () {
                return i
              }, getAudioBuffer: function () {
                return a
              }, getVideoBufferLength: function () {
                return i.length
              }, getAudioBufferLength: function () {
                return a.length
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2590: function (e, t, n) {
      var r, i;
      r = [n(8333), n(5337)], void 0 === (i = function (e, t) {
        return {
          create: function () {
            var n = e.create("FrameTracking"), r = new Map, i = {video: {lastRendered: []}, audio: {lastRendered: []}},
              a = 0, o = t.create(50);

            function s(e) {
              var t = i[e].lastRendered;
              if (0 === t.length) return {avg: 0, min: 0, max: 0};
              var n = t.map((function (e) {
                return e.latency
              }));
              return {
                avg: n.reduce((function (e, t) {
                  return e + t
                }), 0) / n.length, min: Math.min.apply(Math, n), max: Math.max.apply(Math, n)
              }
            }

            function d() {
              if (!i.video.lastRendered || !i.audio.lastRendered || 0 === i.video.lastRendered.length || 0 === i.audio.lastRendered.length) return 0;
              for (var e = i.video.lastRendered, t = i.audio.lastRendered, n = [], r = 0; r < e.length; r++) {
                for (var a = e[r], o = null, s = Number.MAX_VALUE, d = 0; d < t.length; d++) {
                  var u = t[d], c = Math.abs(a.timestamp - u.timestamp);
                  c < s && (s = c, o = u)
                }
                if (o) {
                  var l = a.renderTime - o.renderTime;
                  n.push(l)
                }
              }
              return 0 === n.length ? 0 : n.reduce((function (e, t) {
                return e + t
              }), 0) / n.length
            }

            function u() {
              r.clear(), i.video.lastRendered = [], i.audio.lastRendered = [], a = 0, o = t.create(50)
            }

            return u(), n.debugEnabled() && n.debug("FrameTracking initialized"), {
              trackFrame: function (e, t, n, i) {
                var s = performance.now();
                if (r.set(e, {timestamp: t, arrivalTime: s, type: n, expectedRenderTime: i || t}), "audio" === n) {
                  if (a > 0) {
                    var d = s - a;
                    o.add(d)
                  }
                  a = s
                }
                if (r.size > 1e3) {
                  var u = Array.from(r.keys());
                  u.slice(0, u.length - 1e3).forEach((function (e) {
                    r.delete(e)
                  }))
                }
              }, frameRendered: function (e, t, n, a) {
                if (e && r.has(e)) {
                  var o, s = r.get(e), d = t - s.arrivalTime, u = performance.now();
                  i[n].lastRendered.push({
                    frameId: e,
                    timestamp: a || s.timestamp,
                    renderTime: t,
                    latency: d
                  }), o = u - 1e3, i.video.lastRendered = i.video.lastRendered.filter((function (e) {
                    return e.renderTime > o
                  })), i.audio.lastRendered = i.audio.lastRendered.filter((function (e) {
                    return e.renderTime > o
                  })), r.delete(e)
                }
              }, getFrameStats: function () {
                var e = s("video"), t = s("audio"), n = [];
                i.video.lastRendered.length > 0 && n.push("Video: " + i.video.lastRendered.length + " frames, latency: " + e.avg.toFixed(1) + "ms (min: " + e.min.toFixed(1) + ", max: " + e.max.toFixed(1) + ")"), i.audio.lastRendered.length > 0 && n.push("Audio: " + i.audio.lastRendered.length + " frames, latency: " + t.avg.toFixed(1) + "ms (min: " + t.min.toFixed(1) + ", max: " + t.max.toFixed(1) + ")");
                var r = function () {
                  if (o.count < 10) return "unknown";
                  var e = o.get();
                  return e.deviation > 2 * e.arithmetic ? "bursty" : e.deviation < .5 * e.arithmetic ? "smooth" : "variable"
                }();
                if ("unknown" !== r && o.count > 0) {
                  var a = o.get();
                  n.push("Audio Delivery: " + r + " (interval avg: " + a.arithmetic.toFixed(1) + "ms, dev: " + a.deviation.toFixed(1) + "ms, min: " + a.minimum.toFixed(1) + "ms, max: " + a.maximum.toFixed(1) + "ms)")
                }
                if (i.video.lastRendered.length > 0 && i.audio.lastRendered.length > 0) {
                  var u = d();
                  0 !== u ? n.push("AV Sync Diff: " + u.toFixed(2) + "ms") : n.push("AV Sync: no comparable frames")
                }
                return {
                  parts: n,
                  avSyncDiff: i.video.lastRendered.length > 0 && i.audio.lastRendered.length > 0 ? d() : 0,
                  deliveryPattern: r
                }
              }, reset: u, destroy: function () {
                n.debugEnabled() && n.debug("destroy"), u()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4545: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6637), n(3778), n(492), n(1520), n(907), n(9623), n(3038), n(2628)], void 0 === (i = function (e, t, n, r, i, a, o, s, d) {
        var u = e.create("MoqHandler");
        return {
          create: function (e) {
            var c, l, f, E, p, m, g = [{
              type: i.CONFIG, listener: function (e) {
                var t;
                U(e) && (t = e.data.config, h = 0, R = 0, (l = t).playback && (T = !!l.playback.muted, S = !!l.playback.automute, y = !!l.playback.autoplay, A = l.playback.volume || 1))
              }
            }, {
              type: i.STREAM_FRAGMENT, listener: function (e) {
                U(e) && _[h].addStreamFragment(e)
              }
            }, {
              type: i.STREAM_INFO, listener: function (e) {
                U(e) && _[h].addStreamInfo(e)
              }
            }, {
              type: i.MEDIA_ERROR_RECOVER, listener: function () {
                var t = _[h], n = t.getLastError();
                n && !O && (O = !0, t.recoverFromError(n) ? e.emit(a.MEDIA_ERROR_RECOVERED, {data: {code: O}}) : N(t, {data: {buffer: !1}}))
              }
            }, {
              type: i.MEDIA_ERROR_RECOVERED, listener: function () {
                O = !1
              }
            }, {
              type: i.MEDIA_ERROR_QUEUED, listener: function () {
              }
            }, {
              type: i.MEDIA_ERROR_UNQUEUED, listener: function () {
              }
            }, {
              type: i.WEB_TRANSPORT_META_DATA, listener: function (e) {
                U(e) && _[h].addWtMetaData(e)
              }
            }, {
              type: i.WEB_TRANSPORT_GOP_CACHE, listener: function (e) {
                U(e) && _[h].addGopCacheData(e)
              }
            }, {
              type: s.CREATE_VIDEO, listener: function (t) {
                var n, r;
                U(t) && (t.data.elementIds && (p = t.data.elementIds), t.data.container && (m = t.data.container)), R = p.length;
                for (var i = 0; i < R; i++) r = {
                  elementId: p[i],
                  index: i
                }, n = d.create(e, r.elementId, m, r.index, T, S, y, A, I, l.playback.latencyControlMode), _.push(n), v[i] = [];
                e.emit(a.ELEMENT_CREATED, {video: D(_[h])}), M(h), w(_[h]), u.debugEnabled() && u.debug("add time update interval for play stats"), c = setInterval(P, 100)
              }
            }, {
              type: s.DESTROY_VIDEO, listener: function () {
              }
            }, {
              type: s.VIDEO_SOURCE, listener: function () {
              }
            }, {
              type: s.PLAY, listener: function (e) {
                !function (e, t) {
                  e ? e.play(t) : u.debugEnabled() && u.debug("moqElement could not be found")
                }(_[h], e)
              }
            }, {
              type: s.PAUSE, listener: function (e) {
                u.debugEnabled() && u.debug("onPause index: " + h), N(_[h], e, e.data.buffer), function () {
                  for (var e in v) if (Object.prototype.hasOwnProperty.call(v, e)) for (; v[e].length;) v[e].pop()
                }()
              }
            }, {
              type: s.MUTE, listener: function () {
                var e;
                u.debugEnabled() && u.debug("mute index: " + h), (e = _[h]) ? (T = !0, e.setMute()) : u.debugEnabled() && u.debug("moqElement could not be found")
              }
            }, {
              type: s.UNMUTE, listener: function () {
                u.debugEnabled() && u.debug("unmute index: " + h);
                for (var e = 0; e < _.length; e++) t = _[e], n = !0, t ? (n && (T = !1), t.setUnmute()) : u.debugEnabled() && u.debug("moqElement could not be found");
                var t, n
              }
            }, {
              type: s.SEEK, listener: function () {
              }
            }, {
              type: s.SET_VOLUME, listener: function (e) {
                var t, n;
                U(e) && (u.debugEnabled() && u.debug("onSetVolume index: " + h), A = Math.min(1, Math.max(0, e.data.volume)), t = _[h], n = A, t ? (t.setVolume(n), A = n) : u.debugEnabled() && u.debug("moqElement could not be found"))
              }
            }, {
              type: s.SET_RATE, listener: function () {
              }
            }, {type: o.LOAD_START, listener: C}, {type: o.PROGRESS, listener: C}, {
              type: o.SUSPEND,
              listener: C
            }, {type: o.ABORT, listener: C}, {type: o.EMPTIED, listener: C}, {
              type: o.STALLED,
              listener: C
            }, {type: o.PLAY, listener: C}, {type: o.PAUSE, listener: C}, {
              type: o.LOADED_META_DATA,
              listener: C
            }, {type: o.LOADED_DATA, listener: C}, {type: o.WAITING, listener: C}, {
              type: o.ERROR,
              listener: C
            }, {type: o.PLAYING, listener: C}, {type: o.CAN_PLAY, listener: C}, {
              type: o.CAN_PLAY_THROUGH,
              listener: C
            }, {type: o.SEEKING, listener: C}, {type: o.SEEKED, listener: C}, {
              type: o.TIME_UPDATE,
              listener: C
            }, {type: o.ENDED, listener: C}, {type: o.RATE_CHANGE, listener: C}, {
              type: o.DURATION_CHANGE,
              listener: C
            }, {type: o.VOLUME_CHANGE, listener: C}, {
              type: o.ELEMENT_CREATED,
              listener: C
            }, {type: o.PLAY_START_SUCCESS, listener: C}, {
              type: o.PLAY_START_ABORT_ERROR,
              listener: C
            }, {type: o.PLAY_START_NOT_ALLOWED_ERROR, listener: C}, {
              type: o.VIEWPORT_VISIBLE,
              listener: C
            }, {type: o.VIEWPORT_HIDDEN, listener: C}, {
              type: o.VIDEO_DECODE_ERROR,
              listener: C
            }, {type: o.AUDIO_DECODE_ERROR, listener: C}, {
              type: o.VIDEO_DECODER_STARTUP_ERROR,
              listener: C
            }, {type: o.AUDIO_DECODER_STARTUP_ERROR, listener: C}, {
              type: o.ADJUSTED_META_DATA,
              listener: C
            }, {
              type: i.SWITCH_STREAM_INIT, listener: function () {
              }
            }, {
              type: i.SWITCH_STREAM_SUCCESS, listener: function () {
              }
            }, {
              type: i.UPDATE_SOURCE_INIT, listener: function () {
              }
            }, {
              type: i.UPDATE_SOURCE_SUCCESS, listener: function () {
              }
            }, {
              type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case r.PAUSED:
                  case r.PLAYING:
                }
              }
            }, {
              type: i.BUFFER_TWEAKS_CREATED, listener: function (e) {
                U(e) && (I = e.data.tweaks.buffer || {})
              }
            }], b = [], _ = [], h = 0, T = !1, A = 1, S = !1, y = !1, R = 0, v = {0: []}, O = !1, I = {};

            function C(t) {
              if (t && t.name && t.data) {
                var r = h;
                E = w(_[r]), t.name === o.VIDEO_DECODE_ERROR || t.name === o.AUDIO_DECODE_ERROR ? E = {
                  code: n.MEDIA.DECODE_ERROR,
                  message: t.data.error.message
                } : t.name !== o.VIDEO_DECODER_STARTUP_ERROR && t.name !== o.AUDIO_DECODER_STARTUP_ERROR || (E = {
                  code: n.MEDIA.DECODER_STARTUP_ERROR,
                  message: t.data.error.message
                });
                var i = L(E, t.data, !1), a = t.name, s = function (e) {
                  return "moqHandler." + function (e) {
                    var t = e.indexOf(".") + 1;
                    return e.substring(t)
                  }(e)
                }(a);
                if (a !== o.TIME_UPDATE) for (v[r].unshift(a); v[r].length > 20;) v[r].pop();
                e.emit(s, i)
              }
            }

            function N(e, t) {
              e ? e.pause(t) : u.debugEnabled() && u.debug("moqElement could not be found")
            }

            function D(e) {
              if (e) return e.getVideoElement();
              u.debugEnabled() && u.debug("moqElement could not be found")
            }

            function w(e) {
              return e ? e.getMoqPayload() : (u.debugEnabled() && u.debug("moqElement could not be found"), {index: 0})
            }

            function U(e, t) {
              var n = e && Object.prototype.hasOwnProperty.call(e, "data");
              return t ? n && Object.prototype.hasOwnProperty.call(e.data, t) : n
            }

            function P() {
              for (f = w(_[h]); b.length > 2;) b.shift();
              b.push(f), e.emit(o.TIME_UPDATE, f)
            }

            function M(t) {
              for (var n = _.map((function (e) {
                return e.getVideoElement()
              })), r = 0; r < n.length; r += 1) void 0 !== typeof n[r] && n[r] || n.pop();
              n.length - 1 < t && (t = -1), e.emit(a.ACTIVE_VIDEO_ELEMENT_CHANGE, {
                videoElementList: n,
                activeVideoElement: t < 0 ? null : n[t]
              })
            }

            function L(e, t, n) {
              for (var r in t) "object" != typeof t[r] ? Object.prototype.hasOwnProperty.call(e, r) && !n || (n ? e[r] += t[r] : e[r] = t[r]) : (Object.prototype.hasOwnProperty.call(e, r) || (e[r] = {}), L(e[r], t[r], n));
              return e
            }

            return t.add({target: e, listeners: g}), {
              destroy: function () {
                clearInterval(c), c = void 0, t.remove({target: e, listeners: g}), function (e) {
                  if (e) {
                    for (var t = 0; t < e.length; t++) e[t].destroy();
                    M(-1), e = []
                  } else u.debugEnabled() && u.debug("moqElement could not be found")
                }(_)
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5082: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(492), n(6637), n(1520), n(3038), n(907), n(738), n(3701)], void 0 === (i = function (e, t, n, r, i, a, o, s, d) {
        return {
          create: function (t) {
            var o = e.create("MoQPlaybackControl"), u = !1, c = !0, l = !1, f = null, E = null, p = {}, m = null, g = [{
              type: i.CONFIG, listener: function (e) {
                e.data.config.tweaks && e.data.config.tweaks.buffer && (p = e.data.config.tweaks.buffer)
              }
            }, {
              type: i.STARTUP_STATS_COMPLETED, listener: function (e) {
                E = e.data
              }
            }, {
              type: i.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (f = e.data.state, E = null, f) {
                  case n.PLAYING:
                    l = !1;
                    break;
                  case n.LOADING:
                    o.debugEnabled() && o.debug("add play state listeners"), r.add({target: t, listeners: b});
                    break;
                  case n.PAUSED:
                    l = !1, E = null;
                    break;
                  case n.PAUSING:
                    r.remove({
                      target: t,
                      listeners: b
                    }), o.warnEnabled() && o.warn("entering paused state"), u = !1, c = !0
                }
              }
            }, {
              type: a.PLAY, listener: function (e) {
                o.debugEnabled() && o.debug("on play")
              }
            }, {
              type: i.BUFFER_GOAL_STATS, listener: function (e) {
                m = e.data
              }
            }], b = [{
              type: s.PRIVATE_MEDIA_STATS, listener: function (e) {
                if (m || void 0 !== p.start) {
                  var n = e.data.mediaStats, r = n.bufferDelay, i = n.timeLag,
                    a = void 0 !== p.start ? p.start : null === m || 0 === m.min ? .6 : m.min - m.min / 4;
                  a = Math.max(.1, a);
                  var s = void 0 !== p.min ? p.min : .09;
                  a <= 0 && (a = .6);
                  var f = i > a + a / 4, g = i <= (s = Math.max(.09, s)) || i < a && !f;
                  o.detailEnabled() && o.detail("timeLag: " + i + " referenceThreshold: " + a + " resumeThreshold: " + s), function (e) {
                    var n = e.needToBuffer, r = e.needToResume;
                    e.canStart && !l && !u && E ? (o.debugEnabled() && o.debug("Starting playback"), u = !0, t.emit(d.PLAYBACK_STARTED, E), c = !1, o.debugEnabled() && o.debug("Buffer sufficient for playback, current delay: " + e.timeLag)) : u && !c && n && !l ? (o.debugEnabled() && o.debug("Need to buffer, current delay: " + e.timeLag), c = !0, t.emit(d.BUFFERING)) : u && c && r && !n && !l && (o.debugEnabled() && o.debug("Resuming playback"), t.emit(d.PLAYBACK_STARTED), c = !1, o.debugEnabled() && o.debug("Buffer sufficient for playback, current delay: " + e.timeLag))
                  }({bufferDelay: r, timeLag: i, needToBuffer: f, needToResume: g, canStart: r >= a || r < a && !f})
                }
              }
            }];
            return o.debugEnabled() && o.debug("init"), r.add({target: t, listeners: g}), {
              destroy: function () {
                r.remove({target: t, listeners: g})
              }, reset: function () {
                u = !1, c = !0, l = !1, E = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2628: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(6637), n(9623), n(4283), n(6660), n(4286), n(7894), n(4221), n(9467), n(6415), n(2590)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l) {
        var f = i.VideoDecoderModule, E = a.VideoRenderer, p = o.AudioDecoderModule, m = s.AudioRenderer;
        return {
          create: function (t, n, i, a, o, s, g, b, _, h) {
            var T, A, S, y, R, v = e.create("MoQProxy"), O = !1, I = !1, C = !1, N = performance.now(), D = null,
              w = null, U = null, P = null, M = !1, L = !1, F = !0, x = !1, k = null, B = null, H = !1, G = null,
              V = NaN, W = 0, Y = !1, j = 0, K = c.create(t), q = l.create(), z = d.create(t, "Decode"),
              Q = u.create(t, "Render"), J = 1e5, X = null, $ = !1, Z = !1, ee = 0, te = void 0, ne = -1, re = 0,
              ie = 0, ae = -1, oe = 0, se = 0, de = 0, ue = 0, ce = 0, le = 0, fe = 0, Ee = {value: 0}, pe = {value: 0},
              me = {value: 0}, ge = {value: 0}, be = 0, _e = 0, he = 0;

            function Te() {
              v.debugEnabled() && v.debug("reset"), O = !1, I = !1, C = !1, G = null, V = NaN, W = 0, j = 0, H = !1, ne = -1, re = 0, ie = 0, ae = -1, oe = 0, se = 0, de = 0, ue = 0, ce = 0, le = 0, fe = 0, q.reset(), Ee.value = 0, pe.value = 0, me.value = 0, ge.value = 0, be = 0, _e = 0, he = 0
            }

            function Ae() {
              D || ((D = new f).on("frameDecoded", (function (e, t) {
                t && (e.frameId = t), Q.appendVideoFragment(e)
              })), D.on("decodeError", (function (e) {
                v.debugEnabled() && v.debug("Video decode error:" + JSON.stringify(e));
                var n = Date.now();
                n - ee < 1e3 ? v.debugEnabled() && v.debug("Skipping duplicate error emission") : (ee = n, Ve(e, "video"), M ? t.emit(r.VIDEO_DECODE_ERROR, {error: e}) : t.emit(r.VIDEO_DECODER_STARTUP_ERROR, {error: e}))
              })), D.on("configured", (function (e) {
                v.debugEnabled() && v.debug("VideoDecoder configured:" + JSON.stringify(e)), M = !0, Z && (Z = !1, $ = !1)
              })))
            }

            function Se() {
              U || ((U = new p).on("frameDecoded", (function (e, t, n) {
                Q.appendAudioFragment(e, t, n)
              })), U.on("decodeError", (function (e) {
                v.debugEnabled() && v.debug("Audio decode error:" + JSON.stringify(e));
                var n = Date.now();
                n - ee < 1e3 ? v.debugEnabled() && v.debug("Skipping duplicate error emission") : (ee = n, Ve(e, "audio"), L ? t.emit(r.AUDIO_DECODE_ERROR, {error: e}) : t.emit(r.AUDIO_DECODER_STARTUP_ERROR, {error: e}))
              })), U.on("configured", (function (e) {
                v.debugEnabled() && v.debug("AudioDecoder configured:" + JSON.stringify(e)), L = !0, Z && (Z = !1, $ = !1)
              })))
            }

            function ye() {
              w = new E(T, {
                autoResize: !0, events: {
                  videoRendered: function (e, t, n, r, i, a) {
                    v.debugEnabled() && Fe(Ee) && v.debug("[Video] Rendered with timestamp " + e.toFixed(2) + ", size: " + t + "x" + n + ", rendered size: " + r + "x" + i + (a ? ", frameId: " + a : "")), a && xe(a, performance.now(), "video", e)
                  }
                }
              })
            }

            function Re() {
              P || (P = new m({
                schedulingLatencySecs: .05,
                startTimeoutMs: 100,
                startBufferMs: B / 1e3,
                volume: b,
                muted: o,
                allowDelayedRendering: !0,
                events: {
                  audioScheduled: function (e, t, n, r) {
                    v.debugEnabled() && Fe(me) && v.debug("[Audio] Scheduled with start time: " + e.toFixed(2) + " s, current time: " + t.toFixed(2) + ", external sync time: " + n.toFixed(2) + ", delta deviation: " + (t - n - r).toFixed(2))
                  }, audioRendered: function (e, t, n, r, i, a, o) {
                    if (v.debugEnabled() && Fe(pe) && v.debug("[Audio] Rendered with timestamp " + e.toFixed(2) + " and duration " + t.toFixed(2) + ", start time: " + n.toFixed(2) + " s, current time: " + r.toFixed(2) + ", external sync time: " + i.toFixed(2) + ", delta deviation: " + (r - i - a).toFixed(2) + (o ? ", frameId: " + o : "")), o) {
                      var s = e + t;
                      xe(o, performance.now(), "audio", s)
                    }
                  }, audioError: function (e) {
                    v.debugEnabled() && v.debug("[Audio] Renderer error: " + JSON.stringify(e))
                  }, audioLag: function (e, t) {
                    v.debugEnabled() && v.debug("[Audio] Lagging: " + e + ", timeLag: " + t.toFixed(2))
                  }, underrun: function () {
                    v.debugEnabled() && v.debug("[Audio] Underrun: chunk too late to schedule")
                  }, closed: function () {
                    v.debugEnabled() && v.debug("[Audio] Closed")
                  }, audioRemoved: function (e, t, n) {
                    v.detailEnabled() && v.detail("[Audio] Removed at " + e.toFixed(2) + " s, current time: " + t.toFixed(2) + ", reason: " + n)
                  }, stateChanged: function (e) {
                    v.debugEnabled() && v.debug("[Audio] Context state changed to " + e)
                  }, startSuccess: function () {
                    v.debugEnabled() && v.debug("[Audio] Started")
                  }, startError: function (e) {
                    switch (v.debugEnabled() && v.debug("[Audio] Start error: " + JSON.stringify(e)), e.code) {
                      case 1005:
                        !s || o || x || (x = !0, Ne()), t.emit(r.PLAY_START_NOT_ALLOWED_ERROR, {
                          error: e,
                          automuted: x
                        }), x = !1
                    }
                  }, volumeChanged: function (e, n) {
                    b = e, o = n, v.debugEnabled() && v.debug("[Audio] Volume changed to " + b + ", muted: " + o), t.emit(r.VOLUME_CHANGE, {
                      volume: b,
                      muted: o
                    })
                  }, trace: function (e) {
                    v.debugEnabled && v.debug("[Audio] Trace: " + e)
                  }
                },
                getExternalSyncTime: ke,
                audioLag: {
                  maxLagSecs: Number.POSITIVE_INFINITY,
                  cooldownLagSecs: .6,
                  dropThresholdSecs: Number.POSITIVE_INFINITY,
                  renderFrameDistance: 10,
                  dropFrameDistance: 6,
                  dropMode: "single",
                  fadeMode: "all"
                }
              }))
            }

            function ve() {
              D && (D.close(), D = null)
            }

            function Oe() {
              w && (w.close(), w = null)
            }

            function Ie() {
              U && (U.close(), U = null)
            }

            function Ce() {
              P && (P.close(), P = null)
            }

            function Ne() {
              De(!0)
            }

            function De(e) {
              P ? P.setMute(e) : t.emit(r.VOLUME_CHANGE, {volume: b, muted: e})
            }

            function we() {
              Ue(), k = requestAnimationFrame(Pe), F = !1, O = !0
            }

            function Ue() {
              k && (cancelAnimationFrame(k), k = null), F = !0, O = !1
            }

            function Pe() {
              k = null, F && v.debugEnabled() && v.debug("exit playback loop"), Le(), k = requestAnimationFrame(Pe)
            }

            function Me(e) {
              V = 1e3 * Math.round(Number(e) / 1e3), v.debugEnabled() && v.debug("referenceTimeOffset: " + V)
            }

            function Le() {
              var e = K.getTargetTime(), n = Be(), i = B - n;
              if (!$) {
                var a, o = Q.getVideoBufferedTimeRange();
                if (!I || o.length > 0) {
                  var s = Q.getNextVideoFrameByTimestamp(I ? e - i : Number.MAX_SAFE_INTEGER);
                  s && (I ? C || (C = !0, t.emit(r.LOADED_DATA), t.emit(r.CAN_PLAY_THROUGH), t.emit(r.PLAYING)) : (I = !0, N = performance.now() - N, v.debugEnabled() && v.debug("first frame of gop: " + N)), le && s.timestamp < le && le - s.timestamp < 2e5 && (s.timestamp = le), le = s.timestamp, K.setLastRenderedVideoFrameTimestamp(s.timestamp), re > ie ? (ie++, s.close()) : (ne >= 0 && (v.debugEnabled() && v.debug("render first non-GOP cache video frame, video GOP cache: received " + re + ", dropped " + ie + ", expected " + ne), ne = -1, re = 0, ie = 0), w.renderFrame(s, s.frameId)))
                }
                if ((a = H ? Q.getNextAudioFrameByTimestamp(e + n) : Q.getNextAudioFrameByTimestamp(e - i)) && (H || a.isCodecConfig || (H = !0, v.debugEnabled() && v.debug("render first non-GOP cache audio frame, audio GOP cache: received " + oe + ", dropped " + oe + ", expected " + ae), ae = -1, oe = 0), a.timestamp >= B && (K.setLastRenderedAudioFrameTimestamp(a.timestamp - B), !C && H && "Audio" === G && (C = !0, t.emit(r.LOADED_DATA), t.emit(r.CAN_PLAY_THROUGH), t.emit(r.PLAYING))), P.renderAudioData(a.frame, a.timestamp, a.frameId)), !I || o.length < 5) {
                  var d = z.getNextVideoFrame();
                  if (d) {
                    if (!d.isCodecConfig && !M) return v.debugEnabled() && v.debug("video decoder not configured, skipping to decode frame and re-pushing to the front of the queue"), z.appendVideoFragmentToTheFront(d), d;
                    d.isCodecConfig ? (M = !1, D.configureDecoder(d)) : (d.pto && (d.dtsUs += d.pto, d.timestamp += d.pto), D.decodeChunk(d))
                  }
                }
                var u = z.getNextAudioFrame();
                u && U.decodeChunk(u)
              }
            }

            function Fe(e) {
              var t = Math.floor(performance.now() / 1e3);
              return t !== e.value && (e.value = t, !0)
            }

            function xe(e, t, n, r) {
              if (q.frameRendered(e, t, n, r), Fe(ge)) {
                var i = q.getFrameStats().parts, a = "Frame Stats";
                if (i.length > 0) {
                  a += " - " + i.join(" | ");
                  var o = P ? P.getTimeLag() : 0;
                  o > 0 && (a += " | Audio Lag: " + (1e3 * o).toFixed(1) + "ms"), Math.abs(_e) > 10 && Math.abs(_e - be) > 5 && (a += " | Natural Drift: " + _e.toFixed(1) + "ms", be = _e)
                } else a += " - No frames rendered in last second";
                v.debugEnabled() && v.debug(a)
              }
            }

            function ke() {
              var e = performance.now();
              return e - he > 1e3 && function (e) {
                var t = q.getFrameStats().avSyncDiff, n = P ? P.getTimeLag() : 0;
                _e = t - 1e3 * n, he = e
              }(e), (K.getTargetTime() + Be()) / 1e6
            }

            function Be() {
              return j
            }

            function He(e) {
              var t = e - j;
              j = e, v.debugEnabled() && v.debug("Timing: adjust target time offset to abs " + (j / 1e6).toFixed(3) + ", delta " + (t / 1e6).toFixed(3)), P && P.externalSyncTimeUpdate(e, t)
            }

            function Ge() {
              var e = K.getStateInSeconds(), t = e.lastRenderedFrameTimestamp - e.firstDecodeFrameTimestamp,
                n = e.lastReceivedFrameTimestamp - e.firstDecodeFrameTimestamp, r = 0 === n ? 0 : n - e.currentTime,
                i = K.getTargetTimeInSeconds(), o = i + j / 1e6 - e.currentTime - B / 1e6;
              return function (e, t) {
                var n = 1e6 * (e - t), r = !1;
                n > 0 && (se = 0 === se ? n : Math.min(se, n), de = Math.max(de, n), ue = Math.max(ue, n), v.detailEnabled() && v.detail("Timing: offset " + ((se - j) / 1e6).toFixed(3) + " " + ((de - j) / 1e6).toFixed(3) + " " + (j / 1e6).toFixed(3)), ue > j ? (He(ue), r = !0) : performance.now() > ce && (r = !0, de + J < j && (He(j - J), ue = j)), r && (ce = performance.now() + 5e3, se = 0, de = 0))
              }(n, i), {
                currentTime: e.currentTime,
                targetTime: i,
                targetTimeOffset: j,
                bufferStart: t,
                bufferEnd: n,
                bufferDelay: r,
                timeLag: o,
                playbackRate: 1,
                index: a,
                paused: F,
                started: O
              }
            }

            function Ve(e, t) {
              X || (X = {error: e, type: t}, $ = !0)
            }

            function We() {
              X = null, $ = !1, Z = !1
            }

            return v.debugEnabled() && v.debug("init"), Te(), A = n, S = i.clientWidth, y = i.clientHeight, (T = document.createElement("canvas")).id = A, T.width = S, T.height = y, T.style.width = S + "px", T.style.height = y + "px", R = {
              classic: {start: .6},
              fastadaptive: {start: .3 - .075},
              balancedadaptive: {start: .375}
            }[h].start, B = .5 !== _.start ? _.start : R, B = 1e6 * Math.max(.1, B), v.debugEnabled() && v.debug("latencyControlMode: " + h), v.debugEnabled() && v.debug("bufferGoalStart: " + R), v.debugEnabled() && v.debug("tweaksBuffer.start: " + _.start + " (" + (.5 !== _.start ? "custom" : "default") + ")"), v.debugEnabled() && v.debug("bufferTimeUs: " + B + " (max of bufferGoalStart and tweaksBuffer.start (custom))"), g && (Ae(), Se(), ye(), Re()), i.appendChild(T), {
              destroy: function () {
                v.debugEnabled() && v.debug("destroy"), Te(), q.destroy(), ve(), Ie(), Oe(), Ce(), T && T.parentNode === i && i.removeChild(T), T = null
              }, play: function (e) {
                F && (v.debugEnabled() && v.debug("onPlay"), (!e || e.data && !e.data.buffer) && (D || Ae(), U || Se(), w || ye(), P || Re()), v.debugEnabled() && !te && (te = setInterval((() => {
                  var e = Ge();
                  v.debug("Timing  CC: " + e.currentTime.toFixed(3) + " TT: " + e.targetTime.toFixed(3) + " BE: " + e.bufferEnd.toFixed(3) + " BD: " + e.bufferDelay.toFixed(3) + " TL: " + e.timeLag.toFixed(3))
                }), 1e3)))
              }, pause: function (e) {
                F || (v.debugEnabled() && v.debug("onPause"), e.data.buffer || (Ue(), We(), Oe(), Ce(), ve(), Ie(), G = null, K.reset(), z.clearBuffers(), Q.clearBuffers(), Te()), te && (clearInterval(te), te = void 0))
              }, setVolume: function (e) {
                b = e, P ? P.setVolume(b) : t.emit(r.VOLUME_CHANGE, {volume: b, muted: o})
              }, setMute: Ne, setUnmute: function () {
                De(!1)
              }, addStreamFragment: function (e) {
                var t, n, r, i;
                t = e.data.fragment, n = e.data.type, r = function (e, t) {
                  var n = Number(e.time);
                  if (("aac" === t && "Audio" === G || "avc" === t) && e.flagsParsed && !e.flagsParsed.IsCodecConfig) {
                    if (Y) {
                      var r = isNaN(e.startDelay) ? 0 : Math.max(0, e.startDelay), i = Ge(),
                        a = i ? 1e6 * i.timeLag + 1 * B - 1e6 * i.bufferDelay : 0;
                      !isNaN(V) && W ? (Me(n + r + V - W - a), Y = !1) : (Me(n + r), Y = !1), ue = 0, ce = performance.now() + 5e3
                    }
                    W = n
                  }
                  n = isNaN(V) ? -1 : Math.max(0, n - V);
                  var o = ++fe, s = {
                    payloadUnit: e.payload,
                    dtsUs: n,
                    timestamp: n,
                    pto: e.pto || 0,
                    isCodecConfig: e.flagsParsed && e.flagsParsed.IsCodecConfig,
                    isGopCache: e.flagsParsed && e.flagsParsed.IsGopCache,
                    normalized: !1,
                    frameId: o
                  };
                  return "avc" === t && (s.isKeyframe = e.flagsParsed && e.flagsParsed.IsKeyframe), s
                }(t, n), i = r.dtsUs, r.isCodecConfig || r.isGopCache || q.trackFrame(r.frameId, r.timestamp, "avc" === n ? "video" : "audio", r.timestamp), "avc" === n ? (r.isGopCache && re++, z.appendVideoFragment(r), F && "Video" === G && r.isKeyframe ? null !== (i = z.prepareBuffers()) && (K.setFirstDecodeFrameTimestamp(i), K.setLastReceivedVideoFrameTimestamp(i, !0), we(), v.debugEnabled() && v.debug("onReady")) : r.isCodecConfig || r.isGopCache || K.setLastReceivedVideoFrameTimestamp(i)) : "aac" === n && (r.isGopCache ? oe++ : (z.appendAudioFragment(r), F && "Audio" === G && !r.isCodecConfig ? null !== (i = z.prepareBuffers()) && (K.setFirstDecodeFrameTimestamp(i), K.setLastReceivedAudioFrameTimestamp(i, !0), we(), v.debugEnabled() && v.debug("onReady")) : r.isCodecConfig || r.isGopCache || K.setLastReceivedAudioFrameTimestamp(i))), O && Le()
              }, addStreamInfo: function (e) {
                Y = !0, function (e) {
                  G = e.haveVideo ? "Video" : "Audio", K.setReferenceType(G), z.setReferenceType(G), Q.setReferenceType(G);
                  var t;
                  t = e.haveVideo && e.haveAudio ? "Audio+Video" : e.haveVideo ? "Video-only" : "Audio-only", v.debugEnabled() && v.debug("Stream type: " + t + ", reference: " + G)
                }(e.data.streamInfo)
              }, addWtMetaData: function (e) {
                if (!0 === Y || isNaN(V)) v.debugEnabled() && v.debug(e.data.onMetaData.referenceTime); else {
                  var n = (e.data.onMetaData.originalMetadaTime - V) / 1e6;
                  v.debugEnabled() && v.debug("adjustedTime: " + n), e.data.onMetaData.streamTime = n, t.emit(r.ADJUSTED_META_DATA, e.data)
                }
              }, addGopCacheData: function (e) {
                v.debugEnabled() && v.debug("GOP Cache: " + JSON.stringify(e.data)), ne = e.data.videoframes, ae = e.data.audioframes
              }, getVideoElement: function () {
                return T
              }, getMoqPayload: Ge, recoverFromError: function (e) {
                if (!X || !e) return v.debugEnabled() && v.debug("No matching error to recover from"), !1;
                var t = "video" === X.type, n = "audio" === X.type, r = t ? D : U;
                return r ? t && !M || n && !L ? (v.debugEnabled() && v.debug("Decoder is not configured, skipping recovery"), !1) : r.isBeingConfigured() ? (v.debugEnabled() && v.debug("Decoder is being configured, skipping recovery"), !1) : (Z = !0, r.configureDecoder(), We(), !0) : (v.debugEnabled() && v.debug("No decoder available for recovery"), !1)
              }, getLastError: function () {
                return X
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9467: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        return {
          create: function (t, n) {
            var r = e.create("MoQRenderQueue" + (n ? "-" + n : "")), i = [], a = [], o = ["Audio", "Video"], s = null,
              d = null, u = null, c = !1;

            function l() {
              for (; i.length;) i.shift().close();
              for (; a.length;) a.shift().frame.close();
              d && (d.close(), d = null), u && (u.frame.close(), u = null), s = null, c = !1
            }

            function f() {
              return s
            }

            return r.debugEnabled() && r.debug("init"), {
              destroy: function () {
                r.debugEnabled() && r.debug("destroying"), l()
              }, setReferenceType: function (e) {
                -1 !== o.indexOf(e) && (s = e)
              }, getReferenceType: f, getNextVideoFrame: function () {
                return 0 === i.length ? null : i.shift()
              }, getNextAudioFrame: function () {
                return 0 === a.length ? null : a.shift()
              }, getNextVideoFrameByTimestamp: function (e) {
                return i.length && i[0].timestamp <= e ? i.shift() : null
              }, getNextAudioFrameByTimestamp: function (e) {
                return a.length && a[0].timestamp <= e ? a.shift() : null
              }, getNextTimestamp: function () {
                var e, t = null;
                for (e = 0; e < i.length; e++) i[e].isCodecConfig || i[e].timestamp >= 0 && (!t || i[e].timestamp < t) && (t = i[e].timestamp);
                for (e = 0; e < a.length; e++) a[e].timestamp >= 0 && (!t || a[e].timestamp < t) && (t = a[e].timestamp);
                return t
              }, getLastTimestamp: function () {
                var e = null;
                return i.length && (e = i[i.length - 1].timestamp), a.length && (!e || a[a.length - 1].timestamp > e) && (e = a[a.length - 1].timestamp), e
              }, appendVideoFragment: function (e) {
                i.length, i.push(e)
              }, appendAudioFragment: function (e, t, n) {
                a.length, a.push({frame: e, timestamp: t, frameId: n})
              }, getVideoBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = i;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, getAudioBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = a;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, getBufferedTimeRange: function () {
                var e = {start: 0, end: 0, length: 0}, t = "Audio" === s ? a : i;
                if (t.length > 0) {
                  var n = t[0].timestamp, r = t[t.length - 1].timestamp;
                  e.start = n, e.end = r, e.length = t.length
                }
                return e
              }, setPlaybackRate: function () {
              }, reset: function () {
                l()
              }, clearBuffers: l, ready: function () {
                return null !== f() && c
              }, getVideoBuffer: function () {
                return i
              }, getAudioBuffer: function () {
                return a
              }, getVideoBufferLength: function () {
                return i.length
              }, getAudioBufferLength: function () {
                return a.length
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6636: function (e, t, n) {
      var r, i;
      r = [n(4556), n(492), n(6637), n(8333), n(1520), n(9623), n(738)], void 0 === (i = function (e, t, n, r, i, a, o) {
        return {
          create: function (e) {
            var s, d = r.create("MoQStatsCreator"), u = [{
              type: i.APPLICATION_STATE_CHANGE, listener: function (r) {
                switch (r.data.state) {
                  case t.PAUSED:
                    E(), n.remove({target: e, listeners: c})
                }
              }
            }, {
              type: i.CONFIG, listener: function () {
              }
            }], c = [{
              type: a.TIME_UPDATE, listener: function (e) {
                s.currentTime = e.data.currentTime, s.playbackRate = e.data.playbackRate, s.playedStart = 0, s.playedEnd = e.data.currentTime, s.bufferStart = e.data.bufferStart, s.bufferEnd = e.data.bufferEnd, s.duration = e.data.bufferEnd - e.data.bufferStart, s.bufferDelay = e.data.bufferDelay, s.timeLag = e.data.timeLag, f()
              }
            }], l = [{
              type: i.STREAM_INFO, listener: function () {
                d.debugEnabled() && d.debug("onStreamInfo"), n.add({target: e, listeners: c})
              }
            }];

            function f() {
              e.emit(o.PRIVATE_MEDIA_STATS, {
                mediaStats: {
                  bufferStart: s.bufferStart,
                  bufferEnd: s.bufferEnd,
                  bufferDelay: s.bufferDelay,
                  timeLag: s.timeLag,
                  bufferUpdate: s.bufferUpdate,
                  duration: s.duration,
                  currentTime: s.currentTime,
                  playbackRate: s.playbackRate,
                  playedStart: s.playedStart,
                  playedEnd: s.playedEnd
                }
              }), e.emit(o.PUBLIC_MEDIA_STATS, {
                mediaStats: {
                  bufferStart: s.bufferStart,
                  bufferEnd: s.bufferEnd,
                  bufferDelay: s.bufferDelay,
                  bufferUpdate: s.bufferUpdate,
                  duration: s.duration,
                  currentTime: s.currentTime,
                  playbackRate: s.playbackRate,
                  playedStart: s.playedStart,
                  playedEnd: s.playedEnd
                }
              })
            }

            function E() {
              s = {
                bufferStart: 0,
                bufferEnd: 0,
                bufferDelay: 0,
                bufferUpdate: 0,
                duration: 0,
                currentTime: 0,
                playbackRate: 1,
                playedStart: 0,
                playedEnd: 0
              }, f()
            }

            return E(), n.add({target: e, listeners: u}), n.add({target: e, listeners: l}), {
              destroy: function () {
                n.remove({target: e, listeners: u}), n.add({target: e, listeners: l})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6415: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        return {
          create: function () {
            var t, n = e.create("TimeControl"), r = ["Audio", "Video"], i = null;

            function a() {
              return i
            }

            function o(e) {
              if (!e) {
                if (!i) return 0;
                e = i
              }
              var n = (t["lastRendered" + e + "FrameTimestamp"] - t["firstRendered" + e + "FrameTimestamp"]) / 1e6;
              return isNaN(n) ? 0 : n
            }

            function s() {
              return t.firstDecodeFrameTimestamp + 1e3 * (performance.now() - t.firstDecodeFrameTimestampReal)
            }

            function d(e) {
              if (!e) {
                if (!i) return 0;
                e = i
              }
              return Math.abs(t["lastReceived" + e + "FrameTimestamp"] - t["lastRendered" + e + "FrameTimestamp"]) / 1e6
            }

            function u() {
              t = {
                firstRenderedAudioFrameTimestampReal: NaN,
                firstRenderedAudioFrameTimestamp: NaN,
                lastRenderedAudioFrameTimestamp: NaN,
                firstReceivedAudioFrameTimestampReal: NaN,
                firstReceivedAudioFrameTimestamp: NaN,
                lastReceivedAudioFrameTimestamp: NaN,
                firstRenderedVideoFrameTimestampReal: NaN,
                firstRenderedVideoFrameTimestamp: NaN,
                lastRenderedVideoFrameTimestamp: NaN,
                firstReceivedVideoFrameTimestampReal: NaN,
                firstReceivedVideoFrameTimestamp: NaN,
                lastReceivedVideoFrameTimestamp: NaN,
                firstDecodeFrameTimestamp: NaN,
                firstDecodeFrameTimestampReal: NaN
              }, i = null
            }

            function c() {
              return {
                firstRenderedFrameTimestampReal: t["firstRendered" + i + "FrameTimestampReal"] || 0,
                firstRenderedFrameTimestamp: t["firstRendered" + i + "FrameTimestamp"] || 0,
                lastRenderedFrameTimestamp: t["lastRendered" + i + "FrameTimestamp"] || 0,
                firstReceivedFrameTimestampReal: t["firstReceived" + i + "FrameTimestampReal"] || 0,
                firstReceivedFrameTimestamp: t["firstReceived" + i + "FrameTimestamp"] || 0,
                lastReceivedFrameTimestamp: t["lastReceived" + i + "FrameTimestamp"] || 0,
                firstRenderedAudioFrameTimestampReal: t.firstRenderedAudioFrameTimestampReal,
                firstRenderedAudioFrameTimestamp: t.firstRenderedAudioFrameTimestamp,
                lastRenderedAudioFrameTimestamp: t.lastRenderedAudioFrameTimestamp,
                firstReceivedAudioFrameTimestampReal: t.firstReceivedAudioFrameTimestampReal,
                firstReceivedAudioFrameTimestamp: t.firstReceivedAudioFrameTimestamp,
                lastReceivedAudioFrameTimestamp: t.lastReceivedAudioFrameTimestamp,
                firstRenderedVideoFrameTimestampReal: t.firstRenderedVideoFrameTimestampReal,
                firstRenderedVideoFrameTimestamp: t.firstRenderedVideoFrameTimestamp,
                lastRenderedVideoFrameTimestamp: t.lastRenderedVideoFrameTimestamp,
                firstReceivedVideoFrameTimestampReal: t.firstReceivedVideoFrameTimestampReal,
                firstReceivedVideoFrameTimestamp: t.firstReceivedVideoFrameTimestamp,
                lastReceivedVideoFrameTimestamp: t.lastReceivedVideoFrameTimestamp,
                firstDecodeFrameTimestamp: t.firstDecodeFrameTimestamp,
                firstDecodeFrameTimestampReal: t.firstDecodeFrameTimestampReal,
                currentTime: o(),
                timeOffset: d(),
                type: a()
              }
            }

            return u(), n.debugEnabled() && n.debug("TimeControl initialized"), {
              setLastRenderedAudioFrameTimestamp: function (e) {
                isNaN(t.firstRenderedAudioFrameTimestamp) && (t.firstRenderedAudioFrameTimestamp = e), t.lastRenderedAudioFrameTimestamp = e, isNaN(t.firstRenderedAudioFrameTimestampReal) && (t.firstRenderedAudioFrameTimestampReal = performance.now())
              }, getLastRenderedAudioFrameTimestamp: function () {
                return t.lastRenderedAudioFrameTimestamp
              }, setLastReceivedAudioFrameTimestamp: function (e, n) {
                (n || isNaN(t.firstReceivedAudioFrameTimestamp)) && (t.firstReceivedAudioFrameTimestamp = e), t.lastReceivedAudioFrameTimestamp = e, (n || isNaN(t.firstReceivedAudioFrameTimestampReal)) && (t.firstReceivedAudioFrameTimestampReal = performance.now())
              }, getLastReceivedAudioFrameTimestamp: function () {
                return t.lastReceivedAudioFrameTimestamp
              }, setLastRenderedVideoFrameTimestamp: function (e) {
                isNaN(t.firstRenderedVideoFrameTimestamp) && (t.firstRenderedVideoFrameTimestamp = e), t.lastRenderedVideoFrameTimestamp = e, isNaN(t.firstRenderedVideoFrameTimestampReal) && (t.firstRenderedVideoFrameTimestampReal = performance.now())
              }, getLastRenderedVideoFrameTimestamp: function () {
                return t.lastRenderedVideoFrameTimestamp
              }, setLastReceivedVideoFrameTimestamp: function (e, n) {
                (n || isNaN(t.firstReceivedVideoFrameTimestamp)) && (t.firstReceivedVideoFrameTimestamp = e), t.lastReceivedVideoFrameTimestamp = e, (n || isNaN(t.firstReceivedVideoFrameTimestampReal)) && (t.firstReceivedVideoFrameTimestampReal = performance.now())
              }, getLastReceivedVideoFrameTimestamp: function () {
                return t.lastReceivedVideoFrameTimestamp
              }, setFirstDecodeFrameTimestamp: function (e, n) {
                (n || isNaN(t.firstDecodeFrameTimestamp)) && (t.firstDecodeFrameTimestamp = e), (n || isNaN(t.firstDecodeFrameTimestampReal)) && (t.firstDecodeFrameTimestampReal = performance.now())
              }, setReferenceType: function (e) {
                -1 !== r.indexOf(e) && (i = e)
              }, getReferenceType: a, getCurrentTime: o, getTargetTime: s, getTargetTimeInSeconds: function () {
                return Math.round(s() / 1e6 * 1e3) / 1e3
              }, getTimeOffset: d, getState: c, getStateInSeconds: function () {
                var e = c();
                for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && "number" == typeof e[t] && -1 !== t.indexOf("Timestamp") && (e[t] /= 1e6, e[t] = Math.round(1e3 * e[t]) / 1e3);
                return e
              }, reset: u
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3038: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqControl.";
        return {
          BASE: e,
          CREATE_VIDEO: e + "createVideo",
          DESTROY_VIDEO: e + "destroyVideo",
          VIDEO_SOURCE: e + "videoSource",
          UPDATE_SOURCE: e + "updateSource",
          PLAY: e + "play",
          PAUSE: e + "pause",
          SEEK: e + "seek",
          MUTE: e + "mute",
          UNMUTE: e + "unmute",
          SET_VOLUME: e + "volume",
          SET_RATE: e + "playbackRate"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 907: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqHandler.";
        return {
          BASE: e,
          LOAD_START: e + "loadstart",
          PROGRESS: e + "progress",
          SUSPEND: e + "suspend",
          ABORT: e + "abort",
          EMPTIED: e + "emptied",
          STALLED: e + "stalled",
          PLAY: e + "play",
          PAUSE: e + "pause",
          LOADED_META_DATA: e + "loadedmetadata",
          LOADED_DATA: e + "loadeddata",
          WAITING: e + "waiting",
          ERROR: e + "error",
          PLAYING: e + "playing",
          CAN_PLAY: e + "canplay",
          CAN_PLAY_THROUGH: e + "canplaythrough",
          SEEKING: e + "seeking",
          SEEKED: e + "seeked",
          TIME_UPDATE: e + "timeupdate",
          ENDED: e + "ended",
          RATE_CHANGE: e + "ratechange",
          DURATION_CHANGE: e + "durationchange",
          VOLUME_CHANGE: e + "volumechange",
          QUALITY_UPDATE: e + "qualityupdate",
          VIDEO_SOURCE: e + "videoSource",
          ELEMENT_CREATED: e + "elementCreated",
          PLAY_START_SUCCESS: e + "playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: e + "playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: e + "playStartAbortError",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden",
          VIDEO_DECODER_CONFIGURED: e + "videoDecoderConfigured",
          AUDIO_DECODER_CONFIGURED: e + "audioDecoderConfigured",
          VIDEO_DECODE_ERROR: e + "videoDecodeError",
          AUDIO_DECODE_ERROR: e + "audioDecodeError",
          VIDEO_DECODER_STARTUP_ERROR: e + "videoDecoderStartupError",
          AUDIO_DECODER_STARTUP_ERROR: e + "audioDecoderStartupError",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_TIMEOUT: e + "updateSourceTimeout",
          MEDIA_ERROR_RECOVERED: e + "recovered",
          ACTIVE_VIDEO_ELEMENT_CHANGE: e + "activeVideoElementChange",
          SWITCH_STREAM: e + "switchStream",
          TIME_OFFSET: e + "timeOffset",
          ADJUSTED_META_DATA: e + "adjustedMetaData"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1520: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqManager.";
        return {
          BASE: e,
          CONFIG: e + "config",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          WEB_TRANSPORT_META_DATA: e + "wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: e + "wtGOPCache",
          APPLICATION_STATE_CHANGE: e + "applicationStateChange",
          STARTUP_STATS_ADDED: e + "startupStatsAdded",
          STARTUP_STATS_COMPLETED: e + "startupStatsCompleted",
          DOCUMENT_VISIBLE: e + "documentVisible",
          DOCUMENT_HIDDEN: e + "documentHidden",
          NETWORK_ONLINE: e + "networkOnline",
          NETWORK_OFFLINE: e + "networkOffline",
          SWITCH_STREAM_INIT: e + "switchStreamInit",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          UPDATE_SOURCE_INIT: e + "updateSourceInit",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          BUFFER_TWEAKS_CREATED: e + "bufferTweaksCreated",
          MEDIA_ERROR: e + "mediaError",
          MEDIA_ERROR_RECOVER: e + "mediaErrorRecover",
          MEDIA_ERROR_RECOVERED: e + "mediaErrorRecovered",
          MEDIA_ERROR_QUEUED: e + "mediaErrorQueued",
          MEDIA_ERROR_UNQUEUED: e + "mediaErrorUnqueued",
          BUFFER_GOAL_STATS: e + "bufferGoalStats"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 3701: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqPlaybackControl.";
        return {BASE: e, PLAYBACK_STARTED: e + "playbackStarted", BUFFERING: e + "buffering"}
      }.apply(t, [])) || (e.exports = n)
    }, 3242: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqPlayback.";
        return {
          BASE: e,
          LOAD_START: e + "loadstart",
          PROGRESS: e + "progress",
          SUSPEND: e + "suspend",
          ABORT: e + "abort",
          EMPTIED: e + "emptied",
          STALLED: e + "stalled",
          PLAY: e + "play",
          PAUSE: e + "pause",
          LOADED_META_DATA: e + "loadedmetadata",
          LOADED_DATA: e + "loadeddata",
          WAITING: e + "waiting",
          MEDIA_ERROR: e + "mediaerror",
          MEDIA_ERROR_RECOVER: e + "mediaerrorrecover",
          MEDIA_ERROR_RECOVERED: e + "mediaerrorrecovered",
          PLAYING: e + "playing",
          CAN_PLAY: e + "canplay",
          CAN_PLAY_THROUGH: e + "canplaythrough",
          SEEKING: e + "seeking",
          SEEKED: e + "seeked",
          TIME_UPDATE: e + "timeupdate",
          ENDED: e + "ended",
          RATE_CHANGE: e + "ratechange",
          DURATION_CHANGE: e + "durationchange",
          VOLUME_CHANGE: e + "volumechange",
          ELEMENT_CREATED: e + "elementCreated",
          QUALITY_STATS: e + "qualitystats",
          PLAY_STATS: e + "playStats",
          MEDIA_ERROR_RECOVER_STATS: e + "mediaErrorRecoverStats",
          FRAME_DROP: e + "framedrop",
          PLAYBACK_FINISHED: e + "playbackFinished",
          PLAYBACK_ERROR: e + "playbackError",
          PLAYBACK_STARTED: e + "playbackStarted",
          PLAYBACK_SUSPENDED: e + "playbackSuspended",
          BUFFERING: e + "buffering",
          PLAY_START_SUCCESS: e + "playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: e + "playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: e + "playStartAbortError",
          VIEWPORT_VISIBLE: e + "viewportvisible",
          VIEWPORT_HIDDEN: e + "viewporthidden",
          ELEMENTS_UPDATED: e + "elementsUpdated",
          TIME_OFFSET: e + "timeOffset",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_TIMEOUT: e + "updateSourceTimeout",
          ACTIVE_VIDEO_ELEMENT_CHANGE: e + "activeVideoElementChange",
          SOURCE_ENDED: e + "sourceEnded",
          SWITCH_STREAM: e + "switchStream",
          ERROR: e + "error",
          FRAME_CORRUPTED: e + "frameCorrupted",
          RECOVER: e + "recover",
          RECOVERED: e + "recovered",
          ADJUSTED_META_DATA: e + "adjustedMetaData"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9623: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "moqProxy.",
          LOAD_START: "moqProxy.loadstart",
          PROGRESS: "moqProxy.progress",
          SUSPEND: "moqProxy.suspend",
          ABORT: "moqProxy.abort",
          EMPTIED: "moqProxy.emptied",
          STALLED: "moqProxy.stalled",
          PLAY: "moqProxy.play",
          PAUSE: "moqProxy.pause",
          LOADED_META_DATA: "moqProxy.loadedmetadata",
          LOADED_DATA: "moqProxy.loadeddata",
          WAITING: "moqProxy.waiting",
          ERROR: "moqProxy.error",
          VIDEO_DECODER_CONFIGURED: "moqProxy.videoDecoderConfigured",
          AUDIO_DECODER_CONFIGURED: "moqProxy.audioDecoderConfigured",
          VIDEO_DECODE_ERROR: "moqProxy.videoDecodeError",
          AUDIO_DECODE_ERROR: "moqProxy.audioDecodeError",
          VIDEO_DECODER_STARTUP_ERROR: "moqProxy.videoDecoderStartupError",
          AUDIO_DECODER_STARTUP_ERROR: "moqProxy.audioDecoderStartupError",
          PLAYING: "moqProxy.playing",
          CAN_PLAY: "moqProxy.canplay",
          CAN_PLAY_THROUGH: "moqProxy.canplaythrough",
          SEEKING: "moqProxy.seeking",
          SEEKED: "moqProxy.seeked",
          TIME_UPDATE: "moqProxy.timeupdate",
          ENDED: "moqProxy.ended",
          RATE_CHANGE: "moqProxy.ratechange",
          DURATION_CHANGE: "moqProxy.durationchange",
          VOLUME_CHANGE: "moqProxy.volumechange",
          QUALITY_UPDATE: "moqProxy.qualityupdate",
          ELEMENT_CREATED: "moqProxy.elementCreated",
          PLAY_START_SUCCESS: "moqProxy.playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: "moqProxy.playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: "moqProxy.playStartAbortError",
          VIEWPORT_VISIBLE: "moqProxy.viewportvisible",
          VIEWPORT_HIDDEN: "moqProxy.viewporthidden",
          WEB_TRANSPORT_META_DATA: "moqProxy.wtMetaData",
          TIME_OFFSET: "moqProxy.timeOffset",
          ADJUSTED_META_DATA: "moqProxy.adjustedMetaData"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 738: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "moqStatsCreator.";
        return {
          BASE: e,
          PUBLIC_MEDIA_STATS: e + "publicMediaStats",
          PRIVATE_MEDIA_STATS: e + "privateMediaStats",
          MEDIA_ERROR_RECOVER_STATS: e + "mediaErrorRecoverStats"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4286: function (e) {
      var t;
      self, t = () => (() => {
        "use strict";
        var e = {
          d: (t, n) => {
            for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {enumerable: !0, get: n[r]})
          }, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: e => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
          }
        }, t = {};
        e.r(t), e.d(t, {AudioDecoderModule: () => s});
        var n = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3];

        function r(e) {
          if (e.byteLength < 2) throw new Error("Insufficient MP4A config length");
          var t = (248 & e[0]) >> 3, r = ((7 & e[0]) << 1) + ((128 & e[1]) >> 7);
          if (r < 0 || r >= n.length) throw new Error("Invalid sampleRateIdc ".concat(r));
          var i = (120 & e[1]) >> 3;
          if (i <= 0) throw new Error("Invalid AAC config: numberOfChannels=".concat(i));
          return {profileIdc: t, sampleRate: n[r], numberOfChannels: i}
        }

        var i, a = (i = function (e, t) {
          return (i = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
          })(e, t)
        }, function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

          function n() {
            this.constructor = e
          }

          i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
        }), o = function () {
          return (o = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
          }).apply(this, arguments)
        }, s = function (e) {
          function t() {
            var t = e.call(this) || this;
            return t._isConfigured = !1, t._decConfig = null, t._timestampQueue = [], t._frameIdQueue = [], t._isBeingConfigured = !1, t._pendingDecoder = null, t._onAudioOutput = function (e) {
              if (t._timestampQueue.length) {
                var n, r = (n = t._timestampQueue).length ? n.shift() : NaN, i = function (e) {
                  if (e.length) return e.shift()
                }(t._frameIdQueue);
                t.emit("frameDecoded", e, r, i)
              } else e.close()
            }, t._onAudioError = function (e) {
              t.emit("decodeError", e)
            }, t._decoder = new AudioDecoder({output: t._onAudioOutput.bind(t), error: t._onAudioError.bind(t)}), t
          }

          return a(t, e), t.prototype.isConfigured = function () {
            return this._isConfigured
          }, t.prototype.isBeingConfigured = function () {
            return this._isBeingConfigured
          }, t.prototype.configureDecoder = function (e) {
            var t, n = this;
            if (!this._isBeingConfigured) if (void 0 !== e || null !== this._decConfig) {
              this._isBeingConfigured = !0, this._pendingDecoder = new AudioDecoder(o({}, this._getAudioDecoderConstructorOptions()));
              var i = e && e.payloadUnit ? r(e.payloadUnit) : this._decConfig, a = {
                codec: "mp4a.40.2",
                numberOfChannels: i.numberOfChannels,
                sampleRate: i.sampleRate,
                description: e && e.payloadUnit && e.isCodecConfig ? e.payloadUnit : null === (t = this._decConfig) || void 0 === t ? void 0 : t.description
              };
              AudioDecoder.isConfigSupported(a).then((function (e) {
                return e.supported ? (n._pendingDecoder.configure(a), "configured" !== n._pendingDecoder.state ? (n._pendingDecoder = null, void n.emit("decodeError", new Error("AudioDecoder configure failed."))) : ("closed" !== n._decoder.state && n._decoder.close(), n._decoder = n._pendingDecoder, n._isBeingConfigured = !1, n._pendingDecoder = null, n._isConfigured = !0, n._decConfig = a, void n.emit("configured", a))) : (n._pendingDecoder = null, void n.emit("decodeError", new Error("AudioDecoder config not supported.")))
              })).catch((function (e) {
                n._pendingDecoder = null, n.emit("decodeError", e)
              }))
            } else this.emit("decodeError", new Error("No chunk or config."))
          }, t.prototype.decodeChunk = function (e) {
            var t = this, n = e.payloadUnit, i = e.dtsUs, a = e.isCodecConfig, s = e.frameId;
            if (this._decoder) {
              if (a && !this._isBeingConfigured) {
                var d = r(n), u = {
                  codec: "mp4a.40.2",
                  numberOfChannels: d.numberOfChannels,
                  sampleRate: d.sampleRate,
                  description: n
                };
                return this._isBeingConfigured = !0, this._pendingDecoder = new AudioDecoder(o({}, this._getAudioDecoderConstructorOptions())), void AudioDecoder.isConfigSupported(u).then((function (e) {
                  return e.supported ? (t._pendingDecoder.configure(u), "configured" !== t._pendingDecoder.state ? (t._pendingDecoder = null, void t.emit("decodeError", new Error("AudioDecoder configure failed."))) : (t._decoder && t._decoder.close(), t._decoder = t._pendingDecoder, t._isBeingConfigured = !1, t._pendingDecoder = null, t._isConfigured = !0, t._decConfig = u, void t.emit("configured", u))) : (t._pendingDecoder = null, void t.emit("decodeError", new Error("AudioDecoder config not supported: ".concat(JSON.stringify(u)))))
                })).catch((function (e) {
                  t._pendingDecoder = null, t.emit("decodeError", e)
                }))
              }
              if (this._isConfigured) if (this._isBeingConfigured) this.trace("Skipping audio frame because it is after the configuration frame while being configured"); else {
                var c = new EncodedAudioChunk({data: n, timestamp: i, type: "key"});
                this._timestampQueue.push(i), this._frameIdQueue.push(s), "configured" === this._decoder.state ? this._decoder.decode(c) : "closed" === this._decoder.state && this._isConfigured ? this.emit("decodeError", new Error("AudioDecoder closed.")) : this.emit("decodeError", new Error("AudioDecoder not configured or configuration changed after startup."))
              }
            }
          }, t.prototype._getAudioDecoderConstructorOptions = function () {
            return {output: this._onAudioOutput.bind(this), error: this._onAudioError.bind(this)}
          }, Object.defineProperty(t.prototype, "config", {
            get: function () {
              return this._isConfigured ? this._decConfig : null
            }, enumerable: !1, configurable: !0
          }), t.prototype.trace = function (e) {
            this.emit("trace", e)
          }, t.prototype.close = function () {
            this._decoder && "closed" !== this._decoder.state && this._decoder.close(), this.emit("closed")
          }, t
        }(function () {
          function e() {
            this.listeners = new Map
          }

          return e.prototype.on = function (e, t) {
            this.listeners.has(e) || this.listeners.set(e, []), this.listeners.get(e).push(t)
          }, e.prototype.emit = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            for (var r = 0, i = this.listeners.get(e) || []; r < i.length; r++) i[r].apply(void 0, t)
          }, e
        }());
        return t
      })(), e.exports = t()
    }, 7894: function (e) {
      var t;
      self, t = () => (() => {
        "use strict";
        var e = {
          d: (t, n) => {
            for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {enumerable: !0, get: n[r]})
          }, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: e => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
          }
        }, t = {};
        e.r(t), e.d(t, {AudioRenderer: () => o});
        var n, r, i = (n = function (e, t) {
          return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
          })(e, t)
        }, function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

          function r() {
            this.constructor = e
          }

          n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r)
        });
        !function (e) {
          e.RUNNING = "running", e.SUSPENDED = "suspended", e.CLOSED = "closed"
        }(r || (r = {}));
        var a = function (e) {
          function t(t, n, r) {
            var i = e.call(this, n) || this;
            return i.code = r, i.name = t || "AudioError", i.code = r, i
          }

          return i(t, e), t
        }(Error), o = function (e) {
          function t(t) {
            void 0 === t && (t = {});
            var n = e.call(this) || this;
            for (var i in n._clockRefUs = NaN, n._dtsOffsetUs = NaN, n._deltaInternalExternalTimeUs = NaN, n._syncTimeDeviationUsArr = [], n._syncTimeDeviationUsMean = NaN, n.SYNC_TIME_DEVIATION_THRESHOLD_US = 5e5, n.SYNC_TIME_DEVIATION_TO_HIGH_US = 5e4, n.SYNC_TIME_DEVIATION_NORMALIZE_US = 1e5, n._nextTimestamp = NaN, n._sourceNodesPending = [], n._state = r.CLOSED, n.SOURCE_NODE_PENDING_CLEAN_TIMEOUT_MS = 5e3, n._sourceNodePendingCleanTimer = void 0, n._allowed = void 0, n._allowedTimer = void 0, n._muted = !1, n._volume = 1, n._timeLag = 0, n._framesRenderedSinceDrop = 0, n._framesDroppedSinceRender = 0, n._currentRenderFrameDistance = 0, n._currentDropFrameDistance = 0, n._renderDropDistanceMax = 0, n._timeLagMaxReached = !1, n._timeLagIncreaseTimeStart = 0, n._timeLagIncreaseTimeEnd = 0, n._timeLagReductionTimeStart = 0, n._timeLagReductionTimeEnd = 0, n._externalSyncTimeSecs = 0, n._lastRenderedTimestampUS = 0, n._blockRenderCount = 0, n._isInRenderBlock = !1, n._lastRenderedDurationUS = 0, n._isInIncreaseBlock = !1, n._increaseBlockCount = 0, n._traceLagHandling = !1, n._fadeInCount = 0, n._fadeOutCount = 0, n._externalSyncTimeDeltaPending = 0, n._config = Object.assign({
              schedulingLatencySecs: .05,
              startTimeoutMs: 100,
              startBufferMs: 500,
              volume: 1,
              muted: !1,
              allowDelayedRendering: !1,
              events: {},
              getExternalSyncTime: function () {
                return -1
              },
              audioLag: {
                maxLagSecs: Number.POSITIVE_INFINITY,
                cooldownLagSecs: .6,
                dropThresholdSecs: Number.POSITIVE_INFINITY,
                renderFrameDistance: 10,
                dropFrameDistance: 6,
                dropMode: "single",
                fadeMode: "all"
              }
            }, t), n._config.events) Object.prototype.hasOwnProperty.call(n._config.events, i) && n.on(i, n._config.events[i]);
            return n._aCtx = new AudioContext({latencyHint: "interactive"}), n._setAudioRenderState(n._aCtx.state), n._aCtx.onstatechange = function () {
              return n._setAudioRenderState(n._aCtx.state)
            }, n._gainNode = n._aCtx.createGain(), n.setVolume(n._config.volume), n.setMute(n._config.muted), n._gainNode.connect(n._aCtx.destination), n
          }

          return i(t, e), t.prototype._setAudioRenderState = function (e) {
            this.trace("state changed to " + e), this._state = e, this.emit("stateChanged", this._state)
          }, t.prototype.renderAudioData = function (e, t, n) {
            var r = this;
            try {
              var i = this._aCtx.currentTime, a = this._config.getExternalSyncTime(), o = this._parseTimestamp(e, t),
                s = e.duration / 1e6;
              if (!o) return void e.close();
              if (Number.isNaN(this._dtsOffsetUs)) {
                this._dtsOffsetUs = o, this._deltaInternalExternalTimeUs = Math.round(1e6 * (i - a)), this._syncTimeDeviationUsArr = [], this._syncTimeDeviationUsMean = NaN, this.trace("delta internal external time us " + this._deltaInternalExternalTimeUs);
                var d = i + this._config.schedulingLatencySecs;
                this._clockRefUs = Math.round(1e6 * d), this.trace("clock ref set to " + this._clockRefUs + ", dts offset " + this._dtsOffsetUs + ", current time " + i + ", external sync time " + a)
              }
              if (i > 0 && a > 0 && !Number.isNaN(this._deltaInternalExternalTimeUs)) {
                if (this._externalSyncTimeSecs ? Math.floor(a) - this._externalSyncTimeSecs > 1 && (this._syncTimeDeviationUsArr.push(this._getSyncTimeDeviationUs()), this._externalSyncTimeSecs = Math.floor(a)) : this._externalSyncTimeSecs = Math.floor(a), 10 === this._syncTimeDeviationUsArr.length) for (this._checkSyncTimeDeviationAfterNormalization(); this._syncTimeDeviationUsArr.length;) this._syncTimeDeviationUsArr.shift();
                this._checkSyncTimeDeviationThresholdReached()
              }
              var u = this._clockRefUs + o - this._dtsOffsetUs, c = u / 1e6 + this._timeLag, l = !1;
              if (this._config.allowDelayedRendering) {
                if (c <= i) {
                  if (this._timeLagIncreaseTimeStart || (this._timeLagIncreaseTimeStart = Date.now()), this._timeLagReductionTimeStart) {
                    var f = (Date.now() - this._timeLagReductionTimeStart) / 1e3;
                    this._timeLagReductionTimeStart = 0, this.trace("time lag reduction time ms " + f.toFixed(2) + ", time lag " + this._timeLag.toFixed(2))
                  }
                  if (!(this._timeLag < this._config.audioLag.maxLagSecs) || this._timeLagMaxReached) return !this._timeLagMaxReached && (this._timeLagMaxReached = !0), this._traceLagHandling && this.trace("decrease, time lag " + this._timeLag.toFixed(2) + ", frames rendered since drop " + this._framesRenderedSinceDrop + ", frames dropped since render " + this._framesDroppedSinceRender), this._timeLag -= s, this.emit("audioLag", "decrease", this._timeLag), e.close(), this._framesRenderedSinceDrop = 0, this._framesDroppedSinceRender++, void (this._timeLag < this._config.audioLag.cooldownLagSecs && (this._timeLagMaxReached = !1));
                  this._timeLag += i - c, c = u / 1e6 + this._timeLag, l = "all" === this._config.audioLag.fadeMode;
                  var E = Math.round(1e6 * c),
                    p = this._lastRenderedTimestampUS > 0 && Math.abs(E - (this._lastRenderedTimestampUS + this._lastRenderedDurationUS)) < 1e3;
                  this._isInIncreaseBlock && !p && this._increaseBlockCount > 0 && (this._traceLagHandling && this.trace("increase block ended with ".concat(this._increaseBlockCount, " chunks (non-consecutive)")), this._isInIncreaseBlock = !1, this._increaseBlockCount = 0), this._isInIncreaseBlock ? this._increaseBlockCount++ : (this._isInIncreaseBlock = !0, this._increaseBlockCount = 1, this._traceLagHandling && this.trace("increase, time lag " + this._timeLag.toFixed(2) + ", frames rendered since drop " + this._framesRenderedSinceDrop + ", frames dropped since render " + this._framesDroppedSinceRender)), this.emit("audioLag", "increase", this._timeLag), this._framesRenderedSinceDrop = 0, this._framesDroppedSinceRender = 0
                } else if (this._timeLag > s && c - s > i + this._config.startBufferMs / 1e3) {
                  if (this._timeLagReductionTimeStart || (this._timeLagReductionTimeStart = Date.now()), this._timeLagIncreaseTimeStart) {
                    var m = (Date.now() - this._timeLagIncreaseTimeStart) / 1e3;
                    this._timeLagIncreaseTimeStart = 0, this.trace("time lag increase duration " + m.toFixed(2) + ", time lag " + this._timeLag.toFixed(2))
                  }
                  this._renderDropDistanceMax || (this._renderDropDistanceMax = this._config.audioLag.renderFrameDistance + this._config.audioLag.dropFrameDistance);
                  var g = ["single", "double", "exponential-low", "exponential-high"];
                  switch (-1 !== g.indexOf(this._config.audioLag.dropMode) ? this._config.audioLag.dropMode : "single") {
                    case g[0]:
                      this._currentDropFrameDistance = this._config.audioLag.dropFrameDistance, this._currentRenderFrameDistance = this._config.audioLag.renderFrameDistance;
                      break;
                    case g[1]:
                      this._currentDropFrameDistance = this._timeLag > this._config.audioLag.dropThresholdSecs || this._config.audioLag.dropThresholdSecs === 1 / 0 ? this._config.audioLag.dropFrameDistance : Math.ceil(this._config.audioLag.dropFrameDistance / 2), this._currentRenderFrameDistance = this._config.audioLag.renderFrameDistance;
                      break;
                    case g[2]:
                      this._currentDropFrameDistance = this._timeLag < this._config.audioLag.dropThresholdSecs && this._config.audioLag.dropThresholdSecs !== 1 / 0 ? Math.ceil(this._config.audioLag.dropFrameDistance * (this._timeLag / this._config.audioLag.dropThresholdSecs)) : this._config.audioLag.dropFrameDistance, this._currentRenderFrameDistance = this._timeLag < this._config.audioLag.dropThresholdSecs && this._config.audioLag.dropThresholdSecs !== 1 / 0 ? this._renderDropDistanceMax - this._currentDropFrameDistance : this._config.audioLag.renderFrameDistance;
                      break;
                    case g[3]:
                      this._currentDropFrameDistance = this._timeLag < this._config.audioLag.dropThresholdSecs && this._config.audioLag.dropThresholdSecs !== 1 / 0 ? Math.ceil(this._config.audioLag.dropFrameDistance * (this._timeLag / this._config.audioLag.dropThresholdSecs)) : this._config.audioLag.dropFrameDistance, this._currentRenderFrameDistance = this._config.audioLag.renderFrameDistance
                  }
                  var b = this._timeLag > this._config.audioLag.dropThresholdSecs,
                    _ = this._framesRenderedSinceDrop + 1 > this._currentRenderFrameDistance && 0 === this._framesDroppedSinceRender,
                    h = 0 === this._framesRenderedSinceDrop && 0 !== this._framesDroppedSinceRender && this._framesDroppedSinceRender + 1 <= this._currentDropFrameDistance,
                    T = b || _ || h,
                    A = b ? "drop threshold not reached" : _ ? "render frame distance " + this._currentRenderFrameDistance + " reached" : "drop frame distance " + this._currentDropFrameDistance + " not reached";
                  if (T) return this._timeLag -= s, this._traceLagHandling && this.trace("decrease, time lag " + this._timeLag.toFixed(2) + ", frames rendered since drop " + this._framesRenderedSinceDrop + ", frames dropped since render " + this._framesDroppedSinceRender + ", reason: " + A), this.emit("audioLag", "decrease", this._timeLag), e.close(), this._framesRenderedSinceDrop = 0, this._framesDroppedSinceRender++, this._isInRenderBlock && this._blockRenderCount > 0 && (this._isInRenderBlock = !1, this._blockRenderCount = 0), this._isInIncreaseBlock && (this._isInIncreaseBlock = !1, this._increaseBlockCount = 0), void (this._timeLag <= s && this._timeLagReductionTimeStart && (f = (Date.now() - this._timeLagReductionTimeStart) / 1e3, this._timeLagReductionTimeStart = 0, this.trace("time lag reduction duration " + f.toFixed(2) + " seconds, time lag " + this._timeLag.toFixed(2))));
                  l = "all" === this._config.audioLag.fadeMode || "decrease" === this._config.audioLag.fadeMode, this._framesRenderedSinceDrop++, this._framesDroppedSinceRender = 0, this._isInRenderBlock ? this._blockRenderCount++ : (this._isInRenderBlock = !0, this._blockRenderCount = 1)
                }
              } else if (c <= i) return this.emit("underrun"), void e.close();
              var S = "none";
              if (l) {
                var y = this._isInRenderBlock && 1 === this._framesRenderedSinceDrop,
                  R = this._framesRenderedSinceDrop >= this._currentRenderFrameDistance;
                this._isInIncreaseBlock ? (S = "both", this._traceLagHandling && this.trace("increase block: count=".concat(this._increaseBlockCount, ", fade=").concat(S))) : y && R ? S = "both" : y ? S = "in" : R && (S = "out"), "in" !== S && "both" !== S || this._fadeInCount++, "out" !== S && "both" !== S || this._fadeOutCount++, this._traceLagHandling && this.trace("fade=".concat(S, ", ins=").concat(this._fadeInCount, ", outs=").concat(this._fadeOutCount, ", balance=").concat(this._fadeInCount - this._fadeOutCount))
              }
              var v = {timestamp: c, sourceNode: this._createBufferSource(e, S), started: !1};
              this._lastRenderedTimestampUS = Math.round(1e6 * c), this._lastRenderedDurationUS = Math.round(1e6 * s), this._sourceNodesPending.push(v), this._sourceNodePendingCleanTimer || (this._sourceNodePendingCleanTimer = window.setTimeout((function () {
                r._sourceNodePendingCleanTimer = void 0, r._checkSourceNodeQueue()
              }), this.SOURCE_NODE_PENDING_CLEAN_TIMEOUT_MS)), v.sourceNode.onended = function (e) {
                var t = r._aCtx.currentTime, i = r._config.getExternalSyncTime(), a = Math.round(1e6 * (t - i)) / 1e6;
                r.emit("audioRendered", o, 1e6 * s, c, t, i, a, n), r._removeSourceNodePending(e, e.started ? "ended after played" : "ended before played")
              }.bind(this, v), this._muted || (v.sourceNode.start(v.timestamp), v.started = !0, this.emit("audioScheduled", c, i, a, this._deltaInternalExternalTimeUs / 1e6), this._checkContextStateAfterSourceNodeStart(v))
            } catch (t) {
              this.emit("audioError", t), e.close()
            }
          }, t.prototype.getLastRenderedTimestampUS = function () {
            return this._lastRenderedTimestampUS
          }, t.prototype._checkSyncTimeDeviationToHigh = function () {
            var e = this._getSyncTimeDeviationUs();
            Math.abs(e) >= this.SYNC_TIME_DEVIATION_TO_HIGH_US && (this.trace("sync time deviation to high " + e), this._adjustClockRef(e), this._checkSourceNodeQueue())
          }, t.prototype._checkSyncTimeDeviationThresholdReached = function () {
            var e = this._getSyncTimeDeviationUs();
            Math.abs(e) >= this.SYNC_TIME_DEVIATION_THRESHOLD_US && (this.trace("sync time deviation threshold reached " + e), this._adjustClockRef(e), this._checkSourceNodeQueue())
          }, t.prototype._checkSyncTimeDeviationAfterNormalization = function () {
            var e = this._syncTimeDeviationUsArr.reduce((function (e, t) {
              return e + t
            }), 0) / this._syncTimeDeviationUsArr.length;
            if (Number.isNaN(this._syncTimeDeviationUsMean)) this._syncTimeDeviationUsMean = e; else {
              var t = e - this._syncTimeDeviationUsMean, n = this._getSyncTimeDeviationUs();
              Math.abs(n) >= this.SYNC_TIME_DEVIATION_NORMALIZE_US && Math.abs(e - this._syncTimeDeviationUsMean) <= 1e4 && (this.trace("sync time deviation after normalization " + n + ", delta mean deviation " + t), this._adjustClockRef(n), this._checkSourceNodeQueue()), this._syncTimeDeviationUsMean = e
            }
          }, t.prototype.externalSyncTimeUpdate = function (e, t) {
            if (0 !== this._aCtx.currentTime && (this._externalSyncTimeDeltaPending += t, Math.abs(this._externalSyncTimeDeltaPending) >= this.SYNC_TIME_DEVIATION_TO_HIGH_US)) {
              var n = this._getSyncTimeDeviationUs();
              this.trace("externalSyncTimeUpdate abs " + Math.round(e) + ", delta pending " + Math.round(this._externalSyncTimeDeltaPending)), this._adjustClockRef(n), this._checkSourceNodeQueue()
            }
          }, t.prototype._adjustClockRef = function (e) {
            this.trace("adjusting clock ref with deviation " + e);
            var t = this._aCtx.currentTime, n = this._config.getExternalSyncTime();
            this._deltaInternalExternalTimeUs = Math.round(1e6 * (t - n)), this.trace("new delta internal external time us " + this._deltaInternalExternalTimeUs), this._syncTimeDeviationUsArr = [], this._syncTimeDeviationUsArr.push(this._getSyncTimeDeviationUs()), this.trace("old clock ref " + this._clockRefUs), this._clockRefUs += e, this.trace("clock ref set to " + this._clockRefUs), this._externalSyncTimeDeltaPending = 0
          }, t.prototype._getSyncTimeDeviationUs = function () {
            var e = this._config.getExternalSyncTime(), t = this._aCtx.currentTime, n = Math.round(1e6 * (t - e));
            return !Number.isNaN(this._deltaInternalExternalTimeUs) && e > 0 ? n - this._deltaInternalExternalTimeUs : 0
          }, t.prototype._parseTimestamp = function (e, t) {
            var n = e.duration, r = 0;
            if (isNaN(this._nextTimestamp)) {
              if (t !== e.timestamp && Math.abs(t - e.timestamp) > 1e3) return this.trace("dtsUs " + t + ", audioData.timestamp " + e.timestamp), this.emit("audioError", new Error("Initial audio decoder output timestamp should match dequeued one")), 0;
              r = t, this.trace("initial timestamp " + r)
            } else if (t >= this._nextTimestamp + n) {
              var i = Math.floor((t - this._nextTimestamp) / n);
              if (r = this._nextTimestamp + n * i, this._config.allowDelayedRendering) {
                var a = Math.floor(1e6 * this._timeLag / n), o = Math.min(i, a);
                o && (this._timeLag -= o * n / 1e6, this.emit("audioLag", "decrease", this._timeLag))
              }
              this.trace("gap of " + n * i + " detected, corrected timestamp is expected next timestamp incl. gap " + r)
            } else r = this._nextTimestamp;
            return this._nextTimestamp = r + n, r
          }, t.prototype._checkContextStateAfterSourceNodeStart = function (e) {
            var t = this;
            !this._allowed && !this._allowedTimer && (this._allowedTimer = setTimeout((function () {
              switch (e.sourceNode.context.state) {
                case"running":
                  t._allowed = !0, t.emit("startSuccess");
                  break;
                case"suspended":
                  void 0 === t._allowed && (t._allowed = !1, t.trace("ctx state suspended after start node scheduled, disabled by autopolicy, currentTime: " + e.sourceNode.context.currentTime), t.emit("startError", new a("NotAllowedError", "The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page.", 1005))), t._allowedTimer = void 0
              }
            }), this._config.startTimeoutMs))
          }, t.prototype._checkSourceNodeQueue = function () {
            for (var e = this._sourceNodesPending.length - 1; e >= 0; e--) {
              var t = this._sourceNodesPending[e];
              t.timestamp + 3 <= this._aCtx.currentTime && this._removeSourceNodePending(t, "too late at check")
            }
          }, t.prototype._removeSourceNodePending = function (e, t) {
            void 0 === t && (t = "");
            var n = this._sourceNodesPending.indexOf(e, 0);
            if (n > -1) {
              var r = this._sourceNodesPending.splice(n, 1)[0];
              r.sourceNode.onended = null, r.started && r.sourceNode.stop(), r.sourceNode.disconnect();
              var i = this._aCtx.currentTime;
              "ended after played" !== t && this.emit("audioRemoved", r.timestamp, i, t)
            }
          }, t.prototype._removeAllSourceNodesPending = function (e) {
            void 0 === e && (e = ""), this._sourceNodePendingCleanTimer && clearTimeout(this._sourceNodePendingCleanTimer);
            for (var t = this._sourceNodesPending.length - 1; t >= 0; t--) {
              var n = this._sourceNodesPending[t];
              this._removeSourceNodePending(n, e)
            }
          }, t.prototype._createBufferSource = function (e, t) {
            void 0 === t && (t = "none");
            var n = e.numberOfChannels, r = e.numberOfFrames, i = e.sampleRate, a = e.format,
              o = this._aCtx.createBuffer(n, r, i);
            if ("f32-planar" === a) for (var s = 0; s < n; s++) {
              var d = new Float32Array(r);
              e.copyTo(d, {planeIndex: s}), "none" !== t && this._applyCosineFade(d, i, t), o.copyToChannel(d, s)
            } else if ("f32" === a) {
              var u = new Float32Array(r * n);
              e.copyTo(u, {planeIndex: 0});
              for (var c = 0; c < n; c++) {
                d = o.getChannelData(c);
                for (var l = 0; l < r; l++) d[l] = u[l * n + c];
                "none" !== t && this._applyCosineFade(d, i, t), o.copyToChannel(d, c)
              }
            } else this.emit("audioError", new Error("Unsupported AudioData format: ".concat(a)));
            e.close();
            var f = this._aCtx.createBufferSource();
            return f.buffer = o, f.connect(this._gainNode), f
          }, t.prototype._applyCosineFade = function (e, t, n) {
            this._traceLagHandling && this.trace("applying ".concat(n, " cosine fade to audio block"));
            var r = Math.min(Math.floor(5 * t / 1e3), Math.floor(e.length / 4));
            if (!(r <= 0)) for (var i = 0; i < r; i++) {
              if ("in" === n || "both" === n) {
                var a = (1 - Math.cos(i * Math.PI / r)) / 2;
                e[i] *= a
              }
              if ("out" === n || "both" === n) {
                var o = e.length - 1 - i, s = (1 - Math.cos((r - i) * Math.PI / r)) / 2;
                e[o] *= s
              }
            }
          }, t.prototype.trace = function (e) {
            this.emit("trace", e)
          }, t.prototype.setVolume = function (e) {
            e <= 0 ? e = 1e-4 : e > 1 && (e = 1), this._volume !== e && (0 === this._volume && this._aCtx.currentTime > 0 && !this._muted && this._checkSyncTimeDeviationToHigh(), this._volume = Math.floor(100 * e) / 100, this._gainNode.gain.value = e, this.emit("volumeChanged", this._volume, this._muted), this.trace("volume changed to ".concat(this._volume)))
          }, t.prototype.setMute = function (e) {
            if (e !== this._muted) {
              this._muted = e;
              var t = this._aCtx.currentTime, n = this._config.getExternalSyncTime();
              if (!1 === e) {
                if (this._allowed = void 0, this._allowedTimer = void 0, 0 === t) {
                  for (var r = 0, i = this._sourceNodesPending.length - 1; i >= 0; i--) this._sourceNodesPending[i].timestamp > r && (this.trace("lastTimestamp updated to " + this._sourceNodesPending[i].timestamp), r = this._sourceNodesPending[i].timestamp);
                  for (i = this._sourceNodesPending.length - 1; i >= 0; i--) (a = this._sourceNodesPending[i]).timestamp = a.timestamp - r + this._config.startBufferMs / 1e3, a.timestamp < 0 && this._removeSourceNodePending(a, "negative at unmute");
                  this._dtsOffsetUs = this._dtsOffsetUs + 1e6 * r - 1e3 * this._config.startBufferMs, this._deltaInternalExternalTimeUs = Math.round(1e6 * (t - n)), this._clockRefUs = Math.round(1e6 * this._config.schedulingLatencySecs), this._syncTimeDeviationUsArr = [], this._syncTimeDeviationUsMean = NaN, this.trace("delta internal external time us " + this._deltaInternalExternalTimeUs), this.trace("dts offset updated to " + this._dtsOffsetUs)
                }
                for (i = this._sourceNodesPending.length - 1; i >= 0; i--) (a = this._sourceNodesPending[i]).timestamp >= t && !a.started ? (a.sourceNode.start(a.timestamp), a.started = !0, this.emit("audioScheduled", a.timestamp, t, n, this._deltaInternalExternalTimeUs), this.trace("audio started at unmute, scheduled at " + a.timestamp + ", current time " + t), this._checkContextStateAfterSourceNodeStart(a)) : a.timestamp < t && this._removeSourceNodePending(a, "too late at unmute")
              } else for (clearTimeout(this._allowedTimer), i = this._sourceNodesPending.length - 1; i >= 0; i--) {
                var a;
                (a = this._sourceNodesPending[i]).started && a.sourceNode.stop(0) && (a.started = !1), this.trace("audio stopped at mute, scheduled at " + a.timestamp + ", current time " + t)
              }
              this.emit("volumeChanged", this._volume, this._muted), this.trace("mute state changed to ".concat(e ? "muted" : "unmuted"))
            }
          }, t.prototype.getTimeLag = function () {
            return this._timeLag
          }, t.prototype.close = function () {
            var e = this;
            this._removeAllSourceNodesPending("close"), "closed" === this._aCtx.state ? this.trace("ctx already closed, skip") : this._aCtx.close().then((function () {
              e.emit("closed")
            })).catch((function (t) {
              e.trace(t.message || "closing ctx failed")
            })), this._clockRefUs = NaN, this._dtsOffsetUs = NaN
          }, t
        }(function () {
          function e() {
            this.listeners = new Map
          }

          return e.prototype.on = function (e, t) {
            this.listeners.has(e) || this.listeners.set(e, []), this.listeners.get(e).push(t)
          }, e.prototype.emit = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            for (var r = 0, i = this.listeners.get(e) || []; r < i.length; r++) i[r].apply(void 0, t)
          }, e
        }());
        return t
      })(), e.exports = t()
    }, 4283: function (e) {
      var t;
      self, t = () => (() => {
        "use strict";
        var e = {
          d: (t, n) => {
            for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {enumerable: !0, get: n[r]})
          }, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: e => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
          }
        }, t = {};
        e.r(t), e.d(t, {VideoDecoderModule: () => a});
        var n, r = (n = function (e, t) {
          return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
          })(e, t)
        }, function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

          function r() {
            this.constructor = e
          }

          n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r)
        }), i = function () {
          return (i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
          }).apply(this, arguments)
        }, a = function (e) {
          function t() {
            var t = e.call(this) || this;
            return t._pendingDecoder = null, t._isConfigured = !1, t._isBeingConfigured = !1, t._decConfig = null, t._gotFirstKeyFrame = !1, t.prerollFramesVideo = 0, t.prerollFramesRemaining = 0, t._pendingFrameIds = new Map, t._decoder = new VideoDecoder(i({}, t._getVideoDecoderConstructorOptions())), t
          }

          return r(t, e), t.prototype.setPrerollInfo = function (e) {
            this.prerollFramesVideo = e, this.prerollFramesRemaining = e
          }, t.prototype.isConfigured = function () {
            return this._isConfigured
          }, t.prototype.isBeingConfigured = function () {
            return this._isBeingConfigured
          }, t.prototype.configureDecoder = function (e) {
            var t = this;
            if (!this._isBeingConfigured) if (void 0 !== e || null !== this._decConfig) {
              this._isBeingConfigured = !0;
              var n = e && e.payloadUnit ? this._getAvcDecoderConfig(e.payloadUnit) : this._decConfig;
              this._pendingDecoder = new VideoDecoder(i({}, this._getVideoDecoderConstructorOptions())), VideoDecoder.isConfigSupported(n).then((function (e) {
                return e.supported ? (t._pendingDecoder.configure(n), "configured" !== t._pendingDecoder.state ? (t._pendingDecoder = null, void t.emit("decodeError", new Error("VideoDecoder configure failed."))) : ("closed" !== t._decoder.state && t._decoder.close(), t._decoder = t._pendingDecoder, t._gotFirstKeyFrame = !1, t._isBeingConfigured = !1, t._pendingDecoder = null, t._isConfigured = !0, t._decConfig = n, void t.emit("configured", n))) : (t._pendingDecoder = null, void t.emit("decodeError", new Error("VideoDecoder config not supported.")))
              })).catch((function (e) {
                t._pendingDecoder = null, t.emit("decodeError", e)
              }))
            } else this.emit("decodeError", new Error("No chunk or config."))
          }, t.prototype.decodeChunk = function (e) {
            var t = this, n = e.payloadUnit, r = e.isCodecConfig, a = e.isKeyframe, o = e.dtsUs, s = e.frameId;
            if (this._decoder) {
              if (r && !this._isBeingConfigured) {
                var d = this._getAvcDecoderConfig(n);
                return this._isBeingConfigured = !0, this._pendingDecoder = new VideoDecoder(i({}, this._getVideoDecoderConstructorOptions())), void VideoDecoder.isConfigSupported(d).then((function (e) {
                  return e.supported ? (t._pendingDecoder.configure(d), "configured" !== t._pendingDecoder.state ? (t._pendingDecoder = null, void t.emit("decodeError", new Error("VideoDecoder configure failed."))) : (t._decoder && t._decoder.close(), t._decoder = t._pendingDecoder, t._gotFirstKeyFrame = !1, t._isBeingConfigured = !1, t._pendingDecoder = null, t._isConfigured = !0, t._decConfig = d, void t.emit("configured", d))) : (t._pendingDecoder = null, void t.emit("decodeError", new Error("VideoDecoder config not supported.")))
                })).catch((function (e) {
                  t._pendingDecoder = null, t.emit("decodeError", e)
                }))
              }
              if (!this._isConfigured || this.prerollFramesRemaining > 0) this.prerollFramesRemaining > 0 && (this.trace("Skipping video preroll frame"), this.prerollFramesRemaining--); else if (this._gotFirstKeyFrame || a) if (this._isBeingConfigured) this.trace("Skipping video frame because it is after the configuration frame while being configured"); else {
                this._gotFirstKeyFrame = !0;
                var u = new EncodedVideoChunk({type: a ? "key" : "delta", timestamp: o, data: n});
                void 0 !== s && this._pendingFrameIds.set(o, s), "configured" === this._decoder.state ? this._decoder.decode(u) : "closed" === this._decoder.state && this._isConfigured ? this.emit("decodeError", new Error("VideoDecoder closed.")) : this.emit("decodeError", new Error("VideoDecoder not configured or configuration changed after startup."))
              }
            }
          }, t.prototype._onFrameDecoded = function (e) {
            var t = this._pendingFrameIds.get(e.timestamp);
            void 0 !== t && this._pendingFrameIds.delete(e.timestamp), this.emit("frameDecoded", e, t)
          }, t.prototype._getAvcDecoderConfig = function (e) {
            return {
              codec: "avc1." + (e[1] << 16 | e[2] << 8 | e[3] | 16777216).toString(16).substring(1),
              description: e,
              optimizeForLatency: !0
            }
          }, t.prototype._getVideoDecoderConstructorOptions = function () {
            var e = this;
            return {
              output: function (t) {
                return e._onFrameDecoded(t)
              }, error: function (t) {
                return e.emit("decodeError", t)
              }
            }
          }, Object.defineProperty(t.prototype, "config", {
            get: function () {
              return this._isConfigured ? this._decConfig : null
            }, enumerable: !1, configurable: !0
          }), t.prototype.trace = function (e) {
            this.emit("trace", e)
          }, t.prototype.close = function () {
            this._pendingDecoder && "closed" !== this._pendingDecoder.state && (this._pendingDecoder.close(), this._pendingDecoder = null), this._decoder && "closed" !== this._decoder.state && this._decoder.close(), this.emit("closed")
          }, t
        }(function () {
          function e() {
            this.listeners = new Map
          }

          return e.prototype.on = function (e, t) {
            this.listeners.has(e) || this.listeners.set(e, []), this.listeners.get(e).push(t)
          }, e.prototype.emit = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            for (var r = 0, i = this.listeners.get(e) || []; r < i.length; r++) i[r].apply(void 0, t)
          }, e
        }());
        return t
      })(), e.exports = t()
    }, 6660: function (e) {
      var t;
      self, t = () => (() => {
        "use strict";
        var e = {
          d: (t, n) => {
            for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {enumerable: !0, get: n[r]})
          }, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: e => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
          }
        }, t = {};
        e.r(t), e.d(t, {VideoRenderer: () => i});
        var n, r = (n = function (e, t) {
          return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
          })(e, t)
        }, function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

          function r() {
            this.constructor = e
          }

          n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r)
        }), i = function (e) {
          function t(t, n) {
            void 0 === n && (n = {});
            var r = e.call(this) || this;
            for (var i in r.canvas = t, r.ctx = r.canvas.getContext("2d"), r._config = Object.assign({
              autoResize: !1,
              events: {}
            }, n), r._config.events) Object.prototype.hasOwnProperty.call(r._config.events, i) && r.on(i, r._config.events[i]);
            return r
          }

          return r(t, e), t.prototype.renderFrame = function (e, t) {
            if (!this.ctx) return this.trace("VideoRenderer: no 2D context available."), void e.close();
            this._config.autoResize && e.displayWidth && e.displayHeight && (this.canvas.width === e.displayWidth && this.canvas.height === e.displayHeight || (this.canvas.width = e.displayWidth, this.canvas.height = e.displayHeight)), this.ctx.drawImage(e, 0, 0, this.canvas.width, this.canvas.height), this.emit("videoRendered", e.timestamp, e.displayWidth, e.displayHeight, this.canvas.width, this.canvas.height, t), e.close()
          }, t.prototype.clear = function () {
            this.ctx && this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
          }, t.prototype.resize = function (e, t) {
            this.canvas.width = e, this.canvas.height = t
          }, t.prototype.trace = function (e) {
            this.emit("trace", e)
          }, t.prototype.close = function () {
            this.emit("closed")
          }, t
        }(function () {
          function e() {
            this.listeners = new Map
          }

          return e.prototype.on = function (e, t) {
            this.listeners.has(e) || this.listeners.set(e, []), this.listeners.get(e).push(t)
          }, e.prototype.emit = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            for (var r = 0, i = this.listeners.get(e) || []; r < i.length; r++) i[r].apply(void 0, t)
          }, e
        }());
        return t
      })(), e.exports = t()
    }, 711: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(9658), n(1933), n(6637), n(5055), n(8250), n(9437), n(1520), n(3038), n(907), n(3242), n(3701), n(738), n(6273), n(5082), n(4545), n(6636)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b) {
        "use strict";
        return {
          create: function (e) {
            var t, r, _ = new n, h = [], T = [{
                type: d.CONFIG, listener: function () {
                }
              }], A = [{from: c.LOAD_START, to: l.LOAD_START}, {from: c.PROGRESS, to: l.PROGRESS}, {
                from: c.SUSPEND,
                to: l.SUSPEND
              }, {from: c.ABORT, to: l.ABORT}, {from: c.EMPTIED, to: l.EMPTIED}, {
                from: c.STALLED,
                to: l.STALLED
              }, {from: c.PLAY, to: l.PLAY}, {from: c.PAUSE, to: l.PAUSE}, {
                from: c.LOADED_META_DATA,
                to: l.LOADED_META_DATA
              }, {from: c.LOADED_DATA, to: l.LOADED_DATA}, {from: c.WAITING, to: l.WAITING}, {
                from: c.PLAYING,
                to: l.PLAYING
              }, {from: c.CAN_PLAY, to: l.CAN_PLAY}, {from: c.CAN_PLAY_THROUGH, to: l.CAN_PLAY_THROUGH}, {
                from: c.SEEKING,
                to: l.SEEKING
              }, {from: c.SEEKED, to: l.SEEKED}, {from: c.TIME_UPDATE, to: l.TIME_UPDATE}, {
                from: c.ENDED,
                to: l.ENDED
              }, {from: c.RATE_CHANGE, to: l.RATE_CHANGE}, {
                from: c.DURATION_CHANGE,
                to: l.DURATION_CHANGE
              }, {from: c.VOLUME_CHANGE, to: l.VOLUME_CHANGE}, {
                from: c.ELEMENT_CREATED,
                to: l.ELEMENT_CREATED
              }, {from: c.PLAY_START_SUCCESS, to: l.PLAY_START_SUCCESS}, {
                from: c.PLAY_START_ABORT_ERROR,
                to: l.PLAY_START_ABORT_ERROR
              }, {from: c.PLAY_START_NOT_ALLOWED_ERROR, to: l.PLAY_START_NOT_ALLOWED_ERROR}, {
                from: c.VIEWPORT_VISIBLE,
                to: l.VIEWPORT_VISIBLE
              }, {from: c.VIEWPORT_HIDDEN, to: l.VIEWPORT_HIDDEN}, {
                from: c.UPDATE_SOURCE_ABORT,
                to: l.UPDATE_SOURCE_ABORT
              }, {from: c.UPDATE_SOURCE_FAIL, to: l.UPDATE_SOURCE_FAIL}, {
                from: c.UPDATE_SOURCE_TIMEOUT,
                to: l.UPDATE_SOURCE_TIMEOUT
              }, {from: c.ACTIVE_VIDEO_ELEMENT_CHANGE, to: l.ACTIVE_VIDEO_ELEMENT_CHANGE}, {
                from: c.VIDEO_DECODE_ERROR,
                to: l.MEDIA_ERROR
              }, {from: c.AUDIO_DECODE_ERROR, to: l.MEDIA_ERROR}, {
                from: c.VIDEO_DECODER_STARTUP_ERROR,
                to: l.MEDIA_ERROR
              }, {from: c.AUDIO_DECODER_STARTUP_ERROR, to: l.MEDIA_ERROR}, {
                from: c.MEDIA_ERROR_RECOVERED,
                to: l.MEDIA_ERROR_RECOVERED
              }, {from: c.SWITCH_STREAM, to: l.SWITCH_STREAM}, {
                from: E.PUBLIC_MEDIA_STATS,
                to: l.PLAY_STATS
              }, {from: E.MEDIA_ERROR_RECOVER_STATS, to: l.MEDIA_ERROR_RECOVER_STATS}, {
                from: f.PLAYBACK_STARTED,
                to: l.PLAYBACK_STARTED
              }, {from: f.BUFFERING, to: l.BUFFERING}, {
                from: c.TIME_OFFSET,
                to: l.TIME_OFFSET
              }, {from: c.ADJUSTED_META_DATA, to: l.ADJUSTED_META_DATA}],
              S = [{from: o.CREATE_VIDEO, to: u.CREATE_VIDEO}, {
                from: o.DESTROY_VIDEO,
                to: u.DESTROY_VIDEO
              }, {from: o.VIDEO_SOURCE, to: u.VIDEO_SOURCE}, {from: o.PLAY, to: u.PLAY}, {
                from: o.PAUSE,
                to: u.PAUSE
              }, {from: o.SEEK, to: u.SEEK}, {from: o.MUTE, to: u.MUTE}, {
                from: o.UNMUTE,
                to: u.UNMUTE
              }, {from: o.SET_VOLUME, to: u.SET_VOLUME}, {from: o.SET_RATE, to: u.SET_RATE}, {
                from: o.UPDATE_SOURCE,
                to: u.UPDATE_SOURCE
              }, {from: p.ERROR, to: d.MEDIA_ERROR}, {from: p.RECOVER, to: d.MEDIA_ERROR_RECOVER}, {
                from: p.RECOVERED,
                to: d.MEDIA_ERROR_RECOVERED
              }, {from: p.QUEUED, to: d.MEDIA_ERROR_QUEUED}, {
                from: p.UNQUEUED,
                to: d.MEDIA_ERROR_UNQUEUED
              }, {from: s.CONFIG, to: d.CONFIG}, {from: s.SERVER_INFO, to: d.SERVER_INFO}, {
                from: s.STREAM_FRAGMENT,
                to: d.STREAM_FRAGMENT
              }, {from: s.RANDOM_ACCESS_POINT, to: d.RANDOM_ACCESS_POINT}, {
                from: s.NETWORK_ONLINE,
                to: d.NETWORK_ONLINE
              }, {from: s.NETWORK_OFFLINE, to: d.NETWORK_OFFLINE}, {
                from: s.WEB_TRANSPORT_META_DATA,
                to: d.WEB_TRANSPORT_META_DATA
              }, {from: s.WEB_TRANSPORT_GOP_CACHE, to: d.WEB_TRANSPORT_GOP_CACHE}, {
                from: s.APPLICATION_STATE_CHANGE,
                to: d.APPLICATION_STATE_CHANGE
              }, {from: s.STARTUP_STATS_ADDED, to: d.STARTUP_STATS_ADDED}, {
                from: s.STARTUP_STATS_COMPLETED,
                to: d.STARTUP_STATS_COMPLETED
              }, {from: s.DOCUMENT_VISIBLE, to: d.DOCUMENT_VISIBLE}, {
                from: s.DOCUMENT_HIDDEN,
                to: d.DOCUMENT_HIDDEN
              }, {from: s.STREAM_INFO, to: d.STREAM_INFO}, {
                from: s.STREAM_INFO_UPDATE,
                to: d.STREAM_INFO_UPDATE
              }, {from: s.SWITCH_STREAM_INIT, to: d.SWITCH_STREAM_INIT}, {
                from: s.SWITCH_STREAM_SUCCESS,
                to: d.SWITCH_STREAM_SUCCESS
              }, {from: s.SWITCH_STREAM_ABORT, to: d.SWITCH_STREAM_ABORT}, {
                from: s.SWITCH_STREAM_FAIL,
                to: d.SWITCH_STREAM_FAIL
              }, {from: s.UPDATE_SOURCE_INIT, to: d.UPDATE_SOURCE_INIT}, {
                from: s.UPDATE_SOURCE_SUCCESS,
                to: d.UPDATE_SOURCE_SUCCESS
              }, {from: s.BUFFER_TWEAKS_CREATED, to: d.BUFFER_TWEAKS_CREATED}, {
                from: s.BUFFER_GOAL_STATS,
                to: d.BUFFER_GOAL_STATS
              }];
            return i.add({
              target: _,
              listeners: T
            }), t = a.create(e, _, S), r = a.create(_, e, A), h.push(b.create(_)), h.push(m.create(_)), h.push(g.create(_)), {
              destroy: function () {
                for (; h.length;) h.pop().destroy();
                t.destroy(), t = null, r.destroy(), r = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4856: function (e, t, n) {
      var r, i;
      r = [n(4556), n(6637), n(8333), n(6627), n(5337), n(492), n(9437), n(1667), n(5075), n(3242)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u) {
        return {
          create: function (c) {
            var l, f, E, p, m, g, b, _, h, T, A, S, y, R = n.create("StatsCollector"), v = 0, O = [{
              type: o.APPLICATION_STATE_CHANGE, listener: function (e) {
                switch (e.data.state) {
                  case a.PAUSED:
                    R.debugEnabled() && R.debug("remove stats listener"), t.remove({target: c, listeners: I});
                    break;
                  case a.PLAYING:
                    break;
                  case a.LOADING:
                    w(), E && (R.debugEnabled() && R.debug("hls: add stats listener"), t.add({
                      target: c,
                      listeners: I
                    }))
                }
              }
            }, {
              type: o.CONFIG, listener: function (e) {
                E = r.mustUseHLS || e.data.config.playback.allowSafariHlsFallback && r.canUseHLS
              }
            }], I = [{type: d.PLAY_STATS, listener: N}, {type: u.PLAY_STATS, listener: N}], C = [{
              type: o.STREAM_FRAGMENT, listener: function (e) {
                "mp4" === e.data.type ? (S += 1, y += e.data.fragment.byteLength) : "avc" === e.data.type && (S += 1, y += e.data.fragment.payload.length)
              }
            }, {
              type: o.STREAM_INFO, listener: function (e) {
                E || (R.debugEnabled() && R.debug("wss: add stats listener"), t.add({
                  target: c,
                  listeners: I
                })), p = e.data.streamInfo.haveVideo
              }
            }, {
              type: o.STREAM_INFO_UPDATE, listener: function (e) {
                p = e.data.streamInfo.haveVideo
              }
            }];

            function N(t) {
              if (l = t.data.mediaStats, m = l.currentTime, g = l.playbackRate, f.playout.start = l.playedStart, f.playout.end = l.playedEnd, f.buffer.update.current = l.bufferUpdate, f.buffer.start = l.bufferStart, f.buffer.end = l.bufferEnd, f.buffer.delay.current = l.bufferDelay ? l.bufferDelay : 0, f.buffer.durationDelta = l.durationDelta, b.add(f.buffer.delay.current), D(b, f.buffer.delay), _.add(f.buffer.update.current), D(_, f.buffer.update), f.duration.current = l.duration, e && !E) {
                var n = Math.floor(e.now() / 1e3);
                v !== n && (v = n, f.bitrate.current = 8 * y, T.add(f.bitrate.current), D(T, f.bitrate), p && (f.framerate.current = S, A.add(f.framerate.current), D(A, f.framerate)), S = 0, y = 0)
              }
              f.currentTime = m, f.playbackrate.current = g, h.add(f.playbackrate.current), D(h, f.playbackrate), c.emit(s.PLAY_STATS, {stats: f})
            }

            function D(e, t) {
              t.avg = e.arithmetic, t.min = e.minimum, t.max = e.maximum, t.deviation = e.deviation
            }

            function w() {
              f = {
                currentTime: 0,
                playout: {start: 0, end: 0},
                duration: {current: 0},
                buffer: {
                  start: 0,
                  end: 0,
                  delay: {before: 0, current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                  update: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                  durationDelta: 0
                },
                buffergoal: {real: 0, base: 0, min: 0, max: 0},
                playbackrate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                quality: {
                  droppedVideoFrames: 0,
                  droppedVideoFramesCurrent: 0,
                  droppedVideoFramesLevel: 0,
                  corruptedVideoFrames: 0,
                  corruptedVideoFramesCurrent: 0,
                  creationTime: 0,
                  totalVideoFrames: 0
                },
                bitrate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0},
                framerate: {current: 0, avg: 0, min: 0, max: 0, deviation: 0}
              }, b = i.create(10), _ = i.create(10), h = i.create(10), T = i.create(10), A = i.create(10), S = 0, y = 0
            }

            return w(), t.add({target: c, listeners: O}), t.add({target: c, listeners: I}), t.add({
              target: c,
              listeners: C
            }), {
              destroy: function () {
                t.remove({target: c, listeners: I}), t.remove({target: c, listeners: O}), t.remove({
                  target: c,
                  listeners: C
                })
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7732: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "networkAdapter.";
        return {
          BASE: e,
          CONNECTING: e + "connecting",
          CONNECTED: e + "connected",
          CONNECTION_OPEN: e + "connectionOpen",
          DISCONNECTED: e + "disconnected",
          RESUMING: e + "resuming",
          MESSAGE: e + "message",
          RECONNECTION_IMMINENT: e + "reconnectionImminent",
          RECONNECTING: e + "reconnecting",
          RECONNECTION_CONFIG_INVALID: e + "reconnectionConfigInvalid",
          CONNECTION_ERROR: e + "connectionError",
          INITIALIZATION_ERROR: e + "initializationError",
          DESTROYED: e + "destroyed",
          ERROR: e + "error",
          STATE_CHANGE: e + "stateChange",
          META_DATA: e + "metaData",
          WEB_TRANSPORT_META_DATA: e + "wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: e + "wtGOPCache",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          RAW_PACKET: e + "raw",
          STREAM_STATUS: e + "streamStatus",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_ERROR: e + "updateSourceError",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          STREAM_QUALITY: e + "streamQuality"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5212: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "networkHandler.";
        return {
          BASE: e,
          CONNECTING: e + "connecting",
          CONNECTED: e + "connected",
          CONNECTION_OPEN: e + "connectionOpen",
          DISCONNECTED: e + "disconnected",
          RESUMING: e + "resuming",
          MESSAGE: e + "message",
          RECONNECTION_IMMINENT: e + "reconnectionImminent",
          RECONNECTING: e + "reconnecting",
          RECONNECTION_CONFIG_INVALID: e + "reconnectionConfigInvalid",
          CONNECTION_ERROR: e + "connectionError",
          INITIALIZATION_ERROR: e + "initializationError",
          DESTROYED: e + "destroyed",
          ERROR: e + "error",
          WARNING: e + "warning",
          STATE_CHANGE: e + "stateChange",
          META_DATA: e + "metaData",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          RAW_PACKET: e + "raw",
          STREAM_STATUS: e + "streamStatus",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          STREAM_QUALITY: e + "streamQuality",
          WEB_TRANSPORT_META_DATA: e + "wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: e + "wtGOPCache"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 312: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "networkmanager.";
        return {
          BASE: e,
          CONNECT: e + "connect",
          DISCONNECT: e + "disconnect",
          PLAY: e + "play",
          PAUSE: e + "pause",
          CONFIG: e + "config",
          UPDATE_SOURCE: e + "updateSource",
          STATE_CHANGE: e + "stateChange",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_FAIL: e + "updateSourceFail",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          SWITCH_STREAM_SUCCESS: e + "switchStreamSuccess",
          SWITCH_STREAM_FAIL: e + "switchStreamFail",
          SWITCH_STREAM_ABORT: e + "switchStreamAbort"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1852: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "networkstatus";
        return {BASE: e, ONLINE: e + "online", OFFLINE: e + "offline"}
      }.apply(t, [])) || (e.exports = n)
    }, 279: function (e, t, n) {
      var r, i;
      r = [n(9658), n(5055), n(9673), n(680), n(1376), n(312), n(5212), n(1852), n(9452), n(5356)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u) {
        "use strict";
        return {
          create: function (c) {
            var l, f, E = new e, p = [], m = [{from: o.CONNECTING, to: i.CONNECTING}, {
                from: o.CONNECTED,
                to: i.CONNECTED
              }, {from: o.CONNECTION_OPEN, to: i.CONNECTION_OPEN}, {from: o.RESUMING, to: i.RESUMING}, {
                from: o.DESTROYED,
                to: i.DESTROYED
              }, {from: o.RECONNECTING, to: i.RECONNECTING}, {
                from: o.RECONNECTION_IMMINENT,
                to: i.RECONNECTION_IMMINENT
              }, {from: o.RECONNECTION_CONFIG_INVALID, to: i.RECONNECTION_CONFIG_INVALID}, {
                from: o.DISCONNECTED,
                to: i.DISCONNECTED
              }, {from: o.INITIALIZATION_ERROR, to: i.INITIALIZATION_ERROR}, {
                from: o.CONNECTION_ERROR,
                to: i.CONNECTION_ERROR
              }, {from: o.ERROR, to: i.ERROR}, {from: o.WARNING, to: i.WARNING}, {
                from: o.STATE_CHANGE,
                to: i.STATE_CHANGE
              }, {from: o.UPDATE_SOURCE_SUCCESS, to: i.UPDATE_SOURCE_SUCCESS}, {
                from: o.UPDATE_SOURCE_FAIL,
                to: i.UPDATE_SOURCE_FAIL
              }, {from: o.UPDATE_SOURCE_ABORT, to: i.UPDATE_SOURCE_ABORT}, {
                from: o.META_DATA,
                to: i.META_DATA
              }, {from: o.RANDOM_ACCESS_POINT, to: i.RANDOM_ACCESS_POINT}, {
                from: o.SERVER_INFO,
                to: i.SERVER_INFO
              }, {from: o.STREAM_INFO, to: i.STREAM_INFO}, {
                from: o.STREAM_INFO_UPDATE,
                to: i.STREAM_INFO_UPDATE
              }, {from: o.RAW_PACKET, to: i.RAW_PACKET}, {
                from: o.STREAM_FRAGMENT,
                to: i.STREAM_FRAGMENT
              }, {from: o.STREAM_STATUS, to: i.STREAM_STATUS}, {
                from: o.STREAM_QUALITY,
                to: i.STREAM_QUALITY
              }, {from: o.WEB_TRANSPORT_META_DATA, to: i.WEB_TRANSPORT_META_DATA}, {
                from: o.WEB_TRANSPORT_GOP_CACHE,
                to: i.WEB_TRANSPORT_GOP_CACHE
              }, {from: s.ONLINE, to: i.ONLINE}, {from: s.OFFLINE, to: i.OFFLINE}],
              g = [{from: n.CONNECT, to: a.CONNECT}, {from: n.DISCONNECT, to: a.DISCONNECT}, {
                from: n.NETWORK_PLAY,
                to: a.PLAY
              }, {from: n.PAUSE, to: a.PAUSE}, {from: n.CONFIG, to: a.CONFIG}, {
                from: n.NETWORK_UPDATE_SOURCE,
                to: a.UPDATE_SOURCE
              }, {from: r.STATE_CHANGE, to: a.STATE_CHANGE}, {
                from: r.UPDATE_SOURCE_SUCCESS,
                to: a.UPDATE_SOURCE_SUCCESS
              }, {from: r.UPDATE_SOURCE_FAIL, to: a.UPDATE_SOURCE_FAIL}, {
                from: r.UPDATE_SOURCE_ABORT,
                to: a.UPDATE_SOURCE_ABORT
              }, {from: r.SWITCH_STREAM_SUCCESS, to: a.SWITCH_STREAM_SUCCESS}, {
                from: r.SWITCH_STREAM_FAIL,
                to: a.SWITCH_STREAM_FAIL
              }, {from: r.SWITCH_STREAM_ABORT, to: a.SWITCH_STREAM_ABORT}];
            return l = t.create(c, E, g), f = t.create(E, c, m), p.push(d.create(E)), p.push(u.create(E)), {
              destroy: function () {
                for (l.destroy(), l = null, f.destroy(), f = null; p.length;) p.pop().destroy()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6143: function (e, t, n) {
      var r, i;
      r = [n(9658), n(8333), n(6627), n(8197), n(6637), n(8405), n(3778), n(3890), n(728), n(4046), n(7402), n(4677), n(7732), n(9134), n(7903)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p) {
        var m = 5e3;
        return {
          create: function (g, b) {
            var _, h, T, A, S, y, R, v = (new Date).getTime().toString(), O = t.create("NetworkAdapter " + v),
              I = new e, C = [4102, 4103, 4105, 4106, 4107, 4108, 4109, 4111, 4115, 4201, 4500, 4503],
              N = [{type: E.META_DATA, listener: Q}, {
                type: E.WEB_TRANSPORT_META_DATA,
                listener: Q
              }, {type: E.WEB_TRANSPORT_GOP_CACHE, listener: Q}, {
                type: E.SERVER_INFO, listener: function (e) {
                  R = e.data.onServerInfo, re(e)
                }
              }, {
                type: E.STREAM_INFO, listener: function (e) {
                  if (W() && -1 === R.events.indexOf("onUpdateSourceSuccess")) {
                    var t = y.update.options.tag, n = y.update.options.count;
                    g.emit(f.UPDATE_SOURCE_SUCCESS, ne({
                      tag: t,
                      count: n,
                      type: y.update.type,
                      id: y.update.id
                    })), x[n] ? (S = r.copy(x[n]), y === x[n] && (y = void 0), delete x[n]) : (S = y, y = void 0)
                  }
                  re(e)
                }
              }, {
                type: E.STREAM_INFO_UPDATE, listener: function (e) {
                  re(e)
                }
              }, {
                type: E.STREAM_FRAGMENT, listener: function (e) {
                  re(e, !0)
                }
              }, {
                type: E.RANDOM_ACCESS_POINT, listener: function (e) {
                  re(e)
                }
              }, {
                type: E.RAW_PACKET, listener: function (e) {
                  re(e, !0)
                }
              }, {
                type: E.STREAM_STATUS, listener: function (e) {
                  W() && "client" === y.update.options.method && "stopped" === e.data.onStreamStatus.status && g.emit(f.UPDATE_SOURCE_ERROR, ne({
                    tag: y.update.options.tag,
                    count: y.update.options.count,
                    code: o.NETWORK.SOURCE_STREAM_STOPPED,
                    message: s.NETWORK.SOURCE_STREAM_STOPPED,
                    type: y.update.type,
                    id: y.update.id
                  })), re(e)
                }
              }, {
                type: E.STREAM_QUALITY, listener: function (e) {
                  re(e)
                }
              }, {
                type: E.UPDATE_SOURCE_SUCCESS, listener: function (e) {
                  if (W() && F.requestId >= e.data.onUpdateSourceSuccess.requestId || A && -1 !== e.data[e.data.eventType].tag.indexOf(A.update.id)) {
                    A && -1 !== e.data[e.data.eventType].tag.indexOf(A.update.id) && (y = A, A = null);
                    var t = e.data[e.data.eventType].tag, n = e.data[e.data.eventType].count,
                      i = x[n] ? x[n].update.type : y.update.type, a = x[n] ? x[n].update.id : y.update.id;
                    0 === n && (t = y.update.options.tag, n = y.update.options.count), g.emit(f.UPDATE_SOURCE_SUCCESS, ne({
                      tag: t,
                      count: n,
                      type: i,
                      id: a
                    })), x[n] ? (S = r.copy(x[n]), y === x[n] && (y = void 0), delete x[n]) : (S = y, y = void 0)
                  }
                }
              }, {
                type: E.UPDATE_SOURCE_ERROR, listener: function (e) {
                  if (W() && F.requestId >= e.data.onUpdateSourceError.requestId) {
                    var t = e.data.onUpdateSourceError.code, n = "Unknown reason.";
                    Object.prototype.hasOwnProperty.call(d, +t) && (n = d[+t]), t > 1e3 && t < 4e3 && (t += 3100);
                    var r = e.data[e.data.eventType].tag, i = e.data[e.data.eventType].count,
                      a = x[i] ? x[i].update.type : y.update.type, o = x[i] ? x[i].update.id : y.update.id;
                    0 === i && (r = y.update.options.tag, i = y.update.options.count), g.emit(f.UPDATE_SOURCE_ERROR, ne({
                      tag: r,
                      count: i,
                      code: t,
                      message: n,
                      type: a,
                      id: o
                    })), y === x[i] && (y = void 0), delete x[i]
                  }
                }
              }, {
                type: E.UPDATE_SOURCE_ABORT, listener: function (e) {
                  if (W() && F.requestId >= e.data.onUpdateSourceAbort.requestId) {
                    var t = e.data[e.data.eventType].tag, n = e.data[e.data.eventType].count,
                      r = x[n] ? x[n].update.type : y.update.type, i = x[n] ? x[n].update.id : y.update.id;
                    0 === n && (t = y.update.options.tag, n = y.update.options.count);
                    var a = e.data[e.data.eventType].reason;
                    g.emit(f.UPDATE_SOURCE_ABORT, ne({
                      tag: t,
                      count: n,
                      reason: a,
                      type: r,
                      id: i
                    })), y === x[n] && (y = void 0), delete x[n]
                  }
                }
              }], D = null, w = a.UNINITIALIZED, U = 0, P = !1, M = !1, L = {
                minDelay: 2,
                maxDelay: 10,
                delaySteps: 10,
                maxRetries: 10,
                delays: [],
                retryCount: 0,
                randomFactor: 1.5
              }, F = {requestId: 0}, x = {}, k = !1;

            function B(e) {
              if (O.debugEnabled() && O.debug("on connect"), ie(!1), M = !1, clearTimeout(_), (S = e.data).count = L.retryCount, S.reconnect) {
                var t = u.validate(S.reconnect);
                if (t.success) for (var n in S.reconnect) Object.prototype.hasOwnProperty.call(S.reconnect, n) && (L[n] = S.reconnect[n]); else g.emit(f.RECONNECTION_CONFIG_INVALID, ne({
                  code: o.NETWORK.RECONNECTION_CONFIG_INVALID,
                  message: t.reason
                }))
              }
              if (S.timeouts) {
                var r = 1e3 * S.timeouts.connecting;
                m = Math.max(Math.min(r, 3e4), 5e3)
              }
              try {
                y = e.data.update ? e.data : void 0, s = S.url, O.debugEnabled() && O.debug("create connection"), Z(), D.open(s), -1 === S.config.query.flags.indexOf("metastreamonly") && (D.addEventListener("open", j), D.addEventListener("close", K), D.addEventListener("error", q)), U = setTimeout(z, m), g.emit(e.name ? f.CONNECTING : f.RECONNECTING, ne(S)), W() && (clearTimeout(T), T = setTimeout(J, 1e3 * e.data.update.options.timeout))
              } catch (e) {
                var i = "Connection initialization error.", a = e ? te(e) : void 0;
                a && a.message && (i = a.message), a && a.code && (i += " (code:" + a.code + ")"), a && a.name && (i = a.name + ": " + i), g.emit(f.INITIALIZATION_ERROR, ne({
                  code: o.NETWORK.COULD_NOT_ESTABLISH_CONNECTION,
                  message: i
                }))
              }
              var s
            }

            function H() {
              var e = w;
              return (w = null !== D ? D.readyState() + 2 : a.UNINITIALIZED) !== e && g.emit(f.STATE_CHANGE, ne({connectionState: w})), w
            }

            function G() {
              return S
            }

            function V() {
              return P
            }

            function W() {
              return y || !1
            }

            function Y() {
              return G().config.query.cid
            }

            function j() {
              O.debugEnabled() && O.debug("connection open"), setTimeout((function () {
                g.emit(f.CONNECTION_OPEN, ne())
              }), 0), setTimeout((function () {
                !M && D && D.isReady() && (clearTimeout(U), g.emit(f.CONNECTED, ne({count: L.retryCount})), L.retryCount = 0)
              }), 200)
            }

            function K(e) {
              O.debugEnabled() && O.debug("connection close"), clearTimeout(U);
              var t = e;
              if (n.isTridentBrowser && 1005 === e.code && ((t = r.copy(e)).code = parseInt(e.reason.split(" ")[1], 10)), 4200 === t.code) $(!0); else if (4403 === t.code) g.emit(f.ERROR, ne({
                code: o.STREAM.SOURCE_STOPPED,
                message: s.STREAM.SOURCE_STOPPED
              })); else if (4404 === t.code) g.emit(f.ERROR, ne({
                code: o.STREAM.NOT_FOUND,
                message: s.STREAM.NOT_FOUND
              })); else if (4424 === t.code) g.emit(f.ERROR, ne({
                code: o.STREAM.SOURCE_NOT_RETRIEVED,
                message: s.STREAM.SOURCE_NOT_RETRIEVED
              })); else if (4401 === t.code) g.emit(f.ERROR, ne({
                code: o.NETWORK.PLAYBACK_ACCESS_REJECTED,
                message: s.NETWORK.PLAYBACK_ACCESS_REJECTED
              })); else {
                var i = t.code, a = "Unknown reason.";
                1111 === i ? (i = o.NETWORK.TRANSPORT_NOT_CONNECTED, a = "Maybe no network, wrong url or server down. Reconnect possible.") : (Object.prototype.hasOwnProperty.call(d, +i) && (a = d[+i]), i > 1e3 && i < 4e3 && (i += 3100)), X(t, f.DISCONNECTED, ne({
                  code: i,
                  message: a
                }))
              }
            }

            function q(e) {
              O.debugEnabled() && O.debug("connection error"), clearTimeout(h), h = setTimeout((function () {
                if (!M && D.isReady()) {
                  clearTimeout(U);
                  var t = "Connection error.", n = e || void 0;
                  n && n.message && (t = n.message), n && n.code && (t += " (code:" + n.code + ")"), n && n.name && (t = n.name + ": " + t), X(e, f.CONNECTION_ERROR, ne({
                    code: 1111 === n.code ? o.NETWORK.TRANSPORT_NOT_CONNECTED : o.NETWORK.CONNECTION_ERROR,
                    message: t
                  }))
                }
              }), 200)
            }

            function z() {
              O.debugEnabled() && O.debug("connection timeout"), M || !D.isReady() || S && -1 !== S.config.query.flags.indexOf("metastreamonly") || X(null, f.INITIALIZATION_ERROR, ne({
                code: o.NETWORK.COULD_NOT_ESTABLISH_CONNECTION,
                message: "Could not open connection. Timeout reached."
              }))
            }

            function Q(e) {
              re(e)
            }

            function J() {
              if (W()) for (g.emit(f.UPDATE_SOURCE_ERROR, ne({
                tag: y.update.options.tag,
                count: y.update.options.count,
                code: o.NETWORK.SOURCE_TIMEOUT,
                message: s.NETWORK.SOURCE_TIMEOUT,
                type: y.update.type,
                id: y.update.id
              })), A = y, y = void 0; Object.keys(x).length;) delete x[Object.keys(x)[0]]
            }

            function X(e, t, n) {
              if (!M) if (clearTimeout(_), _ = 0, V() && (e && e.data && -1 !== C.indexOf(e.data.code) || n && n.data && -1 !== C.indexOf(n.data.code)) && L.retryCount < L.maxRetries) {
                if (M = !0, !L.retryCount) {
                  for (; L.delays.length;) L.delays.pop();
                  L.delays = c.calculate(L.minDelay, L.maxDelay, L.delaySteps, L.maxRetries, L.randomFactor)
                }
                var r = L.delays[L.retryCount];
                L.retryCount++, S.count = L.retryCount;
                var i = e && e.data && e.data.code ? e.data.code : e && e.code ? e.code : 0;
                i && (i = n && n.data && n.data.code ? n.data.code : n && n.code ? n.code : 0), g.emit(f.RECONNECTION_IMMINENT, ne({
                  delay: r,
                  count: L.retryCount,
                  code: i
                }))
              } else g.emit(t, n && n.data ? n : ne(n))
            }

            function $(e) {
              O.debugEnabled() && O.debug("destroy connection" + (e ? " silent" : "")), y = void 0, Z(), g.emit(f.DESTROYED, ne({silent: !!e}))
            }

            function Z() {
              clearTimeout(U), clearTimeout(_), clearTimeout(h), clearTimeout(T), D.isReady() && (D.removeEventListener("open", j), D.removeEventListener("close", K), D.removeEventListener("error", q), D.close())
            }

            function ee(e, t) {
              if (O.debugEnabled() && O.debug("send " + e), t) try {
                t = JSON.stringify(t)
              } catch (e) {
                t = "{}"
              } else t = "{}";
              var n = F.requestId + 1;
              (F = {}).eventType = e, F[e] = JSON.parse(t), F.requestId = n;
              var r = JSON.stringify(F);
              try {
                H() === a.OPEN && D.send(r)
              } catch (e) {
              }
            }

            function te(e) {
              return {code: e.code, name: e.name, message: e.message}
            }

            function ne(e) {
              return {
                data: e || void 0,
                connectionState: H(),
                connectionId: S.config.query.cid,
                active: V(),
                update: W()
              }
            }

            function re(e, t) {
              var n = e.name.replace(E.BASE, f.BASE);
              t ? O.detailEnabled() && O.detail("fired " + n) : O.debugEnabled() && O.debug("fired " + n), k ? O.debugEnabled() && O.debug("passthrough blocked of message type '" + e.name.replace(E.BASE, "") + "'") : g.emit(n, ne(e.data))
            }

            function ie(e) {
              k = !!e, O.debugEnabled() && O.debug("set blockMessagePassthrough to " + k)
            }

            return O.debugEnabled() && O.debug("init"), D = new p(I, b, v), i.add({target: I, listeners: N}), {
              connect: B, disconnect: function (e) {
                $(e.data.silent)
              }, play: function () {
                O.debugEnabled() && O.debug("on play");
                try {
                  ie(!1), S = l.parse(S, !1), !D.isReady() || D.isClosed() ? B({data: S}) : (O.debugEnabled() && O.debug("sending play to server"), ee("onPlay"), g.emit(f.RESUMING, ne()))
                } catch (e) {
                  g.emit(f.ERROR, ne(te(e)))
                }
              }, pause: function () {
                O.debugEnabled() && O.debug("on pause");
                try {
                  D.isReady() && !D.isClosed() && (O.debugEnabled() && O.debug("sending pause to server"), S = l.parse(S, !0), ee("onPause"), ie(!0))
                } catch (e) {
                  g.emit(f.ERROR, ne(te(e)))
                }
              }, updateSource: function (e) {
                if (O.debugEnabled() && O.debug("on update source"), R && -1 !== R.capabilities.indexOf("onUpdateSource") && "server" === e.data.update.options.method && null !== D) {
                  clearTimeout(T), T = setTimeout(J, 1e3 * e.data.update.options.timeout), x[e.data.update.options.count] = e.data, (y = e.data).count = L.retryCount;
                  var t = y.update, n = {options: {faststart: !1}, tag: t.options.tag, count: t.options.count};
                  if (t.entry.h5live.rtmp && t.entry.h5live.rtmp.url && t.entry.h5live.rtmp.streamname && (n.rtmp = {
                    url: t.entry.h5live.rtmp.url,
                    stream: t.entry.h5live.rtmp.streamname
                  }), t.entry.h5live.token && (n.token = t.entry.h5live.token), t.entry.h5live.params && (n.params = t.entry.h5live.params), t.entry.h5live.security && "object" == typeof t.entry.h5live.security) for (var r in n.security = {}, t.entry.h5live.security) Object.prototype.hasOwnProperty.call(t.entry.h5live.security, r) && (n.security[r] = t.entry.h5live.security[r]);
                  ee("onUpdateSource", n)
                }
              }, reset: function () {
                M = !1, L.retryCount = 0
              }, getState: H, getConnectData: G, getServerInfo: function () {
                return R
              }, getConnection: function () {
                return D
              }, setActive: function (e) {
                P = !!e
              }, isActive: V, isUpdate: W, isWaitForReconnect: function () {
                return M
              }, getConnectionId: Y, isConnectionId: function (e) {
                return Y() === e
              }, shouldPauseOnError: function () {
                return G().update && G().update.options.pauseOnError || y && y.update.options.pauseOnError
              }, destroy: function () {
                O.debugEnabled() && O.debug("destroy"), Z(), D = null, i.remove({target: I, listeners: N})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9134: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "networkMessage.";
        return {
          BASE: e,
          META_DATA: e + "metaData",
          WEB_TRANSPORT_META_DATA: e + "wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: e + "wtGOPCache",
          SERVER_INFO: e + "serverInfo",
          STREAM_INFO: e + "streamInfo",
          STREAM_INFO_UPDATE: e + "streamInfoUpdate",
          STREAM_FRAGMENT: e + "streamFragment",
          RANDOM_ACCESS_POINT: e + "randomAccessPoint",
          RAW_PACKET: e + "raw",
          STREAM_STATUS: e + "streamStatus",
          UPDATE_SOURCE_SUCCESS: e + "updateSourceSuccess",
          UPDATE_SOURCE_ERROR: e + "updateSourceError",
          UPDATE_SOURCE_ABORT: e + "updateSourceAbort",
          STREAM_QUALITY: e + "streamQuality"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7903: function (e, t, n) {
      var r, i;
      r = [n(6627), n(2846), n(7361)], void 0 === (i = function (e, t, n) {
        return function (e, r, i) {
          return "webtransport" === r ? n.create(e, i) : t.create(e, i)
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2846: function (e, t, n) {
      var r, i;
      r = [n(8333), n(5169)], void 0 === (i = function (e, t) {
        "use strict";
        return {
          create: function (n, r) {
            var i = e.create("WebSocketAdapter " + r), a = null, o = null;

            function s() {
              i.debugEnabled() && i.debug("close connection"), a && (a.removeEventListener("open", u), a.removeEventListener("close", c), a.removeEventListener("error", l), a.removeEventListener("message", f), a.close(), o.destroy()), o = null, a = null
            }

            function d() {
              var e = 0;
              return a && (e = a.readyState), e
            }

            function u() {
              i.debugEnabled() && i.debug("connection opened")
            }

            function c() {
              i.debugEnabled() && i.debug("connection closed")
            }

            function l() {
              i.debugEnabled() && i.debug("connection error")
            }

            function f(e) {
              e && o.parseMessage(e.data)
            }

            return {
              open: function (e) {
                i.debugEnabled() && i.debug("open connection"), o = t.create(n, r), (a = new WebSocket(e)).binaryType = "arraybuffer", a.addEventListener("open", u), a.addEventListener("close", c), a.addEventListener("error", l), a.addEventListener("message", f)
              }, send: function (e) {
                a && a.send(e)
              }, close: s, destroy: function () {
                i.debugEnabled() && i.debug("destroy connection"), s()
              }, readyState: d, addEventListener: function (e, t) {
                a && -1 !== ["open", "close", "error"].indexOf(e) && a.addEventListener(e, t)
              }, removeEventListener: function (e, t) {
                a && -1 !== ["open", "close", "error"].indexOf(e) && a.removeEventListener(e, t)
              }, isOpening: function () {
                return 0 === d()
              }, isOpen: function () {
                return 1 === d()
              }, isClosing: function () {
                return 2 === d()
              }, isClosed: function () {
                return 3 === d()
              }, isReady: function () {
                return null !== a
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5169: function (e, t, n) {
      var r, i;
      r = [n(8333), n(9134)], void 0 === (i = function (e, t) {
        "use strict";
        return {
          create: function (n, r) {
            var i = e.create("WebSocketMessageHandler " + r), a = 1718909296, o = 1836019558, s = 1835295092, d = [],
              u = 0, c = 0;

            function l(e) {
              if (0 < u) {
                e && i.debugEnabled() && i.debug("output existing buffer & reset from " + e);
                var r = new Uint8Array(u), a = 0;
                for (var o of d) r.set(o, a), a += o.length;
                f(), n.emit(t.STREAM_FRAGMENT, {type: "mp4", fragment: r})
              } else e && i.debugEnabled() && i.debug("reset from " + e), f()
            }

            function f() {
              for (; d.length;) d.pop();
              u = 0, c = 0
            }

            return i.debugEnabled() && i.debug("init websocket message handler"), {
              parseMessage: function (e) {
                if (e) if (e instanceof ArrayBuffer) {
                  var r = new Uint8Array(e);
                  if (n.emit(t.RAW_PACKET), r.length >= 8) {
                    var f = r[4] << 24 | r[5] << 16 | r[6] << 8 | r[7];
                    if (f === o || f === a) {
                      var E = r[0] << 24 | r[1] << 16 | r[2] << 8 | r[3];
                      if (r.length >= E + 8) {
                        var p = r[E + 4] << 24 | r[E + 5] << 16 | r[E + 6] << 8 | r[E + 7];
                        if ((f === o && p === s || f === a && 1836019574 === p) && (u && i.debugEnabled() && i.debug("previous buffer found"), l()), f === o && p === s) {
                          var m = r[E + 0] << 24 | r[E + 1] << 16 | r[E + 2] << 8 | r[E + 3];
                          c = E + m
                        }
                      }
                    }
                  }
                  d.push(r), u += r.length, c && c === u && l()
                } else {
                  var g = JSON.parse(e);
                  if (g && g.eventType) {
                    var b = g.eventType.substr(2, g.eventType.length - 2), _ = t.BASE + b[0].toLowerCase() + b.slice(1);
                    -1 !== _.indexOf(t.STREAM_INFO) && l(_), -1 !== _.indexOf(t.SERVER_INFO) && void 0 === g.onServerInfo.hostname && (g.onServerInfo.hostname = ""), n.emit(_, g)
                  }
                }
              }, destroy: function () {
                i.debugEnabled() && i.debug("destroy websocket message handler"), f()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3346: function (e) {
      var t;
      self, t = () => (() => {
        "use strict";
        var e = {
          228: e => {
            var t = Object.prototype.hasOwnProperty, n = "~";

            function r() {
            }

            function i(e, t, n) {
              this.fn = e, this.context = t, this.once = n || !1
            }

            function a(e, t, r, a, o) {
              if ("function" != typeof r) throw new TypeError("The listener must be a function");
              var s = new i(r, a || e, o), d = n ? n + t : t;
              return e._events[d] ? e._events[d].fn ? e._events[d] = [e._events[d], s] : e._events[d].push(s) : (e._events[d] = s, e._eventsCount++), e
            }

            function o(e, t) {
              0 == --e._eventsCount ? e._events = new r : delete e._events[t]
            }

            function s() {
              this._events = new r, this._eventsCount = 0
            }

            Object.create && (r.prototype = Object.create(null), (new r).__proto__ || (n = !1)), s.prototype.eventNames = function () {
              var e, r, i = [];
              if (0 === this._eventsCount) return i;
              for (r in e = this._events) t.call(e, r) && i.push(n ? r.slice(1) : r);
              return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(e)) : i
            }, s.prototype.listeners = function (e) {
              var t = n ? n + e : e, r = this._events[t];
              if (!r) return [];
              if (r.fn) return [r.fn];
              for (var i = 0, a = r.length, o = new Array(a); i < a; i++) o[i] = r[i].fn;
              return o
            }, s.prototype.listenerCount = function (e) {
              var t = n ? n + e : e, r = this._events[t];
              return r ? r.fn ? 1 : r.length : 0
            }, s.prototype.emit = function (e, t, r, i, a, o) {
              var s = n ? n + e : e;
              if (!this._events[s]) return !1;
              var d, u, c = this._events[s], l = arguments.length;
              if (c.fn) {
                switch (c.once && this.removeListener(e, c.fn, void 0, !0), l) {
                  case 1:
                    return c.fn.call(c.context), !0;
                  case 2:
                    return c.fn.call(c.context, t), !0;
                  case 3:
                    return c.fn.call(c.context, t, r), !0;
                  case 4:
                    return c.fn.call(c.context, t, r, i), !0;
                  case 5:
                    return c.fn.call(c.context, t, r, i, a), !0;
                  case 6:
                    return c.fn.call(c.context, t, r, i, a, o), !0
                }
                for (u = 1, d = new Array(l - 1); u < l; u++) d[u - 1] = arguments[u];
                c.fn.apply(c.context, d)
              } else {
                var f, E = c.length;
                for (u = 0; u < E; u++) switch (c[u].once && this.removeListener(e, c[u].fn, void 0, !0), l) {
                  case 1:
                    c[u].fn.call(c[u].context);
                    break;
                  case 2:
                    c[u].fn.call(c[u].context, t);
                    break;
                  case 3:
                    c[u].fn.call(c[u].context, t, r);
                    break;
                  case 4:
                    c[u].fn.call(c[u].context, t, r, i);
                    break;
                  default:
                    if (!d) for (f = 1, d = new Array(l - 1); f < l; f++) d[f - 1] = arguments[f];
                    c[u].fn.apply(c[u].context, d)
                }
              }
              return !0
            }, s.prototype.on = function (e, t, n) {
              return a(this, e, t, n, !1)
            }, s.prototype.once = function (e, t, n) {
              return a(this, e, t, n, !0)
            }, s.prototype.removeListener = function (e, t, r, i) {
              var a = n ? n + e : e;
              if (!this._events[a]) return this;
              if (!t) return o(this, a), this;
              var s = this._events[a];
              if (s.fn) s.fn !== t || i && !s.once || r && s.context !== r || o(this, a); else {
                for (var d = 0, u = [], c = s.length; d < c; d++) (s[d].fn !== t || i && !s[d].once || r && s[d].context !== r) && u.push(s[d]);
                u.length ? this._events[a] = 1 === u.length ? u[0] : u : o(this, a)
              }
              return this
            }, s.prototype.removeAllListeners = function (e) {
              var t;
              return e ? (t = n ? n + e : e, this._events[t] && o(this, t)) : (this._events = new r, this._eventsCount = 0), this
            }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s
          }
        }, t = {};

        function n(r) {
          var i = t[r];
          if (void 0 !== i) return i.exports;
          var a = t[r] = {exports: {}};
          return e[r](a, a.exports, n), a.exports
        }

        n.d = (e, t) => {
          for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {enumerable: !0, get: t[r]})
        }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
        };
        var r = {};
        n.r(r), n.d(r, {MessagePayloadType: () => a, Transport: () => T, getMessageJsonPayload: () => f});
        var i, a, o = n(228), s = (i = function (e, t) {
          return (i = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
          })(e, t)
        }, function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

          function n() {
            this.constructor = e
          }

          i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
        }), d = function (e) {
          function t() {
            return null !== e && e.apply(this, arguments) || this
          }

          return s(t, e), t
        }(o), u = function () {
          function e() {
            this._events = new d
          }

          return e.prototype.on = function (e, t) {
            return this._events.on(e, t)
          }, e.prototype.off = function (e, t) {
            return this._events.off(e, t)
          }, e.prototype.emit = function (e) {
            for (var t, n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
            return (t = this._events).emit.apply(t, function (e, t, n) {
              if (n || 2 === arguments.length) for (var r, i = 0, a = t.length; i < a; i++) !r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
              return e.concat(r || Array.prototype.slice.call(t))
            }([e], n, !1))
          }, e
        }(), c = function () {
        };

        function l(e) {
          var t = e.buffer, n = e.byteOffset, r = e.byteLength;
          return new DataView(t, n, r)
        }

        function f(e) {
          var t = new TextDecoder;
          return JSON.parse(t.decode(e.payload))
        }

        window.performance, function (e) {
          e[e.IsoBox = 0] = "IsoBox", e[e.Json = 1] = "Json", e[e.Avc = 2] = "Avc", e[e.Aac = 3] = "Aac"
        }(a || (a = {}));
        var E = function (e, t, n, r) {
          return new (n || (n = Promise))((function (i, a) {
            function o(e) {
              try {
                d(r.next(e))
              } catch (e) {
                a(e)
              }
            }

            function s(e) {
              try {
                d(r.throw(e))
              } catch (e) {
                a(e)
              }
            }

            function d(e) {
              var t;
              e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
              }))).then(o, s)
            }

            d((r = r.apply(e, t || [])).next())
          }))
        }, p = function (e, t) {
          var n, r, i, a = {
            label: 0, sent: function () {
              if (1 & i[0]) throw i[1];
              return i[1]
            }, trys: [], ops: []
          }, o = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
          return o.next = s(0), o.throw = s(1), o.return = s(2), "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this
          }), o;

          function s(s) {
            return function (d) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; o && (o = 0, s[0] && (a = 0)), a;) try {
                  if (n = 1, r && (i = 2 & s[0] ? r.return : s[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, s[1])).done) return i;
                  switch (r = 0, i && (s = [2 & s[0], i.value]), s[0]) {
                    case 0:
                    case 1:
                      i = s;
                      break;
                    case 4:
                      return a.label++, {value: s[1], done: !1};
                    case 5:
                      a.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        a = 0;
                        continue
                      }
                      if (3 === s[0] && (!i || s[1] > i[0] && s[1] < i[3])) {
                        a.label = s[1];
                        break
                      }
                      if (6 === s[0] && a.label < i[1]) {
                        a.label = i[1], i = s;
                        break
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(s);
                        break
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue
                  }
                  s = t.call(e, a)
                } catch (e) {
                  s = [6, e], r = 0
                } finally {
                  n = i = 0
                }
                if (5 & s[0]) throw s[1];
                return {value: s[0] ? s[1] : void 0, done: !0}
              }([s, d])
            }
          }
        }, m = function () {
          function e(e, t) {
            this._streamIndex = e, this._incomingStream = t, this._rxDataBuf = null, this._rxDataOffset = 0, this._isClosed = !1, this._reader = null, this._consumePromise = null, this._shouldClose = !1, this._closing = !1, this.onClose = null, this.onMessage = c, this.onError = c, this.onDescription = c, this.onEos = c, this.onVideoCodecInfo = c, this.onAudioCodecInfo = c, this.onTrace = c
          }

          return e.prototype.consume = function () {
            return E(this, void 0, void 0, (function () {
              var e = this;
              return p(this, (function (t) {
                return this._incomingStream ? this._reader ? (this.onTrace("StreamReader ".concat(this._streamIndex, ": Already consuming.")), [2]) : (this._reader = this._incomingStream.readable.getReader(), this._consumePromise = E(e, void 0, void 0, (function () {
                  var e, t, n, r;
                  return p(this, (function (i) {
                    switch (i.label) {
                      case 0:
                        i.trys.push([0, 7, 8, 10]), i.label = 1;
                      case 1:
                        if (this._shouldClose) return [3, 6];
                        if (!this._reader) return [3, 6];
                        e = void 0, i.label = 2;
                      case 2:
                        return i.trys.push([2, 4, , 5]), [4, this._reader.read()];
                      case 3:
                        return e = i.sent(), [3, 5];
                      case 4:
                        return t = i.sent(), this._closing && "WebTransportError" === (null == t ? void 0 : t.name) || this.onTrace("StreamReader ".concat(this._streamIndex, " read error: ").concat(null == t ? void 0 : t.message)), [3, 6];
                      case 5:
                        return n = e.value, e.done ? (this.onTrace("StreamReader.consume done: idx=".concat(this._streamIndex)), [3, 6]) : (n && this._handleReadBuffer(n), [3, 1]);
                      case 6:
                        return [3, 10];
                      case 7:
                        return r = i.sent(), this.onTrace("StreamReader.consume error on stream ".concat(this._streamIndex, ": ").concat(null == r ? void 0 : r.message)), [3, 10];
                      case 8:
                        return [4, this._cleanup()];
                      case 9:
                        return i.sent(), this.onClose && this.onClose(), [7];
                      case 10:
                        return [2]
                    }
                  }))
                })), [2]) : (this.onTrace("StreamReader ".concat(this._streamIndex, ": No incoming stream to consume.")), [2])
              }))
            }))
          }, e.prototype._cleanup = function () {
            return E(this, void 0, void 0, (function () {
              return p(this, (function (e) {
                switch (e.label) {
                  case 0:
                    if (this._isClosed) return [2];
                    if (this._isClosed = !0, !this._reader) return [3, 5];
                    e.label = 1;
                  case 1:
                    return e.trys.push([1, 3, , 4]), [4, this._reader.cancel()];
                  case 2:
                  case 3:
                    return e.sent(), [3, 4];
                  case 4:
                    this._reader.releaseLock(), this._reader = null, e.label = 5;
                  case 5:
                    return this._incomingStream = null, this.onMessage = c, this.onClose = null, this._shouldClose = !1, this._closing = !1, [2]
                }
              }))
            }))
          }, e.prototype.close = function () {
            return E(this, void 0, void 0, (function () {
              return p(this, (function (e) {
                switch (e.label) {
                  case 0:
                    return this._closing = !0, this._shouldClose = !0, this._consumePromise ? [4, this._consumePromise] : [3, 2];
                  case 1:
                    e.sent(), e.label = 2;
                  case 2:
                    return [2]
                }
              }))
            }))
          }, e.prototype._handleReadBuffer = function (e) {
            if (!this._isClosed) {
              for (this._appendBuffer(e); ;) {
                var t = l(this._rxDataBuf), n = t.byteLength - this._rxDataOffset;
                if (n < 20) break;
                var r = t.getUint32(this._rxDataOffset, !0);
                if (n < r) break;
                if (this._popCurrentMessage(r), this._rxDataOffset >= t.byteLength) break
              }
              this._pruneBufferHead()
            }
          }, e.prototype._appendBuffer = function (e) {
            if (this._rxDataBuf) {
              var t = new Uint8Array(this._rxDataBuf.byteLength - this._rxDataOffset + e.byteLength);
              t.set(this._rxDataBuf.subarray(this._rxDataOffset)), t.set(e, this._rxDataBuf.byteLength - this._rxDataOffset), this._rxDataBuf = t
            } else this._rxDataBuf = e;
            this._rxDataOffset = 0
          }, e.prototype._popCurrentMessage = function (e) {
            if (this._rxDataBuf) {
              var t = this._rxDataOffset + e, n = this._rxDataBuf.subarray(this._rxDataOffset, t);
              this._rxDataOffset = t;
              var r = function (e) {
                var t = l(e), n = t.getUint32(0, !0);
                if (n !== e.byteLength) throw new Error("Assertion failed: msg.size=".concat(n, " != data.byteLength=").concat(e.byteLength));
                var r = t.getUint32(4, !0);
                return {
                  size: n,
                  flags: r,
                  time: t.getBigUint64(8, !0),
                  pto: t.getInt32(16, !0),
                  payload: e.subarray(20),
                  flagsParsed: function (e) {
                    return {
                      PayloadType: 255 & e,
                      IsSyncpoint: (256 & e) > 0,
                      IsKeyframe: (512 & e) > 0,
                      IsCodecConfig: (1024 & e) > 0,
                      IsTimingMarker: (4096 & e) > 0,
                      IsGopCache: (8192 & e) > 0
                    }
                  }(r)
                }
              }(n);
              this._processMessage(r)
            }
          }, e.prototype._processMessage = function (e) {
            switch (e.flagsParsed.PayloadType) {
              case a.Json:
                var t = f(e);
                "Description" === t.Type || "Eos" === t.Type || "Error" === t.Type && this.onError(t);
              case a.Avc:
              case a.Aac:
            }
            this.onMessage(e, -1, "")
          }, e.prototype._pruneBufferHead = function () {
            this._rxDataBuf && this._rxDataOffset > 0 && (this._rxDataBuf = this._rxDataBuf.subarray(this._rxDataOffset), this._rxDataOffset = 0)
          }, Object.defineProperty(e.prototype, "groupId", {
            get: function () {
              return -1
            }, enumerable: !1, configurable: !0
          }), e
        }(), g = function () {
          var e = function (t, n) {
            return (e = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
              e.__proto__ = t
            } || function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
            })(t, n)
          };
          return function (t, n) {
            if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");

            function r() {
              this.constructor = t
            }

            e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r)
          }
        }(), b = function (e, t, n, r) {
          return new (n || (n = Promise))((function (i, a) {
            function o(e) {
              try {
                d(r.next(e))
              } catch (e) {
                a(e)
              }
            }

            function s(e) {
              try {
                d(r.throw(e))
              } catch (e) {
                a(e)
              }
            }

            function d(e) {
              var t;
              e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
              }))).then(o, s)
            }

            d((r = r.apply(e, t || [])).next())
          }))
        }, _ = function (e, t) {
          var n, r, i, a = {
            label: 0, sent: function () {
              if (1 & i[0]) throw i[1];
              return i[1]
            }, trys: [], ops: []
          }, o = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
          return o.next = s(0), o.throw = s(1), o.return = s(2), "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this
          }), o;

          function s(s) {
            return function (d) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; o && (o = 0, s[0] && (a = 0)), a;) try {
                  if (n = 1, r && (i = 2 & s[0] ? r.return : s[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, s[1])).done) return i;
                  switch (r = 0, i && (s = [2 & s[0], i.value]), s[0]) {
                    case 0:
                    case 1:
                      i = s;
                      break;
                    case 4:
                      return a.label++, {value: s[1], done: !1};
                    case 5:
                      a.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        a = 0;
                        continue
                      }
                      if (3 === s[0] && (!i || s[1] > i[0] && s[1] < i[3])) {
                        a.label = s[1];
                        break
                      }
                      if (6 === s[0] && a.label < i[1]) {
                        a.label = i[1], i = s;
                        break
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(s);
                        break
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue
                  }
                  s = t.call(e, a)
                } catch (e) {
                  s = [6, e], r = 0
                } finally {
                  n = i = 0
                }
                if (5 & s[0]) throw s[1];
                return {value: s[0] ? s[1] : void 0, done: !0}
              }([s, d])
            }
          }
        }, h = function (e) {
          function t(t, n) {
            var r = e.call(this, t) || this;
            return r.code = n, r.code = n, r
          }

          return g(t, e), t
        }(Error), T = function (e) {
          function t() {
            var t = e.call(this) || this;
            return t._transportConnection = null, t._nextStreamIdx = 0, t._streamReaders = {}, t._groupIdToStreamReader = new Map, t._videoCodecInfo = {}, t._audioCodecInfo = {}, t
          }

          return g(t, e), t.prototype.isConnectionReady = function () {
            return !!this._transportConnection
          }, t.prototype.connect = function (e) {
            return b(this, void 0, void 0, (function () {
              var t, n, r = this;
              return _(this, (function (i) {
                switch (i.label) {
                  case 0:
                    if (this._transportConnection) throw new Error("Transport already connected");
                    try {
                      t = new WebTransport(e), this.emit("log", "Transport connecting to ".concat(e))
                    } catch (e) {
                      return this.emit("error", new Error("Failed to create WebTransport: ".concat(e)), e), [2]
                    }
                    this.emit("log", "Transport created, waiting for connection to be ready"), i.label = 1;
                  case 1:
                    return i.trys.push([1, 3, , 4]), [4, t.ready];
                  case 2:
                    return i.sent(), this._transportConnection = t, [3, 4];
                  case 3:
                    return n = i.sent(), this.emit("error", new Error("Failed to connect: ".concat(n)), n), [2];
                  case 4:
                    return this.emit("log", "Transport connection ready"), this.emit("ready"), t.closed.catch((function (e) {
                      r.emit("error", new Error("Exception on closing WT connection: ".concat(e)), e)
                    })).finally((function () {
                      r.emit("closed")
                    })), [2]
                }
              }))
            }))
          }, t.prototype.disconnect = function () {
            return b(this, void 0, void 0, (function () {
              var e;
              return _(this, (function (t) {
                switch (t.label) {
                  case 0:
                    if (!this._transportConnection) return [3, 2];
                    for (e in this._streamReaders) this._streamReaders[e].close();
                    return [4, this._transportConnection.close()];
                  case 1:
                    t.sent(), this._transportConnection = null, this.emit("closed"), t.label = 2;
                  case 2:
                    return [2]
                }
              }))
            }))
          }, t.prototype.accept = function () {
            return b(this, void 0, void 0, (function () {
              var e, t, n, r, i;
              return _(this, (function (a) {
                switch (a.label) {
                  case 0:
                    if (!this._transportConnection) throw new Error("Transport not connected");
                    e = this._transportConnection.incomingBidirectionalStreams.getReader(), a.label = 1;
                  case 1:
                    this.emit("log", "Waiting to accept new incoming transport streams"), t = void 0, n = !1, a.label = 2;
                  case 2:
                    return a.trys.push([2, 4, , 5]), [4, e.read()];
                  case 3:
                    return r = a.sent(), t = r.value, n = r.done, [3, 5];
                  case 4:
                    return i = a.sent(), this.emit("error", new Error("Exception on incoming stream read: ".concat(i)), i), [2];
                  case 5:
                    return t ? [4, this._addIncomingStream(t)] : [3, 7];
                  case 6:
                    a.sent(), a.label = 7;
                  case 7:
                    return n ? (this.emit("log", "Incoming stream reader done"), [3, 8]) : [3, 1];
                  case 8:
                    return [2]
                }
              }))
            }))
          }, t.prototype._addIncomingStream = function (e) {
            return b(this, void 0, void 0, (function () {
              var t, n, r = this;
              return _(this, (function (i) {
                return t = this._nextStreamIdx++, n = new m(t, e), this._streamReaders[t] = n, n.onError = function (e) {
                  r.emit("serverError", new h(e.Message, e.Code))
                }, n.onMessage = function (e, n, i) {
                  r.emit("message", e, n, i, t)
                }, n.onDescription = function (e, t) {
                  r._groupIdToStreamReader.set(t.GroupId, n), r.emit("streamAdded", n)
                }, n.onVideoCodecInfo = function (e) {
                  r._videoCodecInfo = e
                }, n.onAudioCodecInfo = function (e) {
                  r._audioCodecInfo = e
                }, n.onClose = function () {
                  delete r._streamReaders[t], n.groupId >= 0 && r._groupIdToStreamReader.delete(n.groupId), r.emit("streamRemoved", n)
                }, n.consume(), [2]
              }))
            }))
          }, t.prototype.getConnectionStats = function () {
            return Promise.resolve({bytesSent: 0, bytesReceived: 0})
          }, t.prototype.getStatusInfo = function () {
            return {streamReaders: [], activeStreamReaders: []}
          }, t.prototype.getStreamReaderByGroupId = function (e) {
            return this._groupIdToStreamReader.get(e)
          }, t.prototype.getVideoCodecInfo = function () {
            return this._videoCodecInfo
          }, t.prototype.getAudioCodecInfo = function () {
            return this._audioCodecInfo
          }, t
        }(u);
        return r
      })(), e.exports = t()
    }, 7361: function (e, t, n) {
      var r, i;
      r = [n(8333), n(3346), n(4034)], void 0 === (i = function (e, t, n) {
        "use strict";
        var r = t.Transport;
        return {
          create: function (t, i) {
            var a = e.create("WebTransportAdapter " + i), o = n.create(t, i), s = {}, d = null;

            function u() {
              if (a.debugEnabled() && a.debug("Closing adapter..."), d) {
                d.off("ready", c), d.off("error", l), d.off("serverError", f), d.off("message", E), d.off("log", p);
                var e = d;
                d = null, o.reset(), e.disconnect().then((function () {
                  a.debugEnabled() && a.debug("Transport disconnected successfully")
                })).catch((function (e) {
                  a.debugEnabled() && a.debug("Transport disconnect error:", e)
                }))
              }
              m("close")
            }

            function c() {
              o.reset(), a.debugEnabled() && a.debug("Transport ready"), m("open")
            }

            function l(e) {
              a.debugEnabled() && a.debug("Transport error:" + JSON.stringify(e)), m("close", {
                message: e.message,
                code: e.code || 1111
              })
            }

            function f(e) {
              a.debugEnabled() && a.debug("Server error:" + JSON.stringify(e)), m("close", {
                message: e.message,
                code: e.code
              })
            }

            function E(e) {
              o.parseMessage(e)
            }

            function p(e) {
              a.debugEnabled() && a.debug("Transport log:" + e)
            }

            function m(e, t) {
              s[e] && s[e].forEach((function (e) {
                e(t)
              }))
            }

            function g() {
              return d && d.isConnected ? "connected" : "disconnected"
            }

            return {
              open: function (e) {
                a.debugEnabled() && a.debug("WebTransportAdapter open, url=" + e), (d = new r).on("ready", c), d.on("error", l), d.on("serverError", f), d.on("message", E), d.on("log", p), d.connect(e).then((function () {
                  return a.debugEnabled() && a.debug("Transport connected, now accepting streams"), d.accept()
                })).catch((function (e) {
                  a.debugEnabled() && a.debug("Transport connect/accept error:" + JSON.stringify(e)), m("error", {
                    message: e.message,
                    code: 1111
                  })
                }))
              }, close: u, destroy: function () {
                u()
              }, send: function (e) {
                d && d.isConnected && "function" == typeof d.send && d.send(e)
              }, readyState: g, isReady: function () {
                return null !== d
              }, isOpening: function () {
                return "connecting" === g()
              }, isOpen: function () {
                return "connected" === g()
              }, isClosing: function () {
                return !1
              }, isClosed: function () {
                return "disconnected" === g()
              }, addEventListener: function (e, t) {
                s[e] || (s[e] = []), s[e].push(t)
              }, removeEventListener: function (e, t) {
                s[e] && (s[e] = s[e].filter((function (e) {
                  return e !== t
                })))
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4034: function (e, t, n) {
      var r, i;
      r = [n(8333), n(9134), n(3346)], void 0 === (i = function (e, t, n) {
        "use strict";
        var r = n.MessagePayloadType, i = n.getMessageJsonPayload;
        return {
          create: function (n, a) {
            var o = e.create("WebTransportMessageHandler " + a), s = 0, d = void 0, u = void 0, c = void 0, l = void 0,
              f = void 0, E = !1, p = !1, m = NaN, g = NaN, b = 0, _ = void 0;

            function h(e) {
              var r;
              !function (e) {
                if (Object.hasOwnProperty.call(e, "Server")) {
                  var r = {
                    eventType: "onServerInfo",
                    onServerInfo: {
                      serverName: e.Server.split(" ")[0] || "Unknown",
                      serverVersion: e.Server.split(" ")[1] || "5.0.5.0",
                      interfaceVersion: "1.5.0.5",
                      events: ["Description", "Eos", "onMetaData"],
                      capabilities: [],
                      hostname: ""
                    }
                  };
                  n.emit(t.SERVER_INFO, r)
                }
              }(e), r = {
                eventType: "onStreamStatus",
                onStreamStatus: {status: "started", requestId: 0, count: 0, tag: ""}
              }, n.emit(t.STREAM_STATUS, r), n.emit(t.UPDATE_SOURCE_SUCCESS, {
                eventType: "onUpdateSourceSuccess",
                onUpdateSourceSuccess: {requestId: 0, count: 0, tag: ""}
              }), function (e) {
                var r = "video/mp4; codecs='" + (u ? "avc1.42E01E" : "") + (c && u ? ", " : "") + (c ? "mp4a.40.2" : "") + "'",
                  i = e.width, a = e.height, o = e.framerate, s = {
                    eventType: "onStreamInfo",
                    onStreamInfo: {
                      haveAudio: c,
                      haveVideo: u,
                      mimeType: r,
                      prerollDuration: 0,
                      audioInfo: c ? {sampleRate: 44100, channels: 2, bitsPerSample: 16} : null,
                      videoInfo: u ? {width: i, height: a, frameRate: o} : null
                    }
                  };
                n.emit(t.STREAM_INFO, s)
              }(e), _ && n.emit(t.WEB_TRANSPORT_GOP_CACHE, _)
            }

            function T(e) {
              0 === s && e > 0 && (s = Number(e), o.debugEnabled() && o.debug("referenceTime: ", s))
            }

            return o.debugEnabled() && o.debug("init webtransport message handler"), {
              parseMessage: function (e) {
                var a = e.flagsParsed.PayloadType;
                if (a === r.Json) !function (e) {
                  var r, a = i(e);
                  if (a && "object" == typeof a) if ("onMetaData" === a.eventType && a.onMetaData) {
                    if ("onGopCache" === a.onMetaData.handlerName) o.debugEnabled() && o.debug("onGopCache data:" + JSON.stringify(a)), (r = a.onMetaData.message) ? _ = r : o.debugEnabled() && o.debug("onMetaData gopcache invalid"); else if (e.flagsParsed.IsCodecConfig) o.debugEnabled() && o.debug("onMetaData streaminfo data:" + JSON.stringify(a)), function (e) {
                      e ? (c = !!(d = e).audiocodecid, u = !!d.videocodecid) : o.debugEnabled() && o.debug("onMetaData streaminfo invalid")
                    }(a.onMetaData.message); else if (o.debugEnabled() && o.debug("onMetaData data:" + JSON.stringify(a)), s > 0) {
                      var l = Number(e.time), f = l - s;
                      a.onMetaData.streamTime = f >= 0 ? f / 1e6 : 0, a.onMetaData.originalMetadaTime = l, a.onMetaData.chunkIndex = 1, a.onMetaData.chunkCount = 1, a.onMetaData.message = JSON.stringify(a.onMetaData.message), n.emit(t.WEB_TRANSPORT_META_DATA, a)
                    }
                  } else if ("timingmarker" === a.type) m = a.keyFrameTimestamp, g = performance.now(), isNaN(a.keyFrameDelay) || (b = Math.max(0, a.keyFrameDelay)); else {
                    if ("Description" === a.Type) return;
                    o.debugEnabled() && o.debug("Unhandled JSON message:" + JSON.stringify(a))
                  } else o.debugEnabled() && o.debug("Ignoring unexpected JSON data:" + a)
                }(e); else if (a === r.Avc) {
                  if (e.flagsParsed.IsCodecConfig && (l = e), !E && l && d && e.flagsParsed.IsKeyframe && (h(d), l.time = e.time, n.emit(t.RAW_PACKET), n.emit(t.STREAM_FRAGMENT, {
                    type: "avc",
                    fragment: l
                  }), E = !0, T(e.time || 1), !isNaN(m) && !isNaN(g) && m === e.time)) {
                    var A = 1e3 * Math.floor(performance.now() - g) + b;
                    o.debugEnabled() && o.debug("startDelay: " + (A / 1e6).toFixed(3) + " (" + (b / 1e6).toFixed(3) + ")"), e.startDelay = A
                  }
                  E ? (n.emit(t.RAW_PACKET), n.emit(t.STREAM_FRAGMENT, {
                    type: "avc",
                    fragment: e
                  })) : e.flagsParsed.IsKeyframe && o.debugEnabled() && o.debug("Dropped video key frame")
                } else a === r.Aac ? (e.flagsParsed.IsCodecConfig && (f = e), p || f && d && !e.flagsParsed.IsCodecConfig && (E || !1 === u) && (!1 === u && (h(d), T(e.time || 1)), f.time = e.time, n.emit(t.RAW_PACKET), n.emit(t.STREAM_FRAGMENT, {
                  type: "aac",
                  fragment: f
                }), p = !0), p && (n.emit(t.RAW_PACKET), n.emit(t.STREAM_FRAGMENT, {
                  type: "aac",
                  fragment: e
                }))) : o.debugEnabled() && o.debug("Other message type:" + e)
              }, reset: function () {
                s = 0, d = void 0, u = void 0, c = void 0, l = void 0, f = void 0, E = !1, p = !1, m = NaN, g = NaN, b = 0, _ = void 0
              }, destroy: function () {
                o.debugEnabled() && o.debug("destroy webtransport message handler")
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9452: function (e, t, n) {
      var r, i;
      r = [n(8333), n(6627), n(8197), n(6637), n(8405), n(492), n(5493), n(312), n(5212), n(7732), n(6143)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        var l = e.create("NetworkHandler");
        return {
          create: function (e) {
            var n, i = [{type: s.CONNECT, listener: p}, {
              type: s.DISCONNECT, listener: function () {
                if (l.debugEnabled() && l.debug("on disconnect"), 1 !== E.length || !b().isWaitForReconnect()) for (l.debugEnabled() && l.debug("not waiting for reconnect"); E.length;) E.pop().destroy()
              }
            }, {
              type: s.PLAY, listener: function () {
                l.debugEnabled() && l.debug("on play"), 1 === E.length && E[0].play()
              }
            }, {
              type: s.PAUSE, listener: function () {
                l.debugEnabled() && l.debug("on pause"), 1 === E.length && E[0].pause()
              }
            }, {
              type: s.UPDATE_SOURCE, listener: function (t) {
                if (l.debugEnabled() && l.debug("on update source"), 0 === E.length) t.data.update.options.method = "client", p(t); else {
                  for (; E.length > 1;) {
                    var n = _().getConnectData().update.options;
                    e.emit(u.UPDATE_SOURCE_ABORT, {reason: "superseded", tag: n.tag, count: n.count}), A()
                  }
                  var r = E[0].getConnectData(), i = E[0].getServerInfo(),
                    a = r.config.server.websocket !== t.data.config.server.websocket, o = !i,
                    s = !o && -1 === i.capabilities.indexOf("onUpdateSource"),
                    d = "client" === t.data.update.options.method;
                  a || o || s || d ? (t.data.update.options.method = "client", p(t)) : (t.data.update.options.method = "server", E[0].updateSource(t))
                }
              }
            }, {
              type: s.STATE_CHANGE, listener: function (e) {
                e.data.state === a.PAUSING && n !== a.RECONNECTION_IMMINENT && E.length && b().reset(), n = e.data.state
              }
            }, {
              type: s.CONFIG, listener: function (n) {
                (t.mustUseHLS || n.data.config.playback.allowSafariHlsFallback && t.canUseHLS) && (f = f.filter((function (e) {
                  return e.type === u.META_DATA
                }))), r.add({target: e, listeners: f})
              }
            }, {
              type: s.UPDATE_SOURCE_SUCCESS, listener: function () {
                l.debugEnabled() && l.debug("onExternalUpdateSourceSuccess"), E.length > 1 && (T(), _().setActive(!0))
              }
            }, {
              type: s.UPDATE_SOURCE_FAIL, listener: function () {
                l.debugEnabled() && l.debug("onExternalUpdateSourceFail"), A()
              }
            }, {
              type: s.SWITCH_STREAM_SUCCESS, listener: function () {
                l.debugEnabled() && l.debug("onExternalSwitchStreamSuccess"), E.length > 1 && (T(), _().setActive(!0))
              }
            }, {
              type: s.SWITCH_STREAM_FAIL, listener: function () {
                l.debugEnabled() && l.debug("onExternalSwitchStreamFail"), A()
              }
            }], o = [{
              type: u.CONNECTING, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.CONNECTED, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.CONNECTION_OPEN, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.DISCONNECTED, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), t.update && e.emit(d.UPDATE_SOURCE_FAIL, {
                  tag: t.update.update.options.tag,
                  count: t.update.update.options.count,
                  code: t.data.code,
                  message: t.data.message,
                  type: t.update.update.type,
                  id: t.update.update.id
                }), (h() || t.active) && g(t), A()
              }
            }, {
              type: u.RESUMING, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.MESSAGE, listener: function (e) {
                l.detailEnabled() && l.detail("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.RECONNECTION_IMMINENT, listener: function (e) {
                if (l.debugEnabled() && l.debug("fired " + e.name), e.active) {
                  if (-1 === [a.LOADING, a.PLAYING, a.BUFFERING].indexOf(n)) return void b().reset();
                  g(e)
                }
              }
            }, {
              type: u.RECONNECTING, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.RECONNECTION_CONFIG_INVALID, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), t.update && e.emit(d.UPDATE_SOURCE_FAIL, {
                  tag: t.update.update.options.tag,
                  count: t.update.update.options.count,
                  code: t.data.code,
                  message: t.data.message,
                  type: t.update.update.type,
                  id: t.update.update.id
                }), t.active && g(t)
              }
            }, {
              type: u.CONNECTION_ERROR, listener: function (e) {
                if (l.debugEnabled() && l.debug("fired " + e.name), h() || e.active) {
                  if (-1 === [a.LOADING, a.PLAYING, a.BUFFERING].indexOf(n)) return void b().reset();
                  g(e)
                }
                A()
              }
            }, {
              type: u.INITIALIZATION_ERROR, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), t.update && e.emit(d.UPDATE_SOURCE_FAIL, {
                  tag: t.update.update.options.tag,
                  count: t.update.update.options.count,
                  code: t.data.code,
                  message: t.data.message,
                  type: t.update.update.type,
                  id: t.update.update.id
                }), (h() || t.active) && g(t), A()
              }
            }, {
              type: u.DESTROYED, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.ERROR, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), t.update && e.emit(d.UPDATE_SOURCE_FAIL, {
                  tag: t.update.update.options.tag,
                  count: t.update.update.options.count,
                  code: t.data.code,
                  message: t.data.message,
                  type: t.update.update.type,
                  id: t.update.update.id
                }), (h() || t.active) && g(t), A()
              }
            }, {
              type: u.STATE_CHANGE, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }], f = [{
              type: u.SERVER_INFO, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.STREAM_INFO, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.STREAM_INFO_UPDATE, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.STREAM_FRAGMENT, listener: function (e) {
                e.active && g(e)
              }
            }, {
              type: u.RANDOM_ACCESS_POINT, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.RAW_PACKET, listener: function (e) {
                e.active && g(e)
              }
            }, {
              type: u.STREAM_STATUS, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && !e.update && g(e), e.update && -1 !== e.update.config.query.flags.indexOf("paused") && T()
              }
            }, {
              type: u.STREAM_QUALITY, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }, {
              type: u.UPDATE_SOURCE_SUCCESS, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), t.active || (T(), t.active = !0, _().setActive(!0)), l.debugEnabled() && l.debug("trigger update source success"), e.emit(d.UPDATE_SOURCE_SUCCESS, {
                  tag: t.data.tag,
                  count: t.data.count,
                  type: t.data.type,
                  id: t.data.id
                })
              }
            }, {
              type: u.UPDATE_SOURCE_ERROR, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), l.debugEnabled() && l.debug("trigger update source fail"), e.emit(d.UPDATE_SOURCE_FAIL, {
                  tag: t.data.tag,
                  count: t.data.count,
                  code: t.data.code,
                  message: t.data.message,
                  type: t.data.type,
                  id: t.data.id
                }), h() && (l.debugEnabled() && l.debug("trigger disconnected"), e.emit(d.DISCONNECTED, {
                  code: t.data.code,
                  message: t.data.message
                })), A()
              }
            }, {
              type: u.UPDATE_SOURCE_ABORT, listener: function (t) {
                l.debugEnabled() && l.debug("fired " + t.name), l.debugEnabled() && l.debug("trigger update source abort"), e.emit(d.UPDATE_SOURCE_ABORT, {
                  tag: t.data.tag,
                  count: t.data.count,
                  reason: t.data.reason,
                  type: t.data.type,
                  id: t.data.id
                })
              }
            }, {type: u.META_DATA, listener: m}, {
              type: u.WEB_TRANSPORT_META_DATA,
              listener: m
            }, {
              type: u.WEB_TRANSPORT_GOP_CACHE, listener: function (e) {
                l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
              }
            }], E = [];

            function p(t) {
              l.debugEnabled() && l.debug("on connect"), 1 === E.length && b().isWaitForReconnect() ? b().connect(t) : 1 === E.length ? (E.push(c.create(e, t.data.connectionType)), _().connect(t)) : E.length || (E[0] = c.create(e, t.data.connectionType), E[0].setActive(!0), b().connect(t))
            }

            function m(e) {
              l.debugEnabled() && l.debug("fired " + e.name), e.active && g(e)
            }

            function g(t) {
              t.name = t.name.replace(u.BASE, d.BASE), e.emit(t.name, t)
            }

            function b() {
              l.debugEnabled() && l.debug("get active connection");
              for (var e = !1, t = 0; t < E.length; t += 1) if (E[t].isActive()) {
                l.debugEnabled() && l.debug("found active connection"), e = E[t];
                break
              }
              return e
            }

            function _() {
              var e = !1;
              return E.length && (e = E[E.length - 1]), e
            }

            function h() {
              var e = !!_() && _().shouldPauseOnError();
              return l.debugEnabled() && l.debug("should pause on error: " + e), e
            }

            function T() {
              l.debugEnabled() && l.debug("drop active connection?"), E.length > 1 && (l.debugEnabled() && l.debug("drop active connection!"), E.shift().destroy())
            }

            function A() {
              l.debugEnabled() && l.debug("drop inactive connection?"), E.length > 1 && (l.debugEnabled() && l.debug("drop inactive connection!"), E.pop().destroy())
            }

            return r.add({target: e, listeners: i}), r.add({target: e, listeners: o}), {
              destroy: function () {
                for (var t in l.debugEnabled() && l.debug("destroy"), E) Object.prototype.hasOwnProperty.call(E, t) && (E[t].destroy(), delete E[t]);
                r.remove({target: e, listeners: i}), r.remove({target: e, listeners: o}), r.remove({
                  target: e,
                  listeners: f
                })
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5356: function (e, t, n) {
      var r, i;
      r = [n(6637), n(8333), n(312), n(1852)], void 0 === (i = function (e, t, n, r) {
        return {
          create: function (i) {
            var a, o = t.create("NetworkStatusProxy"), s = ["online", "offline"], d = !1, u = [{
              type: n.STATE_CHANGE, listener: function (e) {
                a || (o.debugEnabled() && o.debug("initial player state"), l()), a = e.data.state
              }
            }];

            function c() {
              l()
            }

            function l() {
              d = navigator.onLine, o.debug(d ? "online" : "offline"), i.emit(d ? r.ONLINE : r.OFFLINE)
            }

            return o.debugEnabled() && o.debug("initialize"), e.add({
              target: i,
              listeners: u
            }), s.forEach((function (e) {
              window.addEventListener(e, c)
            })), {
              destroy: function () {
                e.remove({target: i, listeners: u}), s.forEach((function (e) {
                  window.addEventListener(e, c)
                }))
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4046: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          validate: function (e) {
            for (var t = ["minDelay", "maxDelay", "delaySteps", "maxRetries"], n = 0; n < t.length; ++n) {
              if (!Object.prototype.hasOwnProperty.call(e, t[n])) return {
                success: !1,
                reason: "The reconnect config is invalid, it must contain 'minDelay', 'maxDelay', 'delaySteps', and 'maxRetries'. Reset to default."
              };
              if ("number" != typeof e[t[n]]) return {
                success: !1,
                reason: "The reconnect config is invalid, the value '" + t[n] + "' have to be a number. Reset to default."
              }
            }
            return e[t[0]] > e[t[1]] ? {
              success: !1,
              reason: "The reconnect config is invalid, the value '" + t[0] + "' have to be lower then '" + t[1] + "'. Reset to default."
            } : e[t[0]] < 1 ? {
              success: !1,
              reason: "The reconnect config is invalid, the value '" + t[0] + "' have to be greater or equal then 1 sec. Reset to default."
            } : {success: !0}
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7402: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          calculate: function (e, t, n, r, i) {
            var a = [], o = Math.sqrt(e);
            n > r && (n = r);
            for (var s = (Math.sqrt(t) - o) / (n - 1), d = 0; d < r; d += 1) {
              var u = i * (Math.random() - .5),
                c = o + s * Math.min(n - 1, d) + (!d && o - Math.abs(u) <= .5 ? Math.abs(u) + i * Math.random() : u),
                l = Math.round(c * c * 1e3);
              a.push(l)
            }
            return a
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4677: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          parse: function (e, t) {
            for (var n, r = e.url.split("?"), i = r[1].split("&"), a = {}, o = 0; o < i.length; o += 1) {
              var s = i[o].split("=");
              a[s[0]] = decodeURIComponent(s[1])
            }
            for (; i.length;) i.pop();
            for (n in a) if (Object.prototype.hasOwnProperty.call(a, n)) {
              if ("flags" === n) {
                var d = a[n].split(","), u = d.indexOf("paused");
                t || -1 === u ? t && -1 === u && d.push("paused") : d.splice(u, 1), a[n] = d.join(",")
              }
              i.push(n + "=" + encodeURIComponent(a[n]))
            }
            return r[1] = i.join("&"), e.url = r.join("?"), e
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9336: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {PLAY: "api.play", PAUSE: "api.pause"}
      }.apply(t, [])) || (e.exports = n)
    }, 9673: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "control.",
          CONNECT: "control.connect",
          DISCONNECT: "control.disconnect",
          NETWORK_PLAY: "control.networkPlay",
          NETWORK_PAUSE: "control.networkPause",
          PLAY: "control.play",
          PAUSE: "control.pause",
          MUTE: "control.mute",
          UNMUTE: "control.unmute",
          SET_VOLUME: "control.setVolume",
          SEEK: "control.seek",
          SET_RATE: "control.playbackRate",
          CONFIG: "control.config",
          CREATE_VIDEO: "control.createVideo",
          DESTROY_VIDEO: "control.destroyVideo",
          VIDEO_SOURCE: "control.videoSource",
          UPDATE_SOURCE: "control.updateSource",
          NETWORK_UPDATE_SOURCE: "control.networkUpdateSource",
          SWITCH_STREAM: "control.switchStream",
          SET_ADAPTION: "control.setAdaption"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 680: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "logic.",
          STATE_CHANGE: "logic.stateChange",
          LOADING_TIMEOUT: "logic.loadingTimeout",
          BUFFERING_TIMEOUT: "logic.bufferingTimeout",
          STREAM_INFO: "logic.streamInfo",
          STREAM_INFO_UPDATE: "logic.streamInfoUpdate",
          SERVER_INFO: "logic.serverInfo",
          STREAM_URL: "logic.streamUrl",
          NO_KEEP_CONNECTION: "logic.noKeepConnection",
          MIME_TYPE_UNSUPPORTED: "logic.mimeTypeUnsupported",
          META_DATA_RECEIVED: "logic.metaDataReceived",
          META_DATA_ERROR: "logic.metaDataError",
          NO_SERVER_ERROR: "logic.noServerError",
          MISSING_RTMP_ERROR: "logic.missingRtmpError",
          STARTUP_STATS_ADDED: "logic.startupStatsAdded",
          STARTUP_STATS_COMPLETED: "logic.startupStatsCompleted",
          DOCUMENT_VISIBLE: "logic.documentVisible",
          DOCUMENT_HIDDEN: "logic.documentHidden",
          ERROR: "logic.error",
          UPDATE_SOURCE_INIT: "logic.updateSourceInit",
          UPDATE_SOURCE_SUCCESS: "logic.updateSourceSuccess",
          UPDATE_SOURCE_FAIL: "logic.updateSourceFail",
          UPDATE_SOURCE_ABORT: "logic.updateSourceAbort",
          SWITCH_STREAM_INIT: "logic.switchStreamInit",
          SWITCH_STREAM_SUCCESS: "logic.switchStreamSuccess",
          SWITCH_STREAM_FAIL: "logic.switchStreamFail",
          SWITCH_STREAM_ABORT: "logic.switchStreamAbort",
          ADAPTIVE_STATS: "logic.adaptiveStats",
          STREAM_SWITCH: "logic.streamSwitch",
          BUFFER_GOAL_STATS: "logic.bufferGoalStats",
          LATENCY_CONTROL_MODE_SET: "logic.latencyControlModeSet",
          SOURCE_STREAM_STOPPED: "logic.sourceStreamStopped",
          NOT_CONFIGURED: "logic.notConfigured",
          UPDATE_SOURCE_INVALID: "logic.updateSourceInvalid",
          INVALID_ENTRY_INDEX: "logic.invalidEntryIndex",
          BUFFER_TWEAKS_CREATED: "logic.bufferTweaksCreated",
          BUFFER_TWEAKS_ERROR: "logic.bufferTweaksError"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 594: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "media.",
          LOAD_START: "media.loadstart",
          PROGRESS: "media.progress",
          SUSPEND: "media.suspend",
          ABORT: "media.abort",
          EMPTIED: "media.emptied",
          STALLED: "media.stalled",
          PLAY: "media.play",
          PAUSE: "media.pause",
          LOADED_META_DATA: "media.loadedmetadata",
          LOADED_DATA: "media.loadeddata",
          WAITING: "media.waiting",
          MEDIA_ERROR: "media.mediaerror",
          MEDIA_ERROR_RECOVER: "media.mediaerrorrecover",
          MEDIA_ERROR_RECOVERED: "media.mediaerrorrecovered",
          PLAYING: "media.playing",
          CAN_PLAY: "media.canplay",
          CAN_PLAY_THROUGH: "media.canplaythrough",
          SEEKING: "media.seeking",
          SEEKED: "media.seeked",
          TIME_UPDATE: "media.timeupdate",
          ENDED: "media.ended",
          RATE_CHANGE: "media.ratechange",
          DURATION_CHANGE: "media.durationchange",
          VOLUME_CHANGE: "media.volumechange",
          ELEMENT_CREATED: "media.elementCreated",
          QUALITY_STATS: "media.qualitystats",
          PLAY_STATS: "media.playStats",
          MEDIA_ERROR_RECOVER_STATS: "media.mediaErrorRecoverStats",
          FRAME_DROP: "media.framedrop",
          PLAYBACK_FINISHED: "media.playbackFinished",
          PLAYBACK_ERROR: "media.playbackError",
          PLAYBACK_STARTED: "media.playbackStarted",
          PLAYBACK_SUSPENDED: "media.playbackSuspended",
          BUFFERING: "media.buffering",
          PLAY_START_SUCCESS: "media.playStartSuccess",
          PLAY_START_NOT_ALLOWED_ERROR: "media.playStartNotAllowedError",
          PLAY_START_ABORT_ERROR: "media.playStartAbortError",
          VIEWPORT_VISIBLE: "media.viewportvisible",
          VIEWPORT_HIDDEN: "media.viewporthidden",
          ELEMENTS_UPDATED: "media.elementsUpdated",
          TIME_OFFSET: "media.timeOffset",
          UPDATE_SOURCE_ABORT: "media.updateSourceAbort",
          UPDATE_SOURCE_FAIL: "media.updateSourceFail",
          UPDATE_SOURCE_TIMEOUT: "media.updateSourceTimeout",
          ACTIVE_VIDEO_ELEMENT_CHANGE: "media.activeVideoElementChange",
          OFFLINE_BUFFER_UNDERRUN: "media.offlinebufferunderrun",
          ADJUSTED_META_DATA: "media.adjustedMetaData"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1376: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "network.",
          CONNECTING: "network.connecting",
          CONNECTED: "network.connected",
          CONNECTION_OPEN: "network.connectionOpen",
          DISCONNECTED: "network.disconnected",
          RESUMING: "network.resuming",
          RECONNECTION_IMMINENT: "network.reconnectionImminent",
          RECONNECTING: "network.reconnecting",
          RECONNECTION_CONFIG_INVALID: "network.reconnectionConfigInvalid",
          CONNECTION_ERROR: "network.connectionError",
          INITIALIZATION_ERROR: "network.initializationError",
          ERROR: "network.error",
          WARNING: "network.warning",
          DESTROYED: "network.destroyed",
          STATE_CHANGE: "network.stateChange",
          META_DATA: "network.metaData",
          WEB_TRANSPORT_META_DATA: "network.wtMetaData",
          WEB_TRANSPORT_GOP_CACHE: "network.wtGOPCache",
          SERVER_INFO: "network.serverInfo",
          STREAM_INFO: "network.streamInfo",
          STREAM_INFO_UPDATE: "network.streamInfoUpdate",
          STREAM_FRAGMENT: "network.streamFragment",
          RANDOM_ACCESS_POINT: "network.randomAccessPoint",
          RAW_PACKET: "network.raw",
          STREAM_STATUS: "network.streamStatus",
          UPDATE_SOURCE_SUCCESS: "network.updateSourceSuccess",
          UPDATE_SOURCE_FAIL: "network.updateSourceFail",
          UPDATE_SOURCE_ABORT: "network.updateSourceAbort",
          STREAM_QUALITY: "network.streamQuality",
          ONLINE: "network.online",
          OFFLINE: "network.offline"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7354: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          BASE: "public.",
          READY: "public.ready",
          ERROR: "public.error",
          PAUSE: "public.pause",
          LOADING: "public.loading",
          START_BUFFERING: "public.startBuffering",
          STOP_BUFFERING: "public.stopBuffering",
          PLAY: "public.play",
          METADATA: "public.metaData",
          STATS: "public.stats",
          PLAYBACK_FINISHED: "public.playbackFinished",
          MEDIA: "public.media",
          STREAM_INFO: "public.streamInfo",
          STREAM_INFO_UPDATE: "public.streamInfoUpdate",
          MUTE: "public.mute",
          UNMUTE: "public.unmute",
          VOLUME_CHANGE: "public.volumeChange",
          STATE_CHANGE: "public.stateChange",
          WARNING: "public.warning",
          DESTROY: "public.destroy",
          UPDATE_SOURCE_INIT: "public.updateSourceInit",
          UPDATE_SOURCE_SUCCESS: "public.updateSourceSuccess",
          UPDATE_SOURCE_FAIL: "public.updateSourceFail",
          UPDATE_SOURCE_ABORT: "public.updateSourceAbort",
          SWITCH_STREAM_INIT: "public.switchStreamInit",
          SWITCH_STREAM_SUCCESS: "public.switchStreamSuccess",
          SWITCH_STREAM_FAIL: "public.switchStreamFail",
          SWITCH_STREAM_ABORT: "public.switchStreamAbort",
          SERVER_INFO: "public.serverInfo",
          ACTIVE_VIDEO_ELEMENT_CHANGE: "public.activeVideoElementChange"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1128: function (e, t, n) {
      var r, i;
      r = [n(1969), n(6637), n(5055), n(2682), n(1933), n(8333), n(1473), n(9658), n(8197), n(6725), n(6627), n(8478), n(8877), n(4482), n(6965), n(5810), n(1493), n(828), n(492), n(8405), n(9583), n(3284), n(5493), n(6704), n(1797), n(651), n(2909), n(279), n(1358), n(9673), n(680), n(594), n(1376), n(9336), n(7354)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b, _, h, T, A, S, y, R, v, O, I, C, N, D, w, U, P, M) {
        "use strict";
        var L = a.create("H5Live");

        function F(e) {
          u.validatePlayerDivId(e), this._setBaseValues(e)
        }

        F.getSupportedTechniques = function () {
          var e = [];
          return c.isH5LiveKnownUnsupported || (c.canUseMediaSource && e.push(A.H5LIVE_WSS), (c.mustUseHLS || c.canUseHLS) && e.push(A.H5LIVE_HLS)), e
        }, F.supportedTechniques = F.getSupportedTechniques(), F.isSupported = function () {
          return F.supportedTechniques.length > 0
        };
        var x = F.prototype = Object.create(e.prototype);
        return x._setBaseValues = function (e) {
          this.version = r.CORE, this.type = "h5live", this.mediaplaybackapi = "default", this.networkState = this.NETWORK_STATE.UNINITIALIZED, this._info = i, this.config = p.create(), this._playerDivId = "", this._playing = !1, this._updating = !1, this._serverInfo = null, this._useHLS = !1, this._pauseReason = "", this._playerDivId = e, this._mediaElementIds = [], this._componentEmitter = new s, this._componentListeners = {
            logic: [{type: D.SERVER_INFO, listener: this._onServerInfo.bind(this)}, {
              type: D.NO_KEEP_CONNECTION,
              listener: this._onNoKeepConnection.bind(this)
            }, {type: D.ERROR, listener: this._onLogicError.bind(this)}, {
              type: D.UPDATE_SOURCE_INIT,
              listener: this._onUpdateSourceInit.bind(this)
            }, {
              type: D.SWITCH_STREAM_INIT,
              listener: this._onSwitchStreamInit.bind(this)
            }, {
              type: D.LATENCY_CONTROL_MODE_SET,
              listener: this._onLatencyControlModeSet.bind(this)
            }, {
              type: D.BUFFER_TWEAKS_CREATED,
              listener: this._onBufferTweaksCreated.bind(this)
            }, {type: D.BUFFER_TWEAKS_ERROR, listener: this._onBufferTweaksError.bind(this)}],
            network: [{type: U.CONNECTING, listener: this._onConnectionConnecting.bind(this)}, {
              type: U.CONNECTED,
              listener: this._onConnectionOpen.bind(this)
            }, {type: U.DISCONNECTED, listener: this._onConnectionClosed.bind(this)}, {
              type: U.RECONNECTING,
              listener: this._onConnectionReconnecting.bind(this)
            }, {
              type: U.RECONNECTION_IMMINENT,
              listener: this._onConnectionReconnectionImminent.bind(this)
            }, {type: U.DESTROYED, listener: this._onConnectionDestroyed.bind(this)}, {
              type: U.WARNING,
              listener: this._onConnectionWarning.bind(this)
            }, {type: U.STATE_CHANGE, listener: this._onConnectionStateChange.bind(this)}],
            media: [{
              type: w.MEDIA_ERROR_RECOVER,
              listener: this._onMediaErrorRecover.bind(this)
            }, {type: w.PLAYBACK_STARTED, listener: this._onMediaPlaying.bind(this)}, {
              type: w.BUFFERING,
              listener: this._onMediaBuffering.bind(this)
            }, {
              type: w.PLAY_START_ABORT_ERROR,
              listener: this._onPlayStartAbortError.bind(this)
            }, {
              type: w.PLAY_START_NOT_ALLOWED_ERROR,
              listener: this._onPlayStartNotAllowedError.bind(this)
            }, {type: w.OFFLINE_BUFFER_UNDERRUN, listener: this._onOfflineBufferUnderrun.bind(this)}]
          }, this._setState(_.IDLE)
        }, x._prepareConfig = function (e) {
          var t = this._checkSource(e.source);
          return e.source = t, o.check(e, m.create()).forEach(function (e) {
            this._emitWarning(e)
          }.bind(this)), o.merge(e, this.config), o.clean(this.config), u.validateConfig(F.supportedTechniques[0], this.config)
        }, x._baseSetup = function () {
          this._useHLS = c.mustUseHLS || this.config.playback.allowSafariHlsFallback && c.canUseHLS, c.isMediaOverQuicSupported && this.config.playback.enableMediaOverQuic ? this.mediaplaybackapi = "moq" : this.mediaplaybackapi = this._useHLS ? "hls" : "mse", this._setListeners(this.config.events, this);
          var e = document.getElementById(this._playerDivId);
          this._metaDataEnabled = this.config.playback.metadata;
          var r = this.config.source.entries[this.config.source.startIndex].h5live.params,
            i = this.config.source.entries[this.config.source.startIndex].h5live.rtmp,
            a = r && r.url ? r.url : i && i.url ? i.url : null,
            o = r && r.stream ? r.stream : i && i.streamname ? i.streamname : null;
          for (var s in this.config.url = a && o ? a + "/" + o : "", this.config.type = this.type, this.config.mediaplaybackapi = this.mediaplaybackapi, this.config.latencyControlMode = this.config.playback.latencyControlMode, this.config.id = this.id, this._components = {
            error: v.create(this._componentEmitter),
            state: y.create(this._componentEmitter),
            network: I.create(this._componentEmitter),
            media: C.create(this._componentEmitter, this.config),
            logic: O.create(this._componentEmitter),
            propagator: R.create(this._componentEmitter)
          }, this._components) Object.prototype.hasOwnProperty.call(this._componentListeners, s) && this._componentListeners[s].length && t.add({
            target: this._componentEmitter,
            listeners: this._componentListeners[s]
          });
          for (var d in T) (this._outwardEvents || (this._outwardEvents = [])) && this._outwardEvents.push({
            from: T[d],
            to: T[d]
          }), (this._inwardEvents || (this._inwardEvents = [])) && this._inwardEvents.push({from: T[d], to: M[d]});
          this._outwardTranslator = n.create(this._componentEmitter, this, this._outwardEvents), this._inwardTranslator = n.create(this, this._componentEmitter, this._inwardEvents), this._emitConfig(), this._setupVideoElement(e)
        }, x._testConnection = function () {
          var e, t;
          return e = this.config.source.entries[0].h5live.rtmp.streamname, t = this.config.source.entries[0].h5live.server, new Promise(function (n, r) {
            var i = this;
            if (c.isMediaOverQuicSupported && i.config.playback.enableMediaOverQuic && i.config.playback.enableQuicConnectionProbe) {
              if (!t || !t.webtransport) return i.config.playback.enableMediaOverQuic = !1, i._emitWarning("WebTransport endpoint not configured. Using MSE & WebSocket as default."), void n();
              f.test(t, e).then((function (e) {
                try {
                  if (-1 === e.webtransport.duration) return i.config.playback.enableMediaOverQuic = !1, i._emitWarning("Playback via Media Over Quic not available. Using Media Source Extension & WebSocket as fallback."), void n(e);
                  if ((e.error || "undefined" === e.error || e.webtransport.duration < 10) && e.websocket.duration > 0) return i.config.playback.enableMediaOverQuic = !1, i._emitWarning("Playback via Media Over Quic not available. Using Media Source Extension & WebSocket as fallback."), void n(e);
                  if (e.webtransport.duration > 0 && -1 === e.websocket.duration) return i.config.playback.enableMediaOverQuic = !0, i.mediaplaybackapi = "moq", void n(e);
                  n(e)
                } catch (e) {
                  i.config.playback.enableMediaOverQuic = !1, i._emitWarning("Error during connection test: " + e.message), r(e)
                }
              }), (function () {
                i.config.playback.enableMediaOverQuic = !0, i._emitWarning("Connection test failed for WebSocket"), n()
              })).catch((function (e) {
                i.config.playback.enableMediaOverQuic = !1, i._emitWarning("Connection test failed: " + e.message), r(e)
              }))
            } else try {
              t && t.webtransport && c.isMediaOverQuicSupported || (i.config.playback.enableMediaOverQuic = !1, i._emitWarning("WebTransport endpoint not configured. Using MSE & WebSocket as default.")), n()
            } catch (e) {
              r(e)
            }
          }.bind(this))
        }, x.setup = function (e) {
          var t = !!e.playback && e.playback.enableMediaOverQuic;
          return new Promise(function (n, r) {
            try {
              var i = this._prepareConfig(e);
              if (i) return void r(i);
              this._testConnection().then(function (i) {
                i && L.debugEnabled() && L.debug("connection test result: " + JSON.stringify(i)), this._baseSetup(), this && "function" == typeof this._setState ? setTimeout(function () {
                  try {
                    this._setState(_.READY);
                    var a = {config: this.config, initialEnableMoq: t};
                    if (i && (a.probeDurationWebtransportMs = Math.round(i.webtransport.duration), a.probeDurationWebsocketMs = Math.round(i.websocket.duration)), this.emit(T.READY, a), (!this._pauseReason.length || "destroy" === this._pauseReason) && this.config.playback.autoplay) {
                      var o = e.source.entries[this.config.source.startIndex];
                      (e.source.group && e.source.group.state && "live" !== e.source.group.state || o.bintu && o.bintu.state && "live" !== o.bintu.state) && e.playback.autoplay ? this._componentEmitter.emit(D.SOURCE_STREAM_STOPPED) : this.play()
                    }
                    n(this.config)
                  } catch (e) {
                    r(e)
                  }
                }.bind(this), 20) : r(new l("Player instance not properly initialized"))
              }.bind(this)).catch((function () {
              }))
            } catch (e) {
              r(e)
            }
          }.bind(this))
        }, x._destroy = function () {
          for (var e in this._setState(_.DESTROYING), this._playing && this.pause(this.state), this.emit(T.DESTROY), this._outwardTranslator && this._outwardTranslator.destroy(), this._outwardTranslator = null, this._inwardTranslator && this._inwardTranslator.destroy(), this._inwardTranslator = null, this._components) Object.prototype.hasOwnProperty.call(this._components, e) && (this._components[e].destroy(), delete this._components[e]);
          for (var n in this._componentListeners) Object.prototype.hasOwnProperty.call(this._componentListeners, n) && this._componentListeners[n].length && t.remove({
            target: this._componentEmitter,
            listeners: this._componentListeners[n]
          });
          this.removeAllListeners()
        }, x.destroy = x._destroy, x._emitConfig = function () {
          this._componentEmitter.emit(N.CONFIG, {config: d.copy(this.config)})
        }, x._setState = function (e, t) {
          L.debugEnabled() && L.debug("set state");
          var n = arguments.length > 1 ? arguments[1] : {};
          e !== this.state || t ? (this.state = e, L.debugEnabled() && L.debug("state changed to " + this._getState() + " (" + e + ")"), n.state = e, this._componentEmitter.emit(D.STATE_CHANGE, n)) : L.debugEnabled() && L.debug("state already at " + this._getState() + " (" + e + ")")
        }, x._setListeners = function (e, t) {
          for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n) && "function" == typeof e[n]) {
            var r = n.replace("on", ""), i = e[n];
            t.on(r, i)
          }
        }, x._setupVideoElement = function (e) {
          var t = "h5live-" + this._playerDivId;
          if (this.config.playback.videoId) {
            if ("string" == typeof this.config.playback.videoId) this._mediaElementIds.push(this.config.playback.videoId); else if (Array.isArray(this.config.playback.videoId)) for (var n = 0; n < this.config.playback.videoId.length && (this._mediaElementIds.push("string" == typeof this.config.playback.videoId[n] ? this.config.playback.videoId[n] : t + (n ? "-" + n : "")), c.mustUseHLS || c.canUseHLS && this.config.playback.allowSafariHlsFallback); n += 1) ; else this._mediaElementIds.push(t);
            (c.mustUseHLS || c.canUseHLS && this.config.playback.allowSafariHlsFallback) && 2 !== this._mediaElementIds.length && (this._mediaElementIds.push(t + "-1"), this._emitWarning("Two external video elements should be used for hls playback with multi stream configuration. Please pass two element ids within a string array."))
          } else this._mediaElementIds.push(t), (c.mustUseHLS || c.canUseHLS && this.config.playback.allowSafariHlsFallback) && this._mediaElementIds.push(t + "-1");
          this._componentEmitter.emit(N.CREATE_VIDEO, {elementIds: this._mediaElementIds, container: e})
        }, x._onLogicError = function (e) {
          e.data.state && this._setState(e.data.state), this.state >= _.READY && this.pause(this.state)
        }, x._onUpdateSourceInit = function (e) {
          this._maybePlayOnUpdateOrSwitch(e)
        }, x._onSwitchStreamInit = function (e) {
          this._maybePlayOnUpdateOrSwitch(e)
        }, x._onLatencyControlModeSet = function (e) {
          this.config.latencyControlMode = e.data.latencyControlMode
        }, x._maybePlayOnUpdateOrSwitch = function (e) {
          e.data.options.forcePlay && -1 !== [_.READY, _.PAUSED].indexOf(this.state) && setTimeout(this.play.bind(this), 200)
        }, x._onPlayStartAbortError = function (e) {
          "background" === e.data.reason && this._emitWarning("Muted playback in background failed. Wait for getting visible again during loading state to retry.")
        }, x._onPlayStartNotAllowedError = function (e) {
          e.data.automuted && this._emitWarning("Unmuted autoplay failed by autoplay policy, but 'automute' is enabled. Try to play muted.")
        }, x._onBufferTweaksCreated = function (e) {
          this.config.tweaks = this.config.tweaks || {}, this.config.tweaks.buffer = e.data.tweaks.buffer, this.config.playback.latencyControlMode = e.data.latencyControlMode
        }, x._onBufferTweaksError = function (e) {
          this._emitWarning(e.data.message)
        }, x._onMediaErrorRecover = function (e) {
          this._emitWarning("Recovering from media error " + e.data.code + ", recovery " + e.data.count + "/" + e.data.max + " within the last 60 seconds (" + e.data.total + " total).")
        }, x._onOfflineBufferUnderrun = function () {
          this._emitWarning("Network status is offline during buffering or loading. Wait for becoming online again to recover.")
        }, x._preparePlay = function (e) {
          this.state !== _.LOADING ? (this._setState(_.LOADING, {connectDelay: e}), this.emit(T.LOADING, {connectDelay: e})) : this._setState(_.LOADING, {connectDelay: e}, !0), setTimeout(function () {
            this.state === _.LOADING && (this._componentEmitter.emit(P.PLAY), this._componentEmitter.emit(N.PLAY, {external: !0}))
          }.bind(this), e)
        }, x.play = function () {
          var e = arguments.length ? arguments[0] : 0;
          L.debugEnabled() && L.debug("play in state " + this.state), this.state < _.READY ? this._componentEmitter.emit(D.NOT_CONFIGURED) : this.state === _.READY || this.state === _.PAUSED ? (this._playing = !0, this._preparePlay(e)) : this.state === _.PAUSING && (L.debugEnabled() && L.debug("play in PAUSING state, setting flag to resume"), this._resumeOnPause = !0)
        }, x._onConnectionConnecting = function () {
          L.debugEnabled() && L.debug("connecting")
        }, x._onConnectionStateChange = function (e) {
          this.networkState = e.data.connectionState
        }, x._onConnectionWarning = function (e) {
          var t = "Connection warning!", n = e ? e.data : void 0;
          n && n.message && (t += " " + n.message), n && n.code && (t += " (code:" + n.code + ")"), this._emitWarning(t)
        }, x._onConnectionOpen = function (e) {
          e.data.count ? L.debugEnabled() && L.debug("connection open after " + e.data.count + " reconnect tries") : L.debugEnabled() && L.debug("connection open")
        }, x._onConnectionClosed = function (e) {
          L.debugEnabled() && L.debug("connection closed: " + e.data.code + " " + e.data.message), L.debugEnabled() && L.debug('closed connection with state "' + this._getState() + '", networkstate "' + this._getNetworkState() + '"')
        }, x._onConnectionDestroyed = function (e) {
          L.debugEnabled() && L.debug("connection destroyed" + (e.data.silent ? ", but silent" : "")), this.state === _.READY || e.data.silent || this.pause(this.state)
        }, x._onConnectionReconnecting = function (e) {
          L.debugEnabled() && L.debug("reconnect attempt " + e.data.count + " started")
        }, x._onConnectionReconnectionImminent = function (e) {
          if (this._playing && c.isMediaOverQuicSupported && this.config.playback.enableMediaOverQuic && e.data.count > 1) this._emitWarning("Playback via Media Over Quic not available. Using Media Source Extension & WebSocket as fallback."), this.config.playback.enableMediaOverQuic = !1, this.mediaplaybackapi = "mse", this.config.mediaplaybackapi = this.mediaplaybackapi, this._doFallback(), setTimeout(function () {
            this._preparePlay(0)
          }.bind(this), 20); else {
            var t = e.data.code,
              n = "Connection error: closed " + e.data.count + (e.data.count > 1 ? " times" : " time") + " unexpectedly with code " + t + ", but a reconnect will be prepared in " + (e.data.delay / 1e3).toFixed(3) + " s";
            (!this._useHLS || "iOS" === i.os && e.data.count > 1) && (L.debugEnabled() && L.debug(n), this._emitWarning(n)), this._playing && !this._useHLS && (this._setState(_.RECONNECTION_IMMINENT), this.pause(this.state), this.play(e.data.delay))
          }
        }, x._onServerInfo = function (e) {
          L.debugEnabled() && L.debug("onServerInfo");
          try {
            this._serverInfo = e.data.onServerInfo;
            var t = JSON.stringify(e.data);
            L.debugEnabled() && L.debug(t)
          } catch (e) {
          }
        }, x._onNoKeepConnection = function (e) {
          L.debugEnabled() && L.debug("onNoKeepConnection"), this._emitWarning(e.data.message)
        }, x._emit = x.emit, x.emit = function (e, t) {
          var n = {};
          t && t.name && t.data ? n = t : t ? (n.data = t, n.name = e || "unknown") : (n.data = {}, n.name = e || "unknown"), n.player = this._playerDivId, n.id = this.id, n.version = this.version, n.state = this.state, "Error" === e && n.data.code && n.data.message && L.debugEnabled() && L.debug("error " + n.data.code + " " + n.data.message);
          var r = d.copy(n);
          r.name = "public." + r.name.substr(0, 1).toLowerCase() + r.name.substr(1), this._componentEmitter.emit(r.name, r), this._emit(n.name, n)
        }, x._emitError = function (e, t) {
          this.emit(T.ERROR, {code: e, message: t}), this.state >= _.READY && this.pause(this.state)
        }, x._emitWarning = function (e) {
          this.emit(T.WARNING, {message: e})
        }, x._doFallback = function () {
          t.remove({
            target: this._componentEmitter,
            listeners: this._componentListeners.media
          }), t.remove({
            target: this._componentEmitter,
            listeners: this._componentListeners.network
          }), this._components.media.destroy(), this._components.network.destroy(), this._components.media = C.create(this._componentEmitter, this.config), this._components.network = I.create(this._componentEmitter, this.config), t.add({
            target: this._componentEmitter,
            listeners: this._componentListeners.media
          }), t.add({
            target: this._componentEmitter,
            listeners: this._componentListeners.network
          }), this._emitConfig(), this._componentEmitter.emit(N.CREATE_VIDEO, {
            elementIds: this._mediaElementIds,
            container: document.getElementById(this._playerDivId)
          })
        }, x._getPauseReason = function (e) {
          var t = "";
          if (e) {
            var n = !this._useHLS && this.networkState !== this.NETWORK_STATE.OPEN && this.networkState !== this.NETWORK_STATE.UNINITIALIZED;
            switch (e) {
              case _.READY:
                t = S.SERVER_NOT_FOUND;
                break;
              case _.LOADING:
                t = n ? S.CONNECTION_CLOSE : S.STREAM_NOT_FOUND;
                break;
              case _.BUFFERING:
                t = n ? S.CONNECTION_CLOSE : S.BUFFER;
                break;
              case _.UNKNOWN:
                t = n ? S.CONNECTION_CLOSE : S.UNKNOWN;
                break;
              case _.PLAYING:
                t = n ? S.CONNECTION_CLOSE : S.NORMAL;
                break;
              case _.PLAYBACK_NOT_STARTED:
                t = S.INTERACTION_REQUIRED;
                break;
              case _.PLAYBACK_SUSPENDED:
                t = S.PLAYBACK_SUSPENDED;
                break;
              case _.PLAYBACK_ERROR:
                t = S.PLAYBACK_ERROR;
                break;
              case _.RECONNECTION_IMMINENT:
                t = S.RECONNECTION_IMMINENT;
                break;
              case _.CONNECTION_ERROR:
                t = S.CONNECTION_CLOSE;
                break;
              case _.DESTROYING:
                t = S.DESTROY;
                break;
              case _.VISIBILITY_HIDDEN:
                t = S.VISIBILITY_HIDDEN;
                break;
              case _.NOT_ENOUGH_DATA:
                t = S.NOT_ENOUGH_DATA;
                break;
              case _.SOURCE_STREAM_STOPPED:
                t = S.SOURCE_STREAM_STOPPED;
                break;
              case _.MEDIA_NOT_AVAILABLE:
                t = S.MEDIA_NOT_AVAILABLE;
                break;
              default:
                t = S.NORMAL
            }
          } else t = S.NORMAL;
          return t
        }, x._triggerPause = function () {
          this.state !== _.PAUSED ? (L.debugEnabled() && L.debug('trigger pause with reason "' + this._pauseReason + '", state "' + this._getState() + '", networkstate "' + this._getNetworkState() + '"'), this._setState(_.PAUSED, {reason: this._pauseReason}), this.emit(T.PAUSE, {reason: this._pauseReason}), this._resumeOnPause && (this._resumeOnPause = !1, this.play())) : L.debugEnabled() && L.debug("trigger pause but already in state paused")
        }, x.pause = function () {
          var e = arguments.length ? arguments[0] : 0;
          L.debugEnabled() && L.debug("pause in state " + this.state), this.state < _.READY && !e ? this._emitWarning("A pause call has been ignored since the player has not been set up successfully.") : this.state !== _.PAUSED && this.state !== _.PAUSING && (this._pauseReason = this._getPauseReason(e), this._setState(_.PAUSING), this._playing = !1, this._resumeOnPause = !1, this._componentEmitter.emit(P.PAUSE), this._componentEmitter.emit(N.PAUSE), this._triggerPause(), E.isActive() && E.release())
        }, x.mute = function () {
          this._componentEmitter.emit(N.MUTE)
        }, x.unmute = function () {
          this._componentEmitter.emit(N.UNMUTE)
        }, x.setVolume = function (e) {
          this._componentEmitter.emit(N.SET_VOLUME, {volume: e})
        }, x.updateSource = function (e) {
          return new Promise(function (t, n) {
            if (this._updating) n(new l("Another 'updateSource' call is pending.")); else {
              this._updating = !0;
              var r = function (e, t) {
                this._updating = !1, e.apply(null, t)
              }.bind(this);
              try {
                var i, a = this._checkSource(e);
                if (this.config.source = a, o.clean(this.config.source), i = u.validateConfig(F.supportedTechniques[0], this.config)) i.message.replace("create", "update"), this._componentEmitter.emit(D.UPDATE_SOURCE_INVALID, {
                  code: i.code,
                  message: i.message
                }), r(n, [i]); else {
                  var s = this.config.source.entries[this.config.source.startIndex].h5live.params,
                    c = this.config.source.entries[this.config.source.startIndex].h5live.rtmp,
                    f = s && s.url ? s.url : c && c.url ? c.url : null,
                    E = s && s.stream ? s.stream : c && c.streamname ? c.streamname : null;
                  this.config.url = f && E ? f + "/" + E : "", delete this.config.source.h5live, this._componentEmitter.emit(N.UPDATE_SOURCE, {
                    source: d.copy(this.config.source),
                    options: d.copy(this.config.source.options.switch)
                  }), r(t, [this.config])
                }
              } catch (e) {
                r(n, [new l(e.message, e.code)])
              }
            }
          }.bind(this))
        }, x.switchStream = function (e) {
          return new Promise(function (t, n) {
            var r;
            (r = u.validateSwitchIndex(e, this.config)) ? (this._componentEmitter.emit(D.INVALID_ENTRY_INDEX, {
              code: r.code,
              message: r.message,
              pauseOnError: this.config.source.options.switch.pauseOnError
            }), n(r)) : (this._componentEmitter.emit(N.SWITCH_STREAM, {
              index: e,
              type: "direct"
            }), t(d.copy(this.config)))
          }.bind(this))
        }, x.setAdaption = function (e) {
          var t = !0;
          if (e && e.rule || (t = !1, this._emitWarning("The adaption object is invalid. The adaption will not be updated.")), -1 !== ["deviationOfMean", "deviationOfMean2"].indexOf(e.rule) ? this.config.source.entries.length < 2 && (t = !1, this._emitWarning("Only one entry. The adaption will not be updated.")) : -1 === ["none"].indexOf(e.rule) && (t = !1, this._emitWarning("The adaption rule is not valid. Valid rules are 'deviationOfMean', 'deviationOfMean2' and 'none' (disable). The adaption will not be updated.")), t) {
            var n = 1;
            if (isNaN(e.downStep) ? this._emitWarning("The adaption down step is not valid. The default down step '1' will be set.") : (n = parseInt(e.downStep, 10) || n, n = Math.max(1, Math.min(this.config.source.entries.length - 1, n))), e.downStep = n, Array.isArray(e.omitRenditions)) {
              for (var r = ["high", "medium-high", "medium", "medium-low", "low"], i = !1, a = 0; a < e.omitRenditions.length; a += 1) {
                if (isNaN(e.omitRenditions[a])) {
                  if ("string" == typeof e.omitRenditions[a] && -1 !== r.indexOf(e.omitRenditions[a])) continue;
                  i = !0;
                  break
                }
                var o = parseInt(e.omitRenditions[a], 10);
                if (!(!isNaN(o) && o >= 0 && o < this.config.source.entries.length)) {
                  i = !0;
                  break
                }
              }
              i && (this._emitWarning("The adaption omit renditions [" + e.omitRenditions.join(",") + "] are not valid and will be ignored."), delete e.omitRenditions)
            } else void 0 !== e.omitRenditions && (this._emitWarning("The adaption omit renditions are not valid and will be ignored."), delete e.omitRenditions);
            this._componentEmitter.emit(N.SET_ADAPTION, {adaption: e})
          }
        }, x._parseUrl = function (e) {
          var t = {url: "", streamname: ""}, n = e.lastIndexOf("/"), r = e.substr(0, n), i = e.substr(n, e - n);
          return t.url = r, t.streamname = i, t
        }, x._getState = function () {
          return d.findPropertyByValue(_, this.state)
        }, x._getNetworkState = function () {
          return d.findPropertyByValue(this.NETWORK_STATE, this.networkState)
        }, x._onMediaPlaying = function (e) {
          var t = this.state;
          this._setState(_.PLAYING), this.emit(t === _.BUFFERING ? T.STOP_BUFFERING : T.PLAY, e.data), L.debugEnabled() && L.debug("state is PLAYING"), this.config.playback.enableWakeLock && !E.isActive() && (E.request(), L.debugEnabled() && L.debug("requesting wake lock from h5live"))
        }, x._onMediaBuffering = function () {
          this._setState(_.BUFFERING), this.emit(T.START_BUFFERING)
        }, x._checkSource = function (e) {
          var t, n, r, i = {
            method: this._useHLS ? "client" : "server",
            pauseOnError: !1,
            forcePlay: !0,
            fastStart: !0,
            timeout: 20,
            tag: ""
          };

          function a(e) {
            return e > 2 ? {rule: "deviationOfMean2", downStep: 2, omitRenditions: []} : {
              rule: "none",
              downStep: 1,
              omitRenditions: []
            }
          }

          if (e && e.entries && e.entries.length > 0) {
            for (var s = 0; s < e.entries.length; s += 1) if (n = e.entries[s], t = o.check(n, b.create()), n.index !== s) {
              t.push("Configuration warning. The config entries property 'index' is not configured properly.");
              break
            }
          } else n = g.create(), o.merge(e, n), e.entries = [n], e.startIndex = 0, e.options && (e.options.adaption = d);
          if (void 0 === e.startIndex && (e.startIndex = e.entries.length - 1), isNaN(e.startIndex) || "string" != typeof e.startIndex || (e.startIndex = parseInt(e.startIndex, 10)), (void 0 === e.startIndex || isNaN(e.startIndex) || e.startIndex < 0 || e.startIndex > e.entries.length - 1) && (t.push("Configuration warning. The config property 'startIndex' is not configured properly."), e.startIndex = e.entries.length - 1), e.options) {
            if (e.options.switch) {
              for (r in i) if (Object.prototype.hasOwnProperty.call(e.options.switch, r) && typeof e.options.switch[r] == typeof i[r]) switch (r) {
                case"method":
                  -1 !== ["server", "client"].indexOf(e.options.switch[r]) ? "server" === e.options.switch[r] && this._useHLS || (i[r] = e.options.switch[r]) : this._emitWarning("The switch method is not valid. Valid methods are 'server' and 'client'. The default method 'server' will be set.");
                  break;
                case"timeout":
                  e.options.switch[r] >= 5 && e.options.switch[r] <= 30 ? i[r] = e.options.switch[r] : this._emitWarning("The switch timeout value is not in the valid range. the valid range is between 5 and 30. The default value 20 will be set.");
                  break;
                default:
                  i[r] = e.options.switch[r]
              }
              e.options.switch = i
            } else e.options.switch = i;
            if (e.options.adaption) {
              var d = a(e.entries.length);
              for (r in d) if (Object.prototype.hasOwnProperty.call(e.options.adaption, r) && typeof e.options.adaption[r] == typeof d[r]) switch (r) {
                case"rule":
                  -1 !== ["deviationOfMean", "none", "deviationOfMean2"].indexOf(e.options.adaption[r]) ? e.entries.length > 1 && (d[r] = e.options.adaption[r]) : this._emitWarning("The adaption rule is not valid. Valid rules are 'deviationOfMean', 'deviationOfMean2' and 'none' (disable). The default rule 'none' will be set.");
                  break;
                case"downStep":
                  if (isNaN(e.options.adaption[r])) this._emitWarning("The adaption down step is not valid. The default down step '1' will be set."); else {
                    var u = d[r];
                    u = parseInt(e.options.adaption[r], 10) || u, u = Math.max(1, Math.min(e.entries.length - 1, u)), d[r] = u
                  }
                  break;
                case"omitRenditions":
                  if (Array.isArray(e.options.adaption[r])) {
                    for (var c = ["high", "medium-high", "medium", "medium-low", "low"], l = !1, f = 0; f < e.options.adaption[r].length; f += 1) {
                      if (isNaN(e.options.adaption[r][f])) {
                        if ("string" == typeof e.options.adaption[r][f] && -1 !== c.indexOf(e.options.adaption[r][f])) continue;
                        l = !0;
                        break
                      }
                      var E = parseInt(e.options.adaption[r][f], 10);
                      if (!(!isNaN(E) && E >= 0 && E < e.entries.length)) {
                        l = !0;
                        break
                      }
                    }
                    l ? this._emitWarning("The adaption omit renditions [" + e.options.adaption[r].join(",") + "] are not valid and will be ignored.") : d[r] = e.options.adaption[r]
                  } else this._emitWarning("The adaption omit renditions are not valid and will be ignored.");
                  break;
                default:
                  d[r] = e.options.adaption[r]
              }
              e.options.adaption = d
            } else e.options.adaption = a(e.entries.length)
          } else e.options = {switch: i, adaption: a(e.entries.length)};
          return e.bintu && 1 === e.entries.length && (e.h5live = e.entries[0].h5live), t && t.length && t.forEach(function (e) {
            this._emitWarning(e)
          }.bind(this)), e
        }, x._onUpdateSourceTimeout = function () {
          L.debugEnabled() && L.debug("updateSource timeout")
        }, x._reset = function () {
          this._setState(_.READY), this._setNetworkState(h.IDLE), this._setPauseReason(S.NONE)
        }, x.STATE = _, x.NETWORK_STATE = h, x.PAUSE_REASON = S, F
      }.apply(t, r)) || (e.exports = i)
    }, 1933: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        "use strict";
        var t = e.create("BrowserInfo"), n = "Unknown", r = "";
        screen.width && (r += (screen.width ? screen.width : "") + " x " + (screen.height ? screen.height : ""));
        var i, a, o, s = navigator.userAgent, d = n, u = "0.0", c = n, l = navigator.plugins,
          f = navigator.maxTouchPoints > 0, E = !!window.ManagedMediaSource, p = !!window.MediaSource,
          m = E && window.ManagedMediaSource.isTypeSupported && window.ManagedMediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.2"'),
          g = p && window.MediaSource.isTypeSupported && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.2"'),
          b = !1, _ = !!window.WebTransport, h = !!window.VideoDecoder, T = !!window.AudioDecoder, A = _ && h && T;
        try {
          if (E) {
            var S = new window.ManagedMediaSource, y = window.URL.createObjectURL(S);
            "string" == typeof y && 0 === y.indexOf("blob:http") && (b = !0)
          }
        } catch (e) {
        }
        var R = n, v = [{s: "Windows 3.11", r: /Win16/}, {s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/}, {
          s: "Windows ME",
          r: /(Win 9x 4.90|Windows ME)/
        }, {s: "Windows 98", r: /(Windows 98|Win98)/}, {s: "Windows CE", r: /Windows CE/}, {
          s: "Windows 2000",
          r: /(Windows NT 5.0|Windows 2000)/
        }, {s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/}, {
          s: "Windows Server 2003",
          r: /Windows NT 5.2/
        }, {s: "Windows Vista", r: /Windows NT 6.0/}, {
          s: "Windows 7",
          r: /(Windows 7|Windows NT 6.1)/
        }, {s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/}, {
          s: "Windows 8",
          r: /(Windows 8|Windows NT 6.2)/
        }, {s: "Windows 10", r: /(Windows 10|Windows NT 10.0)/}, {
          s: "Windows NT 4.0",
          r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        }, {s: "Windows ME", r: /Windows ME/}, {s: "Android", r: /Android/}, {
          s: "Open BSD",
          r: /OpenBSD/
        }, {s: "Sun OS", r: /SunOS/}, {s: "Linux", r: /(Linux|X11)/}, {
          s: "iOS",
          r: /(iPhone|iPad|iPod)/
        }, {s: "Mac OS X", r: /Mac OS X/}, {s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/}, {
          s: "QNX",
          r: /QNX/
        }, {s: "UNIX", r: /UNIX/}, {s: "BeOS", r: /BeOS/}, {s: "OS/2", r: /OS\/2/}, {
          s: "Search Bot",
          r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }];
        for (var O in v) {
          var I = v[O];
          if (I.r.test(s)) {
            R = I.s;
            break
          }
        }
        var C = n, N = void 0;
        switch (R) {
          case"Mac OS X":
            null !== (N = /Mac OS X (\d+)_(\d+)_?(\d+)?/.exec(s) || /Mac OS X ([._\d]+)/.exec(s)) && (C = N[1] + "." + (0 | N[2]) + "." + (0 | N[3]));
            break;
          case"Android":
            null !== (N = /Android ([._\d]+)/.exec(s)) && (C = N[1]);
            break;
          case"iOS":
            null !== (N = /OS (\d+)_(\d+)_?(\d+)?/.exec(s)) && (C = N[1] + "." + N[2] + "." + (0 | N[3]));
            break;
          default:
            /Windows/.test(R) && (null !== (N = /Windows (.*)/.exec(R)) && (C = N[1]), R = "Windows")
        }
        if (-1 !== (a = s.indexOf("Opera"))) d = "Opera", u = s.substring(a + 6), -1 !== (a = s.indexOf("Version")) && (u = s.substring(a + 8)), c = "Chromium"; else if (-1 !== (a = s.indexOf("SamsungBrowser"))) d = "Samsung Browser", u = s.substring(a + 15), c = "Chromium"; else if (-1 !== (a = s.indexOf("Edg/"))) d = "Microsoft Edge Chromium", u = s.substring(a + 4), c = "Chromium"; else if (-1 !== (a = s.indexOf("UCBrowser"))) d = "UC Browser", u = s.substring(a + 10), c = "Blink"; else if (-1 !== (a = s.indexOf("YaBrowser"))) d = "Yandex Browser", u = s.substring(a + 10), c = "Blink"; else if (-1 !== (a = s.indexOf("QIHU 360EE")) || -1 !== (a = s.indexOf("360Browser"))) d = "Qihoo 360 Browser", u = "0", c = "Blink"; else if (-1 !== (a = s.indexOf("Iron"))) d = "Iron Browser", u = s.substring(a + 5), c = "Chromium"; else if (-1 !== (a = s.indexOf("Vivaldi"))) d = "Vivaldi Browser", u = s.substring(a + 8), c = "Chromium"; else if (-1 !== (a = s.indexOf("OPR/"))) d = "Opera", u = s.substring(a + 4), c = "Chromium"; else if (-1 !== (a = s.indexOf("MSIE"))) d = "Microsoft Internet Explorer", u = s.substring(a + 5), c = "Trident"; else if (-1 !== (a = s.indexOf("Trident/"))) d = "Microsoft Internet Explorer", u = s.substring(a + 8), -1 !== (a = s.indexOf("rv:")) && (u = s.substring(a + 3)), c = "Trident"; else if (-1 !== (a = s.indexOf("Edge/"))) d = "Microsoft Edge Trident", u = s.substring(a + 5), c = "Trident"; else if (-1 !== (a = s.indexOf("Chrome"))) {
          var D = ["Chromium PDF Viewer", "Native Client", "Chromium PDF Plugin"];
          if (d = "Chrome", u = s.substring(a + 7), c = "Chromium", p && !g && parseInt(u, 10) >= 54) d = "Chromium"; else for (var w = 0; w < l.length; w++) {
            D.includes(l[w].name) && (d = "Chromium");
            break
          }
        } else if (-1 !== (a = s.indexOf("PhantomJS"))) d = "PhantomJS", u = s.substring(a + 10), c = "Webkit"; else if (-1 !== (a = s.indexOf("Safari")) || "iOS" === R && (a = s.length)) {
          d = "Safari", u = s.substring(a + 7), -1 !== (a = s.indexOf("Version")) && (u = s.substring(a + 8)), -1 !== (a = s.indexOf("CriOS")) && (d = "Chrome", u = s.substring(a + 6)), -1 !== (a = s.indexOf("FxiOS")) && (d = "Firefox", u = s.substring(a + 6)), -1 !== (a = s.indexOf("EdgiOS")) && (d = "Microsoft Edge", u = s.substring(a + 7)), -1 !== (o = u.indexOf(";")) && (u = u.substring(0, o)), -1 !== (o = u.indexOf(" ")) && (u = u.substring(0, o)), -1 !== (o = u.indexOf(")")) && (u = u.substring(0, o));
          var U = parseInt(u.split(".")[0], 10);
          if (isNaN(U) || !U || U > 500) {
            for (var P = C.split("."); P.length > 2;) P.pop();
            u = P.length > 1 ? P.join(".") : P[0]
          }
          c = "Webkit"
        } else -1 !== (a = s.indexOf("Firefox")) ? (d = "Firefox", u = s.substring(a + 8), c = "Firefox") : (i = s.lastIndexOf(" ") + 1) < (a = s.lastIndexOf("/")) && (d = s.substring(i, a), u = s.substring(a + 1), d.toLowerCase() === d.toUpperCase() && (d = n));
        -1 !== (o = u.indexOf(";")) && (u = u.substring(0, o)), -1 !== (o = u.indexOf(" ")) && (u = u.substring(0, o)), -1 !== (o = u.indexOf(")")) && (u = u.substring(0, o));
        var M = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(s), L = !!navigator.cookieEnabled;
        void 0 !== navigator.cookieEnabled || L || (document.cookie = "testcookie", L = -1 !== document.cookie.indexOf("testcookie"));
        var F = {
          screen: r,
          browser: d,
          browserVersion: u,
          mobile: M,
          os: R,
          osVersion: C,
          cookies: L,
          browserEngine: c,
          hasManagedMediaSource: E,
          hasMediaSource: p,
          isManagedMediaSourceH264Supported: m,
          isMediaSourceH264Supported: g,
          isManagedMediaSourceValidBlobUrl: b,
          hasTouchPoints: f,
          hasWebTransport: _,
          hasVideoDecoder: h,
          hasAudioDecoder: T,
          isMediaOverQuicSupported: A
        };
        for (var x in F) Object.prototype.hasOwnProperty.call(F, x) && t.debug(x + ": " + F[x]);
        return F
      }.apply(t, r)) || (e.exports = i)
    }, 8818: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        "use strict";
        var t, n = e.create("CodecSupport");

        function r() {
          var e = Object.keys(i).map((function (e) {
            return {codec: i[e], supported: !1}
          })), t = Object.keys(a).map((function (e) {
            return {codec: a[e], supported: !1}
          }));
          return {
            video: {codecs: e, unsupported: e.length},
            audio: {codecs: t, unsupported: t.length},
            webcodecs_vc: !1,
            webcodecs_ac: !1
          }
        }

        var i = {
            "avc1.420015": "h264_baseline",
            "avc1.4D401E": "h264_main",
            "avc1.640028": "h264_high",
            "hvc1.1.6.L93.B0": "hevc_main",
            "av01.0.08M.08": "av1_main"
          }, a = {"mp4a.40.2": "aac_lc", "mp4a.40.5": "aac_hev1", "mp4a.40.29": "aac_hev2", opus: "opus"},
          o = [{width: 640, height: 360}, {width: 854, height: 480}, {width: 1280, height: 720}, {
            width: 1920,
            height: 1080
          }, {width: 3840, height: 2160}], s = [{sampleRate: 16e3, channels: 2}, {sampleRate: 24e3, channels: 2}, {
            sampleRate: 32e3,
            channels: 2
          }, {sampleRate: 44100, channels: 2}, {sampleRate: 48e3, channels: 2}];
        return function () {
          var e = performance.now(), t = {
            video: !(!window.VideoDecoder || !window.VideoDecoder.isConfigSupported),
            audio: !(!window.AudioDecoder || !window.AudioDecoder.isConfigSupported)
          };
          if (!t.video && !t.audio) {
            var d = performance.now() - e, u = r();
            return u.codecs_time = {execution: Math.round(d)}, Promise.resolve(u)
          }
          var c = [], l = [];
          return t.video && Object.keys(i).forEach((function (e) {
            c.push(function (e) {
              for (var t = o.slice().reverse(), n = [], r = 0; r < t.length; r++) {
                var a = t[r], s = {codec: e, codedWidth: a.width, codedHeight: a.height}, d = function (e) {
                  return VideoDecoder.isConfigSupported(s).then((function (t) {
                    return {resolution: e, supported: t.supported}
                  })).catch((function () {
                    return {resolution: e, supported: !1}
                  }))
                }(a);
                n.push(d)
              }
              return Promise.all(n).then((function (t) {
                for (var n = null, r = 0; r < t.length; r++) if (t[r].supported) {
                  n = t[r];
                  break
                }
                return {
                  codec: i[e],
                  supported: !!n,
                  maxResolution: n ? n.resolution.width + "x" + n.resolution.height : void 0
                }
              }))
            }(e))
          })), t.audio && Object.keys(a).forEach((function (e) {
            l.push(function (e) {
              for (var t = s.slice().reverse(), r = [], i = 0; i < t.length; i++) {
                var o = function (t) {
                  var r = {codec: e, sampleRate: t.sampleRate, numberOfChannels: t.channels};
                  return AudioDecoder.isConfigSupported(r).then((function (e) {
                    return n.debugEnabled() && n.debug("support success "), {config: t, supported: e.supported}
                  })).catch((function () {
                    return n.debugEnabled() && n.debug("support fail "), {config: t, supported: !1}
                  }))
                }(t[i]);
                r.push(o)
              }
              return Promise.all(r).then((function (t) {
                for (var n = null, r = 0; r < t.length; r++) if (t[r].supported) {
                  n = t[r];
                  break
                }
                return {
                  codec: a[e],
                  supported: !!n,
                  maxConfig: n ? n.config.sampleRate + "Hz/" + n.config.channels + "ch" : void 0
                }
              }))
            }(e))
          })), Promise.all([Promise.all(c), Promise.all(l)]).then((function (n) {
            for (var r = performance.now() - e, i = n[0], a = n[1], o = 0, s = 0; s < i.length; s++) i[s].supported || o++;
            for (var d = 0, u = 0; u < a.length; u++) a[u].supported || d++;
            return {
              video: {codecs: i, unsupported: o},
              audio: {codecs: a, unsupported: d},
              codecs_time: {execution: Math.round(r.toFixed(2))},
              webcodecs_vc: t.video,
              webcodecs_ac: t.audio
            }
          })).catch((function (e) {
            return n.error("Error during codec support check:", e), r()
          }))
        }().then((function (e) {
          e.moq_supported = function (e) {
            for (var t = !1, n = 0; n < e.video.codecs.length; n++) if ("h264_baseline" === e.video.codecs[n].codec && e.video.codecs[n].supported) {
              t = !0;
              break
            }
            for (var r = !1, i = 0; i < e.audio.codecs.length; i++) if ("aac_lc" === e.audio.codecs[i].codec && e.audio.codecs[i].supported) {
              r = !0;
              break
            }
            return !!(window.WebTransport && e.webcodecs_vc && e.webcodecs_ac && t && r)
          }(e), t = e
        })).catch((function (e) {
          n.error("Failed to initialize codec support:", e), t = r()
        })), {
          getCodecSupport: function () {
            return t
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6627: function (e, t, n) {
      var r, i;
      r = [n(1933), n(8333)], void 0 === (i = function (e, t) {
        var n = t.create("Conditions"), r = e.os, i = parseInt(e.osVersion.split(".")[0], 10), a = e.browser,
          o = parseInt(e.browserVersion.split(".")[0], 10), s = e.browserEngine, d = "Microsoft Edge Trident" === a,
          u = "Microsoft Internet Explorer" === a || d, c = "Webkit" === s, l = "Chromium" === s && o > 57,
          f = "iOS" === r, E = f && o >= 11, p = f && o >= 15, m = "Mac OS X" === r, g = "Chrome" === a,
          b = "Firefox" === a, _ = "Microsoft Edge" === a, h = "Safari" === a,
          T = h && 12.1 === parseFloat(e.browserVersion) && "iOS" !== r, A = T,
          S = !!e.isManagedMediaSourceH264Supported, y = !!e.isManagedMediaSourceValidBlobUrl, R = !!e.hasMediaSource,
          v = !!e.isMediaSourceH264Supported, O = !(S && y) && f && i >= 10, I = e.hasTouchPoints,
          C = e.isMediaOverQuicSupported;
        O || v || S && y || !m || (O = !0);
        var N = !f && R && (b && o >= 48 || d || v) || S && y,
          D = (I || !R) && m && (h && o >= 13 || g && o >= 85 || b || _), w = D && R && v, U = function () {
            var e = !1;
            try {
              (("Chrome" === a || "Chromium" === a) && o < 54 || "Firefox" === a && o < 48 || "Microsoft Internet Explorer" === a && (o < 11 || 11 === o && 7 === i) || (m || f) && "Safari" === a && o < 10) && (e = !0)
            } catch (e) {
            }
            return e
          }(), P = {
            mustUseHLS: O,
            canUseHLS: A,
            isTridentBrowser: u,
            isWebkitBrowser: c,
            useFakeAudio: l,
            canUseMediaSource: N,
            isIOS: f,
            isAboveIOS11: E,
            isAboveIOS15: p,
            isIOSDesktopMode: D,
            isIPadDesktopMode: w,
            isMacOS: m,
            isFirefox: b,
            isSafari: h,
            isChrome: g,
            isSafari121MacOSX: T,
            isH5LiveKnownUnsupported: U,
            isMediaOverQuicSupported: C
          };
        for (var M in P) Object.prototype.hasOwnProperty.call(P, M) && n.debug(M + ": " + P[M]);
        return P
      }.apply(t, r)) || (e.exports = i)
    }, 1473: function (e, t) {
      var n;
      void 0 === (n = function () {
        function e(t, n) {
          var r;
          for (r in t) Object.prototype.hasOwnProperty.call(t, r) && (!n[r] && (n[r] = {}), "object" != typeof t[r] || Array.isArray(t[r]) ? n[r] = t[r] : e(t[r], n[r]))
        }

        return {
          merge: function t(n, r) {
            var i;
            for (i in n) Object.prototype.hasOwnProperty.call(n, i) && Object.prototype.hasOwnProperty.call(r, i) && ("object" != typeof n[i] || null === n[i] || !Object.keys(n[i]).length || "object" == typeof r[i] && Object.keys(r[i]).length || Array.isArray(n[i]) ? "object" != typeof n[i] || Array.isArray(n[i]) ? r[i] = n[i] : t(n[i], r[i]) : e(n[i], r[i]))
          }, clean: function e(t) {
            var n;
            for (n in t) Object.prototype.hasOwnProperty.call(t, n) && (void 0 === t[n] || null === t[n] || "string" == typeof t[n] && 0 === t[n].length) && delete t[n], Object.prototype.hasOwnProperty.call(t, n) && t[n] instanceof Object && e(t[n]);
            for (n in t) (Object.prototype.hasOwnProperty.call(t, n) && (void 0 === t[n] || null === t[n] || "string" == typeof t[n] && 0 === t[n].length) || "object" == typeof t[n] && "function" != typeof t[n] && 0 === Object.keys(t[n]).length) && delete t[n]
          }, check: function e(t, n, r, i) {
            var a;
            for (a in r = r || "", i = i || [], t) Object.prototype.hasOwnProperty.call(t, a) && Object.prototype.hasOwnProperty.call(n, a) && ("object" == typeof t[a] && "object" == typeof n[a] ? i = e(t[a], n[a], r + a + ".", i) : typeof t[a] !== n[a] && "*" !== n[a] && void 0 !== t[a] && "" !== t[a] && i.push("Configuration warning. The config property '$property$' must be of type '$type$'.".replace("$property$", r + a).replace("$type$", n[a]))), Object.prototype.hasOwnProperty.call(t, a) && !Object.prototype.hasOwnProperty.call(n, a) && i.push("Configuration warning. The config property '$property$' is not a valid property. Please remove from config.".replace("$property$", r + a));
            return i
          }, extend: e
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6725: function (e, t, n) {
      var r, i;
      r = [n(8478), n(1313), n(3284), n(3778), n(3890)], void 0 === (i = function (e, t, n, r, i) {
        return {
          validateConfig: function (i, a) {
            for (var o, s = !1, d = a.source.entries, u = 0; u < d.length; u += 1) {
              if (!(o = d[u]) || !o.h5live) {
                s = new e(t.CONFIG_SOURCE, r.SETUP.SOURCE_NOT_SUPPORTED);
                break
              }
              if (!(o.h5live.rtmp && o.h5live.rtmp.url && o.h5live.rtmp.streamname || o.h5live.params)) {
                s = new e(t.CONFIG_RTMP, r.SETUP.CONFIG_RTMP);
                break
              }
              if (i === n.H5LIVE_WSS && (!o.h5live.server || o.h5live.server && !o.h5live.server.websocket)) {
                s = new e(t.CONFIG_WSS, r.SETUP.CONFIG_WSS);
                break
              }
              if (i === n.H5LIVE_HLS) {
                if (!o.h5live.server || o.h5live.server && !o.h5live.server.hls) {
                  s = new e(t.CONFIG_HLS, r.SETUP.CONFIG_HLS);
                  break
                }
                if (a.playback && a.playback.metadata && !o.h5live.server.websocket) {
                  s = new e(t.CONFIG_METADATA, r.SETUP.CONFIG_METADATA);
                  break
                }
              }
              if (!(o.h5live.server && (o.h5live.server.websocket || o.h5live.server.hls) || o.h5live.token)) {
                s = new e(t.CONFIG_TOKEN, r.SETUP.CONFIG_TOKEN);
                break
              }
            }
            return s
          }, validatePlayerDivId: function (t) {
            if (!("string" == typeof t || t instanceof String)) throw new e('The param "playerDivId" must be of type "String".');
            var n = document.getElementById(t);
            if (!n) throw new e('The param "playerDivId" must be the id of an existing "div" element.');
            if ("DIV" !== n.tagName) throw new e('The element with the id "' + t + '" is not a "div" element.');
            return !0
          }, validateSwitchIndex: function (t, n) {
            var a = !1;
            return (!("number" == typeof t || t instanceof Number) || t < 0 || t >= n.source.entries.length) && (a = new e(i.PLAYER.INVALID_ENTRY_INDEX, r.PLAYER.INVALID_ENTRY_INDEX)), a
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8877: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        var t = e.create("ConnectionTest"), n = 0, r = 0, i = void 0, a = void 0, o = void 0, s = {
          websocket: {start: 0, end: 0, duration: 0},
          webtransport: {start: 0, end: 0, duration: 0},
          server: void 0,
          error: void 0
        };

        function d() {
          return "undefined" != typeof window && "WebTransport" in window
        }

        return {
          test: function (e, u) {
            return s.websocket.start = 0, s.websocket.end = 0, s.websocket.duration = 0, s.webtransport.start = 0, s.webtransport.end = 0, s.webtransport.duration = 0, s.server = void 0, s.error = void 0, a = e, o = "?stream=" + u + "&url=rtmp%3A%2F%2Flocalhost%2Fplay&flags=checkandclose", t.debugEnabled() && t.debug("Starting simultaneous connection test..."), t.debugEnabled() && t.debug("WebTransport supported:" + d()), new Promise((function (e) {
              var u, c = [], l = new Promise((function (e, d) {
                s.websocket.start = Date.now();
                var u, c = a.websocket + o, l = !1;
                t.debugEnabled() && t.debug("Connecting to WebSocket:" + c);
                try {
                  (u = new WebSocket(c)).binaryType = "arraybuffer"
                } catch (e) {
                  return t.debugEnabled() && t.debug("WebSocket creation failed:" + e.message), void d("WebSocket creation failed: " + e.message)
                }
                var f = setTimeout((function () {
                  t.debugEnabled() && t.debug("WebSocket timeout - closing connection"), u && u.readyState !== WebSocket.CLOSED && u.close(), l || (l = !0, d("WebSocket timeout"))
                }), 2e3);
                u.addEventListener("open", (function () {
                  t.debugEnabled() && t.debug("WebSocket opened successfully"), l || (clearTimeout(f), s.websocket.end = Date.now(), s.websocket.duration = s.websocket.end - s.websocket.start, n = 1 * s.websocket.duration / 2 > 200 ? 1 * s.websocket.duration / 2 : 200, r = setTimeout((function () {
                    t.debugEnabled() && t.debug("Waiting Timeout reached after " + n + "ms. WebTransport creation failed."), i && "function" == typeof i && i("Waiting Timeout reached after " + n + "ms. WebTransport creation failed.")
                  }), n), u.readyState === WebSocket.OPEN && u.close(), l = !0, e())
                })), u.addEventListener("message", (function (n) {
                  if (t.debugEnabled() && t.debug("WebSocket message received"), !l) {
                    if (clearTimeout(f), s.websocket.end = Date.now(), s.websocket.duration = s.websocket.end - s.websocket.start, "string" == typeof n.data) try {
                      var r = JSON.parse(n.data);
                      r.onServerInfo && (s.server = r.onServerInfo.hostname, t.debugEnabled() && t.debug("Server info received:" + s.server))
                    } catch (e) {
                      t.debugEnabled() && t.debug("Failed to parse message JSON:" + e.message)
                    }
                    u.readyState === WebSocket.OPEN && u.close(), l = !0, e()
                  }
                })), u.addEventListener("error", (function (e) {
                  if (t.debugEnabled() && t.debug("WebSocket error event fired"), !l) {
                    clearTimeout(f);
                    var n = "WebSocket error";
                    e && e.message ? n += ": " + e.message : n += e && "string" == typeof e ? ": " + e : e ? ": " + String(e) : ": Unknown error", t.debugEnabled() && t.debug("WebSocket error occurred:" + n), l = !0, d(n)
                  }
                })), u.addEventListener("close", (function (e) {
                  t.debugEnabled() && t.debug("WebSocket closed - code:" + e.code + "reason:" + e.reason), clearTimeout(f)
                }))
              })).catch((function (e) {
                return t.debugEnabled() && t.debug("WebSocket failed, halting test: " + e), Promise.reject(e)
              }));
              c.push(l), d() ? (u = new Promise((function (e, n) {
                if (i = n, d()) {
                  s.webtransport.start = Date.now();
                  var u, c = a.webtransport.split("/h5live/"), l = c[0] + "/h5live/probe/" + c[1] + o;
                  t.debugEnabled() && t.debug("Connecting to WebTransport:" + l);
                  try {
                    u = new window.WebTransport(l)
                  } catch (e) {
                    return t.debugEnabled() && t.debug("WebTransport creation failed:" + e.message), void n("WebTransport creation failed: " + e.message)
                  }
                  var f = setTimeout((function () {
                    if (t.debugEnabled() && t.debug("WebTransport timeout - closing connection"), u) try {
                      u.close()
                    } catch (e) {
                      t.debugEnabled() && t.debug("Error initiating WebTransport close on timeout:" + (e.message || e))
                    }
                    n("WebTransport timeout")
                  }), 2e3);
                  u.ready.then((function () {
                    clearTimeout(f), clearTimeout(r), s.webtransport.end = Date.now(), s.webtransport.duration = s.webtransport.end - s.webtransport.start, s.webtransport.duration < 10 && (t.debugEnabled() && t.debug("WebTransport duration below 10ms (" + s.webtransport.duration + "ms), marking as failed connection"), s.webtransport.duration = 0);
                    try {
                      u.close(), u.closed.then((function () {
                        t.debugEnabled() && t.debug("WebTransport connection closed successfully after test")
                      })).catch((function (e) {
                        t.debugEnabled() && t.debug("Error closing WebTransport after test:" + (e.message || e))
                      }))
                    } catch (e) {
                      t.debugEnabled() && t.debug("Error initiating WebTransport close after test:" + (e.message || e))
                    }
                    e()
                  })).catch((function (e) {
                    clearTimeout(f);
                    var r = "WebTransport connection failed";
                    e && e.message ? r += ": " + e.message : e && "string" == typeof e ? r += ": " + e : e && (r += ": " + String(e)), t.debugEnabled() && t.debug("WebTransport ready failed:" + r);
                    try {
                      u.close(), u.closed.then((function () {
                        t.debugEnabled() && t.debug("WebTransport connection closed successfully after error")
                      })).catch((function (e) {
                        t.debugEnabled() && t.debug("Error closing WebTransport on error:" + (e.message || e))
                      }))
                    } catch (e) {
                      t.debugEnabled() && t.debug("Error initiating WebTransport close on error:" + (e.message || e))
                    }
                    n(r)
                  }))
                } else n("WebTransport not supported")
              })).then((function () {
                return s.webtransport
              })).catch((function (e) {
                return t.debugEnabled() && t.debug("WebTransport failed, continuing test: " + e), s.webtransport.duration = -1, s.webtransport
              })), c.push(u)) : (t.debugEnabled() && t.debug("WebTransport not supported - testing WebSocket only"), s.webtransport.duration = -1, u = Promise.resolve(), c.push(u)), Promise.all(c).then((function () {
                t.debugEnabled() && t.debug("All connection tests completed");
                var n = JSON.parse(JSON.stringify(s));
                e(n)
              })).catch((function (n) {
                t.debugEnabled() && t.debug("Test halted due to WebSocket failure: " + n), s.error = n;
                var r = JSON.parse(JSON.stringify(s));
                e(r)
              }))
            }))
          }, isWebTransportSupported: d
        }
      }.apply(t, r)) || (e.exports = i)
    }, 9088: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = o(), t = s(), n = d(), r = u(), i = 0, a = void 0;

        function o() {
          var e = l("debug") || l("nanoDebug") || 0, t = +c("nanoDebug");
          return Math.max(e, t)
        }

        function s() {
          var e = l("debugFilter") || l("nanoDebugFilter") || "*";
          return (c("nanoDebugFilter") || e).split("|")
        }

        function d() {
          var e = +l("debugClear") || +l("nanoDebugClear") || 0, t = +c("nanoDebugClear");
          return Math.max(e, t)
        }

        function u() {
          var e = l("debugFunction") || l("nanoDebugFunction") || "";
          return (c("nanoDebugFunction") || e).split(".")
        }

        function c(e) {
          return -1 !== document.cookie.indexOf(e + "=") ? document.cookie.split(e + "=")[1].split(";")[0] : null
        }

        function l(e) {
          if (!a) {
            a = [];
            var t = document.location.search.substr(1, document.location.search.length);
            if ("" === t && -1 !== document.location.href.indexOf("?")) {
              var n = document.location.href.indexOf("?") + 1;
              t = document.location.href.slice(n)
            }
            if ("" !== t) for (var r = t.split("&"), i = 0; i < r.length; ++i) {
              var o = "", s = r[i].split("="), d = s[0];
              s.length > 1 && (o = s[1]), a[decodeURIComponent(d)] = decodeURIComponent(o)
            }
          }
          try {
            return a[e]
          } catch (e) {
            return
          }
        }

        return setInterval((function () {
          e = o(), t = s(), n = d(), r = u()
        }), 5e3), {
          log: function (a, o) {
            try {
              if (e >= o && ("*" === t[0] || t.filter((function (e) {
                return a.includes(e)
              })).length)) {
                var s = (new Date).toISOString() + ": " + a;
                console.debug(s);
                for (var d = 0; d < r.length; d += 1) {
                  var u = u || window, c = r[d];
                  0 === d && "window" === c || !("object" == typeof window[c] && d < r.length - 1 || d === r.length - 1 && "function" == typeof window[c]) || (u = u[c], d === r.length - 1 && u(s))
                }
                i++
              }
              n && i > n && (i = 0, console.clear())
            } catch (e) {
            }
          }, getHTTPParam: l, enabled: function (t) {
            return e >= t
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8478: function (e, t) {
      var n;
      void 0 === (n = function () {
        return function (e, t) {
          var n = new window.Error(e || "");
          return n.code = t || 0, n
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9658: function (e, t) {
      var n;
      void 0 === (n = function () {
        "use strict";

        function e() {
        }

        var t = e.prototype;

        function n(e, t) {
          for (var n = e.length; n--;) if (e[n].listener === t) return n;
          return -1
        }

        function r(e) {
          return function () {
            return this[e].apply(this, arguments)
          }
        }

        return t.getListeners = function (e) {
          var t, n, r = this._getEvents();
          if (e instanceof RegExp) for (n in t = {}, r) Object.prototype.hasOwnProperty.call(r, n) && e.test(n) && (t[n] = r[n]); else t = r[e] || (r[e] = []);
          return t
        }, t.flattenListeners = function (e) {
          var t, n = [];
          for (t = 0; t < e.length; t += 1) n.push(e[t].listener);
          return n
        }, t.getListenersAsObject = function (e) {
          var t, n = this.getListeners(e);
          return n instanceof Array && ((t = {})[e] = n), t || n
        }, t.addListener = function (e, t) {
          var r, i = this.getListenersAsObject(e), a = "object" == typeof t;
          for (r in i) Object.prototype.hasOwnProperty.call(i, r) && -1 === n(i[r], t) && i[r].push(a ? t : {
            listener: t,
            once: !1
          });
          return this
        }, t.on = r("addListener"), t.addOnceListener = function (e, t) {
          return this.addListener(e, {listener: t, once: !0})
        }, t.once = r("addOnceListener"), t.defineEvent = function (e) {
          return this.getListeners(e), this
        }, t.defineEvents = function (e) {
          for (var t = 0; t < e.length; t += 1) this.defineEvent(e[t]);
          return this
        }, t.removeListener = function (e, t) {
          var r, i, a = this.getListenersAsObject(e);
          for (i in a) Object.prototype.hasOwnProperty.call(a, i) && -1 !== (r = n(a[i], t)) && a[i].splice(r, 1);
          return this
        }, t.off = r("removeListener"), t.addListeners = function (e, t) {
          return this.manipulateListeners(!1, e, t)
        }, t.removeListeners = function (e, t) {
          return this.manipulateListeners(!0, e, t)
        }, t.manipulateListeners = function (e, t, n) {
          var r, i, a = e ? this.removeListener : this.addListener, o = e ? this.removeListeners : this.addListeners;
          if ("object" != typeof t || t instanceof RegExp) for (r = n.length; r--;) a.call(this, t, n[r]); else for (r in t) Object.prototype.hasOwnProperty.call(t, r) && (i = t[r]) && ("function" == typeof i ? a.call(this, r, i) : o.call(this, r, i));
          return this
        }, t.removeEvent = function (e) {
          var t, n = typeof e, r = this._getEvents();
          if ("string" === n) delete r[e]; else if (e instanceof RegExp) for (t in r) Object.prototype.hasOwnProperty.call(r, t) && e.test(t) && delete r[t]; else delete this._events;
          return this
        }, t.removeAllListeners = r("removeEvent"), t.emitEvent = function (e, t) {
          var n, r, i, a, o = this.getListenersAsObject(e);
          for (a in o) if (Object.prototype.hasOwnProperty.call(o, a)) for (i = (n = o[a].slice(0)).length; i--;) !0 === (r = n[i]).once && this.removeListener(e, r.listener), r.listener.apply(this, t || []) === this._getOnceReturnValue() && this.removeListener(e, r.listener);
          return this
        }, t.trigger = r("emitEvent"), t.emit = function (e) {
          var t = Array.prototype.slice.call(arguments, 1);
          return t.length ? t.length && "object" != typeof t[0] || t.length && !Object.prototype.hasOwnProperty.call(t[0], "data") ? t[0] = {
            name: e,
            data: t[0]
          } : t[0].name = e : t.push({name: e, data: {}}), this.emitEvent(e, t)
        }, t.emitSimple = function (e, t, n) {
          return this.emitEvent(e, [{name: e || "AnonymousEvent", target: n || this, data: t || {}}])
        }, t.setOnceReturnValue = function (e) {
          return this._onceReturnValue = e, this
        }, t._getOnceReturnValue = function () {
          return !Object.prototype.hasOwnProperty.call(this, "_onceReturnValue") || this._onceReturnValue
        }, t._getEvents = function () {
          return this._events || (this._events = {})
        }, e
      }.apply(t, [])) || (e.exports = n)
    }, 8333: function (e, t, n) {
      var r, i;
      r = [n(9088)], void 0 === (i = function (e) {
        function t(t, n, r) {
          e.log("[" + n + "] " + r, t)
        }

        function n(t) {
          return e.enabled(t)
        }

        return {
          create: function (e) {
            return {
              debug: t.bind(this, 3, e),
              info: t.bind(this, 2, e),
              warn: t.bind(this, 1, e),
              error: t.bind(this, 0, e),
              detail: t.bind(this, 4, e),
              debugEnabled: n.bind(this, 3),
              infoEnabled: n.bind(this, 2),
              warnEnabled: n.bind(this, 1),
              errorEnabled: n.bind(this, 0),
              detailEnabled: n.bind(this, 4)
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 803: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e, t;
        return {
          play: function (n) {
            return new Promise((function (r, i) {
              var a = n.play();
              Promise.all([a]).then((function () {
                r({media: n})
              })).catch((function (r) {
                e = r && r.name ? r.name : "Unknown", t = r && r.message ? r.message : "Message not available.", i({
                  media: n,
                  error: {name: e, message: t}
                })
              }))
            }))
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8197: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = Object.prototype.toString;
        return {
          copy: function t(n) {
            var r;
            switch (typeof n) {
              case"object":
                if (null === n) r = null; else if (n && n.tagName && n.nodeName && n instanceof Element) r = n; else switch (e.call(n)) {
                  case"[object Array]":
                    r = n.map(t);
                    break;
                  case"[object Date]":
                    r = new Date(n);
                    break;
                  case"[object RegExp]":
                    r = new RegExp(n);
                    break;
                  default:
                    r = Object.keys(n).reduce((function (e, r) {
                      return e[r] = t(n[r]), e
                    }), {})
                }
                break;
              case"undefined":
                r = n;
                break;
              default:
                r = n.valueOf()
            }
            return r
          }, findPropertyByValue: function (e, t) {
            if ("object" == typeof e) for (var n in e) if (e[n] === t) return n;
            return !1
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6028: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function (e, t, n) {
            function r(e) {
              n.emit(e.name, e)
            }

            return function () {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.on(t[n], r)
            }(), {
              destroy: function () {
                for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.off(t[n], r)
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 7176: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          normalize: function (e, t, n) {
            for (var r = function (e) {
              var t = e.length - 1, n = e.substr(0, 1).toUpperCase() + e.substr(1, t);
              return ["webkit" + n, "moz" + n, "ms" + n, e]
            }(t), i = "", a = 0; a < r.length; a += 1) if ((i = r[a]) in e.style) {
              e.style[i] = n;
              break
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6835: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          performInSyncedUIBehavior: function (e, t, n) {
            return new Promise((function (r, i) {
              var a = null, o = null;

              function s() {
                window.cancelAnimationFrame(o), a = null, o = null
              }

              o = window.requestAnimationFrame((function d(u) {
                null === a && (a = u);
                var c = u - a;
                c > n ? (i(), s()) : c < n && !t() ? (0 === c && e(), o = window.requestAnimationFrame(d)) : (r(), s())
              }))
            }))
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5337: function (e, t) {
      var n;
      void 0 === (n = function () {
        function e(e) {
          return e.reduce((function (e, t) {
            return e + t
          }), 0) / e.length
        }

        return {
          create: function (t, n) {
            var r = [], i = {};

            function a(e) {
              return {
                minimum: o(i.minimum, e),
                maximum: o(i.maximum, e),
                arithmetic: o(i.arithmetic, e),
                geometric: o(i.geometric, e),
                harmonic: o(i.harmonic, e),
                deviation: o(i.deviation, e),
                count: o(i.count, e)
              }
            }

            function o(e, t) {
              return isNaN(t) ? e : Math.round(e * Math.pow(10, t)) / Math.pow(10, t)
            }

            return i = {
              add: function (o) {
                for (r.push(o); r.length > t;) r.shift();
                var s, d;
                return i.count++, i.changed = !1, (!n || n && 0 % n == 0) && (s = JSON.parse(JSON.stringify(r)).sort((function (e, t) {
                  return e - t
                }), 0), i.arithmetic = e(s), i.geometric = (d = s, Math.pow(d.reduce((function (e, t) {
                  return e ? t ? e * t : e : t
                }), 0), 1 / d.length)), i.harmonic = function (e) {
                  var t = e.reduce((function (e, t, n) {
                    return t ? n - 1 ? e + 1 / t : (e ? 1 / e : 0) + 1 / t : e
                  }), 0);
                  return t ? e.length / t : 0
                }(s), i.minimum = s[0], i.maximum = s[s.length - 1], i.deviation = function (t, n) {
                  var r = n || e(t);
                  return t.length > 1 ? Math.sqrt(t.reduce((function (e, t) {
                    return e + Math.pow(t - r, 2)
                  }), 0) / (t.length - 1)) : 0
                }(s, i.arithmetic), i.changed = !0), a()
              },
              get: a,
              minimum: 0,
              maximum: 0,
              first: 0,
              last: 0,
              arithmetic: 0,
              geometric: 0,
              harmonic: 0,
              deviation: 0,
              count: 0,
              values: r,
              changed: !1
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4482: function (e, t, n) {
      var r, i;
      r = [n(8333)], void 0 === (i = function (e) {
        var t, n = e.create("WakeLock"), r = null, i = !1;
        return (t = "wakeLock" in navigator) ? n.debugEnabled() && n.debug("Wake Lock API is supported") : n.debugEnabled() && n.debug("Wake Lock API is NOT supported"), {
          request: function () {
            t ? i ? n.debugEnabled() && n.debug("Wake Lock request already in progress") : null === r ? (i = !0, n.debugEnabled() && n.debug("Requesting wake lock"), navigator.wakeLock.request("screen").then((function (e) {
              i = !1, null !== r && (n.debugEnabled() && n.debug("Wake Lock already exists, releasing old one before assigning new"), r.release().catch((function (e) {
                n.debugEnabled() && n.debug("Error releasing old wake lock: " + e.message)
              }))), r = e, n.debugEnabled() && n.debug("Wake Lock activated"), r.addEventListener("release", (function () {
                n.debugEnabled() && n.debug("Wake Lock was released"), r = null
              }))
            })).catch((function (e) {
              i = !1, n.debugEnabled() && n.debug("Wake Lock error: " + e.name + ", " + e.message)
            }))) : n.debugEnabled() && n.debug("Wake Lock already active") : n.debugEnabled() && n.debug("Wake Lock API not supported")
          }, release: function () {
            if (n.debugEnabled() && n.debug("Release wake lock called"), null !== r) {
              var e = r;
              r = null, e.release().then((function () {
                n.debugEnabled() && n.debug("Wake Lock released successfully")
              })).catch((function (e) {
                n.debugEnabled() && n.debug("Wake Lock release error: " + e.name + ", " + e.message)
              }))
            } else n.debugEnabled() && n.debug("No wake lock to release")
          }, isActive: function () {
            return null !== r
          }, isSupported: function () {
            return t
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4556: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = Date.now ? Date.now() : +new Date, t = window.performance || {}, n = [], r = {}, i = function (e, t) {
          for (var r = 0, i = n.length, a = []; r < i; r++) n[r][e] === t && a.push(n[r]);
          return a
        }, a = function (e, t) {
          for (var r, i = n.length; i--;) (r = n[i]).entryType !== e || void 0 !== t && r.name !== t || n.splice(i, 1)
        };
        return t.now || (t.now = t.webkitNow || t.mozNow || t.msNow || function () {
          return (Date.now ? Date.now() : +new Date) - e
        }), t.mark || (t.mark = t.webkitMark || function (e) {
          var i = {name: e, entryType: "mark", startTime: t.now(), duration: 0};
          n.push(i), r[e] = i
        }), t.measure || (t.measure = t.webkitMeasure || function (e, t, i) {
          t = r[t].startTime, i = r[i].startTime, n.push({name: e, entryType: "measure", startTime: t, duration: i - t})
        }), t.getEntriesByType || (t.getEntriesByType = t.webkitGetEntriesByType || function (e) {
          return i("entryType", e)
        }), t.getEntriesByName || (t.getEntriesByName = t.webkitGetEntriesByName || function (e) {
          return i("name", e)
        }), t.clearMarks || (t.clearMarks = t.webkitClearMarks || function (e) {
          a("mark", e)
        }), t.clearMeasures || (t.clearMeasures = t.webkitClearMeasures || function (e) {
          a("measure", e)
        }), void 0 === window.performance && (window.performance = t), window.performance
      }.apply(t, [])) || (e.exports = n)
    }, 2874: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = setTimeout;

        function t() {
        }

        function n(e) {
          if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof e) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], d(e, this)
        }

        function r(e, t) {
          for (; 3 === e._state;) e = e._value;
          0 !== e._state ? (e._handled = !0, n._immediateFn((function () {
            var n = 1 === e._state ? t.onFulfilled : t.onRejected;
            if (null !== n) {
              var r;
              try {
                r = n(e._value)
              } catch (e) {
                return void a(t.promise, e)
              }
              i(t.promise, r)
            } else (1 === e._state ? i : a)(t.promise, e._value)
          }))) : e._deferreds.push(t)
        }

        function i(e, t) {
          try {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
            if (t && ("object" == typeof t || "function" == typeof t)) {
              var r = t.then;
              if (t instanceof n) return e._state = 3, e._value = t, void o(e);
              if ("function" == typeof r) return void d((i = r, s = t, function () {
                i.apply(s, arguments)
              }), e)
            }
            e._state = 1, e._value = t, o(e)
          } catch (t) {
            a(e, t)
          }
          var i, s
        }

        function a(e, t) {
          e._state = 2, e._value = t, o(e)
        }

        function o(e) {
          2 === e._state && 0 === e._deferreds.length && n._immediateFn((function () {
            e._handled || n._unhandledRejectionFn(e._value)
          }));
          for (var t = 0, i = e._deferreds.length; t < i; t++) r(e, e._deferreds[t]);
          e._deferreds = null
        }

        function s(e, t, n) {
          this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n
        }

        function d(e, t) {
          var n = !1;
          try {
            e((function (e) {
              n || (n = !0, i(t, e))
            }), (function (e) {
              n || (n = !0, a(t, e))
            }))
          } catch (e) {
            if (n) return;
            n = !0, a(t, e)
          }
        }

        return n.prototype.catch = function (e) {
          return this.then(null, e)
        }, n.prototype.then = function (e, n) {
          var i = new this.constructor(t);
          return r(this, new s(e, n, i)), i
        }, n.all = function (e) {
          var t = Array.prototype.slice.call(e);
          return new n((function (e, n) {
            if (0 === t.length) return e([]);
            var r = t.length;

            function i(a, o) {
              try {
                if (o && ("object" == typeof o || "function" == typeof o)) {
                  var s = o.then;
                  if ("function" == typeof s) return void s.call(o, (function (e) {
                    i(a, e)
                  }), n)
                }
                t[a] = o, 0 == --r && e(t)
              } catch (e) {
                n(e)
              }
            }

            for (var a = 0; a < t.length; a++) i(a, t[a])
          }))
        }, n.resolve = function (e) {
          return e && "object" == typeof e && e.constructor === n ? e : new n((function (t) {
            t(e)
          }))
        }, n.reject = function (e) {
          return new n((function (t, n) {
            n(e)
          }))
        }, n.race = function (e) {
          return new n((function (t, n) {
            for (var r = 0, i = e.length; r < i; r++) e[r].then(t, n)
          }))
        }, n._immediateFn = "function" == typeof window.setImmediate && function (e) {
          window.setImmediate(e)
        } || function (t) {
          e(t, 0)
        }, n._unhandledRejectionFn = function (e) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e)
        }, n._setImmediateFn = function (e) {
          n._immediateFn = e
        }, n._setUnhandledRejectionFn = function (e) {
          n._unhandledRejectionFn = e
        }, void 0 === window.Promise && (window.Promise = n), window.Promise
      }.apply(t, [])) || (e.exports = n)
    }, 130: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {NANOPLAYER: "5.0.5"}
      }.apply(t, [])) || (e.exports = n)
    }, 2058: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              style: {
                width: void 0,
                height: void 0,
                aspectratio: void 0,
                controls: !0,
                interactive: !0,
                view: !0,
                scaling: "letterbox",
                keepFrame: !0,
                displayAudioOnly: !0,
                audioPlayer: !1,
                displayMutedAutoplay: !0,
                backgroundColor: "black",
                fullScreenControl: !0,
                centerView: !0,
                symbolColor: "rgba(244,233,233,1)",
                controlBarColor: "rgba(0,0,0,0.5)",
                buttonAnimation: !0,
                buttonHighlighting: !0,
                buttonCursor: "pointer",
                poster: void 0,
                fullScreenBackgroundColor: "inherit"
              }, events: {onFullscreenChange: void 0}
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8564: function (e, t, n) {
      var r, i;
      r = [n(6182)], void 0 === (i = function (e) {
        "use strict";
        return {
          create: function (t, n) {
            var r = document.getElementById(t), i = null;
            return window.MutationObserver && (i = new MutationObserver((function (t) {
              t.forEach((function (t) {
                t.addedNodes.forEach((function (t) {
                  "VIDEO" !== t.tagName && "CANVAS" !== t.tagName && "IFRAME" !== t.tagName || n.emit(e.PLAYER_MEDIA_ELEMENT_ADDED, {
                    element: t,
                    tagName: t.tagName
                  })
                }))
              }))
            }))).observe(r, {subtree: !1, childList: !0}), {
              destroy: function () {
                i && (i.disconnect(), i = null), r = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4355: function (e, t, n) {
      var r, i;
      r = [n(6182)], void 0 === (i = function (e) {
        "use strict";
        return {
          create: function (t, n) {
            var r = document.getElementById(t), i = 0, a = 0, o = null, s = null;

            function d(t, r) {
              void 0 === t || void 0 === r || t === i && r === a || (i = t, a = r, n.emit(e.PLAYER_RESIZE, {
                width: i,
                height: a,
                aspectratio: i / a
              }))
            }

            return window.ResizeObserver ? (o = new ResizeObserver((function (e) {
              for (var t = 0; t < e.length; t++) {
                var n = e[t];
                n && n.target && n.target === r && d(n.target.clientWidth, n.target.clientHeight)
              }
            }))).observe(r) : s = setInterval((function () {
              r && d(r.clientWidth, r.clientHeight)
            }), 100), {
              destroy: function () {
                o && (o.disconnect(), o = null), s && (clearInterval(s), s = null), r = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5109: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          create: function () {
            return {
              style: {
                width: "string",
                height: "string",
                aspectratio: "string",
                controls: "boolean",
                interactive: "boolean",
                view: "boolean",
                scaling: "string",
                keepFrame: "boolean",
                displayAudioOnly: "boolean",
                audioPlayer: "boolean",
                displayMutedAutoplay: "boolean",
                backgroundColor: "string",
                fullScreenControl: "boolean",
                centerView: "boolean",
                symbolColor: "string",
                controlBarColor: "string",
                buttonAnimation: "boolean",
                buttonHighlighting: "boolean",
                buttonCursor: "string",
                poster: "string",
                fullScreenBackgroundColor: "string"
              }, events: {onFullscreenChange: "function"}
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 4869: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          NONE: "none",
          LOADING: "loading",
          PLAYBUTTON: "playbutton",
          ERROR: "error",
          AUDIO: "audio"
        })
      }.apply(t, [])) || (e.exports = n)
    }, 5403: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "view.controls.";
        return {
          PLAY: e + "play",
          PAUSE: e + "pause",
          MUTE: e + "mute",
          UNMUTE: e + "unmute",
          VOLUME_CHANGE: e + "volumeChange",
          FULLSCREEN_CHANGE: e + "fullscreenChange",
          OPTIONS_OPEN: e + "optionsOpen",
          OPTIONS_CLOSE: e + "optionsClose"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 2833: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          CLICK: "click",
          DOUBLE_CLICK: "dblclick",
          TOUCH_START: "touchstart",
          TOUCH_END: "touchend",
          TOUCH_MOVE: "touchmove",
          MOUSE_DOWN: "mousedown",
          MOUSE_UP: "mouseup",
          MOUSE_ENTER: "mouseenter",
          MOUSE_LEAVE: "mouseleave",
          MOUSE_MOVE: "mousemove"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 8718: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          FULLSCREEN_CHANGE: "fullscreenchange",
          WEBKIT_FULLSCREEN_CHANGE: "webkitfullscreenchange",
          MOZ_FULLSCREEN_CHANGE: "mozfullscreenchange",
          MS_FULLSCREEN_CHANGE: "MSFullscreenChange",
          MS_FULLSCREEN_CHANGE_LOWERCASE: "msfullscreenchange"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5833: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          FULLSCREEN_ERROR: "fullscreenerror",
          WEBKIT_FULLSCREEN_ERROR: "webkitfullscreenerror",
          MOZ_FULLSCREEN_ERROR: "mozfullscreenerror",
          MS_FULLSCREEN_ERROR: "MSFullscreenError",
          MS_FULLSCREEN_ERROR_LOWERCASE: "msfullscreenerror"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 9087: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "view.fullscreen.";
        return {FULLSCREEN_CHANGE: e + "change", FULLSCREEN_ERROR: e + "error"}
      }.apply(t, [])) || (e.exports = n)
    }, 4124: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({ENTERED: "entered", EXITED: "exited"})
      }.apply(t, [])) || (e.exports = n)
    }, 1117: function (e, t) {
      var n;
      void 0 === (n = function () {
        var e = "view.interaction.";
        return {
          PLAYER_SINGLE_CLICK: e + "playerSingleClick",
          PLAYER_DOUBLE_CLICK: e + "playerDoubleClick",
          PLAYBUTTON_SINGLE_CLICK: e + "playbuttonSingleClick",
          AUDIO_SINGLE_CLICK: e + "audioSingleClick"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 426: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({MUTED: "muted", UNMUTED: "unmuted"})
      }.apply(t, [])) || (e.exports = n)
    }, 1710: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({OPEN: "open", CLOSED: "closed"})
      }.apply(t, [])) || (e.exports = n)
    }, 5459: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({
          UNINITIALIZED: 1,
          IDLE: 2,
          READY: 3,
          LOADING: 4,
          PLAYING: 5,
          PAUSED: 6,
          BUFFERING: 7,
          UNKNOWN: 8,
          PLAYBACK_NOT_STARTED: 9,
          PLAYBACK_SUSPENDED: 10,
          PAUSING: 11,
          PLAYBACK_ERROR: 12,
          RECONNECTION_IMMINENT: 13,
          CONNECTION_ERROR: 14,
          DESTROYING: 15,
          MEDIA_NOT_AVAILABLE: 16,
          VISIBILITY_HIDDEN: 17,
          NOT_ENOUGH_DATA: 18,
          SOURCE_STREAM_STOPPED: 19
        })
      }.apply(t, [])) || (e.exports = n)
    }, 7245: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({PLAY: "play", PAUSE: "pause"})
      }.apply(t, [])) || (e.exports = n)
    }, 8741: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({FULLSCREEN_CHANGE: "FullscreenChange"})
      }.apply(t, [])) || (e.exports = n)
    }, 505: function (e, t) {
      var n;
      void 0 === (n = function () {
        return Object.freeze({NONE: "none", LETTERBOX: "letterbox", CROP: "crop", FILL: "fill"})
      }.apply(t, [])) || (e.exports = n)
    }, 8812: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          controls: {
            fullscreen: {
              viewBox: [0, 0, 24, 24],
              paths: {
                exited: "M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1Zm0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1Zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2ZM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1Z",
                entered: "M6 16h2v2c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1Zm2-8H6c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v2Zm7 11c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1Zm1-11V6c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2Z"
              }
            },
            time: {viewBox: [0, 0, 72, 24], paths: {}},
            mute: {
              viewBox: [0, 0, 24, 24],
              paths: {
                muted: "M7 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L11 9H8c-.55 0-1 .45-1 1z",
                up: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
                down: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L9 9H6c-.55 0-1 .45-1 1z",
                off: "M3.63 3.63c-.39.39-.39 1.02 0 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
              }
            },
            playpause: {
              viewBox: [0, 0, 24, 24],
              paths: {
                play: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z",
                pause: "M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2zm6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2z"
              }
            },
            volume: {
              viewBox: [0, 0, 72, 24],
              paths: {line: "M13 11c-.55 0-1 .45-1 1s.45 1 1 1h46c.55 0 1-.45 1-1s-.45-1-1-1z", right: "", knob: ""}
            },
            options: {
              viewBox: [0, 0, 24, 24],
              paths: {
                settings: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z",
                tune: "M3 18c0 .55.45 1 1 1h5v-2H4c-.55 0-1 .45-1 1zM3 6c0 .55.45 1 1 1h9V5H4c-.55 0-1 .45-1 1zm10 14v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zM7 10v1H4c-.55 0-1 .45-1 1s.45 1 1 1h3v1c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1zm14 2c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1zm-5-3c.55 0 1-.45 1-1V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
              }
            }
          }, centerView: {
            playButton: {
              viewBox: [0, 0, 24, 24],
              paths: {play: "M10.8 15.9l4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4v7c0 .41.47.65.8.4zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"}
            },
            loading: {
              viewBox: [0, 0, 24, 24],
              paths: {
                circleFull: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z",
                circleHalf: "M22 12c0 4.73-3.3 8.71-7.73 9.74c-.62.15-1.22-.34-1.22-.98c0-.46.31-.86.75-.97c3.55-.82 6.2-4 6.2-7.79s-2.65-6.97-6.2-7.79c-.44-.1-.75-.51-.75-.97c0-.64.6-1.13 1.22-.98C18.7 3.29 22 7.27 22 12z",
                circleQuarter: "M20 12c0-3.79-2.65-6.97-6.2-7.79c-.44-.1-.75-.51-.75-.97c0-.64.6-1.13 1.22-.98c4.43 1.03 7.73 5.01 7.73 9.74c0 .55-.45 1-1 1c-.55 0-1-.45-1-1z"
              }
            },
            error: {
              viewBox: [0, 0, 24, 24],
              paths: {
                error: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z",
                warning: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
              }
            },
            audio: {
              viewBox: [0, 0, 24, 24],
              paths: {
                muted: "M7 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L11 9H8c-.55 0-1 .45-1 1z",
                up: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
                down: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L9 9H6c-.55 0-1 .45-1 1z",
                off: "M3.63 3.63c-.39.39-.39 1.02 0 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
              }
            }
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6182: function (e, t) {
      var n;
      void 0 === (n = function () {
        return {
          PAUSE: "view.pause",
          PLAY: "view.play",
          FULLSCREEN_CHANGE: "view.fullscreenChange",
          PLAYER_RESIZE: "view.playerResize",
          PLAYER_MEDIA_ELEMENT_ADDED: "view.playerMediaElementAdded",
          MUTE: "view.mute",
          UNMUTE: "view.unmute",
          VOLUME_CHANGE: "view.volumeChange"
        }
      }.apply(t, [])) || (e.exports = n)
    }, 6643: function (e, t, n) {
      var r, i;
      r = [n(1933), n(2833), n(7245), n(426), n(4124), n(5559), n(4586), n(7615), n(3703), n(2103), n(5770)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c) {
        "use strict";
        return {
          create: function (l, f, E) {
            var p = document.getElementById(l), m = "controls-" + l, g = document.createElement("div"), b = 0,
              _ = E.style.audioPlayer, h = E.style.fullScreenControl, T = E.style.optionsControl,
              A = E.style.controlBarColor, S = {
                symbolColor: E.style.symbolColor,
                buttonAnimation: E.style.buttonAnimation,
                buttonHighlighting: E.style.buttonHighlighting,
                buttonCursor: E.style.buttonCursor
              }, y = {
                playPauseControl: void 0,
                muteControl: void 0,
                volumeControl: void 0,
                fullscreenControl: void 0,
                timeControl: void 0,
                optionsControl: void 0
              };

            function R() {
              g && (g.style.visibility = "visible")
            }

            function v() {
              g && (g.style.visibility = "hidden")
            }

            function O(e) {
              e.button && 0 !== e.button || e.target.id && -1 !== e.target.id.indexOf("playButton-") || I()
            }

            function I() {
              b && clearTimeout(b), b = 0, b = setTimeout(v, 5e3), R()
            }

            return !document.getElementById(m) && p && (g.id = m, g.style.width = "100%", g.style.height = (_ ? "100" : Math.round(e.mobile ? 100 / 6 : 100 / 12)) + "%", g.style.maxHeight = Math.floor(p.clientWidth / 9) + "px", g.style.position = "absolute", g.style.left = "0", g.style.bottom = "0", g.style.zIndex = 1001, g.style.backgroundColor = A, !_ && v(), p.appendChild(g), y.playPauseControl = a.create(g, f, S), y.muteControl = o.create(g, f, S, _), y.volumeControl = s.create(g, f, S, _), y.timeControl = u.create(g, S), !_ && h && (y.fullscreenControl = d.create(g, f, S)), T && (y.optionsControl = c.create(g, f, S)), !_ && p.addEventListener(t.MOUSE_MOVE, O, !0)), {
              size: function () {
                if (g) {
                  g.style.width = "100%";
                  var t = Math.round(e.mobile ? p.clientHeight / 6 : p.clientHeight / 12),
                    n = Math.round(e.mobile ? g.clientWidth / 8 : g.clientWidth / 12);
                  for (var r in g.style.height = (_ ? "100" : Math.min(t, n)) + "px", g.style.maxHeight = Math.floor(p.clientWidth / 9) + "px", y) y[r] && y[r].update()
                }
              }, appear: I, show: R, hide: v, play: function () {
                y.playPauseControl.update(n.PLAY)
              }, pause: function () {
                y.playPauseControl.update(n.PAUSE)
              }, fullscreen: function (e) {
                !_ && h && (g.style.zIndex = 1001, e ? y.fullscreenControl.update(i.ENTERED) : y.fullscreenControl.update(i.EXITED))
              }, mute: function (e) {
                y.muteControl.update(r.MUTED, e)
              }, unmute: function (e) {
                y.muteControl.update(r.UNMUTED, e)
              }, volume: function (e) {
                y.volumeControl.update(e)
              }, time: function (e) {
                y.timeControl.update(e)
              }, destroy: function () {
                for (var e in b && clearTimeout(b), y) void 0 !== y[e] && y[e].destroy(), delete y[e];
                p && _ && p.removeEventListener(t.MOUSE_MOVE, O), p && g && g.parentNode === p && p.removeChild(g), g = null, p = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3703: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(4124), n(8812)], void 0 === (i = function (e, t, n, r, i, a, o) {
        "use strict";
        return {
          create: function (s, d, u) {
            var c, l, f, E = "http://www.w3.org/2000/svg", p = t.create(u.symbolColor), m = p.get(),
              g = document.createElement("div"), b = a.EXITED, _ = "fullscreen-" + s.id,
              h = document.createElementNS(E, "path"), T = s.clientHeight, A = o.controls.fullscreen.paths,
              S = o.controls.fullscreen.viewBox;
            u.buttonHighlighting && (f = "rect", l = 1, c = document.createElementNS(E, f));
            var y = 0;
            return u.buttonHighlighting && ("rect" === f ? (n.setAttribute(c, "x", l), n.setAttribute(c, "y", l), n.setAttribute(c, "width", S[2] - 2 * l), n.setAttribute(c, "height", S[3] - 2 * l), n.setAttribute(c, "rx", 4), n.setAttribute(c, "ry", 4), n.setAttribute(c, "fill", p.getGradientUrl("vertical"))) : (n.setAttribute(c, "cx", S[2] / 2), n.setAttribute(c, "cy", S[3] / 2), n.setAttribute(c, "r", Math.min(S[2], S[3]) - l), n.setAttribute(c, "fill", p.getGradientUrl("radial"))), n.setAttribute(c, "opacity", "0"), m.appendChild(c)), n.setAttribute(m, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(m, "transform", "scale(0.9)"), n.setAttribute(m, "viewBox", S.join(" ")), n.setAttribute(m, "fill", u.symbolColor), g.id = _, g.style.float = "right", g.style.display = "inline-block", g.style.width = T + "px", g.style.height = T + "px", g.style.cursor = u.buttonCursor, g.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.8)")
            })), g.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (y && clearTimeout(y) && (y = 0), y = setTimeout((function () {
                m && -1 !== n.getAttribute(m, "transform").indexOf("0.8") && n.setAttribute(m, "transform", "scale(1.0)")
              }), 50), d.emit(i.FULLSCREEN_CHANGE))
            })), g.addEventListener(r.MOUSE_ENTER, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0.15"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(1.0)")
            })), g.addEventListener(r.MOUSE_LEAVE, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.9)")
            })), m.appendChild(h), g.appendChild(m), s.appendChild(g), {
              update: function (e) {
                e && (b = e), T = s.clientHeight, g.style.width = T + "px", g.style.height = T + "px", b === a.ENTERED ? n.setAttribute(h, "d", A.entered) : b === a.EXITED && n.setAttribute(h, "d", A.exited)
              }, destroy: function () {
                y && clearTimeout(y) && (y = 0), null !== s && null !== m && null !== m.parentNode && m.parentNode === s && s.removeChild(m), m = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4586: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(426), n(8812)], void 0 === (i = function (e, t, n, r, i, a, o) {
        "use strict";
        return {
          create: function (s, d, u) {
            var c, l, f, E = "http://www.w3.org/2000/svg", p = t.create(u.symbolColor), m = p.get(),
              g = document.createElement("div"), b = a.UNMUTED, _ = 1, h = "mute-" + s.id,
              T = document.createElementNS(E, "path"), A = s.clientHeight, S = o.controls.mute.paths,
              y = o.controls.mute.viewBox;
            u.buttonHighlighting && (f = "rect", l = 1, c = document.createElementNS(E, f));
            var R = 0;
            return u.buttonHighlighting && ("rect" === f ? (n.setAttribute(c, "x", l), n.setAttribute(c, "y", l), n.setAttribute(c, "width", y[2] - 2 * l), n.setAttribute(c, "height", y[3] - 2 * l), n.setAttribute(c, "rx", 4), n.setAttribute(c, "ry", 4), n.setAttribute(c, "fill", p.getGradientUrl("vertical"))) : (n.setAttribute(c, "cx", y[2] / 2), n.setAttribute(c, "cy", y[3] / 2), n.setAttribute(c, "r", Math.min(y[2], y[3]) - l), n.setAttribute(c, "fill", p.getGradientUrl("radial"))), n.setAttribute(c, "opacity", "0"), m.appendChild(c)), n.setAttribute(m, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(m, "transform", "scale(0.9)"), n.setAttribute(m, "viewBox", y.join(" ")), n.setAttribute(m, "fill", u.symbolColor), g.id = h, g.style.float = "left", g.style.display = "inline-block", g.style.width = A + "px", g.style.height = A + "px", g.style.cursor = u.buttonCursor, g.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.8)")
            })), g.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (R && clearTimeout(R) && (R = 0), R = setTimeout((function () {
                m && -1 !== n.getAttribute(m, "transform").indexOf("0.8") && n.setAttribute(m, "transform", "scale(1.0)"), b === a.MUTED ? d.emit(i.UNMUTE) : b === a.UNMUTED && d.emit(i.MUTE)
              }), 50))
            })), g.addEventListener(r.MOUSE_ENTER, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0.15"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(1.0)")
            })), g.addEventListener(r.MOUSE_LEAVE, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.9)")
            })), m.appendChild(T), g.appendChild(m), s.appendChild(g), {
              update: function (e, t) {
                e && (b = e), void 0 !== t && (_ = t), A = s.clientHeight, g.style.width = A + "px", g.style.height = A + "px", b === a.MUTED ? n.setAttribute(T, "d", S.off) : b === a.UNMUTED && (_ >= .5 ? n.setAttribute(T, "d", S.up) : _ > 0 ? n.setAttribute(T, "d", S.down) : n.setAttribute(T, "d", S.muted))
              }, destroy: function () {
                R && clearTimeout(R) && (R = 0), null !== s && null !== m && null !== m.parentNode && m.parentNode === s && s.removeChild(m), m = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5770: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(1710), n(8812)], void 0 === (i = function (e, t, n, r, i, a, o) {
        "use strict";
        return {
          create: function (s, d, u) {
            var c, l, f, E = "http://www.w3.org/2000/svg", p = t.create(u.symbolColor), m = p.get(),
              g = document.createElement("div"), b = "options-" + s.id, _ = a.CLOSED,
              h = document.createElementNS(E, "path"), T = s.clientHeight, A = o.controls.options.paths,
              S = o.controls.options.viewBox;
            u.buttonHighlighting && (f = "rect", l = 1, c = document.createElementNS(E, f));
            var y = 0;
            return u.buttonHighlighting && ("rect" === f ? (n.setAttribute(c, "x", l), n.setAttribute(c, "y", l), n.setAttribute(c, "width", S[2] - 2 * l), n.setAttribute(c, "height", S[3] - 2 * l), n.setAttribute(c, "rx", 4), n.setAttribute(c, "ry", 4), n.setAttribute(c, "fill", p.getGradientUrl("vertical"))) : (n.setAttribute(c, "cx", S[2] / 2), n.setAttribute(c, "cy", S[3] / 2), n.setAttribute(c, "r", Math.min(S[2], S[3]) - l), n.setAttribute(c, "fill", p.getGradientUrl("radial"))), n.setAttribute(c, "opacity", "0"), m.appendChild(c)), n.setAttribute(m, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(m, "transform", "scale(0.9)"), n.setAttribute(m, "viewBox", S.join(" ")), n.setAttribute(m, "fill", u.symbolColor), g.id = b, g.style.float = "right", g.style.display = "inline-block", g.style.width = T + "px", g.style.height = T + "px", g.style.cursor = u.buttonCursor, g.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.8)")
            })), g.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (y && clearTimeout(y) && (y = 0), y = setTimeout((function () {
                m && -1 !== n.getAttribute(m, "transform").indexOf("0.8") && n.setAttribute(m, "transform", "scale(1.0)"), _ === a.CLOSED ? d.emit(i.OPTIONS_OPEN) : d.emit(i.OPTIONS_CLOSE)
              }), 50))
            })), g.addEventListener(r.MOUSE_ENTER, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0.15"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(1.0)")
            })), g.addEventListener(r.MOUSE_LEAVE, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.9)")
            })), m.appendChild(h), g.appendChild(m), s.appendChild(g), {
              update: function (e) {
                e && (_ = e), T = s.clientHeight, g.style.width = T + "px", g.style.height = T + "px", n.setAttribute(h, "d", Math.random() > .5 ? A.settings : A.tune)
              }, destroy: function () {
                y && clearTimeout(y) && (y = 0), null !== s && null !== m && null !== m.parentNode && m.parentNode === s && s.removeChild(m), m = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5559: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(7245), n(8812)], void 0 === (i = function (e, t, n, r, i, a, o) {
        "use strict";
        return {
          create: function (s, d, u) {
            var c, l, f, E = "http://www.w3.org/2000/svg", p = t.create(u.symbolColor), m = p.get(),
              g = document.createElement("div"), b = a.PLAY, _ = "playpause-" + s.id,
              h = document.createElementNS(E, "path"), T = s.clientHeight, A = o.controls.playpause.paths,
              S = o.controls.playpause.viewBox;
            u.buttonHighlighting && (f = "rect", l = 1, c = document.createElementNS(E, f));
            var y = 0;
            return u.buttonHighlighting && ("rect" === f ? (n.setAttribute(c, "x", l), n.setAttribute(c, "y", l), n.setAttribute(c, "width", S[2] - 2 * l), n.setAttribute(c, "height", S[3] - 2 * l), n.setAttribute(c, "rx", 4), n.setAttribute(c, "ry", 4), n.setAttribute(c, "fill", p.getGradientUrl("vertical"))) : (n.setAttribute(c, "cx", S[2] / 2), n.setAttribute(c, "cy", S[3] / 2), n.setAttribute(c, "r", Math.min(S[2], S[3]) - l), n.setAttribute(c, "fill", p.getGradientUrl("radial"))), n.setAttribute(c, "opacity", "0"), m.appendChild(c)), n.setAttribute(m, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(m, "transform", "scale(0.9)"), n.setAttribute(m, "viewBox", S.join(" ")), n.setAttribute(m, "fill", u.symbolColor), g.id = _, g.style.float = "left", g.style.display = "inline-block", g.style.width = T + "px", g.style.height = T + "px", g.style.cursor = u.buttonCursor, g.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.8)")
            })), g.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (y && clearTimeout(y) && (y = 0), y = setTimeout((function () {
                m && -1 !== n.getAttribute(m, "transform").indexOf("0.8") && n.setAttribute(m, "transform", "scale(1.0)"), b === a.PLAY ? d.emit(i.PLAY) : b === a.PAUSE && d.emit(i.PAUSE)
              }), 50))
            })), g.addEventListener(r.MOUSE_ENTER, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0.15"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(1.0)")
            })), g.addEventListener(r.MOUSE_LEAVE, (function () {
              u.buttonHighlighting && n.setAttribute(c, "opacity", "0"), u.buttonAnimation && n.setAttribute(m, "transform", "scale(0.9)")
            })), m.appendChild(h), g.appendChild(m), s.appendChild(g), {
              update: function (e) {
                e && (b = e), T = s.clientHeight, g.style.width = T + "px", g.style.height = T + "px", b === a.PLAY ? n.setAttribute(h, "d", A.play) : b === a.PAUSE && n.setAttribute(h, "d", A.pause)
              }, destroy: function () {
                y && clearTimeout(y) && (y = 0), null !== s && null !== m && null !== m.parentNode && m.parentNode === s && s.removeChild(m), m = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2103: function (e, t, n) {
      var r, i;
      r = [n(7251), n(3740), n(8143), n(8812)], void 0 === (i = function (e, t, n, r) {
        "use strict";
        return {
          create: function (i, a) {
            var o = e.create(a.symbolColor).get(), s = document.createElement("div"), d = "time-" + i.id,
              u = document.createElementNS("http://www.w3.org/2000/svg", "text"), c = i.clientHeight, l = "0:00",
              f = r.controls.time.viewBox, E = (Math.min(f[2], f[3]) - 12) / 2, p = Math.min(f[2], f[3]) - E;
            return t.setAttribute(u, "x", E), t.setAttribute(u, "y", p), t.setAttribute(u, "font-size", "12pt"), t.setAttribute(u, "font-weight", "100"), t.setAttribute(u, "font-family", "Arial, Helvetica, sans-serif;"), t.setAttribute(u, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), t.setAttribute(o, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), t.setAttribute(o, "transform", "scale(0.9)"), t.setAttribute(o, "viewBox", f.join(" ")), t.setAttribute(o, "fill", a.symbolColor), s.id = d, s.style.float = "left", s.style.display = "inline-block", s.style.cursor = "default", o.appendChild(u), s.appendChild(o), i.appendChild(s), {
              update: function (e) {
                e && (l = n.format(e)), c = i.clientHeight, s.style.width = f[2] / f[3] * c + "px", s.style.height = c + "px", u.textContent = l
              }, destroy: function () {
                null !== i && null !== o && null !== o.parentNode && o.parentNode === i && i.removeChild(o), o = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7615: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(8812)], void 0 === (i = function (e, t, n, r, i, a) {
        "use strict";
        return {
          create: function (o, s, d) {
            var u, c, l, f = "http://www.w3.org/2000/svg", E = t.create(d.symbolColor), p = E.get(),
              m = document.createElement("div"), g = 1, b = "volume-" + o.id, _ = document.createElementNS(f, "path"),
              h = document.createElementNS(f, "path"), T = document.createElementNS(f, "circle"), A = o.clientHeight,
              S = a.controls.volume.paths, y = a.controls.volume.viewBox, R = 12, v = y[2] - 24, O = v + R, I = !1;
            d.buttonHighlighting && (l = "circle", c = 1, u = document.createElementNS(f, l));
            var C = 0;

            function N(t) {
              t && void 0 !== t.button && 0 !== t.button || (P(t) ? (d.buttonAnimation && d.buttonHighlighting && "rect" !== l && n.setAttribute(u, "r", .8 * (R - c)), document.addEventListener(e.mobile ? r.TOUCH_MOVE : r.MOUSE_MOVE, w), document.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, D), I = !0) : D({button: 0}))
            }

            function D(t) {
              if (!t || void 0 === t.button || 0 === t.button) {
                C && clearTimeout(C) && (C = 0), C = setTimeout((function () {
                  d.buttonAnimation && d.buttonHighlighting && "rect" !== l && n.setAttribute(u, "r", R - c)
                }), 50), document.removeEventListener(e.mobile ? r.TOUCH_MOVE : r.MOUSE_MOVE, w), I = !1;
                var i = L(t), a = p.getBoundingClientRect();
                (i.clientX <= a.left || i.clientX >= a.right || i.clientY <= a.top || i.clientY >= a.bottom) && U()
              }
            }

            function w(e) {
              e && void 0 !== e.button && 0 !== e.button || I && (P(e) || D({button: 0}))
            }

            function U() {
              I || (d.buttonHighlighting && n.setAttribute(u, "opacity", "0"), d.buttonAnimation && n.setAttribute(p, "transform", "scale(0.9)"))
            }

            function P(e) {
              var t = L(e), n = p.getBoundingClientRect();
              t.clientX <= n.left || t.clientX >= n.right || t.clientY <= n.top || (t.clientY, n.bottom);
              var r = n.right - n.left, a = (v + 24) / r, o = (t.clientX - n.left) * a;
              o >= O ? o = O : o <= 12 && (o = 12), M(o);
              var d = (o - 12) / (O - 12);
              return d = Math.round(100 * d) / 100, s.emit(i.VOLUME_CHANGE, {volume: d}), !0
            }

            function M(e) {
              T.setAttribute("cx", e), d.buttonHighlighting && ("rect" === l ? n.setAttribute(u, "x", e - (R - c)) : n.setAttribute(u, "cx", e)), F(h, S.line, e - R, R)
            }

            function L(e, t, n) {
              var r = {clientX: t || 0, clientY: n || 0};
              return void 0 !== e.clientX && void 0 !== e.clientY ? (r.clientX = e.clientX, r.clientY = e.clientY) : e.changedTouches && e.changedTouches.length ? (r.clientX = e.changedTouches[0].clientX, r.clientY = e.changedTouches[0].clientY) : e.touches && e.touches.length && (r.clientX = e.touches[0].clientX, r.clientY = e.touches[0].clientY), r
            }

            function F(e, t, n, r) {
              var i = t.split("h"), a = i[0].split("c"), o = a[0].split(" ");
              o[0] = "M" + (r + 1), a[0] = o.join(" "), i[0] = a.join("c");
              var s = i[1].split("c");
              s[0] = n - 2, i[1] = s.join("c");
              var d = i.join("h");
              e.setAttribute("d", d)
            }

            return F(_, S.line, O - R, R), _.setAttribute("opacity", "0.5"), F(h, S.line, O - R, R), h.setAttribute("opacity", "1"), T.setAttribute("r", 4), T.setAttribute("cx", O), T.setAttribute("cy", y[3] / 2), T.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, N), T.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, D), d.buttonHighlighting && ("rect" === l ? (n.setAttribute(u, "x", O - (R - c)), n.setAttribute(u, "y", c), n.setAttribute(u, "width", 2 * (R - c)), n.setAttribute(u, "height", 2 * (R - c)), n.setAttribute(u, "rx", 4), n.setAttribute(u, "ry", 4), n.setAttribute(u, "fill", E.getGradientUrl("vertical"))) : (n.setAttribute(u, "cx", O), n.setAttribute(u, "cy", y[3] / 2), n.setAttribute(u, "r", R - c), n.setAttribute(u, "fill", E.getGradientUrl("vertical"))), n.setAttribute(u, "opacity", "0"), p.appendChild(u)), n.setAttribute(p, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(p, "transform", "scale(0.9)"), n.setAttribute(p, "viewBox", y.join(" ")), n.setAttribute(p, "fill", d.symbolColor), m.id = b, m.style.float = "left", m.style.display = "inline-block", m.style.width = y[2] / y[3] * A + "px", m.style.height = A + "px", m.style.cursor = d.buttonCursor, m.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, N), m.addEventListener(r.MOUSE_ENTER, (function () {
              d.buttonHighlighting && n.setAttribute(u, "opacity", "0.15"), d.buttonAnimation && n.setAttribute(p, "transform", "scale(1.0)")
            })), m.addEventListener(r.MOUSE_LEAVE, U), p.appendChild(_), p.appendChild(h), p.appendChild(T), m.appendChild(p), o.appendChild(m), {
              update: function (e) {
                void 0 !== e && (g = e), A = o.clientHeight, m.style.width = y[2] / y[3] * A + "px", m.style.height = A + "px", M(v * g + R)
              }, destroy: function () {
                C && clearTimeout(C) && (C = 0), null !== o && null !== p && null !== p.parentNode && p.parentNode === o && o.removeChild(p), p = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6444: function (e, t, n) {
      var r, i;
      r = [n(6627), n(7176), n(4124), n(9087)], void 0 === (i = function (e, t, n, r) {
        "use strict";
        return {
          create: function (t, i, a) {
            var o, s, d, u = document.getElementById(t), c = n.EXITED, l = !1, f = {}, E = "", p = "", m = "",
              g = a.style.backgroundColor, b = a.style.fullScreenBackgroundColor, _ = 0, h = [], T = 1, A = 0, S = null,
              y = "", R = {
                width: "10000px",
                height: "10000px",
                left: "-4000px",
                top: "-4000px",
                padding: "0px",
                margin: "0px",
                position: "fixed",
                "background-color": b,
                "z-index": "0"
              }, v = void 0;

            function O(e) {
              e ? (document.body.style.setProperty("border-width", p), document.body.style.setProperty("background-color", E), u.style.setProperty("border-width", m), u.style.setProperty("background-color", g)) : (p = document.body.style.borderWidth, document.body.style.setProperty("border-width", "0px", "important"), E = document.body.style.backgroundColor, document.body.style.setProperty("background-color", b, "important"), m = u.style.borderWidth, u.style.setProperty("border-width", "0px", "important"), u.style.setProperty("background-color", b, "important"))
            }

            function I() {
              return c === n.ENTERED
            }

            function C() {
              try {
                var e, t;
                if (I()) {
                  for (U(); h.length;) (t = h.shift()).element.style.cssText = t.cssText, t.border && (t.element.frameBorder = t.border);
                  S = null, c = n.EXITED, O(!0), document.body.removeChild(s), function () {
                    if (l && o && f) {
                      var e, t = "";
                      for (e in f) t.length ? t += ", " + e + "=" + f[e] : t += e + "=" + f[e];
                      o.content = t
                    }
                  }(), u.removeChild(d), i.emit(r.FULLSCREEN_CHANGE, {entered: !1}), v && Object.prototype.hasOwnProperty.call(v, "x") && Object.prototype.hasOwnProperty.call(v, "y") && window.scroll(v.x, v.y), v = void 0
                } else {
                  for (v || (v = {y: window.pageYOffset, x: window.pageXOffset}), h.unshift({
                    window: window,
                    document: window.document,
                    element: u,
                    cssText: u.style.cssText,
                    border: null
                  }), P(window), U(), _ = setInterval(w, 300), e = 0; e < h.length; e += 1) (t = h[e]).element.style.setProperty("position", "fixed", "important"), t.element.style.setProperty("left", "0px", "important"), t.element.style.setProperty("top", "0px", "important"), t.element.style.setProperty("right", "0px", "important"), t.element.style.setProperty("bottom", "0px", "important"), t.element.style.setProperty("z-index", "1000", "important"), t.border && (t.element.frameBorder = "0");
                  N(), c = n.ENTERED, u.appendChild(d), document.body.appendChild(s), O(), i.emit(r.FULLSCREEN_CHANGE, {entered: !0})
                }
              } catch (e) {
                i.emit(r.FULLSCREEN_ERROR, {reason: "denied"})
              }
            }

            function N() {
              h.forEach(D)
            }

            function D(t) {
              !S && (S = h[0]), T = S.document.documentElement.clientWidth / S.window.innerWidth, A = (A = (0 === S.window.orientation ? S.window.screen.height : S.window.screen.width) - S.window.innerWidth * T) > 1 && !l ? A : 0, 0 === S.window.orientation ? t.element.style.paddingTop = "env(safe-area-inset-top)" : t.element.style.paddingTop = 0, (window.pageXOffset < 0 || window.pageYOffset < 0) && window.scroll(0, 0), t.element.style.width = S.window.innerWidth * T + "px", t.element.style.height = (e.isChrome ? Math.max(S.document.documentElement.clientHeight, S.window.innerHeight * T) : S.window.innerHeight * T) - A + "px"
            }

            function w() {
              try {
                I() && N()
              } catch (e) {
                i.emit(r.FULLSCREEN_ERROR, {reason: "denied"})
              }
            }

            function U() {
              clearInterval(_), _ = 0
            }

            function P(e) {
              if (e.parent !== e.self) for (var t = e.parent.frames, n = 0; n < t.length; n++) {
                var r = t[n];
                if (e.self === r && r.frameElement && r.frameElement.tagName && "IFRAME" === r.frameElement.tagName) {
                  for (var i = r.frameElement.attributes, a = !1, o = 0; o < i.length; o += 1) if (i[o].nodeName && -1 !== i[o].nodeName.indexOf("allowfullscreen") && "false" !== i[o].nodeValue) {
                    a = !0;
                    break
                  }
                  a && (h.unshift({
                    window: e.parent,
                    document: e.parent.document,
                    element: r.frameElement,
                    cssText: r.frameElement.style.cssText,
                    border: r.frameElement.frameBorder
                  }), P(e.parent))
                }
              }
            }

            return function () {
              var e, t, n, r, i, a = document.querySelectorAll("meta");
              for (e = 0; e < a.length; ++e) {
                var u = a[e].getAttribute("name"), c = a[e].getAttribute("content");
                if (u && "viewport" === u.toLowerCase()) {
                  if (l = !0, c) for (c = c.split(","), t = 0; t < c.length; t++) c[t] && c[t].length && -1 !== (n = c[t].trim().indexOf("=")) && n !== c[t].trim().length - 1 && (r = c[t].trim().substring(0, n), i = c[t].trim().substring(n + 1), r && i && (f[r] = i));
                  o = a[e]
                }
              }
              !function () {
                for (var e in (s = document.createElement("meta")).name = "viewport", f["initial-scale"] && (y += (y.length ? ", " : "") + "initial-scale=1.0"), f["maximum-scale"] && (y += (y.length ? ", " : "") + "maximum-scale=1.0"), s.content = y, d = document.createElement("div"), R) Object.prototype.hasOwnProperty.call(R, e) && d.style.setProperty(e, R[e], "position" === e ? "important" : "")
              }()
            }(), {
              change: function () {
                C()
              }, entered: I, enabled: function () {
                return !0
              }, destroy: function () {
                I() && C(), u = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 4103: function (e, t, n) {
      var r, i;
      r = [n(5533), n(6444)], void 0 === (i = function (e, t) {
        "use strict";
        return {
          create: function (n, r, i) {
            return document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen ? e.create(n, r, i) : t.create(n, r, i)
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 5533: function (e, t, n) {
      var r, i;
      r = [n(8718), n(5833), n(9087)], void 0 === (i = function (e, t, n) {
        "use strict";
        return {
          create: function (r, i, a) {
            var o = document.getElementById(r);
            o.requestFullScreen = o.requestFullscreen || o.mozRequestFullScreen || o.webkitRequestFullscreen || o.msRequestFullscreen, document.exitFullScreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
            var s = o.style.cssText, d = "", u = a.style.backgroundColor, c = a.style.fullScreenBackgroundColor, l = "",
              f = "", E = "", p = "", m = "", g = !1, b = !1;

            function _() {
              T() ? (g = !0, b || y(!0), i.emit(n.FULLSCREEN_CHANGE, {entered: !0})) : (b && y(!1), g && !A() && i.emit(n.FULLSCREEN_CHANGE, {entered: !1}), S() && !A() || (g = !1))
            }

            function h() {
              i.emit(n.FULLSCREEN_ERROR, {reason: "denied"})
            }

            function T() {
              return S() === o
            }

            function A() {
              var e = S();
              return !!e && e !== o
            }

            function S() {
              return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement
            }

            function y(e) {
              e ? (s = o.style.cssText, o.style.width = "100vw", o.style.height = "100vh", d = o.style.borderWidth, o.style.setProperty("border-width", "0px", "important"), o.style.setProperty("background-color", c, "important"), l = o.style.padding, f = o.style.paddingTop, E = o.style.paddingBottom, p = o.style.paddingLeft, m = o.style.paddingRight, o.style.setProperty("padding", "0", "important"), b = !0) : (o.style.cssText = s, o.style.setProperty("border-width", d), o.style.setProperty("background-color", u, "important"), o.style.setProperty("padding", l), o.style.setProperty("padding-top", f), o.style.setProperty("padding-bottom", E), o.style.setProperty("padding-left", p), o.style.setProperty("padding-right", m), b = !1)
            }

            function R() {
            }

            function v() {
            }

            return function () {
              var n;
              for (n in e) Object.prototype.hasOwnProperty.call(e, n) && document.addEventListener(e[n], _);
              for (n in t) Object.prototype.hasOwnProperty.call(t, n) && document.addEventListener(t[n], h)
            }(), {
              change: function () {
                !function () {
                  try {
                    T() ? document.exitFullScreen && document.exitFullScreen() : o.requestFullScreen && o.requestFullScreen().then(R).catch(v)
                  } catch (e) {
                  }
                }()
              }, entered: T, enabled: function () {
                return document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled
              }, destroy: function () {
                !function () {
                  var n;
                  for (n in e) Object.prototype.hasOwnProperty.call(e, n) && document.removeEventListener(e[n], _);
                  for (n in t) Object.prototype.hasOwnProperty.call(t, n) && document.removeEventListener(t[n], h)
                }(), T() && (document.exitFullScreen && document.exitFullScreen(), i.emit(n.FULLSCREEN_EXIT)), o = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 6471: function (e, t, n) {
      var r, i;
      r = [n(1933), n(6627), n(1117), n(2833)], void 0 === (i = function (e, t, n, r) {
        "use strict";
        return {
          create: function (e, i) {
            var a, o = document.getElementById(e), s = {timeout: 0, touchInProgress: !1}, d = 0;

            function u() {
              var e, n;
              if (o) if (o.addEventListener(r.CLICK, l), t.isAboveIOS11 && t.mustUseHLS || !t.isIOS && t.mustUseHLS) a.addEventListener(r.CLICK, l), a.addEventListener("contextmenu", f); else {
                var i = o.querySelectorAll("video");
                for (n = 0; n < i.length; n += 1) (e = i[n]) instanceof Element && (e.addEventListener(r.CLICK, l), e.addEventListener("contextmenu", f))
              }
            }

            function c() {
              var e, n;
              if (clearTimeout(d), d = 0, o) if (o.removeEventListener(r.CLICK, l), t.isAboveIOS11 && t.mustUseHLS || !t.isIOS && t.mustUseHLS) a.removeEventListener(r.CLICK, l), a.removeEventListener("contextmenu", f); else {
                var i = o.querySelectorAll("video");
                for (n = 0; n < i.length; n += 1) (e = i[n]) instanceof Element && (e.removeEventListener(r.CLICK, l), e.removeEventListener("contextmenu", f))
              }
            }

            function l(e) {
              e.preventDefault(), e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, e.currentTarget.id && -1 !== e.currentTarget.id.indexOf("controls-") || e.button && 0 !== e.button || s.touchInProgress || (s.touchInProgress = !0, e.currentTarget.id && -1 !== e.currentTarget.id.indexOf("playButton-") ? i.emit(n.PLAYBUTTON_SINGLE_CLICK) : e.currentTarget.id && -1 !== e.currentTarget.id.indexOf("audio-") ? i.emit(n.AUDIO_SINGLE_CLICK) : i.emit(n.PLAYER_SINGLE_CLICK), s.timeout = setTimeout((function () {
                s.touchInProgress = !1, clearTimeout(s.timeout), s.timeout = 0
              }), 300))
            }

            function f(e) {
              return e.preventDefault(), !1
            }

            return (t.isAboveIOS11 && t.mustUseHLS || !t.isIOS && t.mustUseHLS) && ((a = document.createElement("div")).style.width = "100%", a.style.height = "100%", a.style.position = "absolute", a.style.left = 0, a.style.top = 0, a.style.backgroundColor = "transparent", a.style.border = 0, a.style.display = "block", a.style.visibility = "visible", a.style.zIndex = 2, a.id = "clickWrapper-" + e, o.appendChild(a)), {
              update: function () {
                var t = document.getElementById("middleView-" + e);
                t && t.firstChild && t.firstChild.addEventListener(r.CLICK, l), c(), d = setTimeout(u, 200)
              }, destroy: function () {
                c(), s.timeout && clearTimeout(s.timeout), s.timeout = 0, a && o.removeChild(a), a = null, o = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 1890: function (e, t, n) {
      var r, i;
      r = [n(7176), n(6627), n(505)], void 0 === (i = function (e, t, n) {
        "use strict";
        return {
          create: function (r, i, a, o) {
            a = a || n.LETTERBOX;
            var s, d, u = document.getElementById(r), c = [], l = 0, f = i.width / i.height,
              E = t.isMediaOverQuicSupported && o.playback.enableMediaOverQuic;

            function p() {
              var n = ((u = document.getElementById(r)) && (s = u.clientWidth, d = u.clientHeight), {
                width: s,
                height: d
              }), o = ["100%", "100%"], p = n.width / n.height, g = f, b = m(p - g, 8), _ = m(p / g, 8), h = 1, T = 1;
              if (u) {
                var A, S = E && u.querySelector("canvas");
                switch (a) {
                  case"letterbox":
                    S ? l % 180 ? (_ > 1 && (h /= g, T /= p), _ <= 1 && (h *= p, T *= g)) : (_ > 1 && (h /= _), _ <= 1 && (T *= _)) : l % 180 && (b < 0 ? (h *= g, T *= g) : b >= 0 && (h /= g, T /= g));
                    break;
                  case"crop":
                    S ? l % 180 ? (_ > 1 && (h = h * g * _, T *= g), _ <= 1 && (h *= g, T = T * g / _)) : (_ > 1 && (T *= _), _ <= 1 && (h /= _)) : l % 180 ? b < 0 ? (h /= p, T /= p) : b >= 0 && (h *= p, T *= p) : b < 0 ? (h /= p / g, T /= p / g) : b >= 0 && (h *= p / g, T *= p / g);
                    break;
                  case"fill":
                    S ? l % 180 && (h *= p, T /= p) : l % 180 ? b < 0 ? (h *= g, T /= p) : b >= 0 && (h *= p, T /= g) : b < 0 ? T = n.height / (n.width / g) : b >= 0 && (h = n.width / (n.height * g));
                    break;
                  case"original":
                    o[0] = i.width + "px", o[1] = i.height + "px";
                    break;
                  case"resize":
                    "fixed" !== u.style.position && (o[0] = i.width + "px", o[1] = i.height + "px", u.style.width = o[0], u.style.height = o[1])
                }
                for (; c.length;) c.pop();
                if (h = m(h, 5), T = m(T, 5), t.isAboveIOS11 && t.mustUseHLS || !t.isIOS && t.mustUseHLS) {
                  var y = u.querySelectorAll("iframe");
                  for (A = 0; A < y.length; A += 1) y[A].contentDocument && y[A].contentDocument.body && y[A].contentDocument.body.firstChild && c.push(y[A].contentDocument.body.firstChild)
                } else {
                  var R = S ? u.querySelectorAll("canvas") : u.querySelectorAll("video");
                  for (A = 0; A < R.length; A += 1) c.push(R[A])
                }
                for (A = 0; A < c.length; A += 1) {
                  var v = c[A];
                  v instanceof Element && (e.normalize(v, "transform", "translate(-50%, -50%) scaleX(" + h.toFixed(5) + ") scaleY(" + T.toFixed(5) + ") rotate(" + l.toFixed(0) + "deg)"), v.style.width = o[0], v.style.height = o[1])
                }
              }
            }

            function m(e, t) {
              t = t || 2;
              var n = Math.pow(10, t);
              return Math.ceil(e * n) / n
            }

            return p(), {
              update: function (e, t) {
                a = "string" == typeof e ? e : a, l = "number" == typeof t ? t : l, p()
              }, destroy: function () {
                for (; c.length;) c.pop();
                u = null
              }, getState: function () {
                return {scalingMode: a, rotationMode: l}
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 383: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(8812)], void 0 === (i = function (e, t, n, r, i, a) {
        "use strict";
        return {
          create: function (o, s, d, u, c, l) {
            var f, E, p, m = "http://www.w3.org/2000/svg", g = t.create(c.symbolColor), b = g.get(),
              _ = document.createElementNS(m, "path"), h = a.centerView.audio.paths, T = a.centerView.audio.viewBox,
              A = u(), S = l[0], y = l[1];
            c.buttonHighlighting && (p = "rect", E = 1, f = document.createElementNS(m, p));
            var R = 0;
            return S ? n.setAttribute(_, "d", h.off) : y >= .5 ? n.setAttribute(_, "d", h.up) : y > 0 ? n.setAttribute(_, "d", h.down) : n.setAttribute(_, "d", h.muted), c.buttonHighlighting && ("rect" === p ? (n.setAttribute(f, "x", E), n.setAttribute(f, "y", E), n.setAttribute(f, "width", T[2] - 2 * E), n.setAttribute(f, "height", T[3] - 2 * E), n.setAttribute(f, "rx", 4), n.setAttribute(f, "ry", 4), n.setAttribute(f, "fill", g.getGradientUrl("vertical"))) : (n.setAttribute(f, "cx", T[2] / 2), n.setAttribute(f, "cy", T[3] / 2), n.setAttribute(f, "r", Math.min(T[2], T[3]) - E), n.setAttribute(f, "fill", g.getGradientUrl("radial"))), n.setAttribute(f, "opacity", "0"), b.appendChild(f)), n.setAttribute(b, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(b, "transform", "scale(0.9)"), n.setAttribute(b, "viewBox", T.join(" ")), n.setAttribute(b, "fill", c.symbolColor), b.style.zIndex = 1001, b.id = "audio-" + o, b.addEventListener(r.MOUSE_ENTER, (function () {
              c.buttonHighlighting && n.setAttribute(f, "opacity", "0.15"), c.buttonAnimation && n.setAttribute(b, "transform", "scale(1.0)")
            })), b.addEventListener(r.MOUSE_LEAVE, (function () {
              c.buttonHighlighting && n.setAttribute(f, "opacity", "0"), c.buttonAnimation && n.setAttribute(b, "transform", "scale(0.9)")
            })), b.appendChild(_), b.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              c.buttonAnimation && n.setAttribute(b, "transform", "scale(0.8)")
            })), b.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (R && clearTimeout(R) && (R = 0), R = setTimeout((function () {
                b && b && -1 !== n.getAttribute(b, "transform").indexOf("0.8") && n.setAttribute(b, "transform", "scale(1.0)"), S ? s.emit(i.UNMUTE) : s.emit(i.MUTE)
              }), 50))
            })), d.appendChild(b), d.style.width = A.width + "px", d.style.height = A.height + "px", d.style.cursor = c.buttonCursor, {
              destroy: function () {
                R && clearTimeout(R) && (R = 0), null !== d && null !== b && null !== b.parentNode && b.parentNode === d && d.removeChild(b), b = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 2911: function (e, t, n) {
      var r, i;
      r = [n(7251), n(3740), n(8812)], void 0 === (i = function (e, t, n) {
        "use strict";
        return {
          create: function (r, i, a, o, s) {
            var d = e.create(s.symbolColor).get(), u = document.createElementNS("http://www.w3.org/2000/svg", "path"),
              c = n.centerView.error.paths, l = n.centerView.error.viewBox, f = o();
            return t.setAttribute(u, "d", c.error), t.setAttribute(d, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), t.setAttribute(d, "transform", "scale(0.9)"), t.setAttribute(d, "viewBox", l.join(" ")), t.setAttribute(d, "fill", s.symbolColor), d.style.zIndex = 1001, d.id = "error-" + r, d.appendChild(u), a.appendChild(d), a.style.width = f.width + "px", a.style.height = f.height + "px", a.style.cursor = "default", {
              destroy: function () {
                null !== a && null !== d && null !== d.parentNode && d.parentNode === a && a.removeChild(d), d = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 79: function (e, t, n) {
      var r, i;
      r = [n(6627), n(7251), n(3740), n(8812)], void 0 === (i = function (e, t, n, r) {
        "use strict";
        return {
          create: function (i, a, o, s, d) {
            var u, c = "http://www.w3.org/2000/svg", l = t.create(d.symbolColor).get(),
              f = document.createElementNS(c, "path"), E = document.createElementNS(c, "path"),
              p = document.createElementNS(c, "path"), m = document.createElementNS(c, "animate"),
              g = document.createElementNS(c, "animateTransform"), b = document.createElementNS(c, "animateTransform"),
              _ = r.centerView.loading.paths, h = r.centerView.loading.viewBox, T = s(), A = e.isTridentBrowser,
              S = "quarter";

            function y() {
              clearInterval(u), u = null
            }

            return A || (m.setAttribute("attributeName", "opacity"), m.setAttribute("dur", "1s"), m.setAttribute("values", "0;0.5;0"), m.setAttribute("repeatCount", "indefinite"), f.appendChild(m)), f.setAttribute("opacity", "0"), f.setAttribute("d", _.circleFull), l.appendChild(f), -1 !== S.indexOf("half") && (A || (g.setAttribute("id", "first"), g.setAttribute("attributeName", "transform"), g.setAttribute("attributeType", "XML"), g.setAttribute("type", "rotate"), g.setAttribute("dur", .66), g.setAttribute("from", "0 12 12"), g.setAttribute("to", "360 12 12"), g.setAttribute("begin", "0s"), g.setAttribute("repeatCount", "indefinite"), E.appendChild(g)), E.setAttribute("opacity", "1.0"), E.setAttribute("d", _.circleHalf), l.appendChild(E)), -1 !== S.indexOf("quarter") && (A || (g.setAttribute("id", "first"), g.setAttribute("attributeName", "transform"), g.setAttribute("attributeType", "XML"), g.setAttribute("type", "rotate"), g.setAttribute("dur", .66), g.setAttribute("from", "0 12 12"), g.setAttribute("to", "360 12 12"), g.setAttribute("begin", "0s;second.end"), p.appendChild(g), b.setAttribute("id", "second"), b.setAttribute("attributeName", "transform"), b.setAttribute("attributeType", "XML"), b.setAttribute("type", "rotate"), b.setAttribute("dur", .33), b.setAttribute("from", "360 12 12"), b.setAttribute("to", "720 12 12"), b.setAttribute("begin", "first.end"), p.appendChild(b)), p.setAttribute("opacity", "1.0"), p.setAttribute("d", _.circleQuarter), l.appendChild(p)), n.setAttribute(l, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(l, "transform", "scale(0.9)"), n.setAttribute(l, "viewBox", h.join(" ")), n.setAttribute(l, "fill", d.symbolColor), l.style.zIndex = 1001, l.id = "loading-" + i, o.appendChild(l), o.style.width = T.width + "px", o.style.height = T.height + "px", o.style.cursor = "default", A && function () {
              y();
              var e = 0, t = 0, r = 1, i = 0, a = function () {
                (e += 9.090909090909092 * (i % 2 + 1)) >= 360 && (i++, e = 0), t >= .5 && 1 === r ? r = -1 : t <= 0 && -1 === r && (r = 1), t += .016666666666666666 * r, n.setAttribute(l, "style", "transform: rotate(" + e + "deg)"), f.setAttribute("opacity", t)
              };
              u = setInterval(a, 1e3 / 60), a()
            }(), {
              destroy: function () {
                A && y(), l.parentNode === o && o.removeChild(l), l = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 729: function (e, t, n) {
      var r, i;
      r = [n(7176), n(4869), n(79), n(862), n(2911), n(383)], void 0 === (i = function (e, t, n, r, i, a) {
        "use strict";
        return {
          create: function (o, s, d) {
            var u = {loading: n, playbutton: r, error: i, audio: a}, c = null, l = document.getElementById(o),
              f = "middleView-" + o, E = document.createElement("div"), p = {
                symbolColor: d.style.symbolColor,
                buttonAnimation: d.style.buttonAnimation,
                buttonHighlighting: d.style.buttonHighlighting,
                buttonCursor: d.style.buttonCursor
              }, m = 0;

            function g() {
              E && E.parentNode === l && l.removeChild(E)
            }

            function b() {
              return (l = document.getElementById(o)) && (m = Math.round(.2 * Math.min(l.clientWidth, l.clientHeight))), {
                width: m,
                height: m
              }
            }

            return {
              update: function (n, r) {
                c && c.destroy && (c.destroy(), c = null), n && n !== t.NONE ? (function () {
                  if (!document.getElementById(f)) {
                    var t = b();
                    E.id = f, E.style.width = t.width + "px", E.style.height = t.height + "px", E.style.position = "absolute", E.style.left = "50%", E.style.top = "50%", E.style.marginRight = "-50%", e.normalize(E, "transform", "translate(-50%, -50%)"), E.style.zIndex = 1e3, l && l.appendChild(E)
                  }
                }(), c = u[n].create(o, s, E, b, p, r)) : g()
              }, destroy: function () {
                c && c.destroy && (c.destroy(), c = null), g(), E = null, l = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 862: function (e, t, n) {
      var r, i;
      r = [n(1933), n(7251), n(3740), n(2833), n(5403), n(8812)], void 0 === (i = function (e, t, n, r, i, a) {
        "use strict";
        return {
          create: function (o, s, d, u, c) {
            var l, f, E, p = "http://www.w3.org/2000/svg", m = t.create(c.symbolColor), g = m.get(),
              b = document.createElementNS(p, "path"), _ = a.centerView.playButton.paths,
              h = a.centerView.playButton.viewBox, T = u();
            c.buttonHighlighting && (E = "rect", f = 1, l = document.createElementNS(p, E));
            var A = 0;
            return n.setAttribute(b, "d", _.play), c.buttonHighlighting && ("rect" === E ? (n.setAttribute(l, "x", f), n.setAttribute(l, "y", f), n.setAttribute(l, "width", h[2] - 2 * f), n.setAttribute(l, "height", h[3] - 2 * f), n.setAttribute(l, "rx", 4), n.setAttribute(l, "ry", 4), n.setAttribute(l, "fill", m.getGradientUrl("vertical"))) : (n.setAttribute(l, "cx", h[2] / 2), n.setAttribute(l, "cy", h[3] / 2), n.setAttribute(l, "r", Math.min(h[2], h[3]) - f), n.setAttribute(l, "fill", m.getGradientUrl("radial"))), n.setAttribute(l, "opacity", "0"), g.appendChild(l)), n.setAttribute(g, "style", "-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"), n.setAttribute(g, "transform", "scale(0.9)"), n.setAttribute(g, "viewBox", h.join(" ")), n.setAttribute(g, "fill", c.symbolColor), g.style.zIndex = 1001, g.id = "playButton-" + o, g.addEventListener(r.MOUSE_ENTER, (function () {
              c.buttonHighlighting && n.setAttribute(l, "opacity", "0.15"), c.buttonAnimation && n.setAttribute(g, "transform", "scale(1.0)")
            })), g.addEventListener(r.MOUSE_LEAVE, (function () {
              c.buttonHighlighting && n.setAttribute(l, "opacity", "0"), c.buttonAnimation && n.setAttribute(g, "transform", "scale(0.9)")
            })), g.appendChild(b), g.addEventListener(e.mobile ? r.TOUCH_START : r.MOUSE_DOWN, (function () {
              c.buttonAnimation && n.setAttribute(g, "transform", "scale(0.8)")
            })), g.addEventListener(e.mobile ? r.TOUCH_END : r.MOUSE_UP, (function (e) {
              e && void 0 !== e.button && 0 !== e.button || (A && clearTimeout(A) && (A = 0), A = setTimeout((function () {
                g && -1 !== n.getAttribute(g, "transform").indexOf("0.8") && n.setAttribute(g, "transform", "scale(1.0)"), s.emit(i.PLAY)
              }), 50))
            })), d.appendChild(g), d.style.width = T.width + "px", d.style.height = T.height + "px", d.style.cursor = c.buttonCursor, {
              destroy: function () {
                A && clearTimeout(A) && (A = 0), null !== d && null !== g && null !== g.parentNode && g.parentNode === d && d.removeChild(g), g = null
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 995: function (e, t, n) {
      var r, i;
      r = [n(1933), n(6627), n(7176), n(9583), n(492), n(6637)], void 0 === (i = function (e, t, n, r, i, a) {
        "use strict";
        return {
          create: function (e, t, o) {
            var s, d, u, c = [{
                type: r.STATE_CHANGE, listener: function (e) {
                  switch (e.state) {
                    case i.BUFFERING:
                    case i.PLAYING:
                      u && (u.style.visibility = "hidden");
                      break;
                    case i.READY:
                      u && (u.style.visibility = "visible");
                      break;
                    case i.LOADING:
                      s === i.READY && u && (u.style.visibility = "visible");
                      break;
                    case i.PAUSED:
                      !p && u && (u.style.visibility = "visible")
                  }
                  s = e.state
                }
              }], l = o.style, f = l.poster, E = "string" == typeof f && f.length, p = l.keepFrame,
              m = o.playback.crossOrigin, g = 16, b = 9, _ = I(), h = ["100%", "100%"], T = _.width / _.height,
              A = g / b, S = (T - A).toFixed(2), y = 1, R = 1, v = 0, O = 0;

            function I() {
              return t && (v = t.clientWidth, O = t.clientHeight), {width: v, height: O}
            }

            function C() {
              E && d && (_ = I(), T = _.width / _.height, S = Math.round(100 * (T - A)) / 100, R = y = 1, S < 0 ? R = Math.round(T / A * 100) / 100 : S >= 0 && (y = Math.round(A / T * 100) / 100), n.normalize(d, "transform", "translate(-50%, -50%) scaleX(" + y + ") scaleY(" + R + ") rotate(0deg)"))
            }

            function N() {
              d && (d.parentNode.removeChild(d), d = null), u && (u.parentNode.removeChild(u), u = null), E = !1
            }

            function D() {
              N()
            }

            function w() {
              d && d.naturalWidth && d.naturalHeight && (g = d.naturalWidth, b = d.naturalHeight, A = g / b, C())
            }

            return a.add({target: e, listeners: c}), function () {
              if (E) {
                switch ((u = document.createElement("div")).style.width = h[0], u.style.height = h[1], u.style.top = 0, u.style.left = 0, u.style.position = "absolute", u.style.zIndex = 999, u.style.visibility = "visible", u.style.backgroundColor = l.backgroundColor, (d = document.createElement("img")).style.width = h[0], d.style.height = h[1], d.style.position = "absolute", d.style.left = "50%", d.style.top = "50%", d.style.marginRight = "-50%", d.style.backgroundColor = l.backgroundColor, n.normalize(d, "transform", "translate(-50%, -50%)"), d.style.zIndex = 999, m) {
                  case"anonymous":
                  case"use-credentials":
                    d.setAttribute("crossOrigin", m)
                }
                d.onerror = D, d.onload = w, d.src = f, u.appendChild(d), t.appendChild(u), C()
              }
            }(), {
              update: function () {
                E && C()
              }, destroy: function () {
                N(), a.remove({target: e, listeners: c})
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7661: function (e, t, n) {
      var r, i;
      r = [n(1933), n(6627), n(7176), n(9583), n(492), n(6637), n(6182), n(995)], void 0 === (i = function (e, t, n, r, i, a, o, s) {
        "use strict";
        return {
          create: function (d, u, c) {
            var l, f, E, p = [], m = c.style, g = t.isMediaOverQuicSupported && c.playback.enableMediaOverQuic, b = !1,
              _ = [{
                type: r.STATE_CHANGE, listener: function (e) {
                  f = e.state;
                  for (var t = 0; t < p.length; t += 1) {
                    var n = p[t];
                    n instanceof Element && (m.audioPlayer ? n.style.visibility = "hidden" : f === i.READY || f === i.PAUSED ? !m.keepFrame && (n.style.visibility = "hidden") : f === i.PLAYING && !m.keepFrame && (n.style.visibility = "visible"))
                  }
                }
              }, {
                type: r.STREAM_INFO, listener: function () {
                  for (var e = 0; e < p.length; e += 1) {
                    var t = p[e];
                    t instanceof Element && m.audioPlayer && (t.style.visibility = "hidden")
                  }
                }
              }, {
                type: o.FULLSCREEN_CHANGE, listener: function (e) {
                  b = e.data.entered;
                  for (var t = 0; t < p.length; t += 1) {
                    var n = p[t];
                    n instanceof Element && (b ? n.style.setProperty("background-color", m.fullScreenBackgroundColor) : n.style.setProperty("background-color", m.backgroundColor))
                  }
                }
              }], h = !1;
            return function (t) {
              var n, r, i, a, o, f = ["width", "height"], p = 0;
              (l = document.getElementById(u)) && ("auto" !== t.width && "auto" !== t.height ? t.audioPlayer ? t.width && t.height ? (l.style.width = t.width, l.style.height = t.height) : t.width ? (l.style.width = t.width, l.style.height = Math.round(e.mobile ? 100 / 9 : 100 / 12) / 100 * l.clientWidth + "px") : l.clientWidth || l.clientHeight ? l.clientWidth && (l.style.height = Math.round(e.mobile ? 100 / 9 : 100 / 12) / 100 * l.clientWidth + "px") : (l.style.width = "640px", l.style.height = Math.round(e.mobile ? 100 / 9 : 100 / 12) / 100 * l.clientWidth + "px") : t.width && t.height ? (l.style.width = t.width, l.style.height = t.height) : (t.width || t.height) && t.aspectratio ? (i = -1 !== t[f[p = +!!t.height]].indexOf("%"), a = -1 !== t[f[p]].indexOf("px"), l.style[f[p]] = t[f[p]], (o = t.aspectratio.split("/"))[0] = parseInt(o[0], 10), o[1] = parseInt(o[1], 10), (i || a) && (n = parseInt(t[f[p]].replace(i ? "%" : "px", ""), 10), r = Math.round(n * o[+!p] / o[p]).toString() + (i ? "%" : "px"), l.style[f[+!p]] = r)) : (t.width || t.height) && (t.width || t.aspectratio) && (t.aspectratio || t.height) || l.clientWidth && l.clientHeight || (l.style.width = "640px", l.style.height = "360px") : l.clientWidth || l.clientHeight ? l.clientWidth || "auto" !== t.width ? l.clientHeight || (t.aspectratio && !t.audioPlayer ? ((o = t.aspectratio.split("/"))[0] = parseInt(o[0], 10), o[1] = parseInt(o[1], 10), l.style.height = Math.round(l.clientWidth / o[0] * o[1]).toString() + "px") : l.style.height = t.audioPlayer ? Math.round(e.mobile ? 100 / 6 : 100 / 12) / 100 * l.clientWidth + "px" : Math.round(l.clientWidth / 16 * 9).toString() + "px") : t.aspectratio ? ((o = t.aspectratio.split("/"))[0] = parseInt(o[0], 10), o[1] = parseInt(o[1], 10), l.style.width = Math.round(l.clientHeight * o[0] / o[1]).toString() + "px") : l.style.width = Math.round(16 * l.clientHeight / 9).toString() + "px" : (l.style.width = "640px", l.style.height = t.audioPlayer ? Math.round(e.mobile ? 100 / 6 : 100 / 12) / 100 * l.clientWidth + "px" : "360px"), l.style.overflow = "hidden", l.style.position = "relative", l.style.backgroundColor = t.audioPlayer ? "transparent" : t.backgroundColor ? t.backgroundColor : "black", E = s.create(d, l, c))
            }(m), {
              update: function () {
                for (h || (a.add({target: d, listeners: _}), h = !0); p.length;) p.pop();
                var e;
                if (l) {
                  if (t.isAboveIOS11 && t.mustUseHLS || !t.isIOS && t.mustUseHLS) {
                    var r = l.querySelectorAll("iframe");
                    for (e = 0; e < r.length; e += 1) r[e].contentDocument && r[e].contentDocument.body && r[e].contentDocument.body && p.push(r[e].contentDocument.body.firstChild)
                  } else {
                    var i = g && l.querySelector("canvas") ? l.querySelectorAll("canvas") : l.querySelectorAll("video");
                    for (i.length || (i = l.querySelectorAll("video")), e = 0; e < i.length; e += 1) p.push(i[e])
                  }
                  for (e = 0; e < p.length; e += 1) {
                    var o = p[e];
                    o instanceof Element && (o.style.width = "100%", o.style.height = "100%", o.style.position = "absolute", o.style.left = "50%", o.style.top = "50%", o.style.marginRight = "-50%", o.style.backgroundColor = m.audioPlayer ? "transparent" : b ? m.fullScreenBackgroundColor : m.backgroundColor, n.normalize(o, "transform", "translate(-50%, -50%)"))
                  }
                  E.update()
                }
              }, destroy: function () {
                for (E.destroy(), E = null, a.remove({target: d, listeners: _}), l = null; p.length;) p.pop()
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 3740: function (e, t, n) {
      var r, i;
      r = [n(6627), n(8333)], void 0 === (i = function (e, t) {
        "use strict";
        var n = t.create("Attribute");

        function r(e, t) {
          var r = !!(e && 1 === e.nodeType && t && "string" == typeof t && t.length);
          return !r && n.debugEnabled() && n.debug("element not existing or invalid property"), r
        }

        return {
          setAttribute: function (t, n, i) {
            if (r(t, n)) try {
              e.isTridentBrowser && "transform" === n ? t.style.transform = i : t.setAttribute(n, i)
            } catch (e) {
            }
          }, getAttribute: function (t, n) {
            var i = void 0;
            if (r(t, n)) try {
              i = e.isTridentBrowser && "transform" === n ? t.style.transform : t.getAttribute(n)
            } catch (e) {
            }
            return i
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 7251: function (e, t, n) {
      var r, i;
      r = [n(3740)], void 0 === (i = function (e) {
        "use strict";
        return {
          create: function (t) {
            var n = "http://www.w3.org/2000/svg", r = document.createElementNS(n, "svg"),
              i = document.createElementNS(n, "defs"), a = document.createElementNS(n, "radialGradient"),
              o = document.createElementNS(n, "linearGradient"), s = document.createElementNS(n, "linearGradient"),
              d = document.createElementNS(n, "stop"), u = document.createElementNS(n, "stop"),
              c = document.createElementNS(n, "stop"), l = document.createElementNS(n, "stop"),
              f = document.createElementNS(n, "stop"), E = document.createElementNS(n, "stop"),
              p = document.createElementNS(n, "stop"), m = document.createElementNS(n, "stop"),
              g = document.createElementNS(n, "stop"), b = document.createElementNS(n, "stop"),
              _ = document.createElementNS(n, "stop"), h = document.createElementNS(n, "stop");
            return d.setAttribute("offset", "0%"), d.setAttribute("stop-color", t), u.setAttribute("offset", "30%"), u.setAttribute("stop-color", t), c.setAttribute("stop-opacity", "1"), c.setAttribute("offset", "70%"), c.setAttribute("stop-color", t), c.setAttribute("stop-opacity", "1"), l.setAttribute("offset", "100%"), l.setAttribute("stop-color", t), l.setAttribute("stop-opacity", "0"), f.setAttribute("offset", "0%"), f.setAttribute("stop-color", t), E.setAttribute("offset", "80%"), E.setAttribute("stop-color", t), p.setAttribute("offset", "90%"), p.setAttribute("stop-color", t), p.setAttribute("stop-opacity", "0.1"), m.setAttribute("offset", "100%"), m.setAttribute("stop-color", t), m.setAttribute("stop-opacity", "0"), g.setAttribute("offset", "0%"), g.setAttribute("stop-color", t), _.setAttribute("stop-opacity", "0"), b.setAttribute("offset", "10%"), b.setAttribute("stop-color", t), _.setAttribute("stop-opacity", "0.15"), _.setAttribute("offset", "90%"), _.setAttribute("stop-color", t), _.setAttribute("stop-opacity", "0.15"), h.setAttribute("offset", "100%"), h.setAttribute("stop-color", t), h.setAttribute("stop-opacity", "0"), a.setAttribute("id", "hoverTransparencyRadial"), o.setAttribute("id", "hoverTransparencyHorizontal"), s.setAttribute("id", "hoverTransparencyVertical"), s.setAttribute("x1", "0"), s.setAttribute("y1", "0"), s.setAttribute("x2", "0"), s.setAttribute("y2", "1"), a.appendChild(d), a.appendChild(u), a.appendChild(c), a.appendChild(l), o.appendChild(f), o.appendChild(E), o.appendChild(p), o.appendChild(m), s.appendChild(g), s.appendChild(b), s.appendChild(_), s.appendChild(h), i.appendChild(a), i.appendChild(o), i.appendChild(s), e.setAttribute(r, "version", "1.1"), e.setAttribute(r, "xmlns", n), e.setAttribute(r, "xmlns:xlink", "http://www.w3.org/1999/xlink"), e.setAttribute(r, "enable-background", "new 0 0 0 0"), e.setAttribute(r, "xml:space", "preserve"), e.setAttribute(r, "x", "0px"), e.setAttribute(r, "y", "0px"), r.appendChild(i), {
              get: function () {
                return r
              }, getGradientUrl: function (e) {
                var t = "";
                switch (e = e || "radial") {
                  case"horizontal":
                    t = o.getAttribute("id");
                    break;
                  case"vertical":
                    t = s.getAttribute("id");
                    break;
                  case"radial":
                    t = a.getAttribute("id")
                }
                return "url(#" + t + ")"
              }
            }
          }
        }
      }.apply(t, r)) || (e.exports = i)
    }, 8143: function (e, t) {
      var n;
      void 0 === (n = function () {
        "use strict";
        return {
          format: function (e) {
            var t = Math.floor(e / 3600), n = Math.floor((e - 3600 * t) / 60);
            e = Math.floor(e - 3600 * t - 60 * n);
            var r = "";
            return 0 !== t && (r = t + ":"), (r += (n = n < 10 && "" !== r ? "0" + n : String(n)) + ":") + (e < 10 ? "0" + e : String(e))
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 5623: function (e, t) {
      var n;
      void 0 === (n = function () {
        "use strict";
        return {
          isColor: function (e) {
            var t = /^[a-zA-Z]*$/.test(e) && 1 === ["AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenRod", "DarkGray", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "Darkorange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "GoldenRod", "Gray", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenRodYellow", "LightGrey", "LightGreen", "LightPink", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquaMarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenRod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow", "YellowGreen"].filter((function (t) {
                return t.toLowerCase() === e.toLowerCase()
              })).length, n = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3}|[a-fA-F0-9]{8}|[a-fA-F0-9]{4})$/.test(e),
              r = /^[Rr][Gg][Bb]\(\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*,\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*,\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*\)$/.test(e),
              i = /^[Rr][Gg][Bb][Aa]\(\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*,\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*,\s*(0|[1-9]\d?|1\d\d?|2[0-4]\d|25[0-5])%?\s*,\s*((0.[1-9])|[01])\s*\)$/.test(e),
              a = /^[Hh][Ss][Ll]\(\s*(0|[1-9]\d?|[12]\d\d|3[0-5]\d)\s*,\s*((0|[1-9]\d?|100)%)\s*,\s*((0|[1-9]\d?|100)%)\s*\)$/.test(e),
              o = /^[Hh][Ss][Ll][Aa]\(\s*(0|[1-9]\d?|[12]\d\d|3[0-5]\d)\s*,\s*((0|[1-9]\d?|100)%)\s*,\s*((0|[1-9]\d?|100)%)\s*,\s*((0.[1-9])|[01])\s*\)$/.test(e);
            return t || n || r || i || a || o
          }
        }
      }.apply(t, [])) || (e.exports = n)
    }, 1583: function (e, t, n) {
      var r, i;
      r = [n(1933), n(1473), n(9088), n(9658), n(6627), n(9583), n(5623), n(2058), n(5109), n(4355), n(8564), n(5459), n(2833), n(6182), n(8741), n(9087), n(1117), n(5403), n(4869), n(6471), n(7661), n(729), n(1890), n(4103), n(6643)], void 0 === (i = function (e, t, n, r, i, a, o, s, d, u, c, l, f, E, p, m, g, b, _, h, T, A, S, y, R) {
        "use strict";

        function v() {
          this.version = ""
        }

        var O = v.prototype = Object.create(r.prototype);
        return O.setBaseValues = function (e) {
          this.config = s.create(), this._playerDivId = e, this._emitter = new r, this._muted = !1, this._volume = 100, this._handleAutoplay = !1, this.state = l.IDLE
        }, O.baseSetup = function (e) {
          this._validate(e.style), t.extend(e, this.config), t.merge(e, this.config), t.clean(this.config), this.registerExternalEventHandler(), (i.mustUseHLS || i.canUseHLS && this.config.playback.allowSafariHlsFallback) && (this.config.style.keepFrame = !1), this.config.style.view ? (this._style = T.create(this._emitter, this._playerDivId, this.config), this.config.style.audioPlayer || (this.config.style.centerView && (this._middleView = A.create(this._playerDivId, this._emitter, this.config)), this._resizeListener = u.create(this._playerDivId, this._emitter), this._mutationListener = c.create(this._playerDivId, this._emitter), this.config.style.interactive && (this._interactive = h.create(this._playerDivId, this._emitter))), this.config.style.controls && (this._controls = R.create(this._playerDivId, this._emitter, this.config)), this.config.style.audioPlayer || (this._fullscreen = y.create(this._playerDivId, this._emitter, this.config))) : this._fullscreen = y.create(this._playerDivId, this._emitter, this.config), this.registerInternalEventHandler()
        }, O.postSetup = function () {
          this.config.style.view && (this._style.update(), this.config.style.interactive && !this.config.style.audioPlayer ? this._interactive.update() : this.config.style.controls && this._controls.show())
        }, O.registerExternalEventHandler = function () {
          for (var e in E) Object.prototype.hasOwnProperty.call(E, e) && this._emitter.on(E[e], this._emit.bind(this, E[e]))
        }, O.registerInternalEventHandler = function () {
          var e, t;
          if (this._interactive && (this._emitter.on(g.PLAYBUTTON_SINGLE_CLICK, function () {
            this.state !== l.READY && this.state !== l.PAUSED ? this._emitter.emit(E.PAUSE) : this._emitter.emit(E.PLAY)
          }.bind(this)), this._emitter.on(g.AUDIO_SINGLE_CLICK, function () {
            this._muted ? this._emitter.emit(E.UNMUTE) : this._emitter.emit(E.MUTE)
          }.bind(this)), this._emitter.on(g.PLAYER_SINGLE_CLICK, function () {
            this._controls && this._controls.appear()
          }.bind(this))), this._controls) for (e in t = [b.FULLSCREEN_CHANGE], b) Object.prototype.hasOwnProperty.call(b, e) && Object.prototype.hasOwnProperty.call(E, e) && (-1 === t.indexOf(b[e]) ? this._emitter.on(b[e], this._emitter.emit.bind(this._emitter, E[e])) : this._fullscreen && this._emitter.on(b[e], function () {
            this._fullscreen && this._fullscreen.change()
          }.bind(this)));
          if (this._fullscreen) for (e in t = [m.FULLSCREEN_ERROR], m) Object.prototype.hasOwnProperty.call(m, e) && -1 === t.indexOf(m[e]) && (this._emitter.on(m[e], this._emitter.emit.bind(this._emitter, E[e])), this._emitter.on(m[e], this.handleFullscreen.bind(this)));
          this._resizeListener && (this._emitter.on(E.PLAYER_RESIZE, this._onPlayerResize.bind(this)), this._onPlayerResize(null)), this._mutationListener && this._emitter.on(E.PLAYER_MEDIA_ELEMENT_ADDED, this._onPlayerMediaElementAdded.bind(this))
        }, O.removeExternalEventHandler = function () {
          if (this._emitter) for (var e in E) Object.prototype.hasOwnProperty.call(E, e) && this._emitter.removeAllListeners(E[e])
        }, O.removeInternalEventHandler = function () {
          if (this._emitter) {
            var e;
            if (this._interactive && (this._emitter.removeAllListeners(g.PLAYER_SINGLE_CLICK), this._emitter.removeAllListeners(g.PLAYBUTTON_SINGLE_CLICK), this._emitter.removeAllListeners(g.AUDIO_SINGLE_CLICK)), this._controls) for (e in b) Object.prototype.hasOwnProperty.call(b, e) && Object.prototype.hasOwnProperty.call(E, e) && this._emitter.removeAllListeners(b[e]);
            if (this._fullscreen) for (e in m) Object.prototype.hasOwnProperty.call(m, e) && this._emitter.removeAllListeners(m[e]);
            this._resizeListener && this._emitter.removeAllListeners(E.PLAYER_RESIZE), this._mutationListener && this._emitter.removeAllListeners(E.PLAYER_MEDIA_ELEMENT_ADDED)
          }
        }, O.destroy = function () {
          this.removeExternalEventHandler(), this.removeInternalEventHandler(), this._emitter = null, this._resizeListener && this._resizeListener.destroy(), this._resizeListener = null, this._mutationListener && this._mutationListener.destroy(), this._mutationListener = null, this._style && this._style.destroy(), this._style = null, this._interactive && this._interactive.destroy(), this._interactive = null, this._scaling && this._scaling.destroy(), this._scaling = null, this._middleView && this._middleView.destroy(), this._middleView = null, this._controls && this._controls.destroy(), this._controls = null, this._fullscreen && this._fullscreen.destroy(), this._fullscreen = null
        }, O.update = function (e) {
          this.state = e.state, this._emitter.emit(a.STATE_CHANGE, e), this.handleView(e.state), this._interactive && this._interactive.update()
        }, O.handleView = function (e) {
          switch (this._viewTimeout && clearTimeout(this._viewTimeout), e) {
            case l.UNINITIALIZED:
              this._middleView && this._middleView.update(_.ERROR), this._controls && this._controls.destroy();
              break;
            case l.IDLE:
              this._middleView && this._middleView.update(_.NONE);
              break;
            case l.READY:
              this._middleView && this._middleView.update(_.PLAYBUTTON), this._controls && this._controls.play();
              break;
            case l.LOADING:
              this._middleView && this._middleView.update(_.LOADING), this._controls && this._controls.pause();
              break;
            case l.PLAYING:
              this.handleAudio(), this._controls && this._controls.pause();
              break;
            case l.PAUSED:
              this._middleView && this._middleView.update(_.PLAYBUTTON), this._controls && this._controls.play();
              break;
            case l.BUFFERING:
              this._viewTimeout = setTimeout(function () {
                this._middleView && this._middleView.update(_.LOADING), this._controls && this._controls.pause()
              }.bind(this), 1e3);
              break;
            case l.UNKNOWN:
              this._middleView && this._middleView.update(_.NONE)
          }
          this.state = e
        }, O.handleConfig = function (e) {
          this._handleAutoplay = e.playback.autoplay
        }, O.handleStreamInfo = function (e) {
          this._emitter.emit(a.STREAM_INFO, e), this.progressStreamInfo(e)
        }, O.handleStreamInfoUpdate = function (e) {
          this._emitter.emit(a.STREAM_INFO_UPDATE, e), this.progressStreamInfo(e)
        }, O.progressStreamInfo = function (e) {
          this.streamInfo = e.data.streamInfo, this._style && this._style.update(), this._interactive && this._interactive.update(), this._scaling && this._scaling.destroy() && (this._scaling = null), this.streamInfo.haveVideo && (this._scaling = S.create(this._playerDivId, this.streamInfo.videoInfo, this.config.style.scaling, this.config))
        }, O.handleAudio = function () {
          var e = this.state === l.PLAYING, t = this.streamInfo && this.streamInfo.haveAudio;
          e && !this._muted && t && (this._handleAutoplay = !1);
          var n = this.config.style.displayMutedAutoplay && this._muted && this._handleAutoplay,
            r = this.config.style.displayAudioOnly && this.streamInfo && !this.streamInfo.haveVideo;
          e && (t && n || r ? this._middleView && this._middleView.update(_.AUDIO, [this._muted, this._volume]) : this._middleView && this._middleView.update(_.NONE))
        }, O.handleMute = function (e, t) {
          this._controls && (e ? this._controls.mute(t) : this._controls.unmute(t)), this._muted = e, this.handleAudio()
        }, O.handleVolume = function (e) {
          this._controls && this._controls.volume(e), this._volume = e, this.handleMute(this._muted, this._volume)
        }, O.handleFullscreen = function (e) {
          this._controls && this._controls.fullscreen(e.data.entered)
        }, O.handleStats = function (e) {
          this._controls && this._controls.time(e.currentTime)
        }, O.handleMetaData = function (e) {
          if (this._scaling && "object" == typeof e.data.message && Object.prototype.hasOwnProperty.call(e.data.message, "nanoStreamStatus")) {
            var t = "object" == typeof e.data.message.nanoStreamStatus && Object.prototype.hasOwnProperty.call(e.data.message.nanoStreamStatus, "VideoRotation") ? e.data.message.nanoStreamStatus.VideoRotation : 0,
              n = this._scaling.getState();
            n.scalingMode === this.config.style.scaling && n.rotationMode === t || this._scaling.update(this.config.style.scaling, t)
          }
        }, O.handleActiveVideoElementChange = function () {
          this._style && this._style.update(), this._scaling && this._scaling.update()
        }, O.requestFullscreen = function () {
          return new Promise(function (e, t) {
            function n() {
              this._emitter.off(m.FULLSCREEN_ERROR, r), e()
            }

            function r(e) {
              this._emitter.off(m.FULLSCREEN_CHANGE, n), t({reason: e.data.reason})
            }

            this._fullscreen && this._fullscreen.enabled() ? this._fullscreen.entered() ? n.call(this) : (this._emitter.once(m.FULLSCREEN_CHANGE, n.bind(this)), this._emitter.once(m.FULLSCREEN_ERROR, r.bind(this)), this._fullscreen.change()) : r.call(this, {data: {reason: "disabled"}})
          }.bind(this))
        }, O.exitFullscreen = function () {
          return new Promise(function (e, t) {
            function n() {
              this._emitter.off(m.FULLSCREEN_ERROR, r), e()
            }

            function r(e) {
              this._emitter.off(m.FULLSCREEN_CHANGE, n), t({reason: e.data.reason})
            }

            this._fullscreen && this._fullscreen.enabled() ? this._fullscreen.entered() ? (this._emitter.once(m.FULLSCREEN_CHANGE, n.bind(this)), this._emitter.once(m.FULLSCREEN_ERROR, r.bind(this)), this._fullscreen.change()) : n.call(this) : r.call(this, {data: {reason: "disabled"}})
          }.bind(this))
        }, O._emit = function (e, t) {
          var n = {};
          t && t.name && t.data ? n = t : t ? (n.data = t, n.name = e || "unknown") : (n.data = {}, n.name = e || "unknown"), n.player = this._playerDivId, n.state = this.state, this.emit(n.name, n)
        }, O._validate = function (e) {
          e.symbolColor && !o.isColor(e.symbolColor) && delete e.symbolColor, e.controlBarColor && !o.isColor(e.controlBarColor) && delete e.controlBarColor, "inherit" === e.fullScreenBackgroundColor && (e.fullScreenBackgroundColor = e.backgroundColor)
        }, O._onPlayerResize = function () {
          this.handleView(this.state), this._interactive && this._interactive.update(), this._style && this._style.update(), this._scaling && this._scaling.update(), this._controls && this._controls.size()
        }, O._onPlayerMediaElementAdded = function () {
          this._style && this._style.update(), this._scaling && this._scaling.update()
        }, v.events = E, v.publicEvents = p, v.emptyConfig = s, v.validConfig = d, v
      }.apply(t, r)) || (e.exports = i)
    }
  }, t = {};
  !function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {exports: {}};
    return e[r].call(i.exports, i, i.exports, n), i.exports
  }(9921)
}();